var partialBody = "#_partialBody";
var target = "#_partialTable";
var pagerBase = "#_pagerBase";
var detailPartial = "#detailInitPartial";
var paymentArea = "#_PaymentArea";
var btnId = "#detailDefaultFormBtn";
var btn2Id = "#TeamDefaultBtn";
var selectedRowId = 0;
var countdownInterval;
var reservationCancellationInFlight = false;
var imageFile;
var clickedDataId;
var lasteTeamId = 0;
var lastTransferinId;
let editorInstances = [];
let isProcessing = false;
let isModalOpen = false;
var allowDragModal = false;

function publicListEnhancementOptions(target) {
    const table = $(target);
    const initial = table.attr('data-public-search-initial') === 'true'
        || table.attr('data-public-catalog-initial') === 'true';
    return { target, showSkeleton: !initial, preserveOnError: initial };
}


$(async function () {
    document.documentElement.style.scrollBehavior = "auto";

    if (document.querySelector('[data-potential-landing]') && await window.isPotentialCompanyBrowser?.()) return;

    const initialHome = document.querySelector('#_HomePageArea[data-home-initial="true"]');
    const initialList = document.querySelector('#_FieldTable[data-public-catalog-initial="true"], [data-public-search-initial="true"]');
    if (initialHome || initialList) {
        try {
            await Promise.all([
                afterScreenLoad(window.location.pathname + window.location.search, undefined, {
                    keepInitialPublicCatalog: Number(initialList?.getAttribute('data-public-catalog-page') || 1) > 1
                }),
                initialHome ? LoadHomePageAreas() : Promise.resolve()
            ]);
        } catch (error) {
            console.error('İlk sayfa bileşenleri yüklenemedi.', error);
        }
    }

    CheckMember();
    if (!window.sahaseninSessionHealthTimer) {
        window.sahaseninSessionHealthTimer = window.setInterval(function () {
            if (!document.hidden) CheckMember();
        }, 15000);
    }
    loadExMatchSectionFooter();
});




// GLOBAL interval referansı (tek instance çalışsın diye)
let sahaseninCountdownInterval = null;
const countdownDates = new WeakMap();

function sahaseninFormatRemainingTime(diffMs) {
    if (diffMs <= 0) return "Süresi dolmuş";

    let totalSeconds = Math.floor(diffMs / 1000);

    let weeks = Math.floor(totalSeconds / (7 * 24 * 60 * 60));
    totalSeconds %= (7 * 24 * 60 * 60);

    let days = Math.floor(totalSeconds / (24 * 60 * 60));
    totalSeconds %= (24 * 60 * 60);

    let hours = Math.floor(totalSeconds / (60 * 60));
    totalSeconds %= (60 * 60);

    let minutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;

    const pad = (n) => n.toString().padStart(2, '0');

    if (weeks > 0) return `${weeks} hafta ${days} gün`;
    if (days > 0) return `${days} gün ${hours} saat`;
    if (hours > 0) return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    return `${pad(minutes)}:${pad(seconds)}`;
}

function sahaseninUpdateCountdown() {
    const now = Date.now();
    // Remove expired quick-action requests even while their card content is loading.
    $('[id="_quickActionRequests"]').each(function () {
        const $panel = $(this);
        let removed = false;
        $panel.find('.globalRequestCard[data-request-expire]').each(function () {
            const expiry = SahaseninTime.parse(this.getAttribute('data-request-expire'))?.getTime();
            if (Number.isFinite(expiry) && expiry <= now) {
                $(this).remove();
                removed = true;
            }
        });
        if (removed) {
            const count = $panel.find('.globalRequestCard').length;
            const $tab = $panel.parent().parent().find('[data-global-tab][data-id="_quickActionRequests"]');
            $tab.find('.text-primary').text(count || '').toggle(count > 0);
            $tab.attr('aria-disabled', String(count === 0)).toggleClass('opacity-50', count === 0);
            if (count === 0 && !$panel.find('.quick-request-empty').length) {
                $('<p class="quick-request-empty text-muted p-2">Bekleyen isteğiniz yok.</p>').appendTo($panel);
            }
        }
    });

    $('.countdown-timer').each(function () {
        const $el = $(this);
        const expireStr = $el.data('expire');

        if (!expireStr) return;

        let expiry = countdownDates.get(this);
        if (!expiry || expiry.source !== expireStr) {
            expiry = { source:expireStr, time:SahaseninTime.parse(expireStr)?.getTime() };
            countdownDates.set(this, expiry);
        }
        if (!Number.isFinite(expiry.time)) return;
        const diff = expiry.time - now;

        const text = sahaseninFormatRemainingTime(diff);

        if (!document.hidden && !this.closest('.sheed-modal-suspended')) {
            const label = this.querySelector('.time-text');
            if (label && label.textContent !== text) label.textContent = text;
        }

        if (diff <= 0) {
            $el.removeClass('countdown-timer').text('Süresi dolmuş');
            $el.closest('.card').find('.AcceptGlobalRequest, .DeclineGlobalRequest').remove();
        }
    });
}

// 🔥 DIŞARIDAN ÇAĞIRACAĞIN FONKSİYON
function sahaseninInitCountdown() {

    // zaten interval varsa tekrar başlatma (memory leak önler)
    if (sahaseninCountdownInterval) return;

    sahaseninUpdateCountdown();

    sahaseninCountdownInterval = setInterval(() => {
        sahaseninUpdateCountdown();

        // eğer hiç timer kalmadıysa interval'ı durdur
        if ($('.countdown-timer, [id="_quickActionRequests"] .globalRequestCard[data-request-expire]').length === 0) {
            clearInterval(sahaseninCountdownInterval);
            sahaseninCountdownInterval = null;
        }

    }, 1000);
}
document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
        if (sahaseninCountdownInterval) sahaseninUpdateCountdown();
        void CheckMember();
    }
});




function completeImageLoad(img) { return window.sahaseninImages?.reveal(img); }
function startDeferredImageLoad(img) { window.sahaseninImages?.start(img); }
function applyLazyLoadToImages(container) {
    $(container || document).each((_, root) => window.sahaseninImages?.prepare(root));
}

$(function () {
    applyLazyLoadToImages(document);
});

async function loadExMatchSectionFooter() {
    const element = $('#_ExMatchSectionFooter');
    if (!element.length || element.attr('data-loaded') === 'true' || element.attr('aria-busy') === 'true') return;
    element.attr('aria-busy', 'true');
    element.html('<p class="text-white-50 fs-08" role="status">Son maçlar yükleniyor…</p>');
    try {
        await Request({ url: '/Home/_ExMatchSectionFooter', type: 'GET', target: '#_ExMatchSectionFooter',
            showSkeleton: false, preserveOnError: true, rejectOnAbort: true, timeout: 10000 });
        element.attr('data-loaded', 'true');
    } catch (_) {
        element.html('<p class="text-white-50 fs-08" role="status">Son maçlar şu anda yüklenemiyor.</p><button type="button" class="btn text-white fs-08 retry-footer-matches">Yeniden dene</button>');
    } finally { element.attr('aria-busy', 'false'); }
}
$(document).on('click', '.retry-footer-matches', loadExMatchSectionFooter);

function advertsReady() {
    window.sahaseninAdvertCleanup?.();
    // İç tanımlı ayarlar
    var advertSelector = '.advert';      // reklam kartlarının selector'u
    var mainImageSelector = '#mainImage';   // ana resim selector'u
    var mainLinkSelector = '#mainAdvertLink';
    var mainTitleSelector = '#mainAdvertTitle';
    var mainDescriptionSelector = '#mainAdvertDescription';
    var activeClass = 'active';       // aktif kart sınıfı
    var intervalMs = 5000;           // otomatik geçiş süresi (ms)

    var $posts = $(advertSelector);
    var $mainImg = $(mainImageSelector);
    var $mainLink = $(mainLinkSelector);
    var $mainTitle = $(mainTitleSelector);
    var $mainDescription = $(mainDescriptionSelector);
    var currentIndex = 0;
    var total = $posts.length;
    var timer = null;

    // Eğer hiç reklam veya ana resim yoksa fonksiyondan çık
    if (total === 0 || $mainImg.length === 0) {
        return;
    }

    // Aktif sınıfını ayarla
    function setActive(index) {
        $posts.removeClass(activeClass);
        $posts.eq(index).addClass(activeClass);
    }

    // Ana resmi güncelle
    function updateMainImage(index) {
        var $post = $posts.eq(index);
        var imgUrl = $post.data('img');
        $mainLink.attr('data-url', $post.attr('data-url') || '');
        $mainLink.attr('aria-label', (($post.data('name') || 'İçerik') + ' reklamını aç'));
        $mainTitle.text($post.data('name') || '');
        $mainDescription.html($post.attr('data-description') || '');
        if (!imgUrl) return;
        $mainImg.stop(true, true).fadeOut(200, function () {
            if (window.sahaseninResponsiveImages) {
                window.sahaseninResponsiveImages.setSource($mainImg[0], imgUrl);
            } else {
                $mainImg.attr('src', imgUrl);
            }
            $mainImg.fadeIn(200);
        });
    }

    function openAdvert(url) {
        if (typeof url !== 'string' || !url.trim()) return;
        pageLink(url.trim());
    }

    // Otomatik geçiş fonksiyonu
    function autoRotate() {
        if (!$mainImg[0].isConnected) { cleanup(); return; }
        if (document.hidden || !inView) return;
        currentIndex = (currentIndex + 1) % total;
        setActive(currentIndex);
        updateMainImage(currentIndex);
    }

    // Otomatik döngüyü başlat
    function startAuto() {
        stopAuto();
        if (!inView || document.hidden || total < 2) return;
        timer = setInterval(autoRotate, intervalMs);
    }

    // Otomatik döngüyü durdur
    function stopAuto() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }

    // Reklam tıklanınca
    $posts.off('.advertRotation').on('click.advertRotation', function () {
        var idx = $(this).data('index');
        if (typeof idx === 'number') {
            currentIndex = idx;
            setActive(currentIndex);
            updateMainImage(currentIndex);
            openAdvert($(this).attr('data-url'));
        }
    });

    $mainLink.off('.advertRotation').on('click.advertRotation', function () {
        openAdvert($(this).attr('data-url'));
    });

    // Hover ile duraklat / devam ettir
    $posts.on('mouseenter.advertRotation', () => {
        if (document.documentElement.dataset.inputKind !== 'touch') stopAuto();
    });
    $posts.on('mouseleave.advertRotation', startAuto);

    var inView = false;
    var observer = new IntersectionObserver(entries => {
        inView = entries.some(entry => entry.isIntersecting);
        if (inView) startAuto(); else stopAuto();
    }, { threshold: 0.1 });
    observer.observe($mainImg[0]);
    function onVisibility() { if (document.hidden) stopAuto(); else startAuto(); }
    document.addEventListener('visibilitychange', onVisibility);
    function cleanup() {
        stopAuto();
        observer.disconnect();
        document.removeEventListener('visibilitychange', onVisibility);
        $posts.off('.advertRotation');
        $mainLink.off('.advertRotation');
        if (window.sahaseninAdvertCleanup === cleanup) delete window.sahaseninAdvertCleanup;
    }
    window.sahaseninAdvertCleanup = cleanup;
    // The first image already exists in server HTML; do not download/fade it again.
    setActive(currentIndex);
}















$(document).on("click", ".ContactModalPotantielCompany", function () {

    var element = $(this);
    var id = element.data('id');

    const modal = createModal({
        title: 'İletişim'
    });

    Request({
        url: '/Company/_ContactModalPotantielCompany',
        type: 'POST',
        data: { id: id },
        success: function (response) {

            modal.updateContent(response);

            var waitScreen = $("#WaitScreen");
            var phonesArea = $("#PhonesArea");
            var counterSpan = $('#companyPhoneSecondCounter');

            var seconds = 10; // 10 saniye
            counterSpan.text(seconds); // başlangıç değeri

            // Her saniye geri sayım
            var interval = setInterval(function () {
                seconds--;
                counterSpan.text(seconds);

                if (seconds <= 0) {
                    clearInterval(interval);
                    waitScreen.fadeOut(500, function () {
                        phonesArea.removeClass("d-none").hide().fadeIn(500);
                    });
                }
            }, 1000);
        }
    });
});



$(document).on("click", "#MobileBackBtn", function () {

    $(this).addClass('Active');
});

$(document).on('keydown', '#teamModal[role="button"], .js-draft-opponent-picker[role="button"]', function (event) {
    if (event.target !== this) return;
    if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); $(this).trigger('click'); }
});

$(document).on('click', '#teamModal, .js-draft-opponent-picker', function (event) {
    if ($(event.target).closest('.remove_TeamInOrganizerBtn, .deleteInOrganizerMatchRequest, .deleteTeamJoinMatchRequestMessage').length) return;
    event.preventDefault(); event.stopPropagation();
    openDraftTeamPicker(Number($(this).data('match')), $(this).hasClass('js-draft-opponent-picker') ? 'opponent' : 'home');
});

async function openDraftTeamPicker(matchId, side = 'home') {
    const modal = createModal({ title: side === 'opponent' ? 'Rakip ve maç düzenini seç' : 'Ev sahibi takımını seç', modalClass: 'match-host-modal' });
    try {
        const response = await Request({ url: '/Match/_changeMatchTeam', type: 'POST', data: { matchId, side }, cacheable: false });
        modal.updateContent(response);
        const picker = $('.match-host-picker').last();
        picker.on('click', '.match-host-option', async function () {
            const button = $(this);
            if (button.prop('disabled') || button.attr('aria-pressed') === 'true' || picker.data('busy')) return;
            if (button.data('action') === 'choose-home') { modal.close(); await openDraftTeamPicker(matchId); return; }
            const available = picker.find('button:enabled');
            picker.data('busy', true); available.prop('disabled', true);
            picker.find('[role="alert"]').prop('hidden', true);
            try {
                await Request({ url: '/Reservation/UpdateTeam', type: 'POST', data: { id: matchId, teamId: Number(button.data('team-id')) } });
                modal.close(); updateAfterMatchArea(matchId);
            } catch (error) {
                picker.find('[role="alert"]').text(error.responseText || 'Takım seçimi kaydedilemedi. Tekrar deneyin.').prop('hidden', false);
            } finally { picker.data('busy', false); available.prop('disabled', false); }
        });
    } catch (error) { modal.updateContent('<p class="fs-08 draft-manager__error" role="alert"></p>'); $('.match-host-modal [role="alert"]').last().text(error.responseText || 'Seçenekler yüklenemedi. Lütfen tekrar aç.'); }
}

let activeDraftMatchManager = null;
$(document).on('click', '.js-draft-match-manager', async function () {
    if (activeDraftMatchManager) return;
    const state = { matchId: Number($(this).data('match')), section: $(this).data('section'), version: 0 };
    state.modal = createModal({ title: state.section === 'roster' ? 'Kadroyu Yönet' : 'Oyuncu İlanlarını Yönet', modalClass: 'draft-manager-modal',
        onClose: () => { state.rosterResizeObserver?.disconnect(); if (activeDraftMatchManager === state) activeDraftMatchManager = null; } });
    activeDraftMatchManager = state;
    await refreshDraftMatchManager();
});

async function refreshDraftMatchManager(options = {}) {
    const state = activeDraftMatchManager;
    if (!state) return;
    const version = ++state.version;
    const body = $('.draft-manager-modal .custom-modal-body').last();
    try {
        const html = await Request({ url: '/Match/_DraftMatchManager', type: 'POST', data: { matchId: state.matchId, section: state.section }, cacheable: false });
        if (activeDraftMatchManager !== state || state.version !== version) return;
        const scroll = body.scrollTop();
        const focused = document.activeElement;
        const focusId = body[0]?.contains(focused) ? focused.id : null;
        const focusedValue = focusId ? focused.value : null;
        state.rosterResizeObserver?.disconnect();
        state.modal.updateContent(html);
        if (state.section === 'roster') activateDraftRosterTeam(body, state.activeRosterTeam);
        body.scrollTop(scroll);
        if (focusId) {
            const input = document.getElementById(focusId);
            if (input && body[0]?.contains(input)) { if (options.preserveValues !== false) input.value = focusedValue; input.focus({ preventScroll: true }); }
        }
    } catch (error) {
        if (activeDraftMatchManager !== state || state.version !== version) return;
        if (!body.find('[data-draft-manager]').length) {
            state.modal.updateContent('<p class="fs-08 draft-manager__error" role="alert"></p><button type="button" class="fs-08 btn js-draft-manager-retry">Tekrar dene</button>');
            body.find('.draft-manager__error').text(error.responseText || 'İçerik yüklenemedi. Tekrar dene.');
        } else {
            body.find('.draft-manager__error').remove();
            $('<p class="fs-08 draft-manager__error" role="alert"></p>').text(error.responseText || 'İçerik yenilenemedi. Lütfen tekrar dene.').prependTo(body);
        }
    }
}
$(document).on('click', '.js-draft-manager-retry', refreshDraftMatchManager);

function activateDraftRosterTeam(root, teamId) {
    const tabs = root.find('.js-draft-roster-tab');
    if (!tabs.length) return;
    const selected = tabs.filter(function () { return Number($(this).data('roster-team')) === Number(teamId); }).first();
    const activeTeam = Number((selected.length ? selected : tabs.first()).data('roster-team'));
    tabs.each(function () {
        const active = Number($(this).data('roster-team')) === activeTeam;
        $(this).attr('aria-selected', String(active)).attr('tabindex', active ? 0 : -1);
    });
    root.find('.draft-roster[role="tabpanel"]').each(function () { this.hidden = Number($(this).data('roster-team')) !== activeTeam; });
    if (activeDraftMatchManager?.section === 'roster') activeDraftMatchManager.activeRosterTeam = activeTeam;
}

$(document).on('click', '.js-draft-roster-tab', async function () {
    if ($(this).attr('aria-selected') === 'true') return;
    const root = $(this).closest('[data-draft-manager="roster"]');
    activateDraftRosterTeam(root, $(this).data('roster-team'));
    $(this).closest('.custom-modal-body').scrollTop(0);
    await StaffEditorAreaEach();
});

$(document).on('keydown', '.js-draft-roster-tab', function (event) {
    const tabs = $(this).closest('[role="tablist"]').find('.js-draft-roster-tab');
    const index = tabs.index(this);
    const next = event.key === 'ArrowRight' ? (index + 1) % tabs.length
        : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length
        : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : -1;
    if (next < 0) return;
    event.preventDefault(); tabs.eq(next).trigger('focus').trigger('click');
});

function fitDraftRosterFields(element) {
    const state = activeDraftMatchManager;
    if (state?.section !== 'roster' || !element.closest('[data-draft-manager="roster"]').length) return;
    const fit = card => {
        const field = card.querySelector('.field');
        if (field && card.clientWidth > 0) field.style.zoom = String(Math.min(1, card.clientWidth / 375));
    };
    state.rosterResizeObserver ??= new ResizeObserver(entries => entries.forEach(entry => fit(entry.target)));
    element.find('.field-card').each(function () { fit(this); state.rosterResizeObserver.observe(this); });
}


// Tıklandığında slide toggle ve ikon değişimi
$(document).on('click', '.week-header', function (e) {
    e.preventDefault();

    var $hdr = $(this);
    var $group = $hdr.closest('.week-group');
    var $content = $group.find('.week-content').first();

    // d-none varsa önce kaldır
    if ($content.hasClass('d-none')) {
        $content.removeClass('d-none').hide().slideDown(200);
    } else {
        $content.slideUp(200, function () {
            $content.addClass('d-none');
        });
    }

    // ikon toggle (fa-chevron-down <-> fa-chevron-up)
    var $icon = $hdr.find('.toggle-icon');
    if ($icon.hasClass('fa-chevron-down')) {
        $icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
    } else {
        $icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
    }
});


function loadMatchShareArea() {

    var element = $('#_MatchShareArea');
    var matchId = element.data('match');

    if (element.length > 0) {

        InitLoadScreenElement(element);

        Request({
            url: '/Match/_MatchShareArea',
            type: 'POST',
            data: {
                matchId: matchId
            },
            target: '#_MatchShareArea',
            success: function (response) {

            }
        });
    }
}


$(document).on("click", ".sociall", function () {

    var element = $(this);

    try {
        window.location = element.data('command');

        setTimeout(function () {

            var endTime = new Date().getTime();
        }, 1000);
    } catch (error) {

        console.log("sociall: ", error.responseText);
    }
});

$(document).on("click", ".open-map", function (e) {
    e.preventDefault();
    var url = $(this).data("url");

    if (url) {

        window.location.href = url;
    } else {
        alert("Geçerli bir konum bilgisi bulunamadı!");
    }
});


$(document).on("click", ".quickLoginModal", async function (e) {
    e.preventDefault();

    await quickLoginModal();
});

$(document).on("click", ".memberNewSubscribeBtn", async function (e) {
    e.preventDefault();
    e.stopPropagation();

    var companyId = Number($(this).data("company-id")) || 0;
    var memberId = await getCurrentUserId();

    if (memberId <= 0) {
        await quickLoginModal();
        return;
    }

    var subscriptionUrl = companyId > 0
        ? `/Abonelik-Olustur?companyId=${encodeURIComponent(companyId)}`
        : "/Abonelik-Olustur";
    await pageLink(subscriptionUrl);
});

async function quickLoginModal() {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                Logged();
            }
            else {

                NotLogged();

                const modal = createModal({
                    title: 'Giriş yaparak devam edebilirsiniz',
                    closable: false
                });

                Request({
                    url: '/Giris',
                    type: 'GET',
                    data: {
                        pageLink: true,
                        modal: true
                    },
                    success: function (response) {

                        modal.updateContent(response);
                    },
                    error: function () {
                        console.error('Tema modu sunucuya gönderilemedi.');
                    }
                });
            }
        });
}



$(document).on("click", ".toggle-dark-mode", function () {

    var element = $(this)
    var mode = element.data('mode');

    Request({
        url: '/Member/SetThemeMode',
        type: 'POST',
        data: { mode: mode },
        success: function () {

            CheckThemeMode(mode);
        },
        error: function () {
            console.error('Tema modu sunucuya gönderilemedi.');
        }
    });
});



$(document).on("change", ".nxc5", function () {
    nxc5();
});
function nxc5() {
    // Keep registration actions clickable so missing fields can be explained.
    if (document.querySelector('.member-register-wizard')) {
        $('#nxc5').addClass('nextStepBtn').removeClass('disabled text-muted');
        return;
    }
    var permission = true;

    $('.nxc5').each(function () {
        if ($(this).is(':checkbox')) {
            if (!$(this).is(':checked')) {
                permission = false;
                return false;
            }
            return;
        }

        var val = $(this).val();
        if (val === "" || val === "0" || val === null || val === undefined) {
            permission = false;
            return false;
        }
    });

    var element = $('#nxc5');

    if (permission) {

        element.addClass("nextStepBtn");
        element.removeClass("text-muted");
        element.removeClass("disabled");
    }
    else {

        element.removeClass("nextStepBtn");
        element.addClass("text-muted");
        element.addClass("disabled");
    }
}


$(document).on("click", ".loadMemberPositionSelectorAreaBtn", function () {

    loadMemberPositionSelectorArea();
});


async function loadMemberPositionSelectorArea() {

    var areas = $('._MemberPositionSelectorArea');

    areas.each(function () {

        var area = $(this);
        var memberId = area.data('member');
        InitLoadScreenElement(area);

        Request({
            url: '/Member/_MemberPositionSelectorArea',
            type: 'POST',
            data: {
                memberId: memberId
            },
            success: function (response) {

                area.html(response);
            },
            error: function (error) {

                ShowErrorAlert(error.responseText);
            }
        });

    });
}

$(document).on("click", ".position-area", function () {

    var element = $(this);

    var permission = element.data('permission');
    if (permission === 'False')
        return;

    if (element.hasClass('is-selected'))
        element.removeClass("is-selected");

    else
        element.addClass("is-selected");

    var positionIds = $('.position-area.is-selected').map(function () {
        return $(this).data('position-id');
    }).get();

    Request({
        url: '/Member/UpdateMemberPositionRelations',
        type: 'POST',
        data: {
            positionIds: positionIds
        },
        success: function (response) {

            if (response.count > 0) {
                $('#nxc').removeClass("text-muted").addClass("nextStepBtn");
            }
            else {
                $('#nxc').addClass("text-muted").removeClass("nextStepBtn");
            }
        },
        error: function (error) {

            ShowErrorAlert(error.responseText);
        }
    });
});





$(document).on("click", ".FirstSaveFirstMemberTypeId", function () {

    var element = $(this);
    FirstSaveFirstMemberTypeId = element.data('id');
    $(".FirstSaveFirstMemberTypeId").removeClass("checked ultra-shadowed").addClass("shadow-none");
    $(".FirstSaveFirstMemberTypeId .member-type-check").remove();

    element.removeClass("shadow-none").addClass("checked ultra-shadowed");
    element.find('.member-type-image-wrapper').prepend(
        '<span class="member-type-check fs-08"><i class="fa-solid fa-check"></i></span>');

    $('#MemberTypeId').val(FirstSaveFirstMemberTypeId);

    UpdateFirstSaveStepsBar();
    GetDynamicStepListForMemberTypeId();
});

$(document).on("click", ".select-card", function () {

    var element = $(this);

    var memberId = $('#MemberId').val();
    var value = element.data('id');

    Request({
        url: '/Member/UpdateFirstSaveProp',
        type: 'POST',
        data: {
            memberId: memberId,
            value: value
        },
        success: function () {

            $(".select-card").removeClass("checked ultra-shadowed").addClass("shadow-none");
            $(".select-card .member-type-check").remove();
            element.removeClass("shadow-none").addClass("checked ultra-shadowed");
            element.find('.member-type-image-wrapper').prepend(
                '<span class="member-type-check fs-08"><i class="fa-solid fa-check"></i></span>');

            $('#MemberTypeId').val(value);

            UpdateFirstSaveStepsBar();
            GetDynamicStepListForMemberTypeId();
        },
        error: function (error) {

            console.error('select-card():', error.responseText);
        }
    });
});









async function backItems() {

    var backText = $('.current-page.pageLink').text() ?? 'Geri';
    var pageTitle = $('#pageheadLabel').text() ?? '';

    $('.headerText').text(pageTitle);
    $('#headerText').text(pageTitle);

    backText = backText.length > 10 ? 'Geri' : backText;
    $('#backText').text('Geri');
    $('.backText').text('Geri');

    document.getElementById('mobileLiveBtnArea').classList.add('d-none');
    $('#backArea').removeClass('d-none');
    $('.backArea').removeClass('d-none');

    if (currentUrl === '/Anasayfa' || currentUrl === '/Giris') {
        document.getElementById('mobileLiveBtnArea').classList.remove('d-none');
        $('#backArea').addClass('d-none');
        $('.backArea').addClass('d-none');
        $('.homeItem').addClass('d-none');
        $('.backItem').addClass('d-none');
    }
    else {
        $('.homeItem').addClass('d-none');
        $('.backItem').removeClass('d-none');
    }
}


async function loadPartialAreas() {
    var partialAreas = $('._PartialArea');
    var requests = [];

    if (partialAreas.length > 0) {
        partialAreas.each(function () {
            var url = $(this).data('url');
            var id = '#' + $(this).attr('id');

            if (url && !$(this).data('partialLoadStarted')) {
                const element = $(this);
                element.data('partialLoadStarted', true);
                var request = Request({
                    url: url,
                    type: 'GET',
                    target: id
                }).catch((error) => {
                    element.removeData('partialLoadStarted');
                    console.log("loadPartialAreas: " + id);
                });

                requests.push(request);
            }
        });

        await Promise.all(requests);

        LoadRelationName();
        relationBuilder();
        LoadRelationImg();
        addPhoneMask();
    }
}


async function sliderGalleryBuilder(root = document) {
    // Varsayılan süreler (ms)
    const DEFAULT_SLIDE_INTERVAL_MS = 3000;
    const RESUME_AFTER_MS = 5000;
    const DRAG_THRESHOLD_PX = 50;

    // Her çağrıldığında tüm slider'lar için yeniden kurulum yapıyoruz.
    $(root).find('.slider-container').add($(root).filter('.slider-container')).each(function (idx) {
        const $slider = $(this);
        const itemCount = $slider.find('.slider-item').length;
        if ($slider.data('sliderItemCount') === itemCount && $slider.data('sliderInstanceId')) return;
        $slider.data('sliderItemCount', itemCount);

        // Benzersiz instance id'si (eğer daha önce oluşturulmuşsa aynı id'yi kullan)
        const existingId = $slider.data('sliderInstanceId');
        const instanceId = existingId || `slider-instance-${Date.now()}-${idx}`;
        $slider.data('sliderInstanceId', instanceId);

        // Temizlik: önceki event/interval/timeout'ları temizle
        //  - jQuery namespaced event'leri ve document üzerindeki namespaced event'leri kaldır
        $slider.off('.' + instanceId);
        $slider.find('.dots').off('.' + instanceId);
        $(document).off('.' + instanceId);

        // Önceki zamanlayıcıları temizle
        const prevInterval = $slider.data('autoSlideInterval');
        if (prevInterval) {
            clearInterval(prevInterval);
            $slider.removeData('autoSlideInterval');
        }
        const prevResume = $slider.data('autoSlideResume');
        if (prevResume) {
            clearTimeout(prevResume);
            $slider.removeData('autoSlideResume');
        }

        // Element referansları (korunan class/id'ler burada bozulmadı)
        const $sliderTrack = $slider.find('.slider-track');
        const $sliderItems = $slider.find('.slider-item');
        const $dotsContainer = $slider.find('.dots');

        if (!$sliderTrack.length || !$sliderItems.length || !$dotsContainer.length) {
            // Gerekli yapı yoksa atla
            return;
        }

        // Dots'ları yeniden oluştur (önce var olanları temizle)
        $dotsContainer.empty();
        $sliderItems.each(function (i) {
            const $dot = $('<div>')
                .addClass('dot')
                .attr('data-index', i);
            if (i === 0) $dot.addClass('active');
            $dotsContainer.append($dot);
        });

        // Slider durumu (her slider için bağımsız)
        let currentIndex = 0;
        let isDragging = false;
        let startX = 0;
        let autoSlideInterval = null;
        let resumeTimeout = null;

        // Süreleri slider üzerinden override edilebilir (HTML'de data-slide-duration ile)
        const slideIntervalMs = parseInt($slider.data('slideDuration'), 10) || DEFAULT_SLIDE_INTERVAL_MS;
        const resumeAfterMs = parseInt($slider.data('resumeAfter'), 10) || RESUME_AFTER_MS;

        // Helper'lar
        const updateDots = () => {
            $dotsContainer.find('.dot').removeClass('active');
            $dotsContainer.find(`.dot[data-index="${currentIndex}"]`).addClass('active');
        };

        const slideTo = (index) => {
            if (index < 0) index = 0;
            if (index >= $sliderItems.length) index = $sliderItems.length - 1;
            // Varsayım: her .slider-item %100 genişliğinde, bu yüzden % çarpımı kullanılıyor
            $sliderTrack.css('transform', `translateX(-${index * 100}%)`);
            currentIndex = index;
            updateDots();
        };

        const stopAuto = () => {
            const t = $slider.data('autoSlideInterval');
            if (t) {
                clearInterval(t);
                $slider.removeData('autoSlideInterval');
            }
            if (autoSlideInterval) {
                clearInterval(autoSlideInterval);
                autoSlideInterval = null;
            }
        };

        const startAuto = () => {
            stopAuto();
            autoSlideInterval = setInterval(() => {
                if (!$slider[0].isConnected) { stopAuto(); return; }
                if (document.hidden || $slider.closest('.sheed-modal-suspended').length) return;
                let next = currentIndex + 1;
                if (next >= $sliderItems.length) next = 0;
                slideTo(next);
            }, slideIntervalMs);
            $slider.data('autoSlideInterval', autoSlideInterval);
        };

        // Başlat
        slideTo(0);
        startAuto();
        window.sahaseninExperience?.own($slider[0], () => {
            stopAuto(); clearTimeout($slider.data('autoSlideResume'));
            $slider.off('.' + instanceId); $slider.find('.dots').off('.' + instanceId);
            $(document).off('.' + instanceId);
        });

        // Drag / touch handling
        const pointerStart = (e) => {
            // Dokunmatikten geliyorsa touches[0], değilse pageX
            const original = e.originalEvent || e;
            startX = original.touches ? original.touches[0].pageX : (original.pageX || e.pageX);
            isDragging = true;

            // Bu slider'ın otomatik kaydırmasını durdur
            stopAuto();
            if (resumeTimeout) {
                clearTimeout(resumeTimeout);
                resumeTimeout = null;
                $slider.removeData('autoSlideResume');
            }
        };

        const pointerMove = (e) => {
            if (!isDragging) return;
            // Burada istersen görsel bir takip (drag preview) ekleyebilirsin.
            // Mevcut hedef: sadece kaydırma işlemini algılamak, bu yüzden preventDefault yapmıyoruz
        };

        const pointerEnd = (e) => {
            if (!isDragging) return;
            const original = e.originalEvent || e;
            const endX = original.changedTouches ? original.changedTouches[0].pageX : (original.pageX || e.pageX);
            const delta = startX - endX;

            if (delta > DRAG_THRESHOLD_PX && currentIndex < $sliderItems.length - 1) {
                slideTo(currentIndex + 1);
            } else if (delta < -DRAG_THRESHOLD_PX && currentIndex > 0) {
                slideTo(currentIndex - 1);
            }
            isDragging = false;

            // Etkileşim bittikten sonra otomatik kaydırmayı yeniden başlat (sadece bu slider için)
            if (resumeTimeout) clearTimeout(resumeTimeout);
            resumeTimeout = setTimeout(() => {
                startAuto();
                $slider.removeData('autoSlideResume');
                resumeTimeout = null;
            }, resumeAfterMs);
            $slider.data('autoSlideResume', resumeTimeout);
        };

        // Event binding (namespaced ile bind ediyoruz ki cleanup kolay olsun)
        $slider.on('mousedown.' + instanceId + ' touchstart.' + instanceId, pointerStart);
        $(document).on('mousemove.' + instanceId + ' touchmove.' + instanceId, pointerMove);
        $(document).on('mouseup.' + instanceId + ' touchend.' + instanceId, pointerEnd);

        // Dots click - sadece ilgili slider'ın dots container'ına bağlanmış durumda
        $dotsContainer.on('click.' + instanceId, '.dot', function (ev) {
            ev.stopPropagation();
            ev.preventDefault();
            const idx = $(this).data('index');
            slideTo(parseInt(idx, 10) || 0);

            // Noktaya tıklama da otomatik kaydırmayı durdurup belli süre sonra yeniden başlatır
            stopAuto();
            if (resumeTimeout) clearTimeout(resumeTimeout);
            resumeTimeout = setTimeout(() => {
                startAuto();
                $slider.removeData('autoSlideResume');
                resumeTimeout = null;
            }, resumeAfterMs);
            $slider.data('autoSlideResume', resumeTimeout);
        });

        // Son olarak instance referanslarını data'ya kaydet (temizlik için)
        $slider.data('autoSlideInterval', autoSlideInterval);
        $slider.data('autoSlideInstanceId', instanceId);
    });
}


window.addEventListener('load', function () {

    var body = document.body;
    var html = document.documentElement;
    var navbar = document.querySelector('.navbar');

    function getScrollTop() {
        // Body scroll veya html scroll — hangisi değişiyorsa onu al
        return body.scrollTop || html.scrollTop || 0;
    }

    function onScroll() {
        var scrollTop = getScrollTop();

        if (scrollTop > 10) {
            navbar.classList.add('navbar--static');
        } else {
            navbar.classList.remove('navbar--static');
        }

        // console.log(scrollTop);
    }

    // Body scroll'u dinle
    body.addEventListener('scroll', onScroll, { passive: true });

    // HTML scroll ihtimali için yedek
    html.addEventListener('scroll', onScroll, { passive: true });

    // İlk kontrol (sayfa ortasından açılırsa)
    onScroll();
});









function findInRenderTarget(target, selector) {
    var root = target ? $(target) : $(document);
    return root.filter(selector).add(root.find(selector));
}

function draggableCardBuilder(target) {

    var containers = findInRenderTarget(target, '.card-container');

    if (containers.length > 0) {
        containers.each(function () {
            var $cardContainer = $(this);
            if ($cardContainer.hasClass('initComplete')) return;
            $cardContainer.addClass('initComplete');

            var isDragging = false,
                startX, startY,
                scrollLeft,
                lastX, lastTime,
                velocity = 0,
                isHorizontalScroll = false,
                isVerticalScroll = false,
                momentumAnimationId = null;

            // Mevcut momentum animasyonunu durdurmak için
            function stopMomentum() {
                if (momentumAnimationId) {
                    cancelAnimationFrame(momentumAnimationId);
                    momentumAnimationId = null;
                }
            }

            // Card-container içerisindeki card'a tıklanırsa, momentum durdurulsun
            $cardContainer.on('click', '.card', function () {
                stopMomentum();
            });

            // Ortak fare hareket fonksiyonu
            function onMouseMove(e) {
                if (!isDragging) return;
                var x = e.pageX - $cardContainer.offset().left,
                    y = e.pageY - $cardContainer.offset().top;

                var walkX = Math.abs(x - startX),
                    walkY = Math.abs(y - startY);

                if (!isHorizontalScroll && walkX > walkY) {
                    isHorizontalScroll = true;
                }
                if (!isVerticalScroll && walkY > walkX) {
                    isVerticalScroll = true;
                }

                if (isHorizontalScroll) {
                    $cardContainer.scrollLeft(scrollLeft - (x - startX));
                }
                // Yatay kaydırma yapılıyorsa bile, isteğe bağlı olarak sayfa kaymasını engelleyebiliriz
                if (isVerticalScroll) {
                    e.preventDefault();
                }

                var now = Date.now();
                var timeDiff = now - lastTime;
                var distanceDiff = e.pageX - lastX;
                velocity = distanceDiff / timeDiff;
                lastX = e.pageX;
                lastTime = now;
            }

            function onMouseUp() {
                if (!isDragging) return;
                isDragging = false;
                $cardContainer.css('cursor', 'grab');
                $(document).off('mousemove', onMouseMove);
                $(document).off('mouseup', onMouseUp);
                applyMomentumScroll();
            }

            // Ortak dokunmatik hareket fonksiyonu
            function onTouchMove(e) {
                if (!isDragging) return;
                // Card-container üzerinde kaydırma yapıldığında sayfa kaymasını engelle
                e.preventDefault();
                var touch = e.touches[0];
                var x = touch.pageX - $cardContainer.offset().left,
                    y = touch.pageY - $cardContainer.offset().top;

                var walkX = Math.abs(x - startX),
                    walkY = Math.abs(y - startY);

                if (!isHorizontalScroll && walkX > walkY) {
                    isHorizontalScroll = true;
                }
                if (!isVerticalScroll && walkY > walkX) {
                    isVerticalScroll = true;
                }

                if (isHorizontalScroll) {
                    $cardContainer.scrollLeft(scrollLeft - (x - startX));
                }

                var now = Date.now();
                var timeDiff = now - lastTime;
                var distanceDiff = x - lastX;
                velocity = distanceDiff / timeDiff;
                lastX = x;
                lastTime = now;
            }

            function onTouchEnd() {
                if (!isDragging) return;
                isDragging = false;
                $cardContainer.css('cursor', 'grab');
                document.removeEventListener('touchmove', onTouchMove, { passive: false });
                document.removeEventListener('touchend', onTouchEnd);
                applyMomentumScroll();
            }

            // Momentum kaydırma fonksiyonu (yumuşak ve kesintisiz)
            function applyMomentumScroll() {
                if (Math.abs(velocity) > 0) {
                    var momentum = velocity * 10; // Momentum başlangıç katsayısı
                    var lastTimestamp = null;

                    function scrollStep(timestamp) {
                        if (lastTimestamp === null) {
                            lastTimestamp = timestamp;
                        }
                        var timeElapsed = timestamp - lastTimestamp;
                        lastTimestamp = timestamp;

                        if (Math.abs(momentum) < 0.1) {
                            momentumAnimationId = null;
                            return;
                        }

                        $cardContainer.scrollLeft($cardContainer.scrollLeft() - momentum);
                        momentum *= 0.95; // Yavaşlama oranı

                        momentumAnimationId = requestAnimationFrame(scrollStep);
                    }
                    momentumAnimationId = requestAnimationFrame(scrollStep);
                }
            }

            // Başlatma - Fare
            $cardContainer.on('mousedown', function (e) {
                stopMomentum(); // Olası mevcut momentum animasyonunu durdur
                isDragging = true;
                startX = e.pageX - $cardContainer.offset().left;
                startY = e.pageY - $cardContainer.offset().top;
                scrollLeft = $cardContainer.scrollLeft();
                lastX = e.pageX;
                lastTime = Date.now();
                $cardContainer.css('cursor', 'grabbing');
                isHorizontalScroll = false;
                isVerticalScroll = false;
                $(document).on('mousemove', onMouseMove);
                $(document).on('mouseup', onMouseUp);
            });

            // Başlatma - Dokunmatik
            $cardContainer.on('touchstart', function (e) {
                stopMomentum();
                isDragging = true;
                var touch = e.touches[0];
                startX = touch.pageX - $cardContainer.offset().left;
                startY = touch.pageY - $cardContainer.offset().top;
                scrollLeft = $cardContainer.scrollLeft();
                lastX = touch.pageX;
                lastTime = Date.now();
                $cardContainer.css('cursor', 'grabbing');
                isHorizontalScroll = false;
                isVerticalScroll = false;
                document.addEventListener('touchmove', onTouchMove, { passive: false });
                document.addEventListener('touchend', onTouchEnd);
            });
        });
    }
}

function centerActiveCard(animationDuration = 300) {

    // Sayfadaki tüm card-container'ları döngüye al
    $('.card-container').each(function () {
        var $container = $(this);
        var $activeCard = $container.find('.card.activeCard');

        // Eğer bu container içinde '.active' sınıfına sahip bir kart yoksa işlemi atla
        if ($activeCard.length === 0) return;

        // Container ve aktif kartın genişliklerini al
        var containerWidth = $container.outerWidth();
        var cardWidth = $activeCard.outerWidth();

        // Elemanların sayfadaki mutlak (X ekseni) konumlarını al
        var containerLeft = $container.offset().left;
        var cardLeft = $activeCard.offset().left;

        // Kartın merkezini, container'ın merkezine hizalamak için gereken sapma miktarını hesapla
        var shiftAmount = (cardLeft + (cardWidth / 2)) - (containerLeft + (containerWidth / 2));

        // Hedef scroll pozisyonu: Mevcut scroll değeri + gereken kaydırma miktarı
        var targetScroll = $container.scrollLeft() + shiftAmount;

        // Hesaplanan hedefe jQuery ile yumuşak (smooth) bir şekilde kaydır
        $container.animate({
            scrollLeft: targetScroll
        }, animationDuration);
    });
}








// URL'den koordinatları almak için fonksiyon
function getCoordinatesFromURL(url, callback) {
    // Eğer URL 'ftid' içeriyorsa
    if (url.includes("ftid=")) {
        const placeId = url.split("ftid=")[1].split("&")[0]; // 'ftid' değerini çıkar
        const apiUrl = `/getCoordinates?placeId=${placeId}`; // Backend proxy'sine istek

        // API'ye istek yapıyoruz
        fetch(apiUrl)
            .then((response) => response.json())
            .then((data) => {
                if (data.result && data.result.geometry) {
                    const lat = data.result.geometry.location.lat;
                    const lng = data.result.geometry.location.lng;
                    callback({ lat, lng }); // Koordinatları döndür
                } else {
                    alert("Mekan bilgisi alınamadı.");
                }
            })
            .catch((error) => {
                console.error("API hatası:", error.responseText);
                alert("API hatası oluştu.");
            });
    } else {
        // URL koordinat içeriyorsa (örneğin: q=37.7749,-122.4194)
        const regex = /[?&]q=([^&?]+)/;
        const match = url.match(regex);

        if (match && match.length === 2) {
            const coords = match[1].split(",");
            const lat = parseFloat(coords[0]);
            const lng = parseFloat(coords[1]);
            callback({ lat, lng });
        } else {
            alert("Geçerli koordinatlar bulunamadı.");
        }
    }
}



$(document).on('change', '#PlayerTypeEnum', function (e) {

    var element = $(this);
    var value = element.val();
    var numericValue = Number(value);
    var target = $('#PlayerTypeDiv');

    element.toggleClass('is-invalid', !Number.isFinite(numericValue) || numericValue <= 0);

    if (target.length > 0) {

        var inputs = $('.PlayerTypeDivInput');

        if (numericValue !== 2) {

            target.addClass('d-none');
            inputs.removeClass('nxc5 is-invalid');
            $('.paidServiceAgreementAccepted').removeClass('nxc5 is-invalid');

            editableMemberProp('PlayerTypeEnum', value);
        }
        else {

            target.removeClass('d-none');
            inputs.each(function () {
                $(this).toggleClass('nxc5', this.dataset.registrationRequired !== 'false');
            });
            $('.paidServiceAgreementAccepted').addClass('nxc5');
            inputs.each(function () {
                var input = $(this);
                var inputValue = input.val();
                input.toggleClass(
                    'is-invalid',
                    input.hasClass('nxc5') && (inputValue === '' || inputValue === null || Number(inputValue) <= 0));
            });
            $('.paidServiceAgreementAccepted').toggleClass(
                'is-invalid',
                !$('.paidServiceAgreementAccepted').is(':checked'));
        }

        nxc5();
    }
});

$(document).on('change', '.paidServiceAgreementAccepted', function () {
    const checkbox = $(this);
    const accepted = checkbox.is(':checked');
    const registration = !!document.querySelector('.member-register-wizard');
    checkbox.toggleClass('is-invalid', !accepted);
    const save = () => Request({ url: '/Member/AcceptPaidServiceAgreement', type: 'POST',
        data: { documentId: checkbox.data('document-id'), accepted } });
    const request = registration ? registrationFieldSaveQueue.then(save) : save();
    const result = request.then(response => {
        registrationFieldSaveErrors.delete('PaidServiceAgreement');
        registrationFieldSaveRetries.delete('PaidServiceAgreement');
        if (response?.message) ShowSuccessAlert(response.message);
        nxc5();
        return true;
    }).catch(error => {
        if (registration) {
            registrationFieldSaveErrors.add('PaidServiceAgreement');
            registrationFieldSaveRetries.set('PaidServiceAgreement', () => {
                checkbox.prop('checked', accepted).trigger('change');
                return registrationFieldSaveQueue;
            });
        }
        checkbox.prop('checked', !accepted);
        ShowErrorAlert(error.responseText);
        nxc5();
        return false;
    });
    if (registration) registrationFieldSaveQueue = result;
});

$(document).on(
    'input change',
    '.member-register-content input.required, .member-register-content input.nxc5, .member-register-content select.required, .member-register-content select.nxc5',
    function () {
        var field = $(this);
        if (field.is(':checkbox')) {
            field.toggleClass('is-invalid', !field.is(':checked'));
        } else {
            var value = (field.val() ?? '').toString().trim();
            field.toggleClass('is-invalid', value === '' || value === '0');
        }
        updateSubmitButtonState();
    });

var paidServiceAgreementModalState = null;

function getRequestErrorPayload(error) {
    if (error && error.responseJSON)
        return error.responseJSON;

    var responseText = error && error.responseText;
    if (!responseText)
        return {};

    try {
        return JSON.parse(responseText);
    } catch (_) {
        return { message: responseText };
    }
}

function isPaidServiceAgreementRequiredError(error) {
    var payload = getRequestErrorPayload(error);
    return payload.agreementRequired === true ||
        payload.code === 'PAID_SERVICE_AGREEMENT_REQUIRED';
}

function isPaidServiceIbanRequiredError(error) {
    var payload = getRequestErrorPayload(error);
    return payload.ibanRequired === true ||
        payload.code === 'PAID_SERVICE_IBAN_REQUIRED';
}

function showPaidServiceIbanRequirement(error) {
    var payload = getRequestErrorPayload(error);
    var canAddIban = payload.ibanOwnerIsCurrentUser !== false;
    Swal.fire({
        title: 'IBAN bilgisi gerekli',
        text: getRequestErrorMessage(error),
        icon: 'info',
        showCancelButton: canAddIban,
        confirmButtonText: canAddIban ? 'IBAN Ekle' : 'Tamam',
        cancelButtonText: 'Daha sonra'
    }).then(function (answer) {
        if (!answer.isConfirmed || !canAddIban) return;
        if (typeof pageLink === 'function')
            pageLink('/Hesaplarim');
        else
            window.location.href = '/Hesaplarim';
    });
}

function getRequestErrorMessage(error) {
    var payload = getRequestErrorPayload(error);
    return payload.message || (error && error.responseText) || 'Beklenmedik bir hata oluştu.';
}

async function openPaidServiceAgreementModal(onAccepted) {
    var modal = createModal({
        title: 'Ücretli Hizmet Sözleşmesi',
        inner: true
    });

    paidServiceAgreementModalState = {
        modal: modal,
        onAccepted: typeof onAccepted === 'function' ? onAccepted : null
    };

    try {
        var response = await Request({
            url: '/Member/_PaidServiceAgreement',
            type: 'POST',
            cacheable: false
        });
        modal.updateContent(response);
    } catch (error) {
        modal.updateContent(
            `<div class="alert alert-danger m-2 fs-07">${getRequestErrorMessage(error)}</div>`
        );
    }
}

$(document).on('click', '.openPaidServiceAgreementModal', function () {
    openPaidServiceAgreementModal(function () {
        if (typeof window.quickActionModal === 'function')
            window.quickActionModal();
    });
});

$(document).on('change', '.paidServiceAgreementModalAccepted', function () {
    var checkbox = $(this);
    checkbox
        .closest('.card-body')
        .find('.acceptPaidServiceAgreementBtn')
        .prop('disabled', !checkbox.is(':checked'));
});

$(document).on('click', '.acceptPaidServiceAgreementBtn', function () {
    var button = $(this);
    var checkbox = button
        .closest('.card-body')
        .find('.paidServiceAgreementModalAccepted');

    if (!checkbox.is(':checked'))
        return;

    button.prop('disabled', true);

    Request({
        url: '/Member/AcceptPaidServiceAgreement',
        type: 'POST',
        data: {
            documentId: button.data('document-id'),
            accepted: true
        }
    }).then(function (response) {
        var state = paidServiceAgreementModalState;
        paidServiceAgreementModalState = null;

        if (state && state.modal)
            state.modal.close();

        if (typeof syncQuickActionBtn === 'function')
            syncQuickActionBtn();

        if (response && response.message)
            ShowSuccessAlert(response.message);

        if (state && state.onAccepted)
            window.setTimeout(state.onAccepted, 300);
    }).catch(function (error) {
        button.prop('disabled', false);
        ShowErrorAlert(getRequestErrorMessage(error));
    });
});

$(document).on('click', '.DocumentArea', function (e) {

    if ($(e.target).closest('.openDescription').length) {
        return;
    }

    const area = $(this);
    const hiddenInput = area.find('.hiddenInput');
    const icon = area.find('.checkIcon i');

    const isChecked = hiddenInput.val() === 'True';
    const nextValue = !isChecked;

    hiddenInput.val(nextValue ? 'True' : 'False');

    area.toggleClass('active', nextValue);

    icon.removeClass(
        'fa-square fa-square-check fa-regular fa-solid text-secondary text-success'
    );

    if (nextValue) {
        icon.addClass('fa-solid fa-square-check text-success');
    } else {
        icon.addClass('fa-regular fa-square text-secondary');
    }

    // Validation
    if (hiddenInput.hasClass('required')) {
        hiddenInput.toggleClass('is-invalid', !nextValue);
    }

    updateSubmitButtonState();
});

$(document).on('click', '.openDescription', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const element = $(this);
    if (element.closest('.DocumentArea1, .DocumentArea2').length) {
        return;
    }
    const title = element.data('title');

    const html = element
        .closest('.DocumentArea, [data-description-host]')
        .find('.description')
        .html();

    const modal = createModal({
        title: title,
        inner: true
    });

    modal.updateContent(html);
});






$(document).on('click', '.DocumentArea1, .DocumentArea2', function (e) {

    if (!$(e.target).hasClass('openDescription')) {
        let icon = $(this).find('[data-agreement-check]').first();
        if (!icon.length) {
            icon = $(this).children('i').first();
        }

        icon.toggleClass('fa-square fa-square-check');

        if (icon.hasClass('fa-square-check')) {

            icon.removeClass('text-red');
        }
        else {

            icon.addClass('text-red');
        }
    }
});

$(document).on('click', '.DocumentArea1 a, .DocumentArea2 a', function (e) {
    e.preventDefault();

    var description = $(this).closest('div').find('.description');

    var dataId = description.data('id');

    const modal = createModal({
        title: dataId === 1 ? "Mesafeli Satış Sözleşmesi" : "Açık Rıza Metni",
        inner: true
    });

    modal.updateContent(description.html());
});





function renderRotatingMainSliderCycle(root, cycle) {
    $(root).find('.home-main-slider-slot').each(function () {
        var members = $(this).find('[data-slider-group-member]');
        if (!members.length) return;

        var index = Math.abs(cycle) % members.length;
        members.addClass('d-none').attr('aria-hidden', 'true');
        members.eq(index).removeClass('d-none').attr('aria-hidden', 'false');
    });
}

function SwipperBuilder(target) {
    var elements = findInRenderTarget(target, '.swiper-container');

    if (elements.length > 0) {
        elements.each(function () {
            if (!$(this).hasClass('initComplete')) {
                var root = this;
                var rotatingMainSlider = $(root).hasClass('main-slider-rotating');
                var slotCount = Number($(root).data('main-slider-slot-count')) || 0;
                var groupCycle = 0;
                var previousRealIndex = 0;
                var swiper = new Swiper(root, {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 10,
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: true
                    },
                    pagination: {
                        el: $(this).find('.swiper-pagination')[0],
                        clickable: true,
                    },
                    navigation: {
                        nextEl: $(this).find('.swiper-button-next')[0],
                        prevEl: $(this).find('.swiper-button-prev')[0],
                    },
                    preventClicks: false,              // 👈 Tıklamayı engellemesin
                    preventClicksPropagation: false,   // 👈 Event bubbling devam etsin
                    on: {
                        init: function () {
                            $(this.$el).addClass('initComplete');
                            previousRealIndex = Number(this.realIndex) || 0;
                            if (rotatingMainSlider) renderRotatingMainSliderCycle(root, groupCycle);
                        },
                        slideChange: function () {
                            if (!rotatingMainSlider || slotCount <= 1) return;

                            var currentRealIndex = Number(this.realIndex) || 0;
                            if (previousRealIndex === slotCount - 1 && currentRealIndex === 0 && this.swipeDirection !== 'prev') {
                                groupCycle++;
                                renderRotatingMainSliderCycle(root, groupCycle);
                            } else if (previousRealIndex === 0 && currentRealIndex === slotCount - 1 && this.swipeDirection === 'prev') {
                                groupCycle = Math.max(0, groupCycle - 1);
                                renderRotatingMainSliderCycle(root, groupCycle);
                            }
                            previousRealIndex = currentRealIndex;
                        }
                    }
                });

                if (rotatingMainSlider && slotCount === 1 &&
                    $(root).find('.home-main-slider-slot').first().find('[data-slider-group-member]').length > 1) {
                    var singleSlotTimer = window.setInterval(function () {
                        if (!document.documentElement.contains(root)) {
                            window.clearInterval(singleSlotTimer);
                            return;
                        }
                        groupCycle++;
                        renderRotatingMainSliderCycle(root, groupCycle);
                    }, 4000);
                }

            }
        });
    }
}






async function relationBuilder() {

    $('.bootbox').removeAttr('tabindex');

    $('._RelationBuilder').html("<option value='0'>Yükleniyor...</option>");

    $('._RelationBuilder').each(function () {
        var element = $(this);
        var dataName = element.data('name');
        var dataId = element.data('id');
        var dataNullable = element.data('nullable');
        var dataAll = element.data('all');
        var url = '/' + dataName + '/_RelationBuilder';

        Request({
            url: url,
            type: 'POST',
            data: {
                id: dataId,
                nullable: dataNullable,
                all: dataAll
            },
            success: function (data) {
                element.html(data);

                if ($('.bootbox').length > 0) {
                    element.select2({
                        dropdownParent: $(".bootbox-body")
                    });
                } else {
                    element.select2();
                }

            },
            error: function (xhr, status, error) {

            }
        });
    });

    s2Each();
}

async function s2Each() {
    $('.s2').each(function () {
        var element = $(this);
        var placeholder = element.attr('placeholder');
        var parent = element.data('parent');

        if (parent != undefined) {
            element.select2({
                dropdownParent: parent
            });
        }
        if (placeholder) {
            element.select2({
                placeholder: placeholder
            });
        } else {
            element.select2();
        }
    });
}

function initializeParentS2(element) {
    var select = $(element);
    if (!select.length || typeof select.select2 !== 'function') return;

    // AJAX sayfa geçişlerinde veya geri yüklenen ekranlarda eski Select2 örneği
    // DOM üzerinde kalabilir. Yeniden kurarak disabled/parent bilgisini güncel tut.
    if (select.hasClass('select2-hidden-accessible')) {
        try {
            select.select2('destroy');
        } catch (_) {
            select.next('.select2-container').remove();
            select.removeClass('select2-hidden-accessible').removeAttr('aria-hidden tabindex');
        }
    }

    var options = {};
    var modal = select.closest('.custom-modal');
    if (modal.length) {
        // Sayfadaki başka (kapanmakta olan) bir modalı değil, select'in gerçekten
        // içinde bulunduğu modalı kullan. Davet -> kayıt geçişindeki katman hatasını önler.
        options.dropdownParent = modal;
    }

    select.select2(options);
}

async function parentS2each(root) {
    var scope = root ? $(root) : $(document);
    scope.find('.parentS2').each(function () {
        initializeParentS2(this);
    });
}

async function LoadRelationName() {
    $('.getRelationName').each(function () {

        var element = $(this);
        var id = element.data('id');
        var baseName = element.data('name');

        var txt = element.text();

        if (id > 0) {
            if (txt === "" || txt === "-") {

                Request({
                    url: `/${baseName}/GetName`,
                    method: 'POST',
                    data: { id: id },
                    target: element,
                    getName: true,
                }).then((data) => {

                    element.text(data ?? "-");
                }).catch((jqXHR) => {
                    element.text(baseName + '!');
                });
            }
        }
    });
}

async function LoadRelationImg() {

    $('.getRelationImg').each(function () {
        var element = $(this);
        var id = element.data('id');
        var src = element.attr('src');
        var baseName = element.data('name');

        if (src === '' && id > 0) {

            Request({
                url: `/${baseName}/GetImg`,
                method: 'POST',
                data: { id: id },
                target: element,
                getName: true,
            }).then((data) => {

                var img = data ?? "-";
                element.attr('src', img);

            }).catch((jqXHR) => {
                element.text(baseName + '!');
            });
        }
    });
}


$(document).on("click", ".showSubCommentsBtn", function () {
    var commentId = $(this).data("id");
    var subCommentsDiv = $("#subComments_" + commentId);

    if (subCommentsDiv.hasClass("collapse")) {
        subCommentsDiv.removeClass("collapse");
        $(this).html('<i class="fa-solid fa-arrow-up"></i> Gizle');
    } else {
        subCommentsDiv.addClass("collapse");
        $(this).html('<i class="fa-solid fa-arrow-down"></i> Göster');
    }
});





$(document).on("click", ".changeDayBtn", function () {

    var $btn = $(this);
    var id = $btn.data('id');
    var $input = $('input[name="' + id + '"]');

    var card = $btn.closest('.card-body');
    var icon = $btn.find('.dayIcon');

    if (icon.hasClass('fa-toggle-off')) {
        icon.removeClass('fa-toggle-off').addClass('fa-toggle-on');
        card.addClass('bg-half-primary');
        $input.val('True');
        $btn.attr('aria-pressed', 'true');

        $('.hidy[data-id="' + id + '"]').removeClass('d-none');
    } else {
        icon.removeClass('fa-toggle-on').addClass('fa-toggle-off');
        card.removeClass('bg-half-primary');
        $input.val('False');
        $btn.attr('aria-pressed', 'false');

        $('.hidy[data-id="' + id + '"]').addClass('d-none');
    }

    var $summary = $btn.find('.team-day-name small');
    if ($summary.length) {
        if ($input.val() === 'True') {
            var $hours = card.find('.team-day-hours');
            var start = $hours.find('input[type="time"]').eq(0).val() || '19:00';
            var finish = $hours.find('input[type="time"]').eq(1).val() || '23:00';
            $summary.text(start + ' – ' + finish);
        } else {
            $summary.text('Müsait değil');
        }
    }

    submitActiveForm();
});

$(document).on("click", ".CancelFirstSave", function () {

    var memberId = $('#MemberId').val();

    if (memberId > 0) {

        Request({
            url: `/Member/CancelMemberRegistering`,
            method: 'POST',
            data: { id: memberId },
        }).then(() => {

            pageLink('/Giris');
        }).catch((jqXHR) => {
            element.text(baseName + '!');
        });
    }
    else {

        console.error("MemberId not found or invalid.");
        pageLink('/Giris');
    }
});




function normalizeTurkishMobilePhoneDigits(value) {
    var digits = (value || '').toString().replace(/\D/g, '');

    if (digits.startsWith('0090')) {
        digits = digits.slice(4);
    }
    else if (digits.length > 10 && digits.startsWith('90')) {
        digits = digits.slice(2);
    }
    else if (digits.length > 10 && digits.startsWith('0')) {
        digits = digits.slice(1);
    }

    return digits.slice(0, 10);
}

function formatTurkishMobilePhone(value) {
    var digits = normalizeTurkishMobilePhoneDigits(value);
    if (!digits) return '';

    var formatted = '(' + digits.slice(0, 3);
    if (digits.length >= 3) formatted += ')';
    if (digits.length > 3) formatted += ' ' + digits.slice(3, 6);
    if (digits.length > 6) formatted += '-' + digits.slice(6, 10);
    return formatted;
}

function syncPhoneVerificationInput(input) {
    if (!input) return '';
    if (input.dataset.composing === 'true') return '';

    var element = $(input);
    var phone = formatTurkishMobilePhone(element.val());
    var isComplete = /^\(5\d{2}\) \d{3}-\d{4}$/.test(phone);

    if (element.val() !== phone)
        element.val(phone);

    element.closest('.phone-entry-row').toggleClass('is-complete', isComplete);
    $('#changeMyPhoneOkBtn')
        .toggleClass('opacity-50', !isComplete)
        .attr('aria-disabled', isComplete ? 'false' : 'true');

    return isComplete ? phone : '';
}

$(document).on('input change blur', '#phoneInput', function (event) {
    if (event.originalEvent?.isComposing) return;
    syncPhoneVerificationInput(this);
});

var phoneVerificationTimerId = null;
var phoneVerificationSubmittedCode = null;

function syncPhoneVerificationCode() {
    var code = $('.sms-code-cell').map(function () {
        return (($(this).val() || '').toString().match(/\d/) || [''])[0];
    }).get().join('');

    $('#smsInput').val(code);
    $('#changeMyPhoneOkBtn').toggleClass('opacity-50', code.length !== 6);
    if (code.length !== 6) phoneVerificationSubmittedCode = null;
    if (code.length === 6 && $('#phoneForm').hasClass('is-code-step') && phoneVerificationSubmittedCode !== code) {
        phoneVerificationSubmittedCode = code;
        $('#changeMyPhoneOkBtn').trigger('click');
    }
    return code;
}

function resetPhoneVerificationCode() {
    phoneVerificationSubmittedCode = null;
    $('.sms-code-cell').val('');
    $('#smsInput').val('');
    $('#changeMyPhoneOkBtn').addClass('opacity-50');
}

function stopPhoneVerificationTimer() {
    if (phoneVerificationTimerId !== null) {
        window.clearInterval(phoneVerificationTimerId);
        phoneVerificationTimerId = null;
    }
}

function setPhoneVerificationResendState(state, remainingText) {
    var resendArea = $('#smsResendArea');
    var resendButton = $('#resendPhoneVerificationCode');
    var statusIcon = $('#smsResendStatusIcon');
    var statusTitle = $('#smsResendStatusTitle');
    var statusText = $('#smsResendStatusText');
    var buttonLabel = $('#smsResendButtonLabel');
    var buttonHint = $('#smsResendButtonHint');

    resendArea.removeClass('is-waiting is-ready is-sending is-error').addClass('is-' + state);
    statusIcon.removeClass('fa-clock fa-circle-check fa-spinner fa-spin fa-circle-exclamation');

    if (state === 'ready') {
        resendButton.removeClass('is-disabled').attr({ 'aria-disabled': 'false', 'tabindex': '0' });
        statusIcon.addClass('fa-circle-check');
        statusTitle.text('Yeni kod gönderebilirsin');
        statusText.text('SMS ulaşmadıysa aşağıdaki butona dokun. Kod aynı telefon numarasına gönderilir.');
        buttonLabel.text('Kodu Tekrar Gönder');
        buttonHint.text('Buton kullanıma hazır');
        return;
    }

    if (state === 'sending') {
        resendButton.addClass('is-disabled').attr({ 'aria-disabled': 'true', 'tabindex': '-1' });
        statusIcon.addClass('fa-spinner', 'fa-spin');
        statusTitle.text('Yeni kod gönderiliyor');
        statusText.text('Lütfen işlem tamamlanana kadar bekle.');
        buttonLabel.text('Gönderiliyor...');
        buttonHint.text('SMS servisine bağlanılıyor');
        return;
    }

    if (state === 'error') {
        resendButton.removeClass('is-disabled').attr({ 'aria-disabled': 'false', 'tabindex': '0' });
        statusIcon.addClass('fa-circle-exclamation');
        statusTitle.text('Kod gönderilemedi');
        statusText.text('Bağlantını kontrol edip tekrar deneyebilirsin.');
        buttonLabel.text('Tekrar Dene');
        buttonHint.text('Buton kullanıma hazır');
        return;
    }

    resendButton.addClass('is-disabled').attr({ 'aria-disabled': 'true', 'tabindex': '-1' });
    statusIcon.addClass('fa-clock');
    statusTitle.text('Kod telefonuna gönderildi');
    statusText.text('Yeni bir kod istemek için ' + remainingText + ' beklemelisin.');
    buttonLabel.text('Kodu Tekrar Gönder');
    buttonHint.text(remainingText + ' sonra aktif olacak');
}

function startPhoneVerificationTimer() {
    stopPhoneVerificationTimer();
    var remainingSeconds = 120;
    var timerText = $('#smsTimerText');

    function renderTimer() {
        var minutes = Math.floor(remainingSeconds / 60).toString().padStart(2, '0');
        var seconds = (remainingSeconds % 60).toString().padStart(2, '0');
        var remainingText = minutes + ':' + seconds;
        timerText.text(remainingText);
        setPhoneVerificationResendState('waiting', remainingText);
    }

    renderTimer();

    phoneVerificationTimerId = window.setInterval(function () {
        remainingSeconds -= 1;
        renderTimer();

        if (remainingSeconds <= 0) {
            stopPhoneVerificationTimer();
            setPhoneVerificationResendState('ready');
        }
    }, 1000);
}

function sendPhoneVerificationSms(phone) {
    var targetPhone = formatTurkishMobilePhone(phone);
    var verificationCode = Math.floor(100000 + Math.random() * 900000);

    return $.ajax({
        url: "/MemberSms/SendSms",
        type: "POST",
        data: {
            id: 0,
            description: `İşlem için tek kullanımlık kod: ${verificationCode}`,
            phone: targetPhone
        }
    }).done(function () {
        $('#changeMyPhoneGuidInput').val(verificationCode);
    });
}

function getPhoneVerificationTargetPhone() {
    return ($('#phoneVerificationTargetInput').val() || '').toString().trim();
}

function showPhoneVerificationCodeStage(phone) {
    $('#phoneVerificationTargetInput').val(phone);
    $('#phoneForm').addClass('is-code-step');
    $('#verifiedPhoneDisplay').text(phone);
    resetPhoneVerificationCode();
    $('#changeMyPhoneOkBtn').html('<i class="fa-solid fa-lock"></i><span>Onayla</span>');
    startPhoneVerificationTimer();
    $('.sms-code-cell').eq(0).trigger('focus');
}

function showPhoneVerificationNumberStage() {
    stopPhoneVerificationTimer();
    $('#phoneVerificationTargetInput').val('');
    $('#phoneForm').removeClass('is-code-step');
    resetPhoneVerificationCode();
    $('#changeMyPhoneOkBtn').html('<i class="fa-regular fa-paper-plane"></i><span>Doğrulama Kodu Gönder</span>');

    syncPhoneVerificationInput(document.getElementById('phoneInput'));
    document.getElementById('phoneInput')?.focus({ preventScroll: true });
}

$(document).on('input change', '.sms-code-cell', function () {
    var digits = ($(this).val() || '').replace(/\D/g, '').slice(0, 6);
    var cells = $('.sms-code-cell');
    var index = cells.index(this);
    if (digits.length > 1) {
        // iOS can put the entire SMS suggestion into the focused cell.
        var start = digits.length === 6 ? 0 : index;
        cells.slice(start).each(function (offset) { $(this).val(digits[offset] || ''); });
        cells.eq(Math.min(5, start + digits.length)).trigger('focus');
    } else {
        $(this).val(digits);
        if (digits && index < cells.length - 1) cells.eq(index + 1).trigger('focus');
    }
    syncPhoneVerificationCode();
});

$(document).on('keydown', '.sms-code-cell', function (event) {
    if (event.key !== 'Backspace' || $(this).val()) return;
    var cells = $('.sms-code-cell');
    var currentIndex = cells.index(this);
    if (currentIndex > 0) cells.eq(currentIndex - 1).trigger('focus');
});

$(document).on('paste', '.sms-code-cell', function (event) {
    var clipboard = event.originalEvent?.clipboardData?.getData('text') || '';
    var digits = clipboard.replace(/\D/g, '').slice(0, 6);
    if (!digits) return;

    event.preventDefault();
    $('.sms-code-cell').each(function (index) {
        $(this).val(digits[index] || '');
    });
    syncPhoneVerificationCode();
});

$(document).on("click", "#changeMyPhone", function (e) {
    e.preventDefault();

    function openPhoneModal(response) {

        var inner = ($('.custom-modal').length > 0);

        const modal = createModal({
            title: 'Telefon Doğrulama',
            modalClass: 'phone-verification-modal',
            inner: inner
        });

        modal.updateContent(response);

        var phoneInput = document.getElementById('phoneInput');
        if (phoneInput) {
            phoneInput.value = formatTurkishMobilePhone(phoneInput.value);
            syncPhoneVerificationInput(phoneInput);
            // Focus while handling the tap, before a request or animation can
            // consume the user activation required by mobile keyboards.
            modal.element?.classList.add('show');
            phoneInput.focus({ preventScroll: true });
        }

        $(document).off("click", "#changeMyPhoneCancelBtn, .closePhoneVerification").on("click", "#changeMyPhoneCancelBtn, .closePhoneVerification", function () {
            stopPhoneVerificationTimer();
            modal.close();
            removeBodyLock();
        });

        $(document).off("click", "#phoneVerificationBackBtn, .changeVerificationPhone").on("click", "#phoneVerificationBackBtn, .changeVerificationPhone", function () {
            showPhoneVerificationNumberStage();
        });

        $(document).off("click", "#resendPhoneVerificationCode").on("click", "#resendPhoneVerificationCode", function () {
            var button = $(this);
            if (button.hasClass('is-disabled')) return;

            var targetPhone = getPhoneVerificationTargetPhone();
            if (!targetPhone) {
                setPhoneVerificationResendState('error');
                return;
            }

            setPhoneVerificationResendState('sending');
            sendPhoneVerificationSms(targetPhone)
                .done(function () {
                    resetPhoneVerificationCode();
                    startPhoneVerificationTimer();
                    $('.sms-code-cell').eq(0).trigger('focus');
                })
                .fail(function () {
                    setPhoneVerificationResendState('error');
                    ShowErrorAlert();
                });
        });

        $(document).off("click", "#changeMyPhoneOkBtn").on("click", "#changeMyPhoneOkBtn", function (e) {
            e.preventDefault();

            // Akış durumu görünürlük hesabından değil, formun adım sınıfından okunur.
            // Böylece !important içeren responsive stiller iş mantığını etkileyemez.
            if (!$('#phoneForm').hasClass('is-code-step')) {
                var phone = syncPhoneVerificationInput(document.getElementById('phoneInput'));
                if (!phone) {
                    Swal.fire({
                        text: 'Geçersiz telefon numarası',
                        icon: 'error',
                        confirmButtonText: 'Tamam'
                    });
                    $("#phoneInput").val('');
                    $(".phone-entry-row").removeClass('is-complete');
                    $("#changeMyPhoneOkBtn").addClass('opacity-50');
                    return;
                }

                var memberTypeId = 0;

                if ($('#MemberTypeId').length > 0) {
                    memberTypeId = $('#MemberTypeId').val();
                }

                // Telefon numarasının kullanılabilirliğini kontrol ediyoruz
                Request({
                    url: '/CheckPhone',
                    type: 'POST',
                    data: {
                        id: phone,
                        memberTypeId: memberTypeId
                    }
                }).then(function (data) {
                    if (data.used) {
                        Swal.fire({
                            text: data.message || 'Bu telefon numarası kullanımda.',
                            icon: 'warning',
                            confirmButtonText: 'Tamam'
                        }).then(function () {
                            $("#phoneInput").val('');
                            $(".phone-entry-row").removeClass('is-complete');
                            $("#changeMyPhoneOkBtn").addClass('opacity-50');
                        });
                    } else {
                        sendPhoneVerificationSms(phone)
                            .done(function () {
                                showPhoneVerificationCodeStage(phone);
                            })
                            .fail(function () {
                                ShowErrorAlert();
                                $("#phoneInput").val('');
                                $(".phone-entry-row").removeClass('is-complete');
                            });
                    }
                }).catch(function (error) {
                    console.error("CheckPhone() hatası:", error.responseText);
                    Swal.fire({
                        text: error.responseText || 'Telefon numarası şu anda kontrol edilemedi. Lütfen tekrar dene.',
                        icon: 'error',
                        confirmButtonText: 'Tamam'
                    });
                });
            }
            else {
                // SMS onay kodu aşaması: Girilen kod kontrol ediliyor
                var enteredCode = ($("#smsInput").val() || '').toString().trim();
                var guid = ($('#changeMyPhoneGuidInput').val() || '').toString().trim();
                if (enteredCode.length === 6 && guid.length === 6 && enteredCode === guid) {
                    stopPhoneVerificationTimer();
                    var phone = getPhoneVerificationTargetPhone();

                    getCurrentUserId()
                        .then(memberId => {

                            if (memberId > 0) {

                                Request({
                                    url: '/editableMemberProp',
                                    type: 'POST',
                                    data: {
                                        name: 'Phone',
                                        value: phone
                                    },
                                }).then((response) => {

                                    if ($('#CheckPhoneFirst').length > 0) {

                                        modal.close();
                                        removeBodyLock();
                                        $('#changeMyPhone').text(phone).addClass('has-phone');
                                        $('.registration-phone-verified').removeClass('d-none');

                                        $('#Phone').val(phone);
                                        refreshPhoneRoleAvailability();
                                        $('#Phone').removeClass('is-invalid');
                                    }
                                    else {

                                        modal.close();
                                        removeBodyLock();
                                        pageLink('/Profili-Duzenle');
                                    }

                                    updateSubmitButtonState();
                                }).catch((error) => {

                                    Swal.fire({
                                        text: 'Beklenmeyen hata',
                                        icon: 'error',
                                        confirmButtonText: 'Tamam'
                                    });
                                    resetPhoneVerificationCode();
                                });
                            }
                            else {

                                removeSheedModal();
                                removeBodyLock();
                                $('#Phone').val(phone);
                                        refreshPhoneRoleAvailability();
                                $('#Phone').removeClass('is-invalid');
                                $('#changeMyPhone').text(phone).addClass('has-phone');
                                $('.registration-phone-verified').removeClass('d-none');

                                updateSubmitButtonState();
                            }
                        });
                } else {
                    Swal.fire({
                        text: 'SMS onay kodu geçersiz',
                        icon: 'error',
                        confirmButtonText: 'Tamam'
                    });

                    resetPhoneVerificationCode();
                    $('.sms-code-cell').eq(0).trigger('focus');
                }
            }
        });

    }

    var template = document.getElementById('registrationPhoneVerificationTemplate');
    if (template) {
        openPhoneModal(template.innerHTML);
        return;
    }

    Request({
        url: '/Member/_changeMyPhone/',
        type: 'POST'
    }).then(openPhoneModal).catch((error) => {
        console.log(error.responseText);
    });
});


function notReadyFeatureNoty() {

    Swal.fire({
        icon: 'warning',
        title: 'Üzgünüz',
        text: 'Bu özellik henüz kullanılabilir değil',
        showConfirmButton: true,
        confirmButtonText: 'Tamam'
    });
}
$(document).on("click", ".notReadyFeatureNoty", async function () {

    notReadyFeatureNoty();
});

$(document).on("click", ".blockTeamBtn", async function () {

    notReadyFeatureNoty();
});
$(document).on("click", ".messageFriendBtn", async function () {

    var element = $(this);
    var nick = element.data('id');
    var memberId = element.data('member');

    getCurrentUserId()
        .then(currentUserId => {

            if (currentUserId === 0)
                quickLoginModal();

            if (currentUserId === memberId) {

                pageLink('/Arkadas-Listem');
            }
            else {

                pageLink('/Sohbet/' + nick);
            }
        });
});
$(document).on("click", ".messageTeamBtn", async function () {

    var id = $(this).data('id');

    pageLink('/Grup-Sohbeti/' + id);
});
$(document).on("click", ".blockMemberBtn, .blockFriendBtn", async function (event) {
    event.preventDefault();
    event.stopPropagation();

    const button = $(this);
    if (button.data("loading")) return;

    const memberId = Number(button.data("member") || button.data("id") || 0);
    const isBlocked = String(button.attr("data-blocked") || "false").toLowerCase() === "true";
    const shouldBlock = !isBlocked;

    if (!memberId) {
        ShowErrorAlert("Kullanıcı bilgisi bulunamadı.");
        return;
    }

    if (shouldBlock) {
        const confirmation = await Swal.fire({
            title: "Kullanıcı engellensin mi?",
            text: "Bu kullanıcı sizinle birebir sohbet başlatamaz ve mevcut arkadaşlık bağlantınız kaldırılır.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Engelle",
            cancelButtonText: "Vazgeç"
        });

        if (!confirmation.isConfirmed) return;
    }

    button.data("loading", true).addClass("disabled");

    Request({
        url: "/Member/SetMemberBlock",
        type: "POST",
        data: {
            memberId: memberId,
            blocked: shouldBlock
        }
    }).then(function (response) {
        const blocked = response && typeof response.blocked === "boolean"
            ? response.blocked
            : shouldBlock;
        const memberButtons = $('.blockMemberBtn[data-member="' + memberId + '"], .blockFriendBtn[data-member="' + memberId + '"]');

        memberButtons.each(function () {
            const item = $(this);
            item.attr("data-blocked", blocked ? "true" : "false");
            item.attr("title", blocked ? "Engeli kaldır" : "Engelle");
            item.attr("aria-label", blocked ? "Engeli kaldır" : "Engelle");
            item.toggleClass("text-red bg-half-red", !blocked);
            item.toggleClass("text-primary bg-half-primary", blocked);
            item.find("i")
                .toggleClass("fa-ban", !blocked)
                .toggleClass("fa-user-check", blocked);
            const textNodes = item.contents().filter(function () {
                return this.nodeType === 3;
            });
            if (textNodes.length) {
                textNodes.last()[0].textContent = blocked ? " Engeli kaldır" : "";
            }
        });

        if (blocked) {
            memberButtons.each(function () {
                const blockButton = $(this);
                blockButton.closest(".card")
                    .find(".globalActionBtn, a.btn, button.btn")
                    .not(blockButton)
                    .remove();
            });
        } else {
            const blockedCard = button.closest(".blocked-member-card");
            if (blockedCard.length) {
                blockedCard.fadeOut(160, function () {
                    blockedCard.remove();
                    if ($(".blocked-member-card").length === 0) {
                        pageLink("/Engellenenler");
                    }
                });
            }
        }

        Swal.fire({
            icon: "success",
            text: response && response.message
                ? response.message
                : (blocked ? "Kullanıcı engellendi." : "Kullanıcının engeli kaldırıldı."),
            timer: 1400,
            showConfirmButton: false
        });
    }).catch(function (error) {
        ShowErrorAlert(getRequestErrorMessage(error));
    }).finally(function () {
        button.data("loading", false).removeClass("disabled");
    });
});

$(document).on("click", ".DeleteMyAccount", async function () {

    /*notReadyFeatureNoty();*/

    var id = $(this).data('id');
    var phone = $(this).data('phone');
    var deactivateAccount = function () {
        return Request({
            url: '/Member/DeleteMyAccount',
            type: 'DELETE',
            data: { id: id }
        }).then(function () {
            NotLogged();
            pageLink('/giris');
        }).catch(function (error) {
            ShowErrorAlert(getRequestErrorMessage(error));
        });
    };

    const result = await Swal.fire({
        title: 'Hesabınızı silmek istediğinize emin misiniz?',
        text: 'Hesabınız silinmiş olarak işaretlenecek; daha sonra giriş ekranında açıkça onay vererek yeniden etkinleştirebilirsiniz.',
        icon: 'warning',
        showCancelButton: true,

        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'Vazgeç'
    });

    if (result.isConfirmed) {

        if (phone != '') {

            var guid = Math.floor(1000 + Math.random() * 9000);
            var sms = `hesap silme işlemi için parolanız: ${guid}`;
            var sendSmsUrl = "/MemberSms/SendSms";

            $.post(sendSmsUrl, { id: 0, description: sms, phone: phone })
                .done(function () {
                    bootbox.prompt({
                        title: "SMS Onayı",
                        inputType: 'text',
                        placeholder: "SMS onay kodunu girin",
                        buttons: {
                            cancel: {
                                label: 'Vazgeç',
                                className: 'btn-primary'
                            },
                            confirm: {
                                label: 'Tamam',
                                className: 'btn-primary'
                            }
                        },
                        callback: function (result) {

                            if (result === null) {
                                return;
                            }

                            if (result === guid.toString()) {

                                deactivateAccount();

                            } else {

                                Swal.fire({
                                    title: 'Hata!',
                                    text: 'Girdiğiniz SMS onay kodu geçersiz.',
                                    icon: 'error',
                                    confirmButtonText: 'Tamam'
                                });
                            }
                        }
                    });
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    ShowErrorAlert();
                });
        } else {
            await deactivateAccount();
        }
    }
});
function anySelect2IsOpen() {
    return $('.select2-container--open').length > 0;
}


$(document).on("submit", "#CompanyJoinRequestForm", async function (event) {
    event.preventDefault();
    const form = this, button = form.querySelector('[type="submit"]');
    if (button.disabled || !window.SahaseninJoinForm.validate(form) || !form.reportValidity()) return;
    button.disabled = true;
    try {
        const response = await $.ajax({url:'/CompanyJoinRequestForm/Submit',type:'POST',data:$(form).serialize()});
        sessionStorage.removeItem(form.dataset.joinSubmissionStorage);
        removeSheedModal(); removeBodyLock();
        await Swal.fire({icon:'success',title:'Başvurunuz alındı',text:'Başvuru numaranız: ' + response.applicationNumber + '. Ekibimiz GSM numaranızdan sizinle iletişime geçecektir.',confirmButtonText:'Tamam'});
    } catch (error) {
        ShowErrorAlert(error.responseJSON?.message || 'Başvuru gönderilemedi. Bilgilerinizi kontrol edip yeniden deneyin.');
    } finally { button.disabled = false; }
});
$(document).on("click", ".OpenCompanyJoinRequestForm", async function () {

    var element = $(this);
    var companyId = 0;

    if (!element.hasClass('nonCompany')) {
        var companyId = element.data('id');
    }

    OpenCompanyJoinRequestForm(companyId);
});

async function OpenCompanyJoinRequestForm(companyId) {
    const modal = createModal({
        title: 'Bayilik Başvurusu'
    });

    try {

        let response = await Request({
            url: '/Company/_CompanyJoinRequestForm',
            type: 'POST',
            data: {
                id: 0,
                companyId: companyId
            }
        });

        modal.updateContent(response);
        const applicationForm = document.getElementById('CompanyJoinRequestForm');
        if (applicationForm) {
            const storageKey = 'join-public-' + (Number(companyId) || 0);
            applicationForm.dataset.joinSubmissionStorage = storageKey;
            const previousKey = sessionStorage.getItem(storageKey);
            if (previousKey) applicationForm.elements.SubmissionKey.value = previousKey;
            else sessionStorage.setItem(storageKey, applicationForm.elements.SubmissionKey.value);
            window.SahaseninJoinForm.init(applicationForm,{searchUrl:'/Company/JoinFacilitySearch'});
        }
    } catch (error) {
        console.error("Hata oluştu:", error.responseText);
        modal.updateContent('<div class="alert alert-danger">Beklenmedik bir hata oluştu.</div>');
    }
}


$(document).on("click", ".addGroupChatManager", function () {
    var element = $(this);
    var chatId = element.data('chat');
    var memberId = element.data('member');

    $.ajax({
        url: '/UsersMessage/AddGroupChatManager',
        type: 'POST',
        data: {
            chatId: chatId,
            memberId: memberId
        },
        success: function (response) {
            pageLink('/Grup-Sohbeti/' + chatId);
        },
        error: function (jqXHR) {
            ShowErrorAlert(jqXHR.responseText);
        }
    });
});

$(document).on("click", ".OpenSheepPopupForRefereedMatch", async function () {
    const element = $(this);
    const url = element.data('url');

    const modal = createModal({
        title: 'Maç Detayları'
    });

    try {
        fetchSheepPopUpData(url)
            .then(response => {

                modal.updateContent(response);

                afterPage(url);
                syncMatchCountDown();

                $('.targetDivSelector.updateMatchEventsArea').click();
            });

    } catch (error) {
        console.error("Hata oluştu:", error.responseText);
        modal.updateContent('<div class="alert alert-danger">Bir hata oluştu, lütfen tekrar deneyin.</div>');
    }
});






$(document).on("click", ".OpenSheepPopup", async function (e) {
    const element = $(this);
    const url = element.data('url');
    const inlineTarget = element.attr('data-inline-target');
    var header = element.data('header') ?? '';

    var clickedAction = $(e.target).closest('.action');
    if (clickedAction.length && !clickedAction.is(element)) {
        return;
    }

    if (inlineTarget) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const target = document.querySelector(inlineTarget);
        if (!target)
            return;

        const clone = target.cloneNode(true);
        clone.classList.remove('d-none');
        clone.removeAttribute('id');
        openSheepPopUpContent(clone.outerHTML, header);
        return;
    }

    // Anında shadow ekle
    element.addClass('hover');

    // 500ms sonra kaldır (non-blocking)
    setTimeout(() => {
        element.removeClass('hover');
    }, 500);

    // Popup açılmasını bekletmez
    openSheepPopUp(url, header);
});

$(document).on("keydown", ".team-rival-search-card.OpenSheepPopup", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    e.preventDefault();
    $(this).trigger("click");
});


$(document).on("click", ".OpenSheepCompanyDetailPopUp", async function () {
    const element = $(this);
    const url = element.data('url');
    var header = element.data('header') ?? 'Halı saha detayı';

    const modal = createModal({
        title: header
    });

    try {
        fetchSheepPopUpData(url)
            .then(response => {

                modal.updateContent(response);
                afterPage(url);
            });

    } catch (error) {
        console.error("Hata oluştu:", error.responseText);
        modal.updateContent('<div class="alert alert-danger">Bir hata oluştu, lütfen tekrar deneyin.</div>');
    }
});


$(document).on("click", "#afterMatchRateRivalBtn", async function () {

    loadAfterMatchRateRivalArea();
});

async function loadAfterMatchRateRivalArea() {

    var target = $("#afterMatchRateRivalArea");
    var matchId = target.data('match');

    if (matchId > 0) {

        InitLoadScreenElement(target);

        Request({
            url: '/Match/_RateRival/',
            data: {
                id: matchId
            },
            type: 'POST'
        }).then((response) => {

            target.html(response);
        }).catch((error) => {
            console.log("loadPartialAreas: " + matchId);
        });
    }
    else {

        target.html('<div class="w-100 h-100"><p class="w-100 badge badge-danger p-3 text-wrap" style="overflow:hidden;">Tekrar deneyiniz.</p></div>');
        console.log('loadAfterMatchRateRivalArea(): matchId cannot be zero.');
    }
}

$(document).on("click", ".deleteInOrganizerMatchRequest", async function () {
    var element = $(this);
    var id = element.data('id');
    var matchId = element.data('match');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Maç teklifini geri çekmek üzeresiniz",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, Geri çek',
        cancelButtonText: 'Vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/TeamMatchRequestMessage/DeleteTeamMatchRequestMessage/',
                data: {
                    id: id
                },
                type: 'POST'
            }).then((response) => {

                updateAfterMatchArea(matchId);
            }).catch((error) => {
                console.log("loadPartialAreas: " + id);
            });
        }
    });
});
$(document).on("click", ".deleteInOrganizerRefereeRequest", async function () {
    var element = $(this);
    var id = element.data('id');
    var matchId = element.data('match');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Hakme gönderilen teklifi geri çekmek üzeresiniz",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, Geri çek',
        cancelButtonText: 'Vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/Reservation/deleteRefereeReq',
                type: 'POST',
                data: {
                    id: id
                }
            }).then((response) => {

                removeSheedModal();
                openRefereeSelectorBasePageModal(matchId);
            }).catch((error) => {
                console.log("loadPartialAreas: " + id);
            });
        }
    });
});


$(document).on("click", ".sendJoinRefereeMatchBtn", async function () {
    var element = $(this);
    var paid = Number(element.data('paid')) === 1;
    var amount = Number(element.data('amount')) || 0;

    Swal.fire({
        title: 'Emin misiniz?',
        text: paid ? undefined : "Maça hakemlik etme teklifinde bulunacaksınız",
        html: paid
            ? `<p>Başvurarak teklif edilen ${amount.toLocaleString('tr-TR')} TL hizmet bedelini kabul etmiş olacaksınız.</p>
               <div class="form-check d-flex align-items-start gap-2 text-start p-3 border rounded">
                   <input id="paidServiceCancellationConsent" class="form-check-input flex-shrink-0 mt-1" type="checkbox">
                   <label class="form-check-label" for="paidServiceCancellationConsent">Maç ilanı iptal edilirse ücret alamayacağımı kabul ediyorum.</label>
               </div>`
            : undefined,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Teklifi gönder',
        cancelButtonText: 'Vazgeç',
        preConfirm: function () {
            if (paid && !document.getElementById('paidServiceCancellationConsent')?.checked) {
                Swal.showValidationMessage('Devam etmek için iptal koşulunu onaylayın.');
                return false;
            }
            return true;
        }
    }).then((result) => {
        if (result.isConfirmed)
            submitJoinRefereeMatch(element, paid);
    });
});

function submitJoinRefereeMatch(element, cancellationNoFeeAccepted) {
    var paid = Number(element.data('paid')) === 1;

    Request({
        url: '/Reservation/SendJoinRefereeMatch',
        type: 'POST',
        data: {
            matchId: element.data('match'),
            feeAccepted: paid,
            cancellationNoFeeAccepted: Boolean(cancellationNoFeeAccepted)
        }
    }).then(function () {
        location.reload();
    }).catch(function (error) {
        if (isPaidServiceAgreementRequiredError(error)) {
            openPaidServiceAgreementModal(function () {
                submitJoinRefereeMatch(element, cancellationNoFeeAccepted);
            });
            return;
        }

        if (isPaidServiceIbanRequiredError(error)) {
            showPaidServiceIbanRequirement(error);
            return;
        }

        ShowErrorAlert(getRequestErrorMessage(error));
    });
}


$(document).on("click", ".ComeRefereeBtn", async function () {
    var element = $(this);
    var memberId = element.data('member');

    getCurrentUserId()
        .then(async currentUserId => {

            if (currentUserId === 0)
                quickLoginModal();

            else {

                const modal = createModal({
                    title: 'Hakem Çağır'
                });

                try {

                    let response = await Request({
                        url: '/Member/ActiveReservationsModal',
                        type: 'POST',
                        data: { id: memberId }
                    });

                    modal.updateContent(response);

                } catch (error) {
                    console.error("Hata oluştu:", error.responseText);
                    modal.updateContent('<div class="alert alert-danger">Beklenmedik bir hata oluştu.</div>');
                }
            }
        });
});
$(document).on("click", ".selectMatchForRefereeBtn", async function () {
    var element = $(this);
    var matchId = element.data('match');
    var refereeId = element.data('referee');

    Request({
        url: '/Member/selectReservationForReferee',
        type: 'POST',
        data: { matchId: matchId, refereeId: refereeId }
    }).then(() => {

        pageLink(`/Mac-Olustur/${matchId}`)
            .then(() => {

                removeSheedModal();
                openRefereeSelectorBasePageModal(matchId);
            })
            .catch((error) => {

                ShowErrorAlert();
                console.log(error);
            });
    }).catch((error) => {

        ShowErrorAlert();
        console.log(error);
    });
});


$(document).on("click", ".openRivalSelectorModal", async function () {
    var element = $(this);
    var id = element.data('match');

    const modal = createModal({
        title: 'Maç için rakip aranıyor'
    });

    try {
        let response = await Request({
            url: '/Rakip-Bul',
            type: 'GET',
            data: {
                pageLink: true,
                matchId: id
            },
            cacheable: false
        });

        modal.updateContent(response);
        updateFindRivalTable();
    } catch (error) {
        console.error("Hata oluştu:", error.responseText);
        modal.updateContent('<div class="alert alert-danger">Bir hata oluştu, lütfen tekrar deneyin.</div>');
    }
});
$(document).on("click", ".openRefereeSelectorBasePageModal", async function () {
    var element = $(this);
    var id = element.data('match');

    openRefereeSelectorBasePageModal(id);
});
async function openRefereeSelectorBasePageModal(id) {
    const modal = createModal({
        title: 'Maç için hakem aranıyor'
    });

    try {
        let response = await Request({
            url: '/Match/_RefereeSelectorBasePage',
            type: 'POST',
            data: {
                matchId: id
            }
        });

        if (response.success === false) {

            let response2 = await Request({
                url: '/Hakem-Bul',
                type: 'GET',
                data: {
                    matchId: id,
                    pageLink: true
                }
            });

            modal.updateContent(response2);

            refereeSearch();
        }
        else {
            modal.updateContent(response);
        }
    } catch (error) {
        console.error("Hata oluştu:", error.responseText);
        modal.updateContent('<div class="alert alert-danger">Bir hata oluştu, lütfen tekrar deneyin.</div>');
    }
}
$(document).on("click", ".openRefereeSelectorModal", async function () {
    var element = $(this);
    var id = element.data('match');

    const modal = createModal({
        title: 'Maç için hakem aranıyor'
    });

    try {

        let response = await Request({
            url: '/Hakem-Bul',
            type: 'POST',
            data: {
                matchId: id,
                pageLink: true
            }
        });

        modal.updateContent(response);

        refereeSearch();

    } catch (error) {
        console.error("Hata oluştu:", error.responseText);
        modal.updateContent('<div class="alert alert-danger">Bir hata oluştu, lütfen tekrar deneyin.</div>');
    }
});



$(document).on("change", ".updateMatchPlayerPrice", async function () {
    const element = $(this);
    const card = element.closest('.draft-announcement');
    card.attr('aria-busy', 'true');
    try {
        await Request({ url: '/Reservation/UpdateMatchPlayerPrice', type: 'POST', data: {
            matchPlayerId: element.data('match-player'), price: Math.max(0, parseInt(String(element.val()).replace(/\./g, ''), 10) || 0),
            matchId: element.data('match'), isReferee: element.hasClass('isReferee')
        } });
        loadAfterMatchSetting();
    } catch (error) { ShowErrorAlert(error.responseText || 'Oyuncu ücreti kaydedilemedi.'); }
    finally { card.removeAttr('aria-busy'); }
});

$(document).on("click", ".changeMatchPlayerAnnouncementType", async function () {

    var element = $(this);
    if (element.prop('disabled') || element.closest('.draft-announcement').attr('aria-busy') === 'true') return;
    element.closest('.draft-announcement').attr('aria-busy', 'true');
    var type = element.data('type');
    var matchPlayerId = element.data('match-player');
    var matchId = element.data('match');

    Request({
        url: '/Reservation/ChangeMatchPlayerAnnouncementType',
        type: 'POST',
        data: {
            type: type,
            matchId: matchId,
            matchPlayerId: matchPlayerId
        }
    }).then(() => {

        loadAfterMatchSetting();

        var div = $('#EditMatchPlayerModal');

        if (div.length > 0) {

            var matchPlayerId = div.data('match-player');

            removeSheedModal();

            editMatchPlayerModal(matchPlayerId);
        }

    }).catch((error) => {
        ShowErrorAlert(error.responseText || 'İlan koşulu kaydedilemedi.');
    }).finally(() => element.closest('.draft-announcement').removeAttr('aria-busy'));
});

// $(document).on("click", ".updateMatchPlayerIsPriced", async function () {

//     var element = $(this);
//     var matchPlayerId = element.data('match-player');

//     element.find("i.SettingIcon").toggleClass('fa-toggle-on fa-toggle-off');

//     Request({
//         url: '/Reservation/UpdateMatchPlayerIsPriced',
//         type: 'POST',
//         data: {
//             matchPlayerId: matchPlayerId
//         }
//     }).then(() => {

//         loadAfterMatchSetting();
//     }).catch((error) => {
//         console.log("updateMatchPlayerIsPriced: " + error.responseText);
//     });
// });

$(document).on("change", ".updateMatchPlayerPositionId", async function () {
    const element = $(this), card = element.closest('.draft-announcement');
    card.attr('aria-busy', 'true');
    try {
        await Request({ url: '/Reservation/UpdateMatchPlayerPositionId', type: 'POST', data: {
            matchPlayerId: element.data('match-player'), positionId: element.val()
        } });
        loadAfterMatchSetting();
    } catch (error) {
        ShowErrorAlert(error.responseText || 'Oyuncu mevkisi kaydedilemedi.');
        if (card.length) refreshDraftMatchManager({ preserveValues: false });
    } finally { card.removeAttr('aria-busy'); }
});


$(document).on("focus", "#Description", function () {
    if (!$(this).hasClass("border-ff")) return;

    if (isAndroidWebView()) {
        var $card = $(this).closest('.card');
        $card[0].style.setProperty('margin-bottom', '250px', 'important');
    }
});

$(document).on("blur", "#Description", function () {
    if (!$(this).hasClass("border-ff")) return;

    if (isAndroidWebView()) {
        var $card = $(this).closest('.card');
        $card[0].style.setProperty('margin-bottom', '', 'important');
    }
});


$(document).on("click", ".UpdateRefereePricedBtn", async function () {
    const button = $(this), state = $('#IsRefereeWantedPriced');
    if (button.prop('disabled')) return;
    const wasOn = !state.hasClass('disabled');
    const controls = button.closest('#AfterMatchSettingArea').find('button:enabled');
    state.toggleClass('disabled', wasOn);
    button.attr('aria-checked', String(!wasOn));
    button.find('i.SettingIcon').toggleClass('fa-toggle-on fa-toggle-off');
    controls.prop('disabled', true);
    try { await notPublishChangeSettingTask(button.data('match')); }
    catch (error) {
        state.toggleClass('disabled', !wasOn); button.attr('aria-checked', String(wasOn));
        button.find('i.SettingIcon').toggleClass('fa-toggle-on fa-toggle-off');
        ShowErrorAlert(error.responseText || 'Hakem ücret ayarı kaydedilemedi.');
    } finally { controls.prop('disabled', false); }
});

$(document).on("click", ".notPublishedChangeSettingBtn", async function () {
    const button = $(this);
    if (button.prop('disabled')) return;
    const wasOn = !button.hasClass('disabled');
    const controls = button.closest('#AfterMatchSettingArea').find('.draft-switch:enabled, .draft-pay-option:enabled, .js-draft-match-manager:enabled');
    button.toggleClass('disabled', wasOn).toggleClass('text-primary bg-half-primary is-on', !wasOn).attr('aria-checked', String(!wasOn));
    controls.prop('disabled', true);
    try { await notPublishChangeSettingTask(button.data('match')); }
    catch (error) {
        button.toggleClass('disabled', !wasOn).toggleClass('text-primary bg-half-primary is-on', wasOn).attr('aria-checked', String(wasOn));
        ShowErrorAlert(error.responseText || 'Ayar kaydedilemedi. Tekrar deneyin.');
    } finally { controls.prop('disabled', false); }
});

async function notPublishChangeSettingTask(matchId) {

    // Tüm butonları topla
    var model = {
        MatchId: matchId,
        PlayerWanted: !$("#PlayerWanted").hasClass("disabled"),
        IsPlayerWantedPriced: !$("#IsPlayerWantedPriced").hasClass("disabled"),
        RefereeWanted: !$("#RefereeWanted").hasClass("disabled"),
        IsRefereeWantedPriced: !$("#IsRefereeWantedPriced").hasClass("disabled"),
        IsCompanyPriced: !$("#IsCompanyPriced").hasClass("disabled"),
        IsMatchOrganizationPriced: !$("#IsMatchOrganizationPriced").hasClass("disabled"),
        AudiancePermission: !$("#AudiancePermission").hasClass("disabled")
    };

    // AJAX
    await $.ajax({
        url: "/Reservation/UpdateAfterMatchSetting",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(model)
    });
    await loadAfterMatchSetting();
}


$(document).on("click", ".shareButton", async function () {

    var url = window.location.href;

    var element = $(this);
    var shareData = {
        title: document.title,
        text: element.data('desc'),
        url: url
    };

    if (navigator.share && !isAndroidWebView()) {
        // Native Share API

        try {
            await navigator.share(shareData);
        } catch (error) {
            console.error("Paylaşım iptal edildi veya başarısız oldu:", error);
        }
    } else {
        // Android WebView Share

        if (window.jsBridge && window.jsBridge.postMessage) {
            window.jsBridge.postMessage("url:" + url);
        } else {
            ShowErrorAlert("jsBridge interface yok");
        }
    }
});


$(document).on("click", "#btnFindLocation", function () {

    getAppPlatform().then(platform => {
        switch (platform) {

            case platformType.Android:

                break;

            case platformType.iOS:

                break;

            default:

                if (!navigator.geolocation) {
                    ShowErrorAlert("Cihazınızda desteklenmiyor.");
                    return;
                }

                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        var latitude = position.coords.latitude;
                        var longitude = position.coords.longitude;

                        ShowSuccessAlert("Konumunuz bulundu! Enlem: " + latitude + ", Boylam: " + longitude);
                    },
                    function (error) {
                        ShowErrorAlert(typeof getLocationErrorMessage === 'function' ? getLocationErrorMessage(error) : "Konum bilgisi alınamıyor. Konum servislerini kontrol edip yeniden deneyin.");
                    },
                    { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
                );
                break;
        }
    });
});

async function captureProfileCardImgDiv() {
    if (["localhost", "127.0.0.1", "::1"].includes(window.location.hostname)) return;

    // Sadece henüz yakalanmamış kartları seç
    var elements = $('.ProfileCardImgDiv').not('.captured');

    if (elements.length === 0) return;

    // Tüm elementleri döngüye al
    await window.sahaseninFeatureAssets.load('capture');
    for (let i = 0; i < elements.length; i++) {
        var element = $(elements[i]);
        var id = element.data('id');
        var type = element.data('type');

        try {
            // Profil ilk çizimini engellememek için ağır canvas işinden önce tarayıcıya nefes ver.
            await new Promise(resolve => requestAnimationFrame(() => resolve()));
            // 1. KARTIN İÇİNDEKİ TÜM RESİMLERİN YÜKLENMESİNİ BEKLE (1 sn beklemek yerine)
            const images = element.find('img').get();
            await Promise.all(images.map(img => {
                if (img.complete) return Promise.resolve();
                return new Promise((resolve) => {
                    img.onload = resolve;
                    img.onerror = resolve; // Hata alsa bile sonsuz döngüde kalmasın diye devam et
                });
            }));

            // 2. HTML2CANVAS ÇALIŞTIR
            var canvas = await html2canvas(element[0], {
                scale: 2, // Daha yüksek kalite ve doğru oranlar için (Retina etkisi)
                useCORS: true,
                allowTaint: false,
                width: element[0].offsetWidth, // Genişliği tarayıcıdan net al
                height: element[0].offsetHeight, // Yüksekliği tarayıcıdan net al
                scrollX: 0,
                scrollY: -window.scrollY, // Sayfa kaydırılmışsa kaymayı engeller
                backgroundColor: null, // Şeffaflığı korumak için
                onclone: (clonedDoc) => {
                    // Tüm glass-card'ları bul
                    const glassCards = clonedDoc.querySelectorAll('.glass-card');

                    glassCards.forEach(card => {
                        // 1. Blur çalışmadığı için arka planı biraz daha opak (sütlü) yapıyoruz
                        // Normalde 0.1 olan değeri 0.25 veya 0.3'e çekmek cam hissini korur
                        card.style.backgroundColor = "rgba(255, 255, 255, 0.25)";

                        // 3. Mevcut bluru temizle (Canvas hata yapmasın diye)
                        card.style.backdropFilter = "none";
                        card.style.webkitBackdropFilter = "none";
                    });

                    // Klonlanan dokümanda resmin genişliğini zorla sabitleyelim
                    const photo = clonedDoc.querySelector('.player-photo-wrap');
                    if (photo) {
                        photo.style.height = "110px";
                        photo.style.width = "110px";
                    }
                }
            });

            var blob = await new Promise(resolve => {
                canvas.toBlob(resolve, "image/jpeg", 0.9);
            });

            if (!blob) continue;

            var formData = new FormData();
            formData.append("file", blob, "field.jpg");
            formData.append("id", id);
            formData.append("type", type);

            // 3. SUNUCUYA GÖNDER
            await $.ajax({
                url: '/UpdateProfileCardImg',
                type: "POST",
                data: formData,
                processData: false,
                contentType: false
            });

            element.addClass("captured");
            console.log(`captureProfileCardImgDiv(): Saved img. id:${id}, type: ${type}`);

        } catch (err) {
            console.error("captureProfileCardImgDiv hata:", err);
        }
    }
}

$(document).on("click", ".downloadMatchImg", function () {

    var element = $(this);

    if (element.hasClass('processing')) {
        ShowErrorAlert('Daha sonra tekrar deneyin');
        return;
    }

    element.addClass('opacity-50 processing');

    var matchId = element.data('match');
    var type = element.data('type');

    $.ajax({
        url: '/Match/DownloadMatchImg',
        type: 'GET',
        data: {
            matchId: matchId,
            type: type
        },
        xhrFields: {
            responseType: 'blob'
        },
        success: function (blob, status, xhr) {

            var contentDisposition = xhr.getResponseHeader('Content-Disposition');
            var fileName = 'match_' + matchId + '_' + type + '.png';

            if (contentDisposition && contentDisposition.indexOf('filename=') !== -1) {
                var match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
                if (match && match[1]) {
                    fileName = match[1].replace(/['"]/g, '');
                }
            }

            var blobUrl = window.URL.createObjectURL(blob);

            getAppPlatform().then(async function (platform) {

                switch (platform) {

                    case platformType.Android:

                        ShowErrorAlert('Cihazınızda desteklenmiyor.');
                        break;
                    case platformType.iOS:

                        // WebView içinde gerçek "indir" çoğu zaman çalışmaz.
                        // Bu yüzden önce paylaşmayı dene.
                        try {
                            if (navigator.share && window.File) {
                                var file = new File([blob], fileName, {
                                    type: blob.type || 'image/png'
                                });

                                if (navigator.canShare && navigator.canShare({ files: [file] })) {
                                    await navigator.share({
                                        files: [file],
                                        title: fileName,
                                        text: fileName
                                    });

                                    break;
                                }
                            }
                        } catch (e) {
                            // Paylaşım başarısız olursa alttaki fallback çalışsın
                        }

                        // Fallback: görüntüle
                        window.location.href = blobUrl;

                        setTimeout(function () {
                            window.URL.revokeObjectURL(blobUrl);
                        }, 1000);

                        break;

                    default:

                        // WEB: gerçek indirme
                        var a = document.createElement('a');
                        a.href = blobUrl;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);

                        setTimeout(function () {
                            window.URL.revokeObjectURL(blobUrl);
                        }, 1000);

                        break;
                }

                element.removeClass('opacity-50 processing');
            });

        },
        error: function (xhr) {

            element.removeClass('opacity-50 processing');
            ShowErrorAlert(xhr.responseText || 'İndirme işlemi başarısız oldu');
        }
    });
});



function isAndroidWebView() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;

    return (
        /Android/.test(ua) &&
        (ua.includes("wv") || ua.includes("Version/") || ua.includes("; wv"))
    );
}


async function updateLiveMatch() {

    InitLoadScreen('#LiveMatchSectionArea');

    Request({
        url: '/Home/_LiveMatchSection',
        target: '#LiveMatchSectionArea'
    }).then((response) => {

    }).catch((error) => {
        console.log("loadPartialAreas: " + id);
    });
}
async function updateNextMatch() {

    InitLoadScreen('#NextMatchSectionArea');

    Request({
        url: '/Home/_NextMatchSection',
        target: '#NextMatchSectionArea'
    }).then((response) => {

    }).catch((error) => {
        console.log("loadPartialAreas: " + id);
    });
}
async function updateTwentyMatch() {

    InitLoadScreen('#LastTwentyMachArea');

    Request({
        url: '/Home/_LastMatches',
        data: {
            count: 25
        },
        target: '#LastTwentyMachArea'
    }).then((response) => {

    }).catch((error) => {
        console.log("loadPartialAreas: " + id);
    });
}



$(document).on("click", ".leaguePointTableSelector", async function () {

    var element = $(this);
    var type = element.data('type');
    var leagueId = element.data('league');
    var teamId = element.data('team');

    var target = $(`._LeaguePointTable[data-team='${teamId}']`)
    InitLoadScreenElement(target);

    Request({
        url: `/Team/_LeaguePointTable`,
        type: 'POST',
        data: {
            leagueId: leagueId,
            type: type,
            teamId: teamId
        },
        success: function (response) {

            target.html(response);
        },
        error: function (jqXHR) {

            target.html(jqXHR.responseText);
        }
    });
});

async function updateLeaguePointTable() {

    var elements = $('._LeaguePointTable');

    if (elements.length > 0) {
        elements.each(function () {

            var element = $(this);
            InitLoadScreenElement(element);

            var leagueId = element.data('league');
            var teamId = element.data('team');

            var type = $(`.leaguePointTableSelector.targetDivSelector.active[data-team='${teamId}']`).data('type') || 1;

            Request({
                url: `/Team/_LeaguePointTable`,
                type: 'POST',
                data: {
                    leagueId: leagueId,
                    type: type,
                    teamId: teamId
                },
                success: function (response) {

                    element.html(response);
                },
                error: function (jqXHR) {

                    element.html(jqXHR.responseText);
                }
            });
        });
    }
}

$(document).on("click", ".targetDivTriggerBtn", async function () {

    var id = $(this).data('id');

    $('.targetDivSelector[data-id="' + id + '"]').first().trigger('click');
});


$(document).on("click", ".updateMemberPosts", async function () {
    updateMemberPosts();
});
$(document).on("click", ".updateMemberComments", async function () {
    updateMemberComments();
});

$(document).on("click", ".tournamentPointTableSelector", async function () {

    var element = $(this);
    var type = element.data('type');
    var group = element.data('fixture-group');
    var tournamentId = element.data('tournament');

    var target = $(`._TournamentPointTable[data-tournament='${tournamentId}']`)
    InitLoadScreenElement(target);

    Request({
        url: `/Tournament/_TournamentPointTable`,
        type: 'POST',
        data: {
            tournamentId: tournamentId,
            type: type,
            tournamentGroupId: group
        },
        success: function (response) {

            target.html(response);
        },
        error: function (jqXHR) {

            target.html(jqXHR.responseText);
        }
    });
});

async function updateTournamentPointTable() {

    var elements = $('._TournamentPointTable');

    if (elements.length > 0) {
        elements.each(function () {

            var element = $(this);
            InitLoadScreenElement(element);

            var tournamentId = element.data('tournament');

            var type = $(`.tournamentPointTableSelector.targetDivSelector.active[data-tournament='${tournamentId}']`).data('type') || 1;
            var group = $(`.tournamentPointTableSelector.targetDivSelector.active[data-tournament='${tournamentId}']`).data('fixture-group') || 1;

            Request({
                url: `/Tournament/_TournamentPointTable`,
                type: 'POST',
                data: {
                    tournamentId: tournamentId,
                    type: type,
                    tournamentGroupId: group
                },
                success: function (response) {

                    element.html(response);
                },
                error: function (jqXHR) {

                    element.html(jqXHR.responseText);
                }
            });
        });
    }
}



function getReservationModalScope(source) {
    var $source = source ? $(source) : $();
    var $scope = $source.closest('.custom-modal-body');
    if ($scope.length) return $scope.last();

    $scope = $('.custom-modal-body:visible').last();
    return $scope.length ? $scope : $(document);
}

function getReservationModalArea(selector, source) {
    var $scope = getReservationModalScope(source);
    var $area = $scope.find(selector).last();
    if ($area.length) return $area;
    return $(selector).filter(':visible').last();
}

async function loadReservationModalDetailsArea(source) {

    var element = getReservationModalArea("#_ModalReservationDetails", source);
    if (!element.length) return;
    var id = element.data('id');

    $.ajax({
        url: "/Reservation/_ModalReservationDetails",
        type: "POST",
        data: { id: id },
        success: function (response) {
            element.html(response);
        },
        error: function (error) {
            console.error(error);
        }
    });
}

async function loadReservationModalPriceDetailsArea(source) {

    var element = getReservationModalArea("#_ModalReservationPriceDetails", source);
    if (!element.length) return;
    var id = element.data('id');
    var showTotal = element.closest('.reservation-store-step').length > 0;

    var currentHeight = element.outerHeight();
    element.css('min-height', currentHeight + 'px');

    $.ajax({
        url: "/Reservation/_ModalReservationPriceDetails",
        type: "POST",
        data: { id: id, showTotal: showTotal },
        success: function (response) {
            element.html(response);
            element.css('min-height', '');
        },
        error: function (error) {
            console.error(error);
        }
    });
}

async function loadReservationModalMemberCards(source) {

    var element = getReservationModalArea("#_ModalReservationMemberCards", source);
    if (!element.length) return;
    var id = element.data('id');

    try {
        const response = await $.ajax({
            url: "/Reservation/_ModalReservationMemberCards",
            type: "POST",
            data: { id: id }
        });

        element.html(response);

        const wallet = element.find('.reservation-card-wallet');
        const selectedCard = wallet.find('.creditCardOption.checked[data-needs-sync="true"]').first();
        if (selectedCard.length) {
            const controls = wallet.find('.creditCardOption, .useNewReservationCard, .useSavedReservationCards');
            controls.prop('disabled', true);
            wallet.attr('aria-busy', 'true');
            try {
                await Request({
                    url: '/Reservation/UpdateReservationCardInfosForCardId',
                    type: 'POST',
                    data: {
                        id: selectedCard.data('reservation'),
                        cardId: selectedCard.data('id')
                    }
                });
                selectedCard.attr('data-needs-sync', 'false');
            } catch (error) {
                wallet.find('.creditCardOption')
                    .removeClass('checked border-primary')
                    .attr('aria-pressed', 'false');
                wallet.find('.reservation-saved-wallet').addClass('d-none');
                wallet.find('#MemberCreditCardFormDiv').removeClass('d-none');
                ShowErrorAlert(error.responseText || 'Kayıtlı kart seçilemedi. Yeni kart bilgilerinizi girebilirsiniz.');
            } finally {
                controls.prop('disabled', false);
                wallet.removeAttr('aria-busy');
            }
        }
    } catch (error) {
        console.error(error);
    }
}
async function loadReservationModalProductsArea(source) {

    var element = getReservationModalArea("#_ModalReservationProducts", source);
    if (!element.length) return;
    var id = element.data('id');

    $.ajax({
        url: "/Reservation/_ModalReservationProducts",
        type: "POST",
        data: { id: id },
        success: function (response) {
            element.html(response);
        },
        error: function (error) {
            console.error(error);
        }
    });
}









$(document).on("click", ".leaveTeamBtn", function () {

    var element = $(this);

    Swal.fire({
        title: '',
        text: "Emin misiniz?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, Ayrıl!',
        cancelButtonText: 'Vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {

            element.removeClass('leaveTeamBtn');
            element.addClass('opacity-50');

            Request({
                url: '/Member/LeaveTeamAction',
                type: 'POST'
            }).then(() => {

                pageLink('/Takimlarim');
            }).catch((jqXHR) => {

                ShowErrorAlert(jqXHR.responseText);
            });
        }
    });
});


function addToHistory(url) {
    // Aynı URL'yi ardışık olarak eklememek için kontrol
    if (historyStack.length === 0 || historyStack[historyStack.length - 1] !== url) {
        historyStack.push(url);
    }
}

// Geri gitme işlemini kontrol eden kod
$(document).on("click", "#backArea", function () {
    if (historyStack.length >= 2) {
        const lastUrl = historyStack[historyStack.length - 1];
        const prevUrl = historyStack[historyStack.length - 2];

        // Eğer iki URL aynıysa bir önceki geçerli URL'ye dön
        if (lastUrl === prevUrl && historyStack.length > 2) {
            // Daha eski bir URL'ye git
            const olderUrl = historyStack[historyStack.length - 3];
            pageLink(olderUrl);
            // Stack'ten son iki URL'yi çıkar (tekrarı temizle)
            historyStack.splice(-2, 2);
        } else {
            // Normal geri gitme işlemi
            pageLink(prevUrl);
            // Stack'ten son URL'yi çıkar
            historyStack.pop();
        }
    }
});

$(document).on("click", ".openMatchDetailBtn", function () {
    var id = $(this).data("id");

    pageLink(`/Mac/${id}`);
});





$(document).on("click", ".shareOgBtn", async function (e) {
    e.preventDefault();

    var element = $(this);
    var type = element.data("type");
    var url = element.data("url");
    var shareUrl = "";

    switch (type) {
        case "whattsapp":
            shareUrl = "https://wa.me/?text=" + encodeURIComponent(url);
            location.href = shareUrl;
            break;

        case "facebook":
            shareUrl = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url);
            location.href = shareUrl;
            break;

        case "twitter":
            shareUrl = "https://twitter.com/intent/tweet?url=" + encodeURIComponent(url);
            location.href = shareUrl;
            break;

        case "instagram":

            if (navigator.share && !isAndroidWebView()) {
                // Native Share API

                try {
                    await navigator.share(encodeURIComponent(url));
                } catch (error) {
                    console.error("Paylaşım iptal edildi veya başarısız oldu:", error);
                }
            } else {
                // Android WebView Share

                if (window.jsBridge && window.jsBridge.postMessage) {
                    window.jsBridge.postMessage("url:" + encodeURIComponent(url));
                } else {
                    ShowErrorAlert("jsBridge interface yok");
                }
            }
            return;

        default:
            return;
    }
});





$(document).on("click", "#addTeamPageBtn", async function () {

    var url = $(this).data("url");

    try {
        const memberId = await getCurrentUserId();

        if (memberId > 0) {
            try {
                await pageLink(url);

                Permission().then(response => {
                    if (response) {

                        addTeam();
                    }
                });
            } catch (error) {
                ShowErrorAlert();
            }
        } else {
            Swal.fire(
                'Uyarı',
                'Takım kurmak için giriş yapılmalıdır.',
                'info'
            );
        }
    } catch (error) {
        ShowErrorAlert();
    }
});


async function loadMyReviewsAndMyFavoruitesPartials() {

    Request({
        url: '/Degerlendirmelerim',
        data: {
            pageLink: true,
            partial: true
        },
        type: 'GET',
        cacheable: false,
        target: '#MyReviewsArea'
    }).catch(function (error) {
        ShowErrorAlert(error.responseText);
    });

    Request({
        url: '/Favorilerim',
        data: {
            pageLink: true,
            partial: true
        },
        type: 'GET',
        cacheable: false,
        target: '#MyFavoruitesArea'
    }).catch(function (error) {
        ShowErrorAlert(error.responseText);
    });
}


async function loadMyAccountTable() {

    Request({
        url: '/Member/_MyAccountTable',
        type: 'POST',
        cacheable: false,
        target: '#_MyAccountTableArea'
    }).catch(function (error) {
        ShowErrorAlert(error.responseText);
    });
}





$(document).on("click", ".openMyMatch", function () {
    var matchId = $(this).data("id");

    pageLink(`/Mac-Olustur/${matchId}`);
});


$(document).on("change", "#EventTypeSelect", function () {
    var id = $(this).val();

    $('#EventTypeGroupSelect option').show();

    $('#EventTypeGroupSelect option').filter(function () {
        return $(this).data('id') != id;
    }).hide();



    var option = $('#EventTypeGroupSelect option[data-id="' + id + '"]').first();

    option.prop('selected', true);

    $('#EventTypeGroupSelect').val(option.val()).trigger('change');

});





$(document).on("click", ".CheckBoxSwitchForHiddenInput", function () {

    const $icon = $(this).find(".CheckBoxSwitchForHiddenInputIcon");
    const $input = $(this).find(".CheckBoxSwitchForHiddenInputValueInput");

    const newValue = $input.val() !== "True";

    $input.val(newValue ? "True" : "False");
    $icon
        .toggleClass("fa-toggle-on", newValue)
        .toggleClass("fa-toggle-off", !newValue);

});


$(document).on("click", ".OpenChatProfilePage", function (event) {

    if ($(event.target).closest('.moderation-report-chat, .js-share-community-invite, .js-chat-profile-action, .js-teamless-show-guide').length > 0) {
        return;
    }

    var element = $(this);
    var url = element.data('url');

    const modal = createModal({
        title: 'Sohbet Detayları'
    });

    Request({
        url: url,
        type: 'GET',
        success: function (response) {

            modal.updateContent(response);

            syncGlobalActionBtnAreas();
            updateGlobalRequestCards();
            StaffEditorAreaEach();
        },
        error: function (jqXHR) {
            console.error("OpenChatProfilePage - Error details:", jqXHR.responseText);
            ShowErrorAlert();
        }
    });
});

$(document).on("click", ".js-chat-profile-action", function (event) {
    event.preventDefault();
    event.stopPropagation();

    var button = $(this);
    var action = String(button.data("action") || "");
    var chatId = Number(button.data("chat-id")) || 0;
    var districtId = Number(button.data("district-id")) || 0;
    var teamId = Number(button.data("team-id")) || 0;
    var url = button.data("url");

    if (button.prop("disabled"))
        return;

    if (action === "match") {
        if (String(button.data("group-match")) === "true") {
            openTeamlessMatchEntry({ districtId: districtId, groupChatId: chatId });
            return;
        }
        if (teamId <= 0) {
            if (window.Swal && typeof window.Swal.fire === "function") {
                window.Swal.fire({
                    icon: "info",
                    title: "Önce bir takım gerekli",
                    text: "Maç oluşturabilmek için bir takım sahibi olmalı veya bir takımın kadrosunda yer almalısın.",
                    showCancelButton: true,
                    confirmButtonText: "Takımlarım'a Git",
                    cancelButtonText: "Vazgeç"
                }).then(function (result) {
                    if (!result.isConfirmed)
                        return;

                    removeSheedModal();
                    pageLink("/Takimlarim");
                });
            }
            else {
                removeSheedModal();
                pageLink("/Takimlarim");
            }

            return;
        }

        CreateMatchPopUp(teamId, 0, districtId);
        return;
    }

    function openTargetPage() {
        removeSheedModal();
        pageLink(url);
    }

    if (districtId <= 0) {
        openTargetPage();
        return;
    }

    button.prop("disabled", true).addClass("is-loading");

    Request({
        url: "/UsersMessage/ApplyChatDistrict",
        type: "POST",
        data: {
            chatId: chatId,
            target: action
        },
        cacheable: false
    }).then(function () {
        openTargetPage();
    }).catch(function (error) {
        button.prop("disabled", false).removeClass("is-loading");
        ShowErrorAlert(error.responseText);
    });
});





$(document).on("submit", "#TeamForm", function (e) {
    e.preventDefault();

    var typeSelect = $('#EventTypeSelect');

    var form = $(this);
    var formdata = form.serialize();
    var id = form.data('id');
    var teamId = form.data('teamid');
    var selector = form.data('selector');

    Request({
        url: `/Reservation/SaveEvent`,
        type: 'GET',
        data: formdata,
        isFormdata: true
    }).then(() => {

        var selectedOption = typeSelect.find('option:selected');
        var scoreEffect = Number(selectedOption.data('score-effect')) || 0;

        if (scoreEffect !== 0) {

            var dataTeamId = typeSelect.data('teamid');

            if ($('#TeamGoalText_' + dataTeamId).length > 0) {

                var element = $('#TeamGoalText_' + dataTeamId);

                var currentValue = parseInt(element.text(), 10);
                var newValue = currentValue + scoreEffect;

                element.text(newValue);
            }
        }

        updateMatchEventTable(id, teamId, selector);

    }).catch((jqXHR) => {
        console.log("Detail Error details:", jqXHR.responseText);
        ShowErrorAlert();
    });
});

$(document).on("submit", "#_TeamForm", function (e) {
    e.preventDefault();

    var typeSelect = $('#EventTypeSelect');

    var form = $(this);
    var formdata = form.serialize();
    var id = form.data('id');
    var teamId = form.data('teamid');
    var selector = form.data('selector');

    Request({
        url: `/Reservation/SaveEvent`,
        type: 'GET',
        data: formdata,
        isFormdata: true
    }).then(() => {

        var selectedOption = typeSelect.find('option:selected');
        var scoreEffect = Number(selectedOption.data('score-effect')) || 0;

        if (scoreEffect !== 0) {

            var dataTeamId = typeSelect.data('teamid');

            if ($('#TeamGoalText_' + dataTeamId).length > 0) {

                var element = $('#TeamGoalText_' + dataTeamId);

                var currentValue = parseInt(element.text(), 10);
                var newValue = currentValue + scoreEffect;

                element.text(newValue);
            }
        }

        updateMatchEventTable(id, teamId, selector);

    }).catch((jqXHR) => {
        console.log("Detail Error details:", jqXHR.responseText);
        ShowErrorAlert();
    });
});


$(document).on("click", ".deleteMatchEvent", function () {

    var element = $(this);
    var id = element.data('id');
    var teamId = element.data('teamid');
    var reservationId = element.data('reservationid');
    var selector = element.data('selector');
    var scoreEffect = Number(element.data('score-effect')) || 0;

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Bu işlemi geri alamazsınız!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'Hayır, vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: `/Reservation/DeleteMatchEvent`,
                type: 'POST',
                data: {
                    id: id
                }
            }).then(() => {

                updateMatchEventTable(reservationId, teamId, selector);

                if (scoreEffect !== 0) {

                    if ($('#TeamGoalText_' + teamId).length > 0) {

                        var element = $('#TeamGoalText_' + teamId);

                        var currentValue = parseInt(element.text(), 10);
                        var newValue = currentValue - scoreEffect;

                        element.text(newValue);
                    }
                }

            }).catch((jqXHR) => {
                console.log("Detail Error details:", jqXHR.responseText);
                ShowErrorAlert();
            });
        }
    });
});


async function updateMatchEventTable(id, teamId, selector) {

    var target = (selector === 1) ? '#MatchEventsTable' : '#_MatchEventsTable';

    Request({
        url: `/Reservation/MatchEventsTable`,
        type: 'POST',
        data: {
            id: id,
            TeamId: teamId
        },
        target: target
    }).then(() => {

        LoadRelationName();
    }).catch((jqXHR) => {
        console.log("Detail Error details:", jqXHR.responseText);
        ShowErrorAlert();
    });
}



$(document).on('click', '.editMatchPlayerModal', function () {

    var element = $(this);
    var matchPlayerId = element.data('match-player');

    editMatchPlayerModal(matchPlayerId);
});

async function editMatchPlayerModal(matchPlayerId) {

    var modal = createModal({
        title: 'Oyuncu ilanını yönet'
    });

    Request({
        url: `/MatchPlayer/_EditMatchPlayerModal`,
        type: 'POST',
        data: {
            matchPlayerId: matchPlayerId
        },
        target: '#MatchEventArea'
    }).then((response) => {

        modal.updateContent(response);

        loadFindMemberForMatchPlayer();
        updateGlobalRequestCards();

    }).catch((xhr) => {

        modal.updateContent(
            `<div class="text-center p-2 fs-08 fw-bold alert alert-danger m-2 br-12px">
                ${xhr.responseText}
            </div>`);
    });
}

$(document).on('click', '.loadFindMemberForMatchPlayer', function () {

    loadFindMemberForMatchPlayer();
});

async function loadFindMemberForMatchPlayer() {

    var element = $('#FindMemberPageForMyMatch');

    if (element.length > 0) {

        var matchPlayerId = element.data('match-player');

        $.ajax({
            url: '/Oyuncu-Bul',
            type: 'GET',
            data: {
                matchPlayerId: matchPlayerId,
                pageLink: true
            },
            success: function (findMemberPage) {

                $("#FindMemberPageForMyMatch").html(findMemberPage);

                memberSearch();
            },
            error: function (xhr) {

                console.error(xhr.responseText);
            }
        });
    }
}







async function loadMatchEvent(id) {

    var baseDataId = id;
    var relationName = 'MatchEvent';

    Request({
        url: `/MatchEvent/Page`,
        type: 'POST',
        data: { preview: true },
        target: '#MatchEventArea'
    }).then(() => {

        $('<a/>', {
            id: 'detailDefaultFormBtn',
            class: 'd-none',
            'data-name': 'Reservation',
            'data-id': id
        }).appendTo('#MatchEventArea');

        LoadPagerBase();
        Table();
    }).catch((jqXHR) => {
        console.log("Detail Error details:", jqXHR.responseText);
        ShowErrorAlert();
    });
}



$(document).on("click", ".deleteMyMatch", function () {

    var element = $(this);
    var id = element.data("id");

    Swal.fire({
        icon: 'warning',
        text: 'Taslak maçınızı silmek üzeresiniz. ',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Vazgeç',
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/Reservation/DeleteMyMatch',
                type: 'POST',
                data: { id: id },
                success: function () {

                    syncQuickActionBtn();
                    quickActionModal();
                    window.syncNativeLiveActivities?.();
                },
                error: function (xhr, status, error) {
                    ShowErrorAlert();
                }
            });
        }
    });
});
if (!window.openPremiumCancellationDialog) {
    window.openPremiumCancellationDialog = async function (options) {
        options = options || {};
        var escapeHtml = function (value) {
            return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
                return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
            });
        };

        var definitions;
        try {
            var response = await fetch(options.endpoint, { credentials: 'same-origin' });
            if (!response.ok) throw new Error((await response.text()) || 'İptal nedenleri yüklenemedi.');
            definitions = await response.json();
        } catch (error) {
            await Swal.fire({
                icon: 'error',
                title: 'İptal nedenleri yüklenemedi',
                text: error.message || 'Lütfen kısa süre sonra yeniden deneyin.',
                confirmButtonText: 'Tamam'
            });
            return null;
        }

        if (!Array.isArray(definitions) || !definitions.length) {
            await Swal.fire({
                icon: 'info',
                title: 'İptal nedeni bulunamadı',
                text: 'Bu işlem için kullanılabilir bir iptal neden tanımı bulunmuyor.',
                confirmButtonText: 'Tamam'
            });
            return null;
        }

        var descriptionMode = options.descriptionMode === 'required-only' ? 'required-only' : 'always';
        var reasonCards = definitions.map(function (definition) {
            return '<label class="premium-cancel-reason-card">' +
                '<input type="radio" name="premiumCancellationReason" value="' + Number(definition.id) + '" />' +
                '<span class="premium-cancel-reason-check"><i class="fa-solid fa-check"></i></span>' +
                '<span class="premium-cancel-reason-icon"><i class="fa-regular fa-message"></i></span>' +
                '<span class="premium-cancel-reason-copy"><b>' + escapeHtml(definition.name) + '</b>' +
                '<small>' + (definition.requiresDescription ? 'Özel açıklama zorunlu' : 'Hazır iptal nedeni') + '</small></span>' +
                '</label>';
        }).join('');

        var dialogResult = await Swal.fire({
            title: options.title || 'İptal nedenini seçin',
            html: '<div class="premium-cancel-dialog">' +
                '<div class="premium-cancel-dialog-intro"><span><i class="fa-solid fa-shield-halved"></i></span><div><b>' +
                escapeHtml(options.contextLabel || 'GÜVENLİ İPTAL AKIŞI') + '</b><p>' +
                escapeHtml(options.description || 'İşleme devam etmek için iptal nedenini seçin.') + '</p></div></div>' +
                '<div class="premium-cancel-reason-list" role="radiogroup">' + reasonCards + '</div>' +
                '<label id="premiumCancellationDescriptionField" class="premium-cancel-description ' +
                (descriptionMode === 'required-only' ? 'is-hidden' : '') + '">' +
                '<span><b>Özel açıklama</b><small id="premiumCancellationDescriptionHint">İsterseniz seçiminize kısa bir açıklama ekleyebilirsiniz.</small></span>' +
                '<textarea id="premiumCancellationDescription" maxlength="1000" placeholder="Açıklamanızı buraya yazın"></textarea>' +
                '<em id="premiumCancellationDescriptionCount">0 / 1000</em></label>' +
                '<div class="premium-cancel-warning"><i class="fa-solid fa-triangle-exclamation"></i><span>İptal işlemi geri alınamaz. Seçiminizi kontrol ederek devam edin.</span></div>' +
                '</div>',
            showCancelButton: true,
            confirmButtonText: options.confirmText || 'İptali Onayla',
            cancelButtonText: 'Vazgeç',
            focusConfirm: false,
            buttonsStyling: false,
            customClass: {
                popup: 'premium-cancel-popup',
                title: 'premium-cancel-title',
                htmlContainer: 'premium-cancel-html',
                actions: 'premium-cancel-actions',
                confirmButton: 'premium-cancel-confirm',
                cancelButton: 'premium-cancel-dismiss'
            },
            didOpen: function () {
                var popup = Swal.getPopup();
                var descriptionField = popup.querySelector('#premiumCancellationDescriptionField');
                var descriptionInput = popup.querySelector('#premiumCancellationDescription');
                var descriptionHint = popup.querySelector('#premiumCancellationDescriptionHint');
                var descriptionCount = popup.querySelector('#premiumCancellationDescriptionCount');
                popup.querySelectorAll('[name="premiumCancellationReason"]').forEach(function (input) {
                    input.addEventListener('change', function () {
                        var selected = definitions.find(function (item) {
                            return Number(item.id) === Number(input.value);
                        });
                        popup.querySelectorAll('.premium-cancel-reason-card').forEach(function (card) {
                            card.classList.toggle('is-selected', card.contains(input));
                        });
                        var isRequired = selected && selected.requiresDescription;
                        descriptionField.classList.toggle(
                            'is-hidden',
                            descriptionMode === 'required-only' && !isRequired
                        );
                        descriptionField.classList.toggle('is-required', Boolean(isRequired));
                        descriptionHint.textContent = isRequired
                            ? 'Bu iptal nedeni için özel açıklama zorunludur.'
                            : 'İsterseniz seçiminize kısa bir açıklama ekleyebilirsiniz.';
                        if (isRequired || descriptionMode === 'always') {
                            window.setTimeout(function () { descriptionInput.focus(); }, 80);
                        } else {
                            descriptionInput.value = '';
                            descriptionCount.textContent = '0 / 1000';
                        }
                    });
                });
                descriptionInput.addEventListener('input', function () {
                    descriptionCount.textContent = descriptionInput.value.length + ' / 1000';
                });
            },
            preConfirm: function () {
                var popup = Swal.getPopup();
                var selectedInput = popup.querySelector('[name="premiumCancellationReason"]:checked');
                if (!selectedInput) {
                    Swal.showValidationMessage('İptal nedenlerinden birini seçmelisiniz.');
                    return false;
                }
                var definition = definitions.find(function (item) {
                    return Number(item.id) === Number(selectedInput.value);
                });
                var description = (popup.querySelector('#premiumCancellationDescription').value || '').trim();
                if (!definition) {
                    Swal.showValidationMessage('Seçilen iptal nedeni geçersiz.');
                    return false;
                }
                if (definition.requiresDescription && !description) {
                    Swal.showValidationMessage(definition.name + ' için özel açıklama zorunludur.');
                    return false;
                }
                return {
                    id: Number(definition.id),
                    name: definition.name,
                    requiresDescription: Boolean(definition.requiresDescription),
                    description: description
                };
            }
        });

        return dialogResult.isConfirmed ? dialogResult.value : null;
    };
}

$(document).on("click", ".deleteMyReservation", function () {

    var element = $(this);
    var id = element.data("id");
    var last = element.data("last");

    Request({
        url: '/Reservation/_DeleteMyReservation',
        type: 'POST',
        data: { id: id },
        success: async function (response) {
            if (response.permission) {
                const cancellation = await window.openPremiumCancellationDialog({
                    endpoint: '/Reservation/MemberCancellationReasons',
                    title: 'İptal nedeni seçin',
                    contextLabel: 'ÜYE · REZERVASYON İPTALİ',
                    description: response.refundRequired
                        ? 'Kart ödemeniz bankada iptal/iade edildikten sonra rezervasyon iptal edilecek. ' + last
                        : 'Rezervasyonunuzu iptal etmek üzeresiniz. ' + last,
                    confirmText: 'Rezervasyonu İptal Et',
                    descriptionMode: 'always'
                });
                if (!cancellation) return;

                Request({
                    url: '/Reservation/DeleteReservation',
                    type: 'POST',
                    data: {
                        id: id,
                        cancellationReasonId: cancellation.id,
                        cancellationReason: cancellation.name,
                        cancellationDescription: cancellation.description
                    },
                    success: function () {
                        pageLink('/Rezervasyonlarim');
                    },
                    error: function (xhr, status, error) {
                        ShowErrorAlert(xhr.responseText || 'Rezervasyon iptal edilemedi.');
                    }
                });
            }
            else {

                ShowErrorAlert(response.message || "İşlem izni reddedildi");
            }
        },
        error: function (xhr, status, error) {
            ShowErrorAlert();
        }
    });
});
$(document).on("click", ".openMyReservation", function () {

    var id = $(this).data("id");

    Request({
        url: '/Reservation/_MyReservation',
        type: 'POST',
        data: { id: id },
        success: function (partialView) {

            var dialog = bootbox.dialog({
                title: "Rezervasyon Kartı",
                message: partialView,
                size: 'xl',
                onShown: function () {

                    LoadRelationName();
                }
            });
        },
        error: function (xhr, status, error) {
            ShowErrorAlert();
        }
    });
});

$(document).on('input', '#Cvc', function () {
    this.value = this.value.replace(/[^0-9]/g, '');

    if (this.value.length > 4) {
        this.value = this.value.slice(0, 4);
    }
});

$(document).on('input', '#CardNumber', function () {
    this.value = this.value.replace(/[^0-9]/g, '');

    if (this.value.length > 19) {
        this.value = this.value.slice(0, 19);
    }

    var previewValue = (this.value + '••••••••••••••••').slice(0, 16).match(/.{1,4}/g);
    $('#reservationCardNumberPreview').text((previewValue || []).join(' '));
});

$(document).on('input', '#CardName', function () {
    $('#reservationCardNamePreview').text($(this).val().trim().toLocaleUpperCase('tr-TR') || 'KART SAHİBİ');
});

$(document).on("click", ".paymentOption", async function () {

    var element = $(this);
    var scope = getReservationModalScope(element);
    var paymentType = element.data('type');
    var paymentAmountType = scope.find('.reservation-payment-amount-input:checked').first().val() || 'full';

    var id = scope.find("#_ModalReservationPriceDetails").last().data('id') || scope.find("#ModalTime").last().data('reservation');

    // Öncelikle Ödeme Tipini Kaydet
    Request({
        url: "/Reservation/UpdateReservationPaymentType",
        type: 'POST',
        data: {
            id: id,
            paymentType: paymentType,
            paymentAmountType: paymentAmountType
        }
    }).then(() => {

        loadReservationModalPriceDetailsArea(scope);
    }).catch(() => {

    });
});

async function selectReservationSavedCard(element) {
    var wallet = element.closest('.reservation-card-wallet');
    var id = element.data("id");
    var reservationId = element.data("reservation");

    if (element.hasClass('checked') && wallet.find('#MemberCreditCardFormDiv').hasClass('d-none')) {
        return;
    }

    var controls = wallet.find('.creditCardOption, .useNewReservationCard, .useSavedReservationCards');
    controls.prop('disabled', true);
    try {
        await Request({
            url: '/Reservation/UpdateReservationCardInfosForCardId',
            type: 'POST',
            data: {
                id: reservationId,
                cardId: id
            }
        });

        wallet.find('.creditCardOption')
            .removeClass('checked border-primary')
            .attr('aria-pressed', 'false');

        element
            .addClass('checked border-primary')
            .attr('aria-pressed', 'true')
            .attr('data-needs-sync', 'false');

        resetReservationDirectCardForm();
        wallet.find('.reservation-return-saved-card').attr('data-card-id', id);
        wallet.find('#MemberCreditCardFormDiv').addClass('d-none');
        wallet.find('.reservation-saved-wallet').removeClass('d-none');
        $('#creditCardFormArea').addClass('d-none');
    } catch (error) {
        ShowErrorAlert(error.responseText || 'Kayıtlı kart seçilemedi. Lütfen tekrar deneyin.');
    } finally {
        controls.prop('disabled', false);
    }
}

$(document).on("click", ".creditCardOption", async function () {
    await selectReservationSavedCard($(this));
});

$(document).on("click", ".useNewReservationCard", async function () {
    var element = $(this);
    var wallet = element.closest('.reservation-card-wallet');
    var reservationId = element.data("reservation");
    var selectedCard = wallet.find('.creditCardOption.checked').first();

    if (selectedCard.length) {
        wallet.find('.reservation-return-saved-card').attr('data-card-id', selectedCard.data('id'));
    }

    var controls = wallet.find('.creditCardOption, .useNewReservationCard, .useSavedReservationCards');
    controls.prop('disabled', true);
    try {
        await Request({
            url: '/Reservation/UpdateReservationCardInfosForCardId',
            type: 'POST',
            data: {
                id: reservationId,
                cardId: 0
            }
        });

        wallet.find('.creditCardOption')
            .removeClass('checked border-primary')
            .attr('aria-pressed', 'false');
        resetReservationDirectCardForm();
        wallet.find('.reservation-saved-wallet').addClass('d-none');
        wallet.find('#MemberCreditCardFormDiv').removeClass('d-none');
        $('#creditCardFormArea').removeClass('d-none');
    } catch (error) {
        ShowErrorAlert(error.responseText || 'Yeni kart formu açılamadı. Lütfen tekrar deneyin.');
    } finally {
        controls.prop('disabled', false);
    }
});

$(document).on("click", ".useSavedReservationCards", async function () {
    var element = $(this);
    var wallet = element.closest('.reservation-card-wallet');
    var cardId = Number(element.attr('data-card-id'));
    var card = wallet.find('.creditCardOption[data-id="' + cardId + '"]').first();
    if (!card.length) card = wallet.find('.creditCardOption').first();
    if (card.length) await selectReservationSavedCard(card);
});

function resetReservationDirectCardForm() {
    var form = document.getElementById('MemberCreditCardForm');
    if (form) form.reset();
    $('#MemberCreditCardForm .creditCardFormInput').removeClass('is-invalid');
    $('#reservationCardNumberPreview').text('•••• •••• •••• ••••');
    $('#reservationCardNamePreview').text('KART SAHİBİ');
}

function validateReservationDirectCardForm(source) {
    var form = getReservationModalScope(source).find('#MemberCreditCardForm').last();
    if (!form.length) return { valid: false, message: 'Kart formu yüklenemedi. Lütfen tekrar deneyin.' };

    var cardName = String(form.find('[name="CardName"]').val() || '').trim();
    var cardNumber = String(form.find('[name="CardNumber"]').val() || '').replace(/\D/g, '');
    var cvc = String(form.find('[name="Cvc"]').val() || '').replace(/\D/g, '');
    var month = Number(form.find('[name="LastMonth"]').val());
    var yearValue = Number(form.find('[name="LastYear"]').val());
    var fullYear = yearValue < 100 ? 2000 + yearValue : yearValue;
    var now = SahaseninTime.calendarToday();
    var expired = fullYear &&
        (fullYear < now.getFullYear() ||
         (fullYear === now.getFullYear() && month < now.getMonth() + 1));

    form.find('.creditCardFormInput').removeClass('is-invalid');
    if (cardName.length < 2) form.find('[name="CardName"]').addClass('is-invalid');
    if (cardNumber.length < 12 || cardNumber.length > 19) form.find('[name="CardNumber"]').addClass('is-invalid');
    if (cvc.length < 3 || cvc.length > 4) form.find('[name="Cvc"]').addClass('is-invalid');
    if (!month || month < 1 || month > 12) form.find('[name="LastMonth"]').addClass('is-invalid');
    if (!fullYear || expired) form.find('[name="LastYear"], [name="LastMonth"]').addClass('is-invalid');

    if (form.find('.creditCardFormInput.is-invalid').length) {
        return {
            valid: false,
            message: expired
                ? 'Kartın son kullanma tarihi geçmiş. Lütfen geçerli bir kart kullanın.'
                : 'Kart üzerindeki isim, kart numarası, son kullanma tarihi ve CVC alanlarını eksiksiz girin.'
        };
    }

    return { valid: true, message: '' };
}

function updateReservationSummaryPaymentAmount(paymentAmountType, source) {
    var $summary = getReservationModalScope(source).find('.reservation-summary-card.price').last();
    if (!$summary.length) return;

    var paysDeposit = paymentAmountType === 'deposit';
    var baseAmount = Number($summary.attr(paysDeposit ? 'data-deposit-amount' : 'data-full-base-amount')) || 0;
    var payableAmount = Number($summary.attr(paysDeposit ? 'data-deposit-amount' : 'data-full-payable-amount')) || 0;
    var formatter = new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    $summary.find('.reservation-summary-payment-title').text(paysDeposit ? 'Kapora Bedeli' : 'Maç Ücreti');
    $summary.find('.reservation-summary-base-amount').text('₺' + formatter.format(baseAmount));
    $summary.find('.reservation-summary-payable-amount').text('₺' + formatter.format(payableAmount));
}

$(document).on('change', '.reservation-payment-amount-input', function () {
    var scope = getReservationModalScope(this);
    var value = String($(this).val() || 'full');
    scope.find('.reservation-payment-amount-input[value="' + value + '"]').prop('checked', true);
    updateReservationSummaryPaymentAmount(value, scope);

    scope.find('[data-reservation-payment-deadline]').each(function () {
        var deadline = $(this);
        deadline.find('[data-reservation-deadline-title]').text('Son Ödeme Zamanı');
        deadline.find('[data-reservation-deadline-value]').text(
            deadline.data('deposit-deadline')
        );
    });
});

$(document).on("submit", "#MemberCreditCardForm", function (e) {
    e.preventDefault();
});
$(document).on('change', '#_TeamId', function () {
    var _TeamIdValue = $(this).val();

    if (_TeamIdValue == 0) {
        if ($('#TeamId option[value="0"]').length === 0) {
            $('#TeamId').prepend('<option value="0">Takım olmasın</option>');
        }
    }
    else if (_TeamIdValue > 0) {
        $('#TeamId option[value="0"]').remove();

        $('#TeamId option:first').prop('selected', true);
    }
});

$(document).on('click', '.addTeam', function () {

    var memberId = $(this).data('memberid');
    var permission = $(this).data('permission');

    if ($(this).data('after-create') === 'match') {
        pendingCreateMatchAfterTeam = {
            rivalTeamId: 0,
            districtId: 0
        };
    }

    if (permission != "PermissionModal") {
        addTeam();
    }
    else {

        permissionModal();
    }
});


$(document).on('submit', '#PostForm', function (e) {
    e.preventDefault();

    if (validation()) {

        var form = $(this);
        var formData = form.serialize();
        formData += getFormData();

        Request({
            url: '/Post/Save',
            type: 'POST',
            data: formData,
            success: function () {

                removeSheedModal();
                updateMyPostsTableArea();
            },
            error: function (xhr, status, error) {

                ShowErrorAlert();
                console.error("Detaylı hata bilgisi:", error.responseText);
            }
        });
    }
});

$(document).on('click', '.AddPostPopup', function () {

    var element = $(this);
    var video = element.data('video');

    Request({
        url: `/Post/_PostForm`,
        type: 'POST',
        cacheable: false,
        data: {
            id: 0,
            video: video
        },
        success: function (partialView) {
            if (partialView) {

                const modal = createModal({
                    title: 'Yeni Gönderi'
                });

                modal.updateContent(partialView);

                parentS2each();
                loadCKeditor();
            } else {
                ShowErrorAlert();
            }
        },
        error: function (jqXHR) {
            console.error("AddPostPopup(): ", jqXHR.responseText);
            ShowErrorAlert();
        }
    });
});
$(document).on('click', '.EditPostPopup', function () {

    var id = $(this).data('id');

    Request({
        url: `/Post/_PostForm`,
        type: 'POST',
        data: { id: id },
        success: function (partialView) {
            if (partialView) {

                const modal = createModal({
                    title: 'Gönderiyi Düzenle'
                });

                modal.updateContent(partialView);

                parentS2each();
                loadCKeditor();

            } else {
                ShowErrorAlert();
            }
        },
        error: function (jqXHR) {
            console.error("EditPostPopup(): ", jqXHR.responseText);
            ShowErrorAlert();
        }
    });
});
$(document).on('click', '.DeletePostPopup', function () {

    var id = $(this).data('id');

    Swal.fire({
        title: 'Emin misiniz?',
        text: 'Bu Gönderiyi silmek istediğinize emin misiniz?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: `/Post/Delete`,
                type: 'POST',
                data: {
                    id: id
                },
                success: function () {

                    updateMyPostsTableArea();
                },
                error: function (jqXHR) {
                    console.error("DeletePostPopup - Error details:", jqXHR.responseText);
                    ShowErrorAlert();
                }
            });
        }
    });
});







$(document).on('click', '.updateMemberStatsBtn', function () {

    var element = $(this);
    var memberId = element.data('member');

    var target = $('.memberStatisticsArea[data-member="' + memberId + '"]');
    InitLoadScreenElement(target);

    Request({
        url: `/Member/_MemberStatistics`,
        type: 'POST',
        data: {
            id: memberId
        },
        success: function (response) {

            target.html(response);
        },
        error: function (jqXHR) {
            console.error("updateMemberStats():", jqXHR.responseText);
            ShowErrorAlert();
        }
    });
});


// 1. Yıl Değiştiğinde Çalışacak Fonksiyon
function changeFixtureYear(selectedYear) {
    // Bütün yıl konteynerlarını gizle
    const allYearContainers = document.querySelectorAll('.year-container');
    allYearContainers.forEach(container => {
        container.classList.add('d-none');
    });

    // Sadece seçilen yılın konteynerını göster
    const targetYearContainer = document.getElementById('year-container-' + selectedYear);
    if (targetYearContainer) {
        targetYearContainer.classList.remove('d-none');
    }
}

// 2. Hafta Tablarına Tıklandığında Çalışacak Fonksiyon
function changeWeekTab(clickedElement, targetId, yearKey) {
    // Tıklanan elementin bulunduğu tab bar'ı (card-container) bul
    const tabContainer = clickedElement.closest('.card-container');

    // O tab bar içindeki tüm sekmelerden activeCard class'ını kaldır
    const allTabs = tabContainer.querySelectorAll('.btnHref');
    allTabs.forEach(tab => {
        tab.classList.remove('activeCard');
    });

    // Tıklanan sekmeye activeCard class'ını ekle
    clickedElement.classList.add('activeCard');

    // İlgili yılın içerik alanını (week-contents) bul
    const contentContainer = document.querySelector('.week-contents-' + yearKey);

    // O yıla ait tüm hafta içeriklerini gizle
    const allTargets = contentContainer.querySelectorAll('.targetDiv');
    allTargets.forEach(target => {
        target.classList.add('d-none');
    });

    // Sadece tıklanan hedefin id'sine sahip div'i göster
    const targetDiv = document.getElementById(targetId);
    if (targetDiv) {
        targetDiv.classList.remove('d-none');
    }
}


$(document).on('click', '.OpenMemberStatistics', function () {

    var element = $(this);
    var url = element.data('url');
    var memberId = element.data('member');

    var modal = createModal({
        title: 'Oyuncu inceleniyor'
    });

    Request({
        url: url,
        type: 'GET',
        data: {
            pageLink: true,
            selectStatisticsTab: true
        }
    }).then((partialView) => {

        modal.updateContent(partialView);

        var target = $('.memberStatisticsArea[data-member="' + memberId + '"]');
        InitLoadScreenElement(target);

        Request({
            url: `/Member/_MemberStatistics`,
            type: 'POST',
            data: {
                id: memberId,
                selectedTeam: true
            },
            success: function (response) {

                afterPage(url);
                target.html(response);
            },
            error: function (jqXHR) {
                console.error("updateMemberStats():", jqXHR.responseText);
                ShowErrorAlert();
            }
        });

    }).catch((jqXHR) => {
        modal.updateContent(`<span class="w-100 text-center p-2 text-red fw-bold">${jqXHR.responseText}</span>`);
    });
});


async function updateMyPostsTableArea() {

    var target = $('#_MyPostsTableArea');

    if (target.length > 0) {

        Request({
            url: `/Blog/_MyPostsTable`,
            type: 'POST',
            cacheable: false,
            success: function (response) {

                target.html(response);
            }
        });
    }
}






$(document).on('change', '#VideoFileInput', function () {
    var formData = new FormData();
    formData.append('upload', this.files[0]);

    Swal.fire({
        title: 'Yükleniyor...',
        text: 'Lütfen bekleyin, dosyanız yükleniyor.',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });

    $.ajax({
        url: '/FileUpload',
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        success: function (response) {

            Swal.close();

            var url = response.url;

            $('#Video').val(url);

            ShowSuccessAlert();
        },
        error: function (xhr, status, error) {

            Swal.close();
            ShowErrorAlert();
        }
    });
});


$(document).on('click', '.DeleteEventVideoPopupBtn', function () {
    var element = $(this);
    var id = element.data('id');

    Swal.fire({
        title: 'Emin misiniz?',
        text: 'Bu videoyu silmek istediğinize emin misiniz?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: `/Reservation/DeleteMatchVideo`,
                type: 'POST',
                data: {
                    id: id
                },
                success: function () {

                    updateMatchEventsArea();
                },
                error: function (jqXHR) {
                    console.error("deleteTeam - Error details:", jqXHR.responseText);
                    ShowErrorAlert();
                }
            });
        }
    });
});

$(document).off('click', '.js-toggle-more').on('click', '.js-toggle-more', function () {
    var $btn = $(this);

    if ($btn.is(':disabled'))
        return;

    var target = $btn.data('target');
    var $target = $(target);

    // Şu an açık mı?
    var isOpen = $btn.data('open') === true;

    // Toggle durumunu set et
    $btn.data('open', !isOpen);

    // Buton üzerindeki gizli kayıt sayısını her tıklamada güncelle
    var hiddenCountText = $btn.text().match(/\((\d+)\)/);
    var hiddenCount = hiddenCountText ? parseInt(hiddenCountText[1]) : 0;
    $btn.data('hidden-count', hiddenCount);

    // Metin ve ikon güncelle
    if (isOpen) {

        $target.addClass('d-none');

        $btn.find('i').removeClass('fa-minus').addClass('fa-plus');
        $btn.contents().filter(function () {
            return this.nodeType === 3;
        }).remove();
        $btn.append(' Daha Fazla (' + hiddenCount + ')');
    } else {

        $target.removeClass('d-none');

        $btn.find('i').removeClass('fa-plus').addClass('fa-minus');
        $btn.contents().filter(function () {
            return this.nodeType === 3;
        }).remove();
        $btn.append(' Daha Az (' + hiddenCount + ')');
    }
});






async function updateMatchEventsArea() {

    var elements = $('.MatchEventsArea');

    if (elements.length === 0)
        return;

    var promises = [];

    elements.each(function () {

        var element = $(this);
        InitLoadScreenElement(element);

        var matchId = element.data('match');

        var promise = $.ajax({
            url: '/Reservation/MatchEventsArea',
            type: 'POST',
            data: {
                id: matchId
            }
        })
            .done(function (response) {
                element.html(response);
            })
            .fail(function (jqXHR) {
                element.html(jqXHR.responseText);
            });

        promises.push(promise);
    });

    // tüm requestler bitsin
    await Promise.allSettled(promises);

    // artık güvenli
    await syncLargeMatchCards();
}



$(document).on('click', '.AddEventVideoPopupBtn', function () {
    var element = $(this);
    var id = element.data('id');
    var matchId = element.data('match');

    const modal = createModal({
        title: 'Pozisyon Videosu Ekle'
    });

    Request({
        url: `/MatchVideo/_MatchVideoForm`,
        type: 'POST',
        data: {
            id: 0,
            matchId: matchId,
            eventId: id
        },
        success: function (partialView) {
            if (partialView) {

                modal.updateContent(partialView);

                parentS2each();
                loadCKeditor();
            } else {
                console.error("addTeam - Boş partialView alındı.");
                ShowErrorAlert();
            }
        },
        error: function (jqXHR) {

            modal.updateContent(`<span class="w-100 text-center p-2 text-red fw-bold">${jqXHR.responseText}</span>`);
        }
    });
});
$(document).on('click', '.editVideoBtn', function () {
    var element = $(this);
    var id = element.data('id');
    var matchId = element.data('match');

    const modal = createModal({
        title: 'Video Düzenle'
    });

    Request({
        url: `/MatchVideo/_MatchVideoForm`,
        type: 'POST',
        data: {
            id: id,
            matchId: matchId
        },
        success: function (partialView) {
            if (partialView) {

                modal.updateContent(partialView);

                parentS2each();
                loadCKeditor();
            } else {
                console.error("addTeam - Boş partialView alındı.");
                ShowErrorAlert();
            }
        },
        error: function (jqXHR) {

            modal.updateContent(`<span class="w-100 text-center p-2 text-red fw-bold">${jqXHR.responseText}</span>`);
        }
    });
});
$(document).on('submit', '#MatchVideoForm', function (e) {
    e.preventDefault();

    var form = $(this);
    var formData = form.serialize();
    formData += getFormData();

    Request({
        url: '/MatchVideo/Save',
        type: 'POST',
        data: formData,
        success: function () {

            removeSheedModal();
            updateMatchVideoArea();

            updateMatchEventsArea();
        },
        error: function (xhr, status, error) {

            ShowErrorAlert();
            console.error("Detaylı hata bilgisi:", error.responseText);
        }
    });
});
$(document).on('click', '#AddMatchVideoBtn', function () {

    var element = $(this);
    var matchId = element.data('match');

    const modal = createModal({
        title: 'Video Ekle'
    });

    Request({
        url: `/MatchVideo/_MatchVideoForm`,
        type: 'POST',
        data: {
            id: 0,
            matchId: matchId
        },
        success: function (partialView) {
            if (partialView) {

                modal.updateContent(partialView);

                parentS2each();
                loadCKeditor();
            } else {
                console.error("addTeam - Boş partialView alındı.");
                ShowErrorAlert();
            }
        },
        error: function (jqXHR) {

            modal.updateContent(`<span class="w-100 text-center p-2 text-red fw-bold">${jqXHR.responseText}</span>`);
        }
    });
});
$(document).on('click', '.deleteVideoBtn', function () {
    var element = $(this);
    var id = element.data('id');

    Swal.fire({
        title: 'Emin misiniz?',
        text: 'Bu videoyu silmek istediğinize emin misiniz?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: `/MatchVideo/DeleteMatchVideo`,
                type: 'POST',
                data: {
                    id: id
                },
                success: function () {

                    updateMatchVideoArea();
                },
                error: function (jqXHR) {

                    ShowErrorAlert(jqXHR.responseText);
                }
            });
        }
    });
});




$(document).on('click', '.MyDeletedReservationsBtn', function () {

    InitLoadScreen('#Div_MyDeletedReservations');

    Request({
        url: `/Member/MyDeletedOrdersTable`,
        type: 'POST',
        target: '#Div_MyDeletedReservations',
        success: function () {

        },
        error: function (jqXHR) {

        }
    });
});


async function updateMatchVideoArea() {

    var target = '#MatchVideoArea';
    var element = $(target);

    if (element.length) {
        var id = element.data('id');

        Request({
            url: '/Reservation/MatchVideoArea',
            type: 'POST',
            data: {
                id: id
            },
            target: target
        });
    }
}


// $(document).on('click', '#fastEditTeam', function () {

//     var id = $(this).data('id');

//     Request({
//         url: '/Team/_TeamForm',
//         type: 'POST',
//         data: {
//             id: id
//         },
//         success: function (partialView) {
//             if (partialView) {

//                 const modal = createModal({
//                     title: 'Hızlı Düzenle'
//                 });

//                 modal.updateContent(partialView);

//                 readyDynamicFilterPage();
//                 dateInputLoad();
//                 loadCKeditor();
//                 parentS2each();

//             } else {

//                 console.error("addTeam - Boş partialView alındı.");
//                 ShowErrorAlert();
//             }
//         },
//         error: function (jqXHR) {

//             console.error("addTeam - Error details:", jqXHR.responseText);
//             ShowErrorAlert(jqXHR.responseText);
//         }
//     });
// });

var activeCreateTeamOverlay = null;
var createdTeamDetailUrl = '';
var pendingCreateMatchAfterTeam = null;

function closeCreateTeamOverlay(fromHistory) {
    if (activeCreateTeamOverlay && activeCreateTeamOverlay.historyToken &&
        typeof window.releaseModalHistory === 'function') {
        window.releaseModalHistory(activeCreateTeamOverlay.historyToken, fromHistory === true);
    }

    if (activeCreateTeamOverlay && activeCreateTeamOverlay.element) {
        activeCreateTeamOverlay.element.remove();
    } else {
        $('.team-create-overlay').remove();
    }

    $('body').removeClass('team-create-overlay-open');
    activeCreateTeamOverlay = null;
}

function createTeamOverlay() {
    closeCreateTeamOverlay(true);

    var $overlay = $('<div>', {
        'class': 'team-create-overlay',
        'role': 'dialog',
        'aria-modal': 'true',
        'aria-label': 'Takım oluşturma'
    });
    var $shell = $('<div>', { 'class': 'team-create-overlay-shell' });

    $shell.html(
        '<div class="team-create-overlay-loading fs-08" role="status">' +
            '<span><i class="fa-solid fa-spinner fa-spin"></i></span>' +
            '<strong>Takım oluşturma hazırlanıyor</strong>' +
        '</div>'
    );
    $overlay.append($shell);
    $('body').addClass('team-create-overlay-open').append($overlay);

    activeCreateTeamOverlay = {
        element: $overlay,
        updateContent: function (content) {
            $shell.html(content);
            $overlay.scrollTop(0);
        }
    };

    if (typeof window.registerModalHistory === 'function') {
        activeCreateTeamOverlay.historyToken = window.registerModalHistory(function () {
            pendingCreateMatchAfterTeam = null;
            createdTeamDetailUrl = '';
            closeCreateTeamOverlay(true);
        });
    }

    return activeCreateTeamOverlay;
}

function showCreateTeamStep(stepName) {
    var $overlay = $('.team-create-overlay');
    var $steps = $overlay.find('[data-create-team-step]');
    var $target = $steps.filter('[data-create-team-step="' + stepName + '"]');

    if (!$target.length) return;

    $steps.prop('hidden', true).attr('aria-hidden', 'true');
    $target.prop('hidden', false).attr('aria-hidden', 'false');
    $overlay.scrollTop(0);
    $target.find('h1').first().attr('tabindex', '-1').trigger('focus');
}

function updateCreateTeamLocationSummary($form) {
    var cityName = $form.find('#CreateTeamCityId option:selected').text().trim();
    var districtName = $form.find('#CreateTeamDistrictId option:selected').text().trim();
    var summary = cityName && districtName
        ? cityName + ', ' + districtName
        : 'İl ve ilçe seç';

    $form.find('[data-create-team-location-summary]').text(summary);
}

function filterCreateTeamDistricts($form, preferredDistrictId) {
    var cityId = String($form.find('#CreateTeamCityId').val() || '');
    var $district = $form.find('#CreateTeamDistrictId');
    var options = $form.data('create-team-district-options') || [];
    var matchingOptions = options.filter(function (option) {
        return String(option.cityId) === cityId;
    });

    $district.empty();
    matchingOptions.forEach(function (option) {
        $district.append($('<option>', {
            value: option.value,
            text: option.text
        }).attr('data-cityid', option.cityId));
    });

    var preferredValue = String(preferredDistrictId || '');
    if (matchingOptions.some(function (option) { return String(option.value) === preferredValue; })) {
        $district.val(preferredValue);
    } else if (matchingOptions.length) {
        $district.val(String(matchingOptions[0].value));
    }

    updateCreateTeamLocationSummary($form);
}

function initializeCreateTeamLocation($form) {
    if (!$form.length || $form.data('create-team-location-ready')) return;

    var districtOptions = $form.find('#CreateTeamDistrictId option').map(function () {
        return {
            value: this.value,
            text: $(this).text(),
            cityId: $(this).attr('data-cityid')
        };
    }).get();

    $form.data('create-team-location-ready', true);
    $form.data('create-team-district-options', districtOptions);
    filterCreateTeamDistricts($form, $form.find('#CreateTeamDistrictId').val());
}

async function addTeam() {
    if (await Permission() !== true) return;
    activeCreateTeamOverlay = createTeamOverlay();

    try {
        var partialView = await $.ajax({
            url: '/Team/_CreateTeamForm',
            type: 'POST',
            cache: false
        });

        activeCreateTeamOverlay.updateContent(partialView);
        initializeCreateTeamLocation($('#CreateTeamForm'));
        $('#CreateTeamName').trigger('focus');
    } catch (xhr) {
        var message = xhr && xhr.responseText
            ? xhr.responseText.replace(/^"|"$/g, '')
            : 'Takım oluşturma formu şu anda açılamadı.';

        activeCreateTeamOverlay.updateContent(
            '<div class="team-create-load-error fs-08">' +
                '<span class="fs-09"><i class="fa-solid fa-circle-exclamation"></i></span>' +
                '<h3 class="fs-09">Form açılamadı</h3>' +
                '<p class="fs-08">' + $('<div>').text(message).html() + '</p>' +
                '<button type="button" class="team-secondary-button team-create-close fs-08">Kapat</button>' +
            '</div>'
        );
    }
}

$(document).on('click', '.team-create-location-toggle', function () {
    var $button = $(this);
    var expanded = $button.attr('aria-expanded') === 'true';
    var $location = $button.closest('.team-create-location');

    $button.attr('aria-expanded', String(!expanded));
    $button.find('span').text(expanded ? 'Değiştir' : 'Daralt');
    $location.toggleClass('is-expanded', !expanded);
    $location.find('.team-create-location-fields').prop('hidden', expanded);

    if (!expanded) {
        $location.find('#CreateTeamCityId').trigger('focus');
    }
});

$(document).on('change', '#CreateTeamCityId', function () {
    var $form = $(this).closest('#CreateTeamForm');
    initializeCreateTeamLocation($form);
    filterCreateTeamDistricts($form, '');
});

$(document).on('change', '#CreateTeamDistrictId', function () {
    updateCreateTeamLocationSummary($(this).closest('#CreateTeamForm'));
});

$(document).on('click', '.team-create-show-advanced', function () {
    showCreateTeamStep('advanced');
});

$(document).on('click', '.team-create-back-main', function () {
    showCreateTeamStep('main');
});

$(document).on('click', '.team-create-save-advanced', function () {
    $('.team-create-advanced-launch').addClass('is-complete')
        .find('small').text('Tercihlerin kaydedildi');
    showCreateTeamStep('main');
});

$(document).on('keydown', function (event) {
    if (event.key === 'Escape' && $('.team-create-overlay').length) {
        pendingCreateMatchAfterTeam = null;
        closeCreateTeamOverlay();
        createdTeamDetailUrl = '';
    }
});

$(document).on('click', '.team-create-logo-button, .team-create-logo-link', function () {
    $('#CreateTeamLogoFile').trigger('click');
});

$(document).on('change', '#CreateTeamLogoFile', function () {
    var file = this.files && this.files[0];
    var $error = $('.team-create-error');

    if (!file) return;

    if (!/^image\/(png|jpeg|webp)$/i.test(file.type) || file.size > 5 * 1024 * 1024) {
        this.value = '';
        $error.text('Logo; PNG, JPG veya WebP formatında ve en fazla 5 MB olmalıdır.').addClass('is-visible');
        return;
    }

    $error.removeClass('is-visible').text('');
    $('#CreateTeamLogoPreview').attr('src', URL.createObjectURL(file));
    $('.team-create-logo-link').text('Logoyu değiştir');
});

$(document).on('input', '#CreateTeamDescription', function () {
    $('.team-create-counter span').text(String($(this).val() || '').length);
});

$(document).on('change', '#CreateTeamPrivacy', function () {
    var hidden = !$(this).is(':checked');
    var $row = $(this).closest('.team-privacy-row');

    $('#CreateTeamHiddenProfile').val(hidden ? 'true' : 'false');
    $row.toggleClass('is-private', hidden);
    $row.find('.team-privacy-value').text(hidden ? 'Gizli takım' : 'Herkese açık');
    $row.find('.team-privacy-copy small').text(
        hidden ? 'Takımını yalnızca bağlantıyı paylaştığın kişiler görür.' : 'Takımın aramalarda ve önerilerde görünsün.'
    );
});

$(document).on('submit', '#CreateTeamForm', async function (e) {
    e.preventDefault();

    var $form = $(this);
    var $name = $form.find('[name="Name"]');
    var $error = $form.find('.team-create-error');
    var $submit = $form.find('[type="submit"]');
    var originalButtonHtml = $submit.html();
    var name = String($name.val() || '').trim();

    $form.find('.team-create-field-error').text('');
    $name.removeClass('is-invalid');
    $error.removeClass('is-visible').text('');

    if (name.length < 2) {
        $name.addClass('is-invalid').trigger('focus');
        $form.find('[data-error-for="Name"]').text('Takım adı en az 2 karakter olmalı.');
        return;
    }

    if (!$form.find('[name="TeamPlayerCountTypeId"]:checked').length ||
        !$form.find('[name="TeamLevelTypeId"]:checked').length) {
        $error.text('Oyuncu formatı ve takım seviyesini seçmelisin.').addClass('is-visible');
        return;
    }

    if (Number($form.find('[name="CityId"]').val()) <= 0 ||
        Number($form.find('[name="DistrictId"]').val()) <= 0) {
        showCreateTeamStep('main');
        $form.find('#CreateTeamCityId').trigger('focus');
        $error.text('Takım için il ve ilçe seçmelisin.').addClass('is-visible');
        return;
    }

    $name.val(name);
    $submit.prop('disabled', true).html('<i class="fa-solid fa-spinner fa-spin"></i><span>Takım kuruluyor...</span>');

    try {
        var response = await $.ajax({
            url: '/TeamSave',
            type: 'POST',
            data: $form.serialize()
        });

        var logoInput = document.getElementById('CreateTeamLogoFile');
        var logoFile = logoInput && logoInput.files ? logoInput.files[0] : null;
        var logoPreview = '';
        if (logoFile && response.teamId) {
            try {
                await uploadAndUpdateImage(logoFile, 'Team', response.teamId);
                logoPreview = String($('#CreateTeamLogoPreview').attr('src') || '');
            } catch (uploadError) {
                console.warn('Takım oluşturuldu ancak logo yüklenemedi:', uploadError);
            }
        }

        if (typeof window.refreshTeamCreationSurfaces === 'function') {
            try {
                await window.refreshTeamCreationSurfaces(response);
            } catch (refreshError) {
                console.warn('Takım oluşturuldu ancak açık sayfa yenilenemedi:', refreshError);
            }
        }

        createdTeamDetailUrl = '/Takimim/' + encodeURIComponent(response.metaName || response.teamId);

        if (pendingCreateMatchAfterTeam && Number(response.teamId || 0) > 0) {
            var pendingMatch = pendingCreateMatchAfterTeam;
            pendingCreateMatchAfterTeam = null;
            createdTeamDetailUrl = '';
            closeCreateTeamOverlay();
            CreateMatchPopUp(
                Number(response.teamId),
                Number(pendingMatch.rivalTeamId || 0),
                Number(pendingMatch.districtId || 0),
                pendingMatch.facilitySelection
            );
            return;
        }

        var safeName = $('<div>').text(response.name || name).html();
        var logoMarkup = logoPreview
            ? $('<div>').append($('<img>', { 'class': 'team-create-success-logo', src: logoPreview, alt: (response.name || name) + ' logosu' })).html()
            : '<div class="team-create-success-mark fs-09"><i class="fa-solid fa-check"></i></div>';

        activeCreateTeamOverlay.updateContent(
            '<div class="team-create-success-page">' +
                '<header class="team-create-success-topbar"><strong class="fs-09">Yeni takım</strong><button type="button" class="team-create-close" aria-label="Kapat"><i class="fa-solid fa-xmark"></i></button></header>' +
                '<main class="team-create-success fs-08" role="status">' +
                logoMarkup +
                '<span class="team-create-kicker fs-07">Takımın hazır</span>' +
                '<h2 class="fs-09">' + safeName + ' sahaya çıktı!</h2>' +
                '<p class="fs-07">Takımını oluşturdun. Şimdi kadronu kurup ilk maçını planlayabilirsin.</p>' +
                '<div class="team-create-success-steps">' +
                    '<span class="is-complete"><i class="fa-solid fa-check"></i><b>Takım oluşturuldu</b></span>' +
                    '<i></i>' +
                    '<span class="is-current"><b>2</b><strong>Arkadaşlarını davet et</strong></span>' +
                    '<i></i>' +
                    '<span><b>3</b><strong>İlk maçı planla</strong></span>' +
                '</div>' +
                '<h3 class="team-create-next-title fs-09">Sıradaki adımın ne olsun?</h3>' +
                '<section class="team-create-invite-next team-invite-reference-card">' +
                    '<span class="team-invite-reference-visual" aria-hidden="true"><i class="fa-solid fa-user-plus"></i></span>' +
                    '<div class="team-invite-reference-copy"><h2>Arkadaşlarını Takıma Davet Et</h2><p>Sahasenin üyesi olan veya olmayan arkadaşlarını davet et.</p></div>' +
                    '<div class="team-invite-reference-actions">' +
                        '<button type="button" class="team-secondary-button team-invite-reference-select findMemberForTeamBtn"><i class="fa-solid fa-user-plus"></i> Sahasenin\'den Seç</button>' +
                        '<button type="button" class="team-primary-button team-invite-reference-share team-invite-share-button" data-team="' + Number(response.teamId || 0) + '"><i class="fa-solid fa-share-nodes"></i> Davet Linki Paylaş</button>' +
                    '</div>' +
                    '<small class="team-invite-reference-note">Linki açan arkadaşın önce Sahasenin\'e katılır, ardından takımına eklenir.</small>' +
                '</section>' +
                '<div class="team-create-next-grid">' +
                    '<button type="button" class="team-create-next-card team-create-match-action" data-team="' + Number(response.teamId || 0) + '"><span><i class="fa-solid fa-calendar-plus"></i></span><strong class="fs-08">Maç ilanı yayınla</strong><small class="fs-07">Eksik oyuncularını bul</small><i class="fa-solid fa-chevron-right"></i></button>' +
                    '<button type="button" class="team-create-next-card team-create-rival-action"><span><i class="fa-solid fa-shield-halved"></i></span><strong class="fs-08">Rakip takım bul</strong><small class="fs-07">Maç yapacak takım bul</small><i class="fa-solid fa-chevron-right"></i></button>' +
                '</div>' +
                '<button type="button" class="team-create-complete-card team-create-settings"><span><i class="fa-solid fa-shirt"></i></span><span><strong class="fs-08">Takımını tamamla</strong><small class="fs-07">Logo, açıklama ve tercihlerini düzenle</small></span><b>%40</b><i class="fa-solid fa-chevron-right"></i></button>' +
                '<div class="team-create-success-actions">' +
                    '<button type="button" class="team-primary-button team-create-inspect fs-08">Takım sayfasına git <i class="fa-solid fa-arrow-right"></i></button>' +
                '</div>' +
                '</main>' +
            '</div>'
        );
    } catch (xhr) {
        var message = xhr && xhr.responseText
            ? xhr.responseText.replace(/^"|"$/g, '')
            : 'Takım kaydedilemedi. Lütfen tekrar deneyin.';
        $error.text(message).addClass('is-visible');
        $submit.prop('disabled', false).html(originalButtonHtml);
    }
});

$(document).on('click', '.team-create-close', function () {
    pendingCreateMatchAfterTeam = null;
    createdTeamDetailUrl = '';
    closeCreateTeamOverlay();
});

$(document).on('click', '.team-create-inspect', function () {
    var url = createdTeamDetailUrl;
    createdTeamDetailUrl = '';
    closeCreateTeamOverlay();

    if (url) pageLink(url);
});



$(document).on('click', '#companyReservationTableBtn', function () {
    var companyId = $(this).data('company');
    var target = $('#companyReservationTableArea');
    InitLoadScreenElement(target);

    Request({
        url: `/CompanyReservationTable`,
        type: 'POST',
        data: {
            companyId: companyId
        },
        success: function (partialView) {

            target.html(partialView);

        },
        error: function (jqXHR) {
            console.error("addTeam - Error details:", jqXHR.responseText);
            ShowErrorAlert();
        }
    });
});


$(document).on('click', '#addCard', function () {

    var memberId = $(this).data('memberid');

    Request({
        url: `/MemberCreditCard/Form`,
        type: 'POST',
        data: {
            id: 0,
            memberId: memberId
        },
        success: function (partialView) {
            if (partialView) {
                bootbox.dialog({
                    title: 'Kart Ekle',
                    message: partialView,
                    size: 'large',
                    onShown: function () {

                        dateInputLoad();
                        relationBuilder();
                        loadCKeditor();
                        addPhoneMask();
                    },
                    onHidden: function () {
                        pageLink('/Kartlarim');
                    }
                });

            } else {
                console.error("addTeam - Boş partialView alındı.");
                ShowErrorAlert();
            }
        },
        error: function (jqXHR) {
            console.error("addTeam - Error details:", jqXHR.responseText);
            ShowErrorAlert();
        }
    });
});


$(document).on('click', '.toggle-team-active', function () {
    const button = $(this);
    const id = button.data('id');

    Swal.fire({
        title: 'Takımı pasife almak istiyor musunuz?',
        text: 'Takım ve kadro kayıtları pasife alınacak. Bu işlemden sonra takım, takımlarınız arasında görünmeyecek.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Pasife Al',
        cancelButtonText: 'Vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {
            button.prop('disabled', true);
            Request({
                url: '/team/passiveteam',
                type: 'POST',
                data: { id: id },
                success: function () {
                    pageLink('/Takimlarim');
                },
                error: function (jqXHR) {
                    button.prop('disabled', false);
                    ShowErrorAlert(jqXHR.responseText || 'Takım durumu güncellenemedi.');
                }
            });
        }
    });
});


$(document).on("change", "#fileInput", function (event) {

    var file = event.target.files[0];

    if (file) {
        imageFile = file;
    }
});


$(document).on("click", ".ObjDetailBtn", function () {
    var element = $(this);
    var url = element.data('url');

    pageLink(url)
        .then(() => {

            loadPartialAreas();
            LoadRelationName();
            LoadRelationImg();
            relationBuilder();
        });
});

$(document).on("click", ".OpenMyThisTeamMatches", function () {
    var element = $(this);
    var url = element.data('url');
    var uri = element.data('matchesurl');

    pageLink(uri);
});



$(document).on("submit", "#_searchForm_", function (e) {
    e.preventDefault();
});

$(document).on("click", "#clearSearchInput", function () {
    $("#Term").val("");
    clearFilter();
});

$(document).on("keyup", "#Term", function () {
    var element = $(this);

    var value = element.val().toLowerCase();
    $("#dataTable tr").each(function () {
        if ($(this).text().toLowerCase().indexOf(value) > -1) {
            $(this).removeClass("d-none");
        } else {
            $(this).addClass("d-none");
        }
    });
});
async function clearFilter() {
    $("#dataTable tr").each(function () {
        $(this).removeClass("d-none");
    });
}
$(document).on("click", ".customTr", function () {
    clearTableSelectedRow();

    clickedDataId = $(this).data("id");

    $(`.customTr[data-id="${clickedDataId}"]`).addClass("bg-light-darks");

    var element = $(`#${clickedDataId}`);
    var id = element.data("id");
    selectedRowId = id;
});

$(document).on("click", ".OpenDescriptionModal", function () {
    var dataId = $(this).data('id');
    var title = $(this).data('title');
    var content = $('.DescriptionModal[data-id="' + dataId + '"]').html();

    const modal = createModal({
        title: title
    });

    modal.updateContent(`<div class="p-2">${content}</div>`);
});


$(document).on("click", ".cancelTournamentJoinRequestBtn", function () {

    var element = $(this);
    var id = element.data('id');

    // Eğer zaten disabled ise çift tıklamayı engelle
    if (element.prop('disabled')) return;

    Swal.fire({
        title: 'Emin misiniz?',
        text: "İsteği geri çekmek istediğiniz emin misiniz?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Kaydı Sil',
        cancelButtonText: 'İptal'
    }).then((result) => {
        if (result.isConfirmed) {

            // Disable + spinner ekle
            disableWithSpinner(element);

            Request({
                url: `/Tournament/TournamentTeamJoinRequestDelete`,
                type: 'POST',
                data: { id: id }
            }).then(() => {

                // Mevcut buton davranışını koru
                element.addClass('addTournamentJoinRequestBtn');
                element.removeClass('cancelTournamentJoinRequestBtn');

                var icon = element.find('i');
                icon.addClass('fa-user-plus');
                icon.removeClass('fa-user-clock');

                element.find('label').text('Turnuvaya Katıl');
                element.attr('data-id', 0);

                // Spinner'ı kaldırıp butonu tekrar aktif et
                enableAndRemoveSpinner(element);
            }).catch((jqXHR) => {

                ShowErrorAlert(jqXHR && jqXHR.responseText ? jqXHR.responseText : jqXHR);

            });
        }
    });
});

$(document).on("click", ".addTournamentJoinRequestBtn", function () {

    var element = $(this);
    var tournamentId = element.data('tournament');

    // Eğer zaten disabled ise çift tıklamayı engelle
    if (element.prop('disabled')) return;

    Request({
        url: '/Member/getCurrentMemberTeams',
        type: 'POST',
        success: function (memberTeams) {

            // Takım yoksa uyar ve çık
            if (!memberTeams || memberTeams.length === 0) {
                ShowErrorAlert("Bu işlemi gerçekleştirmek için en az bir takımınızın olması gerekir.");
                return;
            }

            // Benzersiz modal içeriği id'si (aynı anda birden fazla modal açılırsa çakışmasın diye)
            var modalContainerId = 'teamSelectModal_' + Date.now();

            // Takım listesi HTML'i (radio inputlarla)
            var html = '<div id="' + modalContainerId + '" class="p-2">';
            html += '<div class="swal-team-list">';
            for (var i = 0; i < memberTeams.length; i++) {
                var t = memberTeams[i];
                var inputId = modalContainerId + '_team_' + i;
                var name = t['Adı'] || t.Name || ('Takım ' + (i + 1));
                var checked = (i === 0) ? 'checked' : '';
                html += '<div class="form-check text-start mb-1">' +
                    '<input class="form-check-input" type="radio" name="' + modalContainerId + '_team" id="' + inputId + '" value="' + t.TeamId + '" ' + checked + '>' +
                    '<label class="form-check-label" for="' + inputId + '">' + htmlspecialchars(name) + '</label>' +
                    '</div>';
            }
            html += '</div>';

            // Validation mesaj alanı
            html += '<div id="' + modalContainerId + '_validation" class="text-danger small mt-2" style="display:none;"></div>';

            // Footer butonları
            html += '<div class="d-flex justify-content-end mt-3">' +
                '<button type="button" id="' + modalContainerId + '_cancel" class="px-2 py-1 border-ff me-2 text-red fw-bold br-12px me-2">İptal</button>' +
                '<button type="button" id="' + modalContainerId + '_confirm" class="px-2 py-1 border-ff text-primary fw-bold br-12px"><i class="fa-solid fa-paper-plane me-2"></i>Gönder</button>' +
                '</div>';

            html += '</div>';

            // Modal oluştur ve içerik güncelle
            var modal = createModal({
                title: 'Hangi takımla katılacaksınız?'
            });
            modal.updateContent(html);

            // Butonlara event bağla (ID'ler benzersiz olduğu için unbind yapmaya gerek yok)
            $('#' + modalContainerId + '_cancel').on('click', function () {
                // Modalı kapat
                try { removeSheedModal(); } catch (e) { /* ignore */ }
            });

            $('#' + modalContainerId + '_confirm').on('click', function () {
                var checked = document.querySelector('#' + modalContainerId + ' input[name="' + modalContainerId + '_team"]:checked');
                var $validation = $('#' + modalContainerId + '_validation');

                if (!checked) {
                    $validation.text('Lütfen bir takım seçin.').show();
                    return;
                }

                var selectedTeamId = checked.value;

                // Kapat modal (SweetAlert davranışına benzer şekilde modal kapanır ve istek atılır)
                try { removeSheedModal(); } catch (e) { /* ignore */ }

                // İsteği gönder
                sendJoinRequest(element, tournamentId, selectedTeamId);
            });

        },
        error: function (xhr, status, error) {
            ShowErrorAlert();
        }
    });

    // Takım seçildikten sonra isteği gönderen yardımcı fonksiyon
    function sendJoinRequest(element, tournamentId, teamId) {
        try {
            // Eğer zaten disabled ise reddet
            if (element.prop('disabled')) return;

            // Disable + spinner ekle
            disableWithSpinner(element);

            Request({
                url: '/Tournament/AddTournamentTeamJoinRequest',
                type: 'POST',
                data: {
                    tournamentId: tournamentId,
                    teamId: teamId
                },
                success: function (response) {

                    element.attr('data-id', response);

                    // Mevcut buton davranışını koru
                    element.removeClass('addTournamentJoinRequestBtn');
                    element.addClass('cancelTournamentJoinRequestBtn');

                    var icon = element.find('i');
                    icon.removeClass('fa-user-plus');
                    icon.addClass('fa-user-clock');

                    element.find('label').text('İsteği iptal et');

                    // İşlem tamamlandığında butonu aktif et ve spinner'ı kaldır
                    enableAndRemoveSpinner(element);
                },
                error: function (xhr, status, error) {
                    ShowErrorAlert(xhr.responseText);
                }
            });
        } catch (e) {
            ShowErrorAlert();
            enableAndRemoveSpinner(element);
        }
    }

    // Basit HTML escape (takım isimleri için)
    function htmlspecialchars(str) {
        if (str === null || str === undefined) return '';
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }
});

/*
 * Yardımcı fonksiyonlar:
 * - disableWithSpinner(element): butonu disable eder ve içine küçük bir spinner ekler.
 * - enableAndRemoveSpinner(element): butonun disabled'ını kaldırır ve spinner'ı siler.
 *
 * Spinner HTML'i Bootstrap'ın küçük spinner'ı kullanılarak eklendi.
 */
function disableWithSpinner($btn) {
    try {
        if (!$btn || !$btn.length) return;
        // Eğer zaten disabled ise çık
        if ($btn.prop('disabled')) return;

        $btn.prop('disabled', true);
        // Küçük spinner ekle (buton içinde <label> varsa onun sonuna eklenir)
        // Spinner için benzersiz sınıf 'btn-spinner' kullanılıyor.
        var spinnerHtml = '<span class="btn-spinner spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>';
        // Eğer zaten varsa tekrar ekleme
        if ($btn.find('.btn-spinner').length === 0) {
            // label varsa onun yanına, yoksa sonuna ekle
            var $label = $btn.find('label');
            if ($label.length) $label.after(spinnerHtml);
            else $btn.append(spinnerHtml);
        }
    } catch (e) {
        // ignore
    }
}

function enableAndRemoveSpinner($btn) {
    try {
        if (!$btn || !$btn.length) return;
        $btn.prop('disabled', false);
        $btn.find('.btn-spinner').remove();
    } catch (e) {
        // ignore
    }
}






$(document).on("click", "#DetailRow", function () {


    if (selectedRowId > 0) {
        var entityName = $(target).data("name");
        var id = selectedRowId;

        pageLink(`/${entityName}/_Detail`, { id: id })
            .then(() => {

                loadDetailDefaultForm();
            })
            .catch((error) => {

                ShowErrorAlert();
            });
    }
    else {
        Swal.fire({
            icon: "info",
            text: "İşlem İçin Önce Bir Kayıt Seçiniz.",
            showConfirmButton: false,
            timer: 1000
        });
    }
});

async function clearTableSelectedRow() {
    selectedRowId = 0;
    clickedDataId = "";

    $(".customTr").removeClass("bg-light-darks");
}

$(document).on('mouseenter', '.customTr', function () {
    if (document.documentElement.dataset.inputKind === 'touch') return;
    var hoveredId = $(this).data("id");

    if (hoveredId !== clickedDataId) {
        $(this).addClass("bg-light-darks");
    }
});

$(document).on('mouseleave', '.customTr', function () {
    var hoveredId = $(this).data("id");

    if (hoveredId !== clickedDataId) {
        $(this).removeClass("bg-light-darks");
    }
});


$(document).on("click", "#DeleteRow", function () {
    if (selectedRowId > 0) {
        var entityName = $(target).data("name");
        var id = selectedRowId;

        Swal.fire({
            title: 'Emin misiniz?',
            text: "Bu işlemi geri alamazsınız!",
            icon: 'warning',
            showCancelButton: true,


            confirmButtonText: 'Kaydı Sil',
            cancelButtonText: 'İptal'
        }).then((result) => {
            if (result.isConfirmed) {
                Request({
                    url: `/${entityName}/Delete`,
                    type: 'POST',
                    data: { id: id }
                }).then(() => {
                    ShowSuccessAlert();

                    LoadPagerBase();
                    Table();
                }).catch((jqXHR) => {

                    console.error("Error details:", jqXHR.responseText);

                    ShowErrorAlert();
                    Table();
                });
            }
        });
    }
    else {
        Swal.fire({
            icon: "info",
            text: "İşlem İçin Önce Bir Kayıt Seçiniz.",
            showConfirmButton: false,
            timer: 1000
        });
    }
});
$(document).on("click", "#detailDefaultFormBtn", function () {
    loadDetailDefaultForm();
});
$(document).on("click", "#AddRecord", function () {
    var entityName = $(target).data("name");

    var classData = $(this).data("classname");
    var className = `Yeni ${classData} Kaydı Ekle`;

    var relationEntityName;
    var relationId;

    var btnSelector = $(btnId).length === 1 ? true : false;

    if ($(btnId).length === 1) {
        relationEntityName = $(btnId).data("name");
        relationId = $(btnId).data("id");
        className = "Yeni Kayıt Ekle";
    }
    else if ($(btn2Id).length === 1) {
        relationEntityName = 'Team';
        relationId = $(btn2Id).data("id");
        className = "Yeni Kayıt Ekle";
    }

    Request({
        url: `/${entityName}/_Form`,
        type: 'POST',
        data: {
            id: 0,
            relationId: relationId,
            entityName: relationEntityName
        },
        success: function (partialView) {
            if (partialView) {
                bootbox.dialog({
                    title: className,
                    message: partialView,
                    size: 'large',
                    onShown: function () {
                        dateInputLoad();
                        relationBuilder();
                        loadCKeditor();
                        addPhoneMask();
                    },
                    onHidden: function () {

                        LoadPagerBase();
                        Table();
                    }
                });

            } else {
                console.error("AddRecord - Boş partialView alındı.");
                ShowErrorAlert();
            }
        },
        error: function (jqXHR) {
            console.error("AddRecord - Error details:", jqXHR.responseText);
            ShowErrorAlert();
        }
    });
});


$(document).on("click", "#EditRow", function () {


    if (selectedRowId > 0) {
        var entityName = $(target).data("name");

        var classData = $(this).data("classname");
        var className = `${classData} Düzenle`;

        var id = selectedRowId;

        var relationEntityName;
        var relationId;

        var _btnId = "#detailDefaultFormBtn";

        var btnSelector = $(_btnId).length === 1 ? true : false;

        if ($(btnId).length === 1) {
            relationEntityName = $(_btnId).data("name");
            relationId = $(_btnId).data("id");
            className = "Kaydı Düzenle";
        }
        else if ($(btn2Id).length === 1) {

            relationEntityName = 'Team';
            relationId = $(btn2Id).data("id");
            className = "Kaydı Düzenle";
        }


        Request({
            url: `/${entityName}/_Form`,
            type: 'POST',
            data: {
                id: id,
                relationId: relationId,
                entityName: relationEntityName
            },
            success: function (partialView) {
                if (partialView) {


                    bootbox.dialog({
                        title: className,
                        message: partialView,
                        size: 'large',
                        onShown: function () {
                            dateInputLoad();
                            relationBuilder();
                            loadCKeditor();
                            addPhoneMask();
                        },
                        onHidden: function () {


                            LoadPagerBase();
                            Table();
                        }
                    });
                } else {
                    console.error("EditRow - Boş partialView alındı.");
                    ShowErrorAlert();
                }
            },
            error: function (jqXHR) {
                console.error("EditRow - Error details:", jqXHR.responseText);
                ShowErrorAlert();
            }
        });
    }
    else {
        Swal.fire({
            icon: "info",
            text: "İşlem İçin Önce Bir Kayıt Seçiniz.",
            showConfirmButton: false,
            timer: 1000
        });
    }
});

$(document).on("click", ".DetailRow", function () {


    var entityName = $(this).data("name");

    getCurrentUserId()
        .then(memberId => {

            pageLink(`/${entityName}/_Detail`, { id: memberId })
                .then(() => {

                })
                .catch((error) => {

                    ShowErrorAlert();
                });
        });
});

async function loadDetailDefaultForm() {

    pageLink(`/Profili-Duzenle`)
        .then(() => {

            dateInputLoad();
            relationBuilder();
            /*loadCKeditor();*/
            addPhoneMask();
        })
        .catch((error) => {

            ShowErrorAlert();
        });
}

$(document).on("click", ".RelationBtn", function () {

    var baseDataId = $("#detailDefaultFormBtn").data("id");
    var relationName = $(this).data("name");

    var data = {
        id: baseDataId,
        keyName: relationName
    };

    pageLink(`/${relationName}/Page`, data)
        .then(() => {

            LoadPagerBase();
            Table();
        })
        .catch((error) => {

            console.log("Detail Error details:", error.responseText);
            ShowErrorAlert();
        });
});

async function Table(team) {

    var entityName = $(target).data("name");
    var id = 0;
    var name = 0;

    getCurrentUserId()
        .then(memberId => {

            id = memberId;
            name = 'Member';

            if (team) {
                id = lasteTeamId;
                name = 'Team';
            }

            Request({
                url: `/${entityName}/_Table`,
                type: 'POST',
                data: {
                    page: page,
                    pageSize: pageSize,
                    relationId: id,
                    entityName: name
                },
                target: target
            }).then(() => {

                LoadRelationName();
                isNotrelationRemover();
            }).catch((jqXHR) => {

                InitErrorScreen(target, jqXHR.responseText);
                ShowErrorAlert();
            });
        });
}

function isNotrelationRemover() {

    $('input.isNotrelationRemover').each(function () {
        var dataId = $(this).data("ids");

        $('tr.customTr[data-id="' + dataId + '"]').addClass('d-none');
    });
}

async function LoadPagerBase() {

    var entityName = $(target).data("name");

    Request({
        url: `/${entityName}/_PagerBase`,
        type: 'POST',
        data: { page: page, pageSize: pageSize },
        target: pagerBase
    }).then(() => {
        $('#pageSize').val(pageSize);
    }).catch((jqXHR) => {
        InitErrorScreen(pagerBase, jqXHR.responseText);
        ShowErrorAlert();
    });
}


$(document).on("click", "._attr", function (e) {
    e.preventDefault();

    $(".partialAttr").html("");
    $("#AccountFormDiv").html("");

    var element = $(this);
    var id = element.data("id");
    var attrId = element.data("aid");
    var memberId = element.data("memberid");
    var target = element.data("target");

    var data = {
        id: id,
        relationId: id,
        entityName: 'MemberMTypeAttrRelation',
        memberId: memberId,
        attrId: attrId,
        isPage: true
    };

    pageLink(`/MemberMTypeAttrRelation/_AttrForm`, data)
        .then(() => {

            loadCKeditor();
            dateInputLoad();
        });
});


$(document).on("click", ".OpenMemberRegisterMagicLinkPopup", function (e) {
    OpenMemberRegisterMagicLinkPopup();
});

async function OpenMemberRegisterMagicLinkPopup() {
    if (await getCurrentUserId() > 0) {
        window.invalidateMemberScopedCaches?.();
        return pageLink('/Kaydi-Tamamla');
    }
}


const registrationBaseSteps = [
    { step: 2, attrId: 0, onlyPlayer: false }, // Ana kayıt formu
    { step: 4, attrId: 0, onlyPlayer: false }, // Profil, doğum tarihi ve mevki
];
const stepsList = registrationBaseSteps.map(function (item) { return Object.assign({}, item); });
let dynamicRegistrationStepsPromise = Promise.resolve(true);
let dynamicRegistrationStepsRequestVersion = 0;
let registrationPositionSavePromise = Promise.resolve(true);
let registrationPositionSaveElement = null;
let registrationPhotoSavePromise = Promise.resolve(true);

function getVisibleRegistrationSteps() {
    const isMemberTypePlayer = Number($('#MemberTypeId').val()) === 1;
    return stepsList.filter(function (step) {
        return isMemberTypePlayer || !step.onlyPlayer;
    });
}

function refreshRegistrationStepOrdinals() {
    const visibleSteps = getVisibleRegistrationSteps();
    const counter = document.getElementById('registrationStepCounter');
    const currentStep = Number(document.getElementById('DataStep')?.value || 2);
    const ordinal = Math.max(0, visibleSteps.findIndex(item => item.step === currentStep)) + 1;
    if (counter) {
        const total = visibleSteps.length;
        counter.querySelector('span').textContent = ordinal + '/' + total;
        counter.setAttribute('aria-valuenow', ordinal);
        counter.setAttribute('aria-valuemax', total);
        counter.setAttribute('aria-valuetext', total + ' adımdan ' + ordinal + '. adım');
    }
    $('.stepBar').each(function () {
        const stepId = Number($(this).data('id'));
        const ordinal = visibleSteps.findIndex(function (step) {
            return step.step === stepId;
        });
        if (ordinal >= 0) {
            $(this).find('.register-progress-dot').text(ordinal + 2);
        }
    });
}

function resetDynamicRegistrationSteps() {
    $('.stepBar[data-dynamic-step="true"]').remove();
    for (var index = stepsList.length - 1; index >= 0; index--) {
        if (stepsList[index].attrId > 0) stepsList.splice(index, 1);
    }
}

function GetDynamicStepListForMemberTypeId() {
    let memberTypeId = Number($('#MemberTypeId').val()) || 0;
    const requestVersion = ++dynamicRegistrationStepsRequestVersion;
    resetDynamicRegistrationSteps();

    if (memberTypeId > 0) {
        dynamicRegistrationStepsPromise = new Promise(function (resolve) {
            $.ajax({
                url: '/Login/GetDynamicStepListForMemberTypeId',
                type: 'POST',
                timeout: 15000,
                data: { MemberTypeId: memberTypeId },
                success: function (response) {
                    if (requestVersion !== dynamicRegistrationStepsRequestVersion) {
                        resolve(true);
                        return;
                    }

                    let stepNumber = 8;
                    let previousStepElement = null;

                    (response || []).forEach((item) => {
                        let dynamicStep = {
                            step: stepNumber,
                            onlyPlayer: false,
                            attrId: item.MemberTypeAttributeId
                        };

                        if ($(`.stepBar[data-id="${dynamicStep.step}"]`).length == 0) {

                            let stepHtml = `
                             <div class="stepBar" data-id="${dynamicStep.step}" data-onlyplayer="0" data-attr="${dynamicStep.attrId}" data-dynamic-step="true">
                                 <span class="register-progress-dot fs-08"></span>
                                 <small class="fs-06">Ek Bilgi</small>
                             </div>
                             `;

                            // Yeni elementi oluşturuyoruz
                            let newStepElement = $(stepHtml);

                            if (previousStepElement === null) {
                                // İlk step: '#DynamicStepsStart'in hemen sonrasına ekle
                                newStepElement.insertAfter('#DynamicStepsStart');
                            } else {
                                // Sonraki stepleri bir önceki eklenen elementin hemen sonrasına ekle
                                newStepElement.insertAfter(previousStepElement);
                            }

                            // Son eklenen elementi güncelle
                            previousStepElement = newStepElement;

                            // Adım sırasını stepsList'e ekle
                            let index = stepsList.findIndex(s => s.step > dynamicStep.step);
                            if (index === -1) {
                                stepsList.push(dynamicStep);
                            } else {
                                stepsList.splice(index, 0, dynamicStep);
                            }

                            stepNumber++;
                        }
                    });
                    refreshRegistrationStepOrdinals();
                    resolve(true);
                },
                error: function (error) {
                    console.error("GetDynamicStepListForMemberTypeId():", error.responseText);
                    resolve(requestVersion !== dynamicRegistrationStepsRequestVersion);
                }
            });
        });
    } else {
        console.error("GetDynamicStepListForMemberTypeId(): MemberTypeId is zero");
        dynamicRegistrationStepsPromise = Promise.resolve(false);
    }

    return dynamicRegistrationStepsPromise;
}



$(document).on("click", ".nextStepBtn", async function (event) {
    event.preventDefault();

    var element = $(this);
    if (element.attr('aria-busy') === 'true') return;
    var isPhoneCheck = element.hasClass('changeMyPhone');
    var ignoreMemberId = element.hasClass('ignoreMemberId');
    element.attr('aria-busy', 'true').prop('disabled', true);
    try {
        await nextStep(isPhoneCheck, ignoreMemberId);
    } catch (error) {
        ShowErrorAlert(error?.responseText || 'Kayıt adımı tamamlanamadı. Lütfen tekrar deneyin.');
    } finally {
        element.removeAttr('aria-busy').prop('disabled', false);
    }
});
async function nextStep(isPhoneCheck, ignoreMemberId, memberId = 0) {

    var memberTypeId = $('#MemberTypeId').val();
    document.querySelector('[data-birth-wheel]')?.flushSelection?.();
    if (!await waitForRegistrationSaves()) return;

    if (isPhoneCheck) {

        var phoneElement = $('#Phone');
        var phoneVal = phoneElement.val();

        if (!/^5\d{9}$/.test(registrationPhoneDigits(phoneVal))) {
            phoneElement.addClass('is-invalid');
            window.SahaseninRegistration?.track('invalid_phone', 'validate');
            showRegistrationValidationError(phoneElement.get(0), 'Geçerli bir telefon numarası giriniz.');
            return;
        }
    }

    // Mevcut step ve memberType bilgisini alıyoruz.
    var currentStep = parseInt($('#DataStep').val(), 10);
    var isMemberTypePlayer = Number(memberTypeId) === 1;

    if (currentStep === 4) {
        const inputs = Array.from(new Set(document.querySelectorAll('#StepsDiv .nxc5, #registrationOptionalDetails .nxc5, #StepsDiv input[type="number"], #registrationOptionalDetails input[type="number"]')));
        const invalid = inputs.filter(input => {
            if (input.disabled) return false;
            const required = input.classList.contains('nxc5');
            const missing = (required && (input.type === 'checkbox' ? !input.checked
                : !String($(input).val() || '').trim() || input.value === '0' || input.inputmask?.isComplete() === false))
                || !input.validity.valid;
            input.classList.toggle('is-invalid', missing);
            return missing;
        });
        if (invalid.length) {
            showRegistrationValidationError(invalid[0], 'Devam etmek için işaretli profil bilgilerini tamamlayın.');
            return;
        }
    }
    if (currentStep === 4 && $('#RegistrationPositionIds').length) {
        var positionElement = $('#RegistrationPositionIds');
        var positionIds = (positionElement.val() || []).map(Number).filter(function (id) { return id > 0; });
        if (positionElement.hasClass('nxc5') && positionIds.length === 0) {
            positionElement.addClass('is-invalid');
            window.SahaseninRegistration?.track('required_position', 'validate');
            await Swal.fire({
                icon: 'warning',
                text: 'Devam etmek için en az bir mevki seçmelisiniz.',
                confirmButtonText: 'Tamam'
            });
            return;
        }

        if (registrationPositionSaveElement === positionElement.get(0)) {
            var positionsSaved = await registrationPositionSavePromise;
            if (!positionsSaved) return;
        }
    }

    if (currentStep === 4) {
        var descriptionSaved = await saveRegistrationDescription();
        if (!descriptionSaved) return;
    }
    if (currentStep >= 8 && !await saveRegistrationDynamicAttribute()) return;

    var dynamicStepsReady = Number(memberTypeId) > 0
        ? await dynamicRegistrationStepsPromise
        : true;
    if (!dynamicStepsReady) dynamicStepsReady = await GetDynamicStepListForMemberTypeId();
    if (!dynamicStepsReady) {
        window.SahaseninRegistration?.track('step_unavailable', 'load');
        ShowErrorAlert('Ek kayıt bilgileri yüklenemedi. Lütfen bağlantınızı kontrol edip tekrar deneyin.');
        return;
    }

    // stepsList içerisinde mevcut adımın indeksini buluyoruz.
    var currentIndex = stepsList.findIndex(function (stepObj) {
        return stepObj.step === currentStep;
    });

    if (currentIndex === -1) {
        window.SahaseninRegistration?.track('step_unavailable', 'navigation');
        console.error("Mevcut adım bulunamadı.");
        ShowErrorAlert('Kayıt adımı bulunamadı. Lütfen kayıt ekranını yeniden açın.');
        return;
    }

    // Sonraki uygun adımı bulmak için döngüye giriyoruz.
    var nextStep = null;
    var nextStepObj = null;
    for (var i = currentIndex + 1; i < stepsList.length; i++) {
        // Eğer üye player değilse ve adım sadece player içinse atla.
        if (!isMemberTypePlayer && stepsList[i].onlyPlayer) {
            continue;
        }
        // Uygun adımı bulduk.
        nextStepObj = stepsList[i];
        nextStep = stepsList[i].step;
        break;
    }

    if (nextStep !== null) {
        // loadStep fonksiyonu, gerekli adım bilgilerini işlemek için çağrılıyor.

        if (memberId === 0) {
            memberId = $('#MemberId').val();
        }

        if (ignoreMemberId) {

            if (memberTypeId > 0) {
                return loadStep(nextStep, memberId);
            }
            else {
                window.SahaseninRegistration?.track('required_member_type', 'validate');
                Swal.fire({
                    icon: 'warning',
                    text: 'Bir üye tipi seçiniz',
                    showConfirmButton: true,
                    confirmButtonText: 'Tamam'
                });
            }
        }
        else {
            if (memberId > 0) {

                if (nextStepObj.attrId > 0) {

                    return loadAttrStep(memberId, nextStepObj.attrId, nextStep);
                }
                else {
                    return loadStep(nextStep, memberId);
                }
            }
            else {
                console.log("MemberId cannot be zero.");
                ShowErrorAlert('Hesap bilgileri kaydedilemedi. Lütfen tekrar deneyin.');
            }
        }
    } else {
        await completeMemberRegistration();
    }
}

async function saveRegistrationDescription() {
    const descriptionInput = document.getElementById('RegistrationDescription');
    if (!descriptionInput) return true;

    const value = descriptionInput.value;
    if (descriptionInput.dataset.required === 'true' && !value.replace(/\u00a0/g, ' ').trim()) {
        descriptionInput.classList.add('border-danger');
        showRegistrationValidationError(descriptionInput, 'Lütfen kendini anlat alanını doldurun.');
        return false;
    }
    descriptionInput.classList.remove('border-danger');
    if (value === descriptionInput.defaultValue) return true;
    const description = $('<div>').text(value).html().replace(/\r?\n/g, '<br>');
    try {
        await Request({
            url: '/Member/SaveDescriptionEdit',
            type: 'POST',
            data: { description: description }
        });
        descriptionInput.defaultValue = value;
        return true;
    } catch (error) {
        ShowErrorAlert(error && error.responseText ? error.responseText : 'Açıklama kaydedilemedi.');
        return false;
    }
}

async function saveRegistrationDynamicAttribute() {
    const form = $('#StepsDiv .MainForm.attr');
    if (!form.length) return true;
    const name = form.find('[name="Name"]').get(0);
    if (!name?.value.trim()) {
        showRegistrationValidationError(name, 'Lütfen ek bilgiye bir isim verin.');
        return false;
    }
    let editorData = '';
    editorInstances.forEach(item => {
        editorData += '&' + encodeURIComponent(item.name) + '=' + encodeURIComponent(item.editor.getData());
    });
    form.find('.ckEditor[name]').each(function () {
        if (!editorInstances.some(item => item.name === this.getAttribute('name')))
            editorData += '&' + encodeURIComponent(this.getAttribute('name')) + '=' + encodeURIComponent(this.innerHTML);
    });
    const formData = form.serialize() + editorData;
    if (form.data('saved-registration-data') === formData) return true;
    try {
        const saved = await Request({ url: '/MemberMTypeAttrRelation/Save', type: 'POST', data: formData, timeout: 15000 });
        const id = saved?.MemberMTypeAttrRelationId || saved?.memberMTypeAttrRelationId || saved?.tempId;
        if (!id) throw new Error('Ek bilgi kaydedilemedi.');
        form.find('[name="MemberMTypeAttrRelationId"], [name="TempId"]').val(id);
        form.data('saved-registration-data', form.serialize() + editorData);
        return true;
    } catch (error) {
        ShowErrorAlert(error?.responseText || 'Ek bilgi kaydedilemedi. Lütfen tekrar deneyin.');
        return false;
    }
}

async function completeMemberRegistration() {
    try {
        if (!await waitForRegistrationSaves()) return;
        const status = await Request({ url: '/Home/ProfileCompletionStatus', type: 'POST', cacheable: false });
        if (!status.activated) {
            const missing = status.missing || [];
            const basic = ['Name', 'Surname', 'NickName', 'Mail', 'Phone', 'GenderTypEnum', 'CityId', 'DistrictId', 'Img', 'AcceptKvkk', 'Password', 'MemberTypeId'];
            if (missing.some(field => basic.includes(field.name)) && Number($('#DataStep').val()) !== 2)
                await loadStep(2, Number($('#MemberId').val()));
            const first = missing[0];
            const input = first && (document.getElementsByName(first.name)[0] || document.getElementById(first.name));
            showRegistrationValidationError(input, missing.length
                ? 'Kaydını tamamlamak için eksik bilgileri doldur: ' + missing.map(field => field.label).join(', ')
                : 'Kaydını tamamlamak için zorunlu alanları doldurmalısın.');
            return;
        }
        window.invalidateMemberScopedCaches?.();
        if (typeof Logged === 'function') await Logged();
        if (typeof appsTokenSync === 'function') appsTokenSync(false);
        const landingReturn = document.querySelector('.member-register-wizard')?.dataset.facilityReturn;
        if (landingReturn || (status.redirectUrl && status.redirectUrl !== "/Bilgilerim")) return pageLink(status.redirectUrl || landingReturn);
        try {
            const invite = await $.get('/Team/PendingInviteRedirect');
            if (invite?.redirectUrl) return pageLink(invite.redirectUrl);
        } catch (_) { }
        return pageLink(document.querySelector('.member-register-wizard[data-completing-account="true"]')
            ? status.redirectUrl || '/Bilgilerim' : '/Sahaya-Nasil-Cikmak-Istersin');
    } catch (error) {
        ShowErrorAlert(error?.responseText || 'Kayıt durumu kontrol edilemedi. Lütfen tekrar dene.');
    }
}

$(document).on('change', '#RegistrationPositionIds', function () {
    return saveRegistrationPositions($(this));
});
function saveRegistrationPositions(element) {
    var positionIds = (element.val() || []).map(Number).filter(function (id) { return id > 0; });
    element.toggleClass('is-invalid', element.hasClass('nxc5') && positionIds.length === 0);
    nxc5();

    const previous = registrationPositionSaveElement === element.get(0) ? registrationPositionSavePromise : Promise.resolve(true);
    registrationPositionSaveElement = element.get(0);
    registrationPositionSavePromise = previous.then(() => Request({
        url: '/Member/UpdateMemberPositionRelations',
        type: 'POST',
        data: { positionIds: positionIds }
    })).then(function () {
        if (!element.get(0)?.isConnected) return true;
        registrationFieldSaveErrors.delete('Positions');
        registrationFieldSaveRetries.delete('Positions');
        element.removeClass('is-invalid');
        return true;
    }).catch(function (error) {
        if (!element.get(0)?.isConnected) return false;
        registrationFieldSaveErrors.add('Positions');
        registrationFieldSaveRetries.set('Positions', () => saveRegistrationPositions(element));
        element.addClass('is-invalid');
        ShowErrorAlert(error && error.responseText ? error.responseText : 'Mevki seçimi kaydedilemedi.');
        return false;
    });
    return registrationPositionSavePromise;
}
$(document).on("click", ".previousStepBtn", function () {

    var element = $(this);

    // Mevcut adım ve üyenin player olup olmadığını alıyoruz.
    var currentStep = parseInt($('#DataStep').val(), 10);
    var isMemberTypePlayer = Number($('#MemberTypeId').val()) === 1;

    // stepsList içerisinde mevcut adımın indeksini buluyoruz.
    var currentIndex = stepsList.findIndex(function (stepObj) {
        return stepObj.step === currentStep;
    });

    if (currentIndex === -1) {
        window.SahaseninRegistration?.track('step_unavailable', 'navigation');
        console.error("Mevcut adım bulunamadı.");
        return;
    }

    // Önceki uygun adımı bulmak için geriye doğru döngüye giriyoruz. 
    var previousStep = null;
    var previousStepObj = null;
    for (var i = currentIndex - 1; i >= 0; i--) {
        // Eğer üye player değilse ve adım sadece player içinse bu adımı atla.
        if (!isMemberTypePlayer && stepsList[i].onlyPlayer) {
            continue;
        }
        // Uygun adımı bulduk.
        previousStepObj = stepsList[i];
        previousStep = stepsList[i].step;
        break;
    }

    if (previousStep !== null) {
        // loadStep fonksiyonu, gerekli adım bilgilerini işlemek için çağrılıyor.
        var MemberId = $('#MemberId').val();

        if (element.hasClass('ignoreMemberId')) {

            loadStep(previousStep, MemberId);
        }
        else {
            if (MemberId > 0) {

                if (previousStepObj.attrId > 0) {

                    loadAttrStep(MemberId, previousStepObj.attrId, previousStep);
                }
                else {
                    loadStep(previousStep, MemberId);
                }
            }
            else {
                console.log("MemberId sıfır olamaz.");
            }
        }
    } else {
        console.log("Daha önceki adım yok veya uygun adım bulunamadı.");
    }
});


function loadAttrStep(id, attrId, step) {
    return Request({
        url: '/Login/Step_Dynamic',
        type: 'POST',
        data: {
            id: id,
            memberTypeAttributeId: attrId,
            step: step
        },
        target: '#StepsDiv',
        preserveOnError: true,
        showSkeleton: false,
        cacheable: false,
        timeout: 15000
    }).then(() => {

        editorInstances = [];

        setRegisterStepPresentation(step);
        window.SahaseninRegistration?.step(Number(step));
        loadCKeditor();

        UpdateFirstSaveStepsBar();

    }).catch((error) => {
        console.error("loadStep():", error.responseText);
        ShowErrorAlert(error?.responseText || 'Ek kayıt bilgileri yüklenemedi. Lütfen tekrar deneyin.');
        return false;
    });
}
async function loadStep(step, id = 0) {

    var element = $('.nextStepBtn');
    var memberTypeId = Number($('#MemberTypeId').val()) || FirstSaveFirstMemberTypeId || 0;

    var data = {};

    if (Number(step) === 2 || element.hasClass('postMemberTypeId')) {
        data = {
            id: id,
            memberTypeId: memberTypeId
        }
    }
    else {
        data = {
            id: id
        }
    }

    return Request({
        url: '/Login/Step_' + step,
        type: 'POST',
        data: data,
        target: '#StepsDiv',
        preserveOnError: true,
        showSkeleton: false,
        cacheable: false,
        timeout: 15000
    }).then(() => {

        editorInstances = [];

        afterLoadStep(step);

        UpdateFirstSaveStepsBar();

        addPhoneMask();

        parentS2each('#StepsDiv');

        loadCKeditor();

        var modalBody = $('.custom-modal-body');
        if (modalBody.length > 0) {
            initCustomRangeBars(modalBody.get(0));
        }
        else {
            initCustomRangeBars();
        }

        if ($('#_MemberPositionSelectorArea').length > 0) {

            loadMemberPositionSelectorArea();
        }
    }).catch((error) => {
        console.error("loadStep():", error.responseText);
        ShowErrorAlert(error?.responseText || 'Kayıt adımı yüklenemedi. Lütfen tekrar deneyin.');
        return false;
    });
}

function afterLoadStep(step) {
    const wizard = document.querySelector('.member-register-wizard');
    if (wizard !== registrationWizard) {
        registrationWizard = wizard;
        registrationFieldSaveErrors.clear();
        registrationFieldSaveRetries.clear();
        registrationFieldSaveQueue = registrationAvailabilityQueue = registrationPositionSavePromise = registrationPhotoSavePromise = Promise.resolve(true);
        registrationPositionSaveElement = null;
        resetDynamicRegistrationSteps();
        dynamicRegistrationStepsRequestVersion++;
        dynamicRegistrationStepsPromise = Promise.resolve(true);
    }
    window.SahaseninRegistration?.step(Number(step));

    setRegisterStepPresentation(step);

    IdentityNumberMask();

    switch (step) {
        case 1:
            ControlStepOneMemberTypeId();
            break;

        case 2:

            applyRegistrationFieldRules(JSON.parse($('#FirstSaveForm').attr('data-registration-rules') || '{}'));
            readyDynamicFilterPage();

            FirstSaveFirstMemberTypeId = Number($('#MemberTypeId').val()) || 0;
            GetDynamicStepListForMemberTypeId();
            checkPasswordTwo();
            refreshPhoneRoleAvailability();
            updateSubmitButtonState();
            break;

        case 4:
            initRegistrationBirthWheels();
            if ($('#PlayerTypeEnum').attr('data-save-default') === 'true') {
                editableMemberProp('PlayerTypeEnum', $('#PlayerTypeEnum').val());
            }
            nxc5();
            break;

        case 3:
            loadMemberPositionSelectorArea();
            break;

        default:
            break;
    }
}

const registerStepPresentation = {
    1: {
        icon: 'fa-people-group',
        title: 'Sahadaki <span>Yerini</span> Seç!',
        description: 'Sahada yıldız mı olacaksın, düdüğü çalıp oyunu mu yöneteceksin, yoksa tribünden coşkuyu mu yaşayacaksın? Rolünü seç, futbolun efsaneleri arasına adını yazdır! 🏆🔥',
        callout: 'Her rol sahada bir fark yaratır. Sen hangi roldesin?'
    },
    2: {
        icon: 'fa-user-plus',
        title: 'Hesap bilgilerini oluştur',
        description: "Sahasenin'e katıl, sahadaki yerini al.",
        callout: 'Bilgilerin güvenle saklanır ve yalnızca deneyimini iyileştirmek için kullanılır.'
    },
    3: {
        icon: 'fa-location-crosshairs',
        title: 'Sahada nerede <span>sen varsın?</span> ⚽',
        description: 'En iyi performans gösterdiğin veya oynamayı sevdiğin pozisyonu seç.',
        callout: 'Bir ana pozisyon ve birden fazla alternatif pozisyon belirleyebilirsin.'
    },
    4: {
        icon: 'fa-medal',
        title: 'Profilini tamamla',
        description: 'Futbol tercihlerini ve fiziksel bilgilerini tamamlayarak sana uygun öneriler al.',
        callout: 'Bilgilerini daha sonra profil ayarlarından değiştirebilirsin.'
    },
    5: {
        icon: 'fa-calendar-check',
        title: 'Ne zaman <span>sahaya çıkıyorsun?</span> ⚽',
        description: 'Uygun olduğun günleri seç, seni maç ve etkinliklerle buluşturalım.',
        callout: 'Daha fazla gün seçmek, sana uygun maç bulma şansını artırır.'
    },
    6: {
        icon: 'fa-pen-to-square',
        title: 'Kendini anlat, <span>sahaya taşı!</span> ⚽',
        description: 'Futbol geçmişinden, güçlü yönlerinden ve sahadaki hedeflerinden bahset.',
        callout: 'Kısa ve samimi bir anlatım takım arkadaşlarının seni daha iyi tanımasını sağlar.'
    }
};

function setRegisterStepPresentation(step) {
    const content = document.getElementById('StepsDiv');
    const intro = document.getElementById('registerStepIntro');
    if (!content || !intro) return;

    content.dataset.currentStep = String(step);
    const avatar = document.getElementById('registrationAvatar');
    if (avatar) {
        const memberId = Number(document.getElementById('MemberId')?.value || 0);
        avatar.dataset.id = memberId;
        $(avatar).data('id', memberId);
        avatar.classList.toggle('ChangeMyProfilePhoto', memberId > 0);
        avatar.classList.toggle('ProfilePhotoFirstSave', memberId <= 0);
        const photo = document.getElementById('Img')?.value || document.querySelector('[data-registration-photo]')?.dataset.registrationPhoto;
        if (photo) avatar.querySelector('img').src = photo.endsWith('/avatar.webp') ? '/avatar.webp' : photo;
    }
    const presentation = registerStepPresentation[step] || {
        icon: 'fa-clipboard-check',
        title: 'Ek bilgilerini <span>tamamla</span>',
        description: 'Profilini tamamlamak için gerekli bilgileri ekle.',
        callout: 'Bu bilgileri daha sonra profil ayarlarından güncelleyebilirsin.'
    };

    const icon = document.getElementById('registerStepIcon');
    if (icon) icon.className = `fa-solid ${presentation.icon} fs-09`;
    const eyebrow = document.getElementById('registerStepEyebrow');
    if (eyebrow) {
        const stepOrdinal = getVisibleRegistrationSteps().findIndex(function (item) {
            return item.step === Number(step);
        });
        eyebrow.textContent = `${stepOrdinal >= 0 ? stepOrdinal + 2 : step}. adım`;
    }
    const title = document.getElementById('registerStepTitle');
    if (title) title.innerHTML = presentation.title;
    const description = document.getElementById('registerStepDescription');
    if (description) description.textContent = presentation.description;
    const callout = document.getElementById('registerStepCallout');
    if (callout) callout.textContent = presentation.callout;
    content.classList.add('fs-08');
    content.querySelectorAll('.previousStepBtn, .nextStepBtn, #SubmitFirstSaveForm, .MyAccountBtn, .CancelFirstSave')
        .forEach((element) => element.classList.add('fs-08'));
    intro.classList.toggle('is-role-step', Number(step) === 1);
}


var FirstSaveFirstMemberTypeId = 0;
function ControlStepOneMemberTypeId() {

    if ($('#MemberId').val() === "0") {

        if (FirstSaveFirstMemberTypeId > 0) {

            $('#MemberTypeId').val(FirstSaveFirstMemberTypeId);

            let element = $(`.FirstSaveFirstMemberTypeId[data-id="${FirstSaveFirstMemberTypeId}"]`);

            $(".FirstSaveFirstMemberTypeId").removeClass("checked ultra-shadowed").addClass("shadow-none");
            $(".FirstSaveFirstMemberTypeId .member-type-check").remove();

            element.removeClass("shadow-none").addClass("checked ultra-shadowed");
            element.find('.member-type-image-wrapper').prepend(
                '<span class="member-type-check fs-08"><i class="fa-solid fa-check"></i></span>');

            UpdateFirstSaveStepsBar();
        }
    }
}

function UpdateFirstSaveStepsBar() {

    var step = $('#DataStep').val();
    var isMemberTypePlayer = Number($('#MemberTypeId').val()) === 1;

    $('.stepBar').each(function () {
        var stepId = parseInt($(this).data('id'), 10);

        $(this).removeClass('active is-current is-complete');

        if (stepId <= step) {
            $(this).addClass('active');
        }
        if (stepId < step) {
            $(this).addClass('is-complete');
        }
        if (stepId === Number(step)) {
            $(this).addClass('is-current');
        }

        if (!isMemberTypePlayer && $(this).data('onlyplayer') == 1) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });

    refreshRegistrationStepOrdinals();

    if (!document.querySelector('.member-register-reference') && window.matchMedia('(max-width: 820px)').matches) {
        document.querySelector('.member-register-progress .stepBar.is-current')
            ?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
}

$(document).on("change", ".birthDatePart", async function (e) {

    var day = Number($('#BirthDay').val());
    var month = Number($('#BirthMonth').val());
    var year = Number($('#BirthYear').val());
    var hasAllParts = day > 0 && month > 0 && year >= 1900;
    var candidate = hasAllParts ? new Date(year, month - 1, day) : null;
    var isValidDate = candidate !== null &&
        candidate.getFullYear() === year &&
        candidate.getMonth() === month - 1 &&
        candidate.getDate() === day;

    $('.birthDatePart').each(function () {
        var field = $(this);
        field.toggleClass('is-invalid', Number(field.val()) <= 0);
    });

    $('.BirthYearInvalidClassDiv').toggleClass('is-invalid', !isValidDate);

    if (!isValidDate) {
        nxc5();
        return;
    }

    $('.birthDatePart').removeClass('is-invalid');
    $('.BirthYearInvalidClassDiv').removeClass('is-invalid br-calc border-ff border-red');

    var date = year + '-' + String(month).padStart(2, '0') + '-' + String(day).padStart(2, '0');
    editableMemberProp('BirthDate', date);
    nxc5();
});




$(document).on("click", ".OpenPublishMatchModal", function () {
    var element = $(this);
    var matchId = element.data('match');

    const modal = window.createMatchPublishModal();

    Request({
        url: `/Match/_CheckDetailToPublishMatchModal`,
        type: 'POST',
        data: {
            matchId: matchId
        },
        success: function (response) {

            modal.updateContent(response);
            syncMatchCountDown();
        },
        error: function (jqXHR) {
            modal.updateContent('<div class="match-publish-error" role="alert">Maç bilgileri yüklenemedi. Pencereyi kapatıp tekrar deneyebilirsin.</div>');
            ShowErrorAlert(jqXHR.responseText || 'Maç bilgileri yüklenemedi.');
        }
    }).catch(function () { /* The error is shown above; keep the close button available. */ });
});

var publishingMatchIds = new Set();

$(document).on("click", ".PublishMatchBtn", async function () {
    var element = $(this);
    var matchId = element.data('match');
    var originalHtml = element.html();
    var wizard = element.closest('.match-publish-wizard');
    var publishData = wizard.length && typeof window.getMatchNotificationPublishPayload === 'function'
        ? window.getMatchNotificationPublishPayload(element[0])
        : { matchId: matchId };
    var notificationExperience = wizard.find('.match-notification-experience')[0];

    if (!Number.isInteger(Number(matchId)) || Number(matchId) <= 0) {
        ShowErrorAlert('Maç bilgisi bulunamadı. Lütfen ekranı yenileyip tekrar deneyin.');
        return;
    }
    matchId = Number(matchId);
    if (publishingMatchIds.has(matchId) || this.disabled) return;
    publishingMatchIds.add(matchId);

    window.setMatchPublishBusy?.(true);
    var publishButtons = wizard.length ? wizard.find('.PublishMatchBtn') : element;
    publishButtons.prop('disabled', true).attr('aria-disabled', 'true');
    wizard.find('.match-publish-error').remove();

    if (!element.hasClass('mini')) {
        element.html('<i class="fa-solid fa-circle-notch fa-spin" aria-hidden="true"></i><span>İlan yayınlanıyor…</span>');
    }

    // The visual and the real request begin together. No request, recipient or
    // delivery behavior depends on animation progress or its ten-second floor.
    var minimumDisplay = new Promise(resolve => window.setTimeout(resolve, 10000));
    var flight = null;
    try {
        var categories = publishData.notifyNearby === undefined ? undefined : [];
        if (publishData.notifyNearby) {
            [['rival', 'notifyRivals'], ['player', 'notifyPlayers'], ['referee', 'notifyReferees'], ['coach', 'notifyCoaches'], ['audience', 'notifyAudience']]
                .forEach(([category, setting]) => { if (publishData[setting]) categories.push(category); });
        }
        if (categories && !categories.length) {
            if (publishData.sharePrivateChats) categories.push('private');
            if (publishData.shareCommunities) categories.push('community');
        }
        flight = window.MatchPublishFlight?.start({ facility: notificationExperience?.dataset.facility, categories: categories });
    } catch (animationError) {
        console.warn('Maç yayın görseli başlatılamadı.', animationError);
    }

    var requestSucceeded = false;
    var publishResult = null;
    var publishError = null;
    try {
        await Request({
            url: `/Match/PublishMatch`, type: 'POST', data: publishData,
            success: function (result) { requestSucceeded = true; publishResult = result; },
            error: function (error) { publishError = error; }
        });
    } catch (error) { publishError = error; }

    try {
        if (flight) await flight.finish(requestSucceeded ? 'success' : 'error');
    } catch (animationError) {
        console.warn('Maç yayın görseli tamamlanamadı.', animationError);
    }
    await minimumDisplay;
    flight?.close();
    window.setMatchPublishBusy?.(false);
    publishingMatchIds.delete(matchId);
    publishButtons.prop('disabled', false).removeAttr('aria-disabled');
    element.html(originalHtml);

    if (requestSucceeded) {
        if (publishResult?.liveMatch && location.hostname === 'sahasenin.com') {
            const payload = 'matchLive:' + JSON.stringify(publishResult.liveMatch);
            if (window.webkit?.messageHandlers?.nativeBridge)
                window.webkit.messageHandlers.nativeBridge.postMessage(payload);
            else window.jsBridge?.postMessage?.(payload);
        }
        removeSheedModal();
        updateAfterMatchArea(matchId);
        syncQuickActionBtn();
        window.showMatchUrgentPrompt?.(matchId, publishResult);
        window.syncNativeLiveActivities?.();
    } else {
        var message = publishError?.responseText || 'Maç ilanı yayınlanamadı. Ayarların korundu; lütfen tekrar deneyin.';
        if (wizard.length) $('<div>', { class: 'match-publish-error', role: 'alert', text: message }).insertBefore(element.closest('.match-publish-footer'));
        ShowErrorAlert(message);
    }
});

$(document).on("click", ".NotPublishMatchBtn", function () {
    var element = $(this);
    var matchId = element.data('match');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Maçı yayından kaldırmanız halinde, maç ayarlarında yeniden değişiklik yapabileceksiniz. Ancak bu işlem sırasında maça iletilmiş tüm katılım istekleri otomatik olarak reddedilecektir. Şimdi yayından kaldırma işlemini gerçekleştirmek istiyor musunuz?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yayından Kaldır',
        cancelButtonText: 'İptal'
    }).then((result) => {
        if (result.isConfirmed) {

            element.removeClass('NotPublishMatchBtn');
            element.addClass('disabled');
            element.addClass('opacity-50');

            if (!element.hasClass('mini')) {
                element.html('<i class="fa-solid fa-circle-xmark me-1"></i> Maç Yayından Kaldırılıyor..');
            }

            Request({
                url: `/Match/NotPublishMatch`,
                type: 'POST',
                data: {
                    matchId: matchId
                },
                success: function () {

                    updateAfterMatchArea(matchId);
                    syncQuickActionBtn();
                },
                error: function (jqXHR) {

                    ShowErrorAlert(jqXHR.responseText);
                }
            });
        }
    });
});



// Butonu loading moduna al
function startLoading() {
    var btn = $("#SubmitFirstSaveForm");
    btn.data('registration-label', btn.html());
    $('#FirstSaveForm').attr('data-submitting', 'true');
    btn.prop("disabled", true);
    btn.addClass("disabled text-muted");
    btn.attr('aria-busy', 'true').html('Kaydediliyor <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
}

// Butonu eski haline getir
function stopLoading() {
    var btn = $("#SubmitFirstSaveForm");
    $('#FirstSaveForm').removeAttr('data-submitting');
    btn.removeAttr('aria-busy').removeClass('text-muted');
    btn.html(btn.data('registration-label') || 'Devam Et <i class="fa-solid fa-arrow-right"></i>');
    updateSubmitButtonState();
}

$(document).on('click', '.register-password-toggle', function () {
    const button = $(this);
    const input = document.getElementById(button.data('target'));
    if (!input) return;

    const showPassword = input.type === 'password';
    input.type = showPassword ? 'text' : 'password';
    button.attr('aria-label', showPassword ? 'Parolayı gizle' : 'Parolayı göster');
    button.find('i')
        .toggleClass('fa-eye', !showPassword)
        .toggleClass('fa-eye-slash', showPassword);
});

// Click event
$(document).on("click", "#SubmitFirstSaveForm", async function (e) {
    e.preventDefault();
    if ($('#FirstSaveForm').attr('data-submitting') === 'true') return;
    startLoading();
    try {
        await registrationPhotoSavePromise;
        if (registrationFieldSaveRetries.has('Img')) await registrationFieldSaveRetries.get('Img')();
        if (!validateRegistrationBasicFields()) return;
        if (registrationFieldSaveErrors.has('RoleRequirements')) {
            await selectRegistrationRole(document.querySelector('.registration-role[aria-pressed="true"]'));
            if (registrationFieldSaveErrors.has('RoleRequirements')) return;
        }
        if (!await refreshPhoneRoleAvailability()) return;
        if ($('#FirstSaveForm').attr('data-existing') === 'true') {
            for (const [id, name] of [['RegistrationNickName', 'NickName'], ['RegistrationMail', 'Mail']]) {
                const input = document.getElementById(id);
                if (input && !input.disabled && input.value !== input.defaultValue) {
                    if (!await editableMemberProp(name, input.value.trim())) return;
                    input.defaultValue = input.value;
                }
            }
            await nextStep($('#CheckPhoneFirst').val() === 'true', false);
            return;
        }
        await submitFirstForm();
    } catch (error) {
        ShowErrorAlert(error?.responseText || 'Kayıt tamamlanamadı. Lütfen tekrar deneyin.');
    } finally {
        stopLoading();
    }
});


async function submitFirstForm() {

    var permission = true;
    var element = $('#FirstSaveForm');
    const checks = await Promise.all([NickDynamic(), MailDynamic()]);
    if (checks.includes(false)) permission = false;

    if ($("#NickDynamic").hasClass('is-invalid')) {

        permission = false;
    }

    if ($("#MailDynamic").hasClass('is-invalid')) {

        permission = false;
    }

    if (($("#PasswordOne").val() || '').length < 8) {

        $("#PasswordOne").addClass('is-invalid');
        permission = false;
    }

    if (validateRegistrationBasicFields() && permission) {

        var formData = element.serialize();
        return SubmitFirstSaveForm(formData);
    } else {
        const invalid = element.find('.is-invalid').get(0);
        showRegistrationValidationError(invalid, 'İşaretli bilgileri kontrol edin. Kullanıcı adı veya e-posta kullanımda olabilir.');
    }
}

async function SubmitFirstSaveForm(formData) {
    const gender = document.getElementById('GenderTypeSwitch')?.dataset.id || 0;
    formData += '&GenderTypEnum=' + encodeURIComponent(gender);
    try {
        const data = await $.ajax({ url: '/FirstSaveMember', type: 'POST', data: formData, timeout: 30000 });
        if (!data.MemberId) { ShowErrorAlert(); return; }
        window.SahaseninRegistration?.refreshIdentity();
        Logged();
        $('#MemberId').val(data.MemberId);
        const savedForm = $('#FirstSaveForm').attr('data-existing', 'true');
        savedForm.find('#Name, #Surname, #DynamicCityId, #DynamicDistrictId').addClass('editableMemberProp');
        savedForm.find('.genderSelect').addClass('editable');
        savedForm.find('#NickDynamic').attr('id', 'RegistrationNickName').val(data.NickName || data.Nick || '');
        savedForm.find('#MailDynamic').attr('id', 'RegistrationMail');
        savedForm.find('#Img').val(data.Img || data.Resim || $('#Img').val());
        document.querySelectorAll('#FirstSaveForm input, #FirstSaveForm select').forEach(input => input.defaultValue = input.value);
        $('#registrationAvatar').removeClass('ProfilePhotoFirstSave').addClass('ChangeMyProfilePhoto').attr('data-id', data.MemberId).data('id', data.MemberId);
        savedForm.find('#PasswordOne').removeClass('required').prop('disabled', true).closest('.registration-password-wrap').hide();
        savedForm.find('#PasswordRequirement').hide();
        await nextStep($('#CheckPhoneFirst').val() === 'true', false, data.MemberId);
    } catch (error) {
        ShowErrorAlert(error?.responseText || 'Kayıt tamamlanamadı. Lütfen bilgilerinizi kontrol edin.');
    }
}


async function CheckPhoneAndMail() {

    var id = $("#MemberId").val();

    if (id === undefined) {

        id = $("input[name='MemberId']").val();
    }

    var mail = $("#Mail").val();
    var phone = $('#Phone').val();

    try {
        const response = await $.post('/Member/CheckPhoneAndMail', { mail: mail, phone: phone, id: id, memberTypeId: Number($('#MemberTypeId').val()) || 0 });
        return response;
    } catch (error) {
        ShowErrorAlert();
    }
}


async function SendPhoneSmsCheckMember(formData) {

    var id = $('#MemberId').val();
    var phone = $('#Phone').val();

    if (phone != '') {

        var guid = Math.floor(1000 + Math.random() * 9000);
        var sms = `İşlem onayı için tek kullanımlık kod: ${guid}`;
        var sendSmsUrl = "/MemberSms/SendSms";

        $.post(sendSmsUrl, { id: 0, description: sms, phone: phone })
            .done(function () {
                bootbox.prompt({
                    title: "SMS Onayı",
                    inputType: 'text',
                    placeholder: "SMS onay kodunu girin",
                    buttons: {
                        cancel: {
                            label: 'Vazgeç',
                            className: 'btn-primary'
                        },
                        confirm: {
                            label: 'Tamam',
                            className: 'btn-primary'
                        }
                    },
                    callback: function (result) {

                        if (result === null) {

                            return;
                        }

                        if (result === guid.toString()) {



                            if (id === 0 || id === undefined) {

                                SubmitFirstSaveForm(formData);
                            }
                            else {

                                SubmitMainFormTask('Member', formData);
                            }

                        } else {

                            Swal.fire({
                                title: 'Hata!',
                                text: 'Girdiğiniz SMS onay kodu geçersiz.',
                                icon: 'error',
                                confirmButtonText: 'Tamam'
                            });
                        }
                    }
                });
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                ShowErrorAlert();
            });
    }
    else {

        SubmitFirstSaveForm(formData);
    }
}


$(document).on("click", "#refereeMatchBtn", function () {

    InitLoadScreen('#refereeMatchArea');

    Request({
        url: "/Member/_MyMatchListForQuicKMenu",
        type: 'POST',
        data: {
            type: 3
        },
        target: '#refereeMatchArea'
    }).then(() => {

    }).catch((error) => {
        console.error(error.responseText);
    });
});
$(document).on("click", "#memberWithMatchBtn", function () {

    $('#findMatchForOnlyPlayerArea').html('');
    InitLoadScreen('#memberWithMatchDiv');

    Request({
        url: "/Member/_MyMatchListForQuicKMenu",
        type: 'POST',
        data: {
            type: 2
        },
        target: '#memberWithMatchDiv'
    }).then(() => {

        StaffEditorAreaEach();
    }).catch((error) => {
        console.error(error.responseText);
    });
});

$(document).on("click", "#rivalJoinMatchRequestBtn", function () {

    InitLoadScreen('#rivalJoinMatchRequestDiv');

    Request({
        url: "/Member/_MyMatchListForQuicKMenu",
        type: 'POST',
        data: {
            type: 1
        },
        target: '#rivalJoinMatchRequestDiv'
    }).then(() => {

    }).catch((error) => {
        console.error(error.responseText);
    });
});


$(document).on("click", ".addProductToReservation", function () {

    var element = $(this)
    var stockId = element.data("id");
    var reservationId = element.data("reservation");
    var stockDetail = element.hasClass("stockDetail");
    var isReservationInner = element.hasClass("reservation");

    if (reservationId > 0) {
        element.prop('disabled', true);
        $.ajax({
            url: "/Reservation/AddProductToReservation",
            type: 'POST',
            data: {
                stockId: stockId,
                reservationId: reservationId
            },
            success: function () {

                loadReservationModalDetailsArea();
                loadReservationModalPriceDetailsArea();

                $('.reservation-product-list-toggle[data-id="' + stockId + '"][data-reservation="' + reservationId + '"]')
                    .removeClass('addProductToReservation')
                    .addClass('removeAllProductsFromReservation reservation-product-remove-all')
                    .prop('disabled', false)
                    .html('<i class="fa-solid fa-minus"></i> Çıkar');
                element.prop('disabled', false);

                if (stockDetail) {
                    element.text("Eklendi");
                    var modal = $(".custom-modal").has(".stockDetail");
                    modal.removeClass("show");
                }

                if (isReservationInner) {
                    element.text("Çıkar");

                    element.removeClass("border-primary");
                    element.addClass("border-red");

                    element.removeClass("text-primary");
                    element.addClass("text-red");
                }
            },
            error: function (ex) {
                element.prop('disabled', false);
                ShowErrorAlert(ex.responseText);
            }
        });
    }
    else {

        ShowErrorAlert('Ürünler yalnızca rezervasyon esnasında eklenebilir.');
    }
});

$(document).on("click", ".removeAllProductsFromReservation", function () {
    var element = $(this);
    var stockId = element.data("id");
    var reservationId = element.data("reservation");

    if (!(stockId > 0 && reservationId > 0)) {
        ShowErrorAlert('Ürün rezervasyon bilgisi bulunamadı.');
        return;
    }

    element.prop('disabled', true);
    $.ajax({
        url: "/Reservation/RemoveAllProductsFromReservation",
        type: 'POST',
        data: {
            stockId: stockId,
            reservationId: reservationId
        },
        success: function () {
            $('.reservation-product-list-toggle[data-id="' + stockId + '"][data-reservation="' + reservationId + '"]')
                .removeClass('removeAllProductsFromReservation reservation-product-remove-all')
                .addClass('addProductToReservation')
                .prop('disabled', false)
                .html('<i class="fa-solid fa-plus"></i> Ekle');

            loadReservationModalDetailsArea();
            loadReservationModalPriceDetailsArea();
        },
        error: function (ex) {
            element.prop('disabled', false);
            ShowErrorAlert(ex.responseText);
        }
    });
});

$(document).on("click", ".removeProductToReservation", function () {

    var element = $(this)
    var id = element.data("id");

    $.ajax({
        url: "/Reservation/RemoveProductToReservation",
        type: 'POST',
        data: {
            id: id
        },
        success: function () {

            loadReservationModalDetailsArea();
            loadReservationModalPriceDetailsArea();
            loadReservationModalProductsArea();
        },
        error: function (ex) {
            ShowErrorAlert(ex.responseText);
        }
    });
});

$(document).on("click", ".removeSheedModal", function () {
    removeSheedModal();
});

$(document).on("click", ".MoveStep2ReservationModal", async function () {

    var element = $(this);
    var modalScope = getReservationModalScope(element);
    var id = element.data("id");

    var validate = true;
    validation();

    var d1 = modalScope.find('.DocumentArea1');
    if (d1.length > 0) {
        var Icon = d1.children('i').first();
        if (Icon.hasClass('fa-square')) {

            Icon.addClass('text-red');
            validate = false;
        }
    }
    var d2 = modalScope.find('.DocumentArea2');
    if (d2.length > 0) {
        var Icon = d2.children('i').first();
        if (Icon.hasClass('fa-square')) {

            Icon.addClass('text-red');
            validate = false;
        }
    }

    const onlinePaymentSelected = modalScope.find('.paymentOption.active[data-type="online"]').length > 0;
    const savedCardSelected = modalScope.find('.creditCardOption.checked').length > 0;
    if (modalScope.find(".creditCardFormInput.is-invalid").length > 0 && onlinePaymentSelected && !savedCardSelected) {
        console.log("form is not valid");
        return;
    }

    if (validate) {

        if (id > 0) {

            const selectedPaymentType = modalScope.find('.paymentOption.active').data('type');
            const selectedPaymentAmountType = modalScope.find('.reservation-payment-panel.active .reservation-payment-amount-input:checked').val() || 'full';
            if (selectedPaymentType) {
                try {
                    await $.ajax({
                        url: '/Reservation/UpdateReservationPaymentType',
                        type: 'POST',
                        data: {
                            id: id,
                            paymentType: selectedPaymentType,
                            paymentAmountType: selectedPaymentAmountType
                        }
                    });
                } catch (error) {
                    ShowErrorAlert(error.responseText || 'Ödeme yöntemi güncellenemedi.');
                    return;
                }
            }

            if (onlinePaymentSelected && !savedCardSelected) {
                const cardForm = modalScope.find('#MemberCreditCardForm').last();
                const cardValidation = validateReservationDirectCardForm(modalScope);
                if (!cardValidation.valid) {
                    ShowErrorAlert(cardValidation.message);
                    return;
                }

                element.addClass('disabled').attr('aria-disabled', 'true');
                try {
                    const saveForLater = modalScope.find('#SaveReservationCard').is(':checked');
                    await $.ajax({
                        url: saveForLater
                            ? '/MemberCreditCard/SaveMemberCreditCardAndReservation'
                            : '/MemberCreditCard/SaveCardInfosReservation',
                        type: 'POST',
                        data: cardForm.serialize() + '&id=' + id + (saveForLater ? '' : '&requireComplete=true')
                    });
                } catch (error) {
                    ShowErrorAlert(error.responseText || 'Kart bilgileri rezervasyona aktarılamadı.');
                    element.removeClass('disabled').removeAttr('aria-disabled');
                    return;
                }
            }

            var modalBody = element.closest('.custom-modal-body').last();

            if (modalBody.length > 0) {

                // ReservationModalForCompanyStore
                Request({
                    url: "/Reservation/ReservationModalForCompanyStore",
                    type: 'POST',
                    data: {
                        id: id
                    }
                }).then((response) => {

                    modalBody.html(response);
                    loadReservationModalDetailsArea(modalBody);
                    loadReservationModalPriceDetailsArea(modalBody);
                    loadReservationModalProductsArea(modalBody);
                    startCountdown();

                }).catch((error) => {
                    console.error("'/Reservation/ReservationModalForCompanyStore':", error.responseText);
                    element.removeClass('disabled').removeAttr('aria-disabled');
                });
            }
            else {
                console.log('modalBody.length = 0');
                ShowErrorAlert();
            }
        }
        else {
            console.log('ReservationId cannot be zero.');
            ShowErrorAlert();
        }
    }
});
function getCheckReservationErrorMessage(error, fallbackMessage) {
    var fallback = fallbackMessage || 'Rezervasyon işlemi tamamlanamadı. Lütfen tekrar deneyin.';

    function readMessage(value) {
        if (!value) return '';

        if (typeof value === 'object') {
            var directMessage = value.message || value.Message || value.detail || value.Detail ||
                value.description || value.Description || value.error || value.Error;
            if (directMessage) return readMessage(directMessage);

            if (value.errors && typeof value.errors === 'object') {
                var validationMessages = Object.keys(value.errors).reduce(function (messages, key) {
                    var fieldMessages = value.errors[key];
                    return messages.concat(Array.isArray(fieldMessages) ? fieldMessages : [fieldMessages]);
                }, []).filter(Boolean);
                if (validationMessages.length) return validationMessages.join(' ');
            }

            return '';
        }

        var text = String(value).trim();
        if (!text) return '';

        try {
            var parsed = JSON.parse(text);
            if (parsed !== text) {
                var parsedMessage = readMessage(parsed);
                if (parsedMessage) return parsedMessage;
            }
        } catch (_) { }

        if (/<[a-z][\s\S]*>/i.test(text)) {
            text = $('<div>').html(text).text().replace(/\s+/g, ' ').trim();
        }

        return text.length > 350 ? text.substring(0, 347) + '...' : text;
    }

    return readMessage(error && error.responseJSON) ||
        readMessage(error && error.responseText) ||
        readMessage(error) ||
        fallback;
}

function resetCheckReservationButton(element) {
    element.find('.spinner-border').remove();
    element.removeClass('text-half-muted disabled').removeAttr('aria-disabled');
}

$(document).on("click", ".CheckReservation", function () {

    var element = $(this);
    var modalScope = getReservationModalScope(element);
    var id = element.data("id");
    var isOnline = element.hasClass('online');
    var isTournament = element.hasClass('isTournament');

    var agreement = modalScope.find('.reservation-store-step .DocumentArea1').last();
    if (agreement.length) {
        var agreementIcon = agreement.find('[data-agreement-check]').first();
        if (!agreementIcon.hasClass('fa-square-check')) {
            agreementIcon.addClass('text-red');
            ShowErrorAlert('Rezervasyonu tamamlamak için Mesafeli Satış Sözleşmesi’ni onaylamalısın.');
            return;
        }
    }

    if (element.find('.spinner-border').length) return;

    if (id > 0) {

        // Spinner ekle
        if (!element.find('.spinner-border').length) {
            element.append('<span class="spinner-border spinner-border-sm mx-2 text-white" role="status"></span>');
            element.addClass('text-half-muted');
            element.addClass('disabled').attr('aria-disabled', 'true');
        }

        if (isOnline) {
            // Online Ödeme
            $.ajax({
                url: "/Reservation/CheckedReservationOnlinePay",
                type: 'POST',
                data: {
                    id: id
                },
                success: function (response) {
                    if (response && response.success && response.paymentUrl && response.paymentSessionId) {
                        try {
                            showPaymentModal(response);
                        } catch (error) {
                            ShowErrorAlert(getCheckReservationErrorMessage(
                                error,
                                'Ödeme ekranı hazırlanamadı. Lütfen tekrar deneyin.'
                            ));
                            resetCheckReservationButton(element);
                            _updateReservationTable();
                        }

                    } else {
                        ShowErrorAlert(getCheckReservationErrorMessage(
                            response,
                            'Online ödeme başlatılamadı. Lütfen kart ve rezervasyon bilgilerini kontrol edin.'
                        ));
                        resetCheckReservationButton(element);
                        _updateReservationTable();
                    }
                },
                error: function (ex) {
                    ShowErrorAlert(getCheckReservationErrorMessage(
                        ex,
                        'Online ödeme başlatılırken bir hata oluştu. Lütfen tekrar deneyin.'
                    ));
                    resetCheckReservationButton(element);
                    console.log('CheckReservation(): ' + ex.responseText);
                    _updateReservationTable();
                }
            });

            function showPaymentModal(paymentSession) {
                var settled = false;
                var closed = false;
                var statusRequestActive = false;
                var pollTimer = 0;
                var paymentModal;
                var expectedOrigin = paymentSession.resultOrigin || window.location.origin;
                var iframeHtml = `
                    <section class="payment-sheet" aria-live="polite">
                        <div class="payment-sheet-status" data-payment-status>
                            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                            <span data-payment-status-text>Banka ekranı hazırlanıyor...</span>
                        </div>
                        <iframe id="paymentFrame"
                                class="payment-sheet-frame"
                                title="3D Secure ödeme doğrulaması"
                                allow="payment"
                                referrerpolicy="no-referrer"
                                src="${paymentSession.paymentUrl}"></iframe>
                        <button type="button" class="payment-sheet-fallback" data-payment-fallback>
                            Doğrulama görünmüyorsa tam ekranda devam et
                        </button>
                    </section>`;

                paymentModal = createModal({
                    title: 'Online Ödeme',
                    content: iframeHtml,
                    modalClass: 'payment-sheet-modal',
                    onClose: function () {
                        closed = true;
                        stopPaymentObservers();
                        if (!settled) {
                            queryPaymentStatus(true);
                            resetCheckReservationButton(element);
                            _updateReservationTable();
                        }
                    }
                });

                var iframe = document.getElementById('paymentFrame');
                var fallbackButton = document.querySelector(
                    '.payment-sheet-modal [data-payment-fallback]');
                var fallbackTimer = window.setTimeout(function () {
                    if (!settled && !closed && fallbackButton) {
                        fallbackButton.classList.add('is-visible');
                    }
                }, 8000);

                function setPaymentStatus(message, checking) {
                    var status = document.querySelector('.payment-sheet-modal [data-payment-status]');
                    var statusText = document.querySelector('.payment-sheet-modal [data-payment-status-text]');
                    if (!status || !statusText) return;
                    statusText.textContent = message;
                    status.classList.toggle('is-visible', checking !== false);
                }

                function stopPaymentObservers() {
                    window.removeEventListener('message', paymentMessageHandler, false);
                    if (pollTimer) {
                        window.clearInterval(pollTimer);
                        pollTimer = 0;
                    }
                    if (fallbackTimer) {
                        window.clearTimeout(fallbackTimer);
                        fallbackTimer = 0;
                    }
                }

                function finishPayment(status) {
                    if (settled) return;
                    settled = true;
                    stopPaymentObservers();
                    paymentModal.close();

                    if (status.state === 'succeeded') {
                        pageLink(status.redirectUrl || `/Rezervasyonlarim?openDetailId=${id}`);
                        return;
                    }

                    resetCheckReservationButton(element);
                    Swal.fire({
                        title: 'Ödeme başarısız',
                        text: status.message || 'Kart işlemi banka tarafından onaylanmadı. Lütfen bilgilerinizi kontrol edip tekrar deneyin.',
                        icon: 'error',
                        confirmButtonText: 'Tamam'
                    }).then(function () {
                        _updateReservationTable();
                    });
                }

                function queryPaymentStatus(ignoreClosed) {
                    if (statusRequestActive || settled || (closed && !ignoreClosed)) return;
                    statusRequestActive = true;
                    $.ajax({
                        url: '/Reservation/OnlinePaymentStatus',
                        type: 'POST',
                        data: {
                            id: id,
                            paymentSessionId: paymentSession.paymentSessionId
                        }
                    }).done(function (status) {
                        if (!status) return;
                        if (status.state === 'succeeded' || status.state === 'failed') {
                            finishPayment(status);
                            return;
                        }
                        if (!closed) {
                            setPaymentStatus(status.message || '3D Secure doğrulaması bekleniyor.', false);
                        }
                    }).fail(function (xhr) {
                        if (xhr && (xhr.status === 401 || xhr.status === 404)) {
                            finishPayment({
                                state: 'failed',
                                message: 'Ödeme oturumunun süresi doldu. Lütfen yeniden deneyin.'
                            });
                        }
                    }).always(function () {
                        statusRequestActive = false;
                    });
                }

                function paymentMessageHandler(event) {
                    if (!iframe || event.source !== iframe.contentWindow) return;
                    if (event.origin !== expectedOrigin) return;
                    if (!event.data || event.data.type !== 'InputFound') return;
                    setPaymentStatus('Ödeme sonucu kontrol ediliyor...', true);
                    queryPaymentStatus(false);
                }

                iframe.addEventListener('load', function () {
                    setPaymentStatus('3D Secure doğrulaması bekleniyor.', false);
                }, { once: true });
                if (fallbackButton) {
                    fallbackButton.addEventListener('click', function () {
                        stopPaymentObservers();
                        window.location.assign(paymentSession.paymentUrl);
                    });
                }
                window.addEventListener('message', paymentMessageHandler, false);
                pollTimer = window.setInterval(function () {
                    queryPaymentStatus(false);
                }, 2000);
            }

        } else {

            // Online Ödeme Olmayan
            Request({
                url: "/Reservation/CheckedReservation",
                type: 'POST',
                data: {
                    id: id
                }
            }).then(() => {
                bootbox.hideAll();

                if (isTournament) {

                    updateTournamentDateTableArea();
                }
                else {

                    pageLink('/Rezervasyonlarim', { openDetailId: id });
                }

            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
                ShowErrorAlert(getCheckReservationErrorMessage(
                    error,
                    'Rezervasyon onaylanırken bir hata oluştu. Lütfen tekrar deneyin.'
                ));
                resetCheckReservationButton(element);
            });
        }
    }
    else {
        console.log('ReservationId cannot be zero.');
        ShowErrorAlert('Rezervasyon bilgisi bulunamadı. Sayfayı yenileyip tekrar deneyin.');
    }
});




$(document).on("click", ".copyBtn", function (e) {
    e.preventDefault();

    var btn = $(this);
    var text = btn.data("text");
    var icon = btn.find("i");

    // Kopyalama
    var tempInput = $("<input>");
    $("body").append(tempInput);
    tempInput.val(text).select();
    document.execCommand("copy");
    tempInput.remove();

    // İkonu değiştirme
    icon.fadeOut(150, function () {
        icon
            .removeClass("fa-regular fa-clipboard")
            .addClass("fa-solid fa-clipboard-check")
            .fadeIn(150);
    });

    // 2 saniye sonra geri alma
    setTimeout(function () {
        icon.fadeOut(150, function () {
            icon
                .removeClass("fa-solid fa-clipboard-check")
                .addClass("fa-regular fa-clipboard")
                .fadeIn(150);
        });
    }, 2000);
});



$(document).on("click", ".createTeamJoinMatchRequestMessage", function () {

    var element = $(this);
    var matchId = element.data('match');
    var teamId = element.data('team');

    const modal = createModal({
        title: 'Maça katılmak istediğin takımını seç'
    });

    Request({
        url: `/Reservation/memberTeamsForJoinMatchRequest`,
        type: 'POST',
        data: {
            teamId: teamId,
            matchId: matchId
        },
        success: function (partialView) {
            if (partialView) {

                modal.updateContent(partialView);

            } else {

                ShowErrorAlert();
            }
        },
        error: function (jqXHR) {

            ShowErrorAlert();
        }
    });
});





function loadAfterMatchSetting() {

    var element = $("#AfterMatchSettingArea");

    if (element.length > 0) {

        var matchId = element.data('match');
        const version = (element.data('settings-version') || 0) + 1;
        element.data('settings-version', version);

        // İçerik boşsa load screen göster, değilse mevcut içeriği opaklaştır
        if ($.trim(element.html()) === "")
            InitLoadScreenElement(element);

        else
            element.addClass('opacity-50');

        return Request({
            url: '/Match/_AfterMatchSetting',
            type: 'POST',
            cacheable: false,
            data: {
                matchId: matchId
            },
            success: function (response) {

                if (element.data('settings-version') !== version) return;
                const focused = document.activeElement;
                const focusId = element[0]?.contains(focused) ? focused.id : null;
                const focusedValue = focusId ? focused.value : null;
                element.removeClass('opacity-50');
                element.html(response);
                if (focusId) {
                    const input = document.getElementById(focusId);
                    if (input && element[0]?.contains(input)) { input.value = focusedValue; input.focus({ preventScroll: true }); }
                }
                s2Each();
                if (activeDraftMatchManager?.section === 'announcements') refreshDraftMatchManager();
                if (typeof window.loadMatchNotificationDeliveryAreas === 'function') {
                    window.loadMatchNotificationDeliveryAreas(element[0]);
                }
            },
            error: function (jqXHR) {
                element.removeClass('opacity-50');
                ShowErrorAlert(jqXHR.responseText);
            }
        });
    }
    else {
        console.log('$("#AfterMatchSettingArea").lenght = 0');
    }
}





$(document).on("click", ".JoinRequestTab", function () {

    var element = $(this);
    var matchId = element.data('match');

    loadJoinRequestArea(matchId);
});

async function loadJoinRequestArea(matchId) {

    InitLoadScreen('#afterMatchJoinRequestsArea');

    Request({
        url: `/Reservation/GetMatchJoinRequestsCount`,
        type: 'POST',
        data: {
            matchId: matchId
        },
        success: function (count) {

            $('#JoinRequestCount').text(count > 99 ? '99+' : count).toggleClass('d-none', count <= 0)
                .attr('aria-label', `${count} yeni talep`);
        },
        error: function (jqXHR) {

            ShowErrorAlert();
        }
    });

    Request({
        url: `/Reservation/afterMatchJoinRequestsArea`,
        type: 'POST',
        data: {
            matchId: matchId
        },
        target: '#afterMatchJoinRequestsArea',
        success: function (partialView) {

        },
        error: function (jqXHR) {

            ShowErrorAlert();
        }
    });
}


async function checkJoinRequestSelect() {

    var value = $('.JoinRequestSelect').data('val');

    if (value) {

        $('.JoinRequestTab').removeClass('d-none');
    }
    else {

        $('.JoinRequestTab').addClass('d-none');

        $('#afterMatchJoinRequestsArea').html('');
    }
}



$(document).on("click", ".myTeamForReservationJoinRequest", function () {

    var element = $(this);
    var teamId = element.data('team');
    var matchId = element.data('match');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Maça Katılma isteği göndermek üzeresiniz",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Maça katıl',
        cancelButtonText: 'Vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {
            Request({
                url: '/Reservation/CreateTeamJoinMatchRequestMessage',
                type: 'POST',
                data: {
                    teamId: teamId,
                    matchId: matchId
                }
            }).then((data) => {

                var dataId = data.TeamJoinMatchRequestMessageId;

                $('.createTeamJoinMatchRequestMessage').text('İstek gönderildi');

                pageLink('/Mac/' + matchId);

            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});

$(document).on("click", ".deleteTeamJoinMatchRequestMessage", function () {

    var element = $(this);
    var id = element.data('id');
    var matchId = element.data('match');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Maça Katılma isteğini geri çekmek üzeresiniz",
        icon: 'warning',
        showCancelButton: true,


        confirmButtonText: 'İsteği geri çek',
        cancelButtonText: 'Vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/TeamJoinMatchRequestMessage/Delete',
                type: 'POST',
                data: { id: id }
            }).then((data) => {

                var dataId = data.TeamJoinMatchRequestMessageId;

                $('.deleteTeamJoinMatchRequestMessage').text('İstek iptal edildi');

                pageLink('/Mac/' + matchId);
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});




$(document).on("click", ".AddMemberTeam", function () {

    var id = $('#TeamDefaultBtn').data('id');
    var memberId = $('#teamMemberSelect').val();

    if (memberId > 0) {

        var formdata = new FormData();
        formdata.append('TeamId', id);
        formdata.append('MemberId', memberId);

        Swal.fire({
            title: 'Emin misiniz?',
            text: "Üye kadrodan dahil edilsin mi?",
            icon: 'warning',
            showCancelButton: true,


            confirmButtonText: 'Evet',
            cancelButtonText: 'Hayır'
        }).then((result) => {
            if (result.isConfirmed) {
                Request({
                    url: '/TeamPlayer/Save',
                    type: 'POST',
                    data: formdata,
                    isFormdata: true
                }).then(() => {

                    StaffEditorAreaEach();
                }).catch((error) => {
                    console.error("Detaylı hata bilgisi:", error.responseText);
                });
            }
        });
    }
});



function showTeamOverview() {
    $('.team-settings-panel').addClass('d-none');
    $('.team-overview-panel').removeClass('d-none');
}

function showTeamInviteNotice(message, icon) {
    if (typeof Swal !== 'undefined' && Swal.fire) {
        Swal.fire({
            toast: true,
            position: 'bottom',
            icon: icon || 'success',
            title: message,
            showConfirmButton: false,
            timer: 2400,
            timerProgressBar: true
        });
        return;
    }

    console.log(message);
}

function recordTeamInviteShareOpened(inviteCode, nativeShareAvailable) {
    if (!inviteCode) return;

    $.ajax({
        url: '/Team/RecordInviteShareOpened',
        type: 'POST',
        data: {
            code: inviteCode,
            nativeShareAvailable: nativeShareAvailable
        }
    }).fail(function (error) {
        console.warn('Davet paylaşım olayı kaydedilemedi:', error && error.responseText);
    });
}

function fitTeamInviteCardPreviews(root) {
    root = root || document.querySelector('.team-invite-share-modal');
    if (!root) return;

    var rootWidth = root.getBoundingClientRect().width || window.innerWidth;
    var availableWidth = Math.min(360, Math.max(1, Math.min(window.innerWidth - 46, rootWidth - 16)));

    root.querySelectorAll('.team-invite-poster-viewport').forEach(function (viewport) {
        var baseWidth = Number(viewport.dataset.baseWidth) || 360;
        var baseHeight = Number(viewport.dataset.baseHeight) || 500;
        var scale = availableWidth / baseWidth;
        var card = viewport.querySelector('.TeamInviteCardImg');

        viewport.style.width = availableWidth + 'px';
        viewport.style.height = (baseHeight * scale) + 'px';
        if (card) card.style.transform = 'scale(' + scale + ')';
    });
}

$(window).off('resize.teamInviteReference').on('resize.teamInviteReference', function () {
    fitTeamInviteCardPreviews();
});

$(document).on('click', '.team-invite-share-switch .targetDivSelector', function () {
    window.requestAnimationFrame(function () {
        fitTeamInviteCardPreviews();
    });
});

$(document).on('click', '.team-invite-share-button', async function (event) {
    event.preventDefault();
    event.stopPropagation();

    var $button = $(this);
    if ($button.hasClass('processing')) return;

    var teamId = Number($button.data('team')) || 0;
    if (teamId <= 0) {
        ShowErrorAlert('Takım bilgisi bulunamadı.');
        return;
    }

    window.teamInviteCardBlobs = {};

    var inviteModal = createModal({
        title: 'Takım daveti paylaşım önizlemesi',
        modalClass: 'team-invite-share-sheet'
    });
    Request({
        url: '/Team/_TeamInviteShareModal',
        type: 'POST',
        data: { teamId: teamId }
    }).then(function (response) {
        inviteModal.updateContent(response);
        window.requestAnimationFrame(function () {
            fitTeamInviteCardPreviews();
            window.setTimeout(captureTeamInviteCards, 80);
        });
    }).catch(function (error) {
        if (error && Number(error.status) === 409) {
            inviteModal.updateContent(
                '<div class="p-4 text-center" role="alert">' +
                '<i class="fa-solid fa-people-group fs-2 mb-3 text-primary" aria-hidden="true"></i>' +
                '<h2 class="fs-5">Önce kadronu düzenle</h2>' +
                '<p>Davet paylaşmadan önce oyuncuların mevkilerini sürükle/bırak ile ayarla.</p>' +
                '<div class="d-flex flex-wrap justify-content-center gap-2">' +
                '<button type="button" class="btn btn-primary team-invite-arrange-roster" data-team="' + teamId + '">Kadroyu düzenle</button>' +
                '<button type="button" class="btn btn-light team-invite-roster-later">Daha sonra</button></div></div>');
            return;
        }
        inviteModal.updateContent('<div class="alert alert-danger m-2 text-center">' +
            (error && error.responseText ? error.responseText : 'Davet önizlemesi hazırlanamadı.') + '</div>');
    });
});

$(document).on('click', '.team-invite-arrange-roster', function () {
    var teamId = Number($(this).data('team')) || 0;
    if (teamId <= 0) return;
    removeSheedModal();
    pageLink('/Takim-Kadrom/' + teamId);
});

$(document).on('click', '.team-invite-roster-later', function () {
    $(this).closest('.custom-modal').find('.custom-modal-header .close-modal').trigger('click');
});

window.teamInviteCardBlobs = window.teamInviteCardBlobs || {};
window.teamInviteCardUrls = window.teamInviteCardUrls || {};

function getTeamInviteCanvasTextSpecs(source, type) {
    var isRoster = type === 'kadro';
    var firstSelector = isRoster ? '.team-invite-roster-hero-one' : '.team-invite-player-hero-one';
    var secondSelector = isRoster ? '.team-invite-roster-hero-two' : '.team-invite-player-hero-two';
    var joinSelector = isRoster ? '.team-invite-roster-join span' : '.team-invite-player-join span';
    var first = source.querySelector(firstSelector);
    var second = source.querySelector(secondSelector);
    var join = source.querySelector(joinSelector);

    return [
        {
            selector: firstSelector,
            text: first ? first.textContent.trim() : '',
            left: isRoster ? 201 : 0,
            top: isRoster ? 53 : 280,
            width: isRoster ? 388 : 785,
            fontSize: isRoster ? 56 : (first ? Number.parseFloat(first.style.fontSize) || 88 : 88),
            lineHeight: isRoster ? 1 : .96,
            scaleX: isRoster ? .93 : .82,
            fill: '#ffffff',
            stroke: 'rgba(18,18,18,.32)',
            strokeWidth: isRoster ? .85 : .9,
            hardShadow: 'rgba(0,0,0,.52)',
            hardShadowY: 3,
            softShadow: 'rgba(0,0,0,.25)',
            softShadowY: isRoster ? 7 : 8,
            softShadowBlur: 14,
            letterSpacing: isRoster ? .4 : .5
        },
        {
            selector: secondSelector,
            text: second ? second.textContent.trim() : '',
            left: isRoster ? 180 : 0,
            top: isRoster ? 103 : 351,
            width: isRoster ? 397 : 785,
            fontSize: isRoster ? 85 : 104,
            lineHeight: .84,
            scaleX: isRoster ? .86 : .84,
            fill: isRoster ? '#72de35' : '#6ddd33',
            stroke: isRoster ? 'rgba(16,80,14,.54)' : 'rgba(20,84,15,.52)',
            strokeWidth: isRoster ? 1 : 1.1,
            hardShadow: isRoster ? 'rgba(10,56,12,.60)' : 'rgba(9,53,10,.58)',
            hardShadowY: 3,
            softShadow: 'rgba(0,0,0,.25)',
            softShadowY: isRoster ? 7 : 8,
            softShadowBlur: 14,
            letterSpacing: .2
        },
        {
            selector: joinSelector,
            text: join ? join.textContent.trim() : '',
            centerX: isRoster ? 350 : 433,
            centerY: isRoster ? 811.5 : 869,
            fontSize: isRoster ? 42 : 47,
            lineHeight: 1,
            scaleX: .97,
            fill: '#ffffff',
            stroke: 'rgba(0,0,0,.28)',
            strokeWidth: 1,
            hardShadow: isRoster ? 'rgba(0,0,0,.62)' : 'rgba(0,0,0,.58)',
            hardShadowY: 2,
            softShadow: 'rgba(0,0,0,.28)',
            softShadowY: 5,
            softShadowBlur: 10,
            letterSpacing: 1
        }
    ].filter(function (spec) { return spec.text; });
}

function drawTeamInviteCanvasText(canvas, specs) {
    var context = canvas.getContext('2d');
    if (!context) return;

    specs.forEach(function (spec) {
        var lineHeight = spec.fontSize * spec.lineHeight;
        var centerX = spec.centerX != null ? spec.centerX : spec.left + (spec.width / 2);
        var centerY = spec.centerY != null ? spec.centerY : spec.top + (lineHeight / 2);

        context.save();
        context.font = '900 ' + spec.fontSize + 'px Impact, "Arial Black", "Inter Display Black", Arial, sans-serif';
        context.textAlign = 'center';
        context.textBaseline = 'alphabetic';
        context.lineJoin = 'round';
        context.miterLimit = 2;
        if ('fontKerning' in context) context.fontKerning = 'normal';
        if ('letterSpacing' in context) context.letterSpacing = spec.letterSpacing + 'px';

        var metrics = context.measureText(spec.text);
        var ascent = metrics.actualBoundingBoxAscent || spec.fontSize * .76;
        var descent = metrics.actualBoundingBoxDescent || spec.fontSize * .18;
        var baseline = centerY + ((ascent - descent) / 2);
        var skewX = Math.tan(-3 * Math.PI / 180);

        context.translate(centerX, centerY);
        context.transform(spec.scaleX, 0, skewX, 1, 0, 0);
        context.translate(-centerX, -centerY);

        context.fillStyle = spec.fill;
        context.shadowColor = spec.softShadow;
        context.shadowBlur = spec.softShadowBlur;
        context.shadowOffsetX = 0;
        context.shadowOffsetY = spec.softShadowY;
        context.fillText(spec.text, centerX, baseline);
        context.shadowColor = 'transparent';
        context.shadowBlur = 0;
        context.shadowOffsetY = 0;
        context.fillStyle = spec.hardShadow;
        context.fillText(spec.text, centerX, baseline + spec.hardShadowY);
        context.lineWidth = spec.strokeWidth * 2;
        context.strokeStyle = spec.stroke;
        context.strokeText(spec.text, centerX, baseline);
        context.fillStyle = spec.fill;
        context.fillText(spec.text, centerX, baseline);
        context.restore();
    });
}

function setTeamInviteActionsState(root, type, state) {
    if (!root) return;

    var actions = root.querySelector('[data-invite-actions="' + type + '"]');
    if (!actions) return;

    var isReady = state === 'ready';
    var isError = state === 'error';
    var wait = actions.querySelector('.team-invite-share-wait');
    var icon = actions.querySelector('.team-invite-share-wait-icon i');
    var title = actions.querySelector('.team-invite-share-wait-copy strong');
    var detail = actions.querySelector('.team-invite-share-wait-copy small');
    var buttons = actions.querySelector('.team-invite-share-buttons');

    actions.classList.toggle('is-preparing', !isReady && !isError);
    actions.classList.toggle('is-error', isError);
    actions.setAttribute('aria-busy', isReady || isError ? 'false' : 'true');

    // Paylaş yalnızca davet URL'sini kullanır; görsel hazırlığını sadece İndir bekler.
    if (buttons) buttons.setAttribute('aria-hidden', 'false');
    actions.querySelectorAll('.waitTeamInviteImg').forEach(function (button) {
        button.classList.toggle('processing', !isReady);
        button.disabled = !isReady;
    });

    if (wait) wait.setAttribute('aria-hidden', isReady ? 'true' : 'false');
    if (icon) {
        icon.className = isError
            ? 'fa-solid fa-triangle-exclamation'
            : 'fa-solid fa-spinner';
    }
    if (title) title.textContent = isError ? 'Görsel hazırlanamadı' : 'Görsel hazırlanıyor';
    if (detail) {
        detail.textContent = isError
            ? 'Davet linkini paylaşabilirsin. Görseli indirmek için pencereyi kapatıp yeniden dene.'
            : 'Görseli birazdan indirebilirsin. Davet linkini şimdi paylaşabilirsin.';
    }
}

function withTeamInviteTimeout(promise, milliseconds) {
    return new Promise(function (resolve, reject) {
        var timer = window.setTimeout(function () {
            reject(new Error('Davet görseli hazırlanırken zaman aşımı oluştu.'));
        }, milliseconds);
        Promise.resolve(promise).then(function (value) {
            window.clearTimeout(timer);
            resolve(value);
        }, function (error) {
            window.clearTimeout(timer);
            reject(error);
        });
    });
}

async function saveTeamInviteCardImage(root, type, blob) {
    var teamId = Number(root.dataset.team) || 0;
    try {
        var formData = new FormData();
        formData.append('file', blob, 'takim-davet-' + type + '-' + teamId + '.jpg');
        formData.append('teamId', String(teamId));
        formData.append('type', type);
        var uploadResult = await $.ajax({
            url: '/Team/SaveTeamInviteCardImg',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            timeout: 15000
        });
        if (root.isConnected && uploadResult && uploadResult.imageUrl) {
            window.teamInviteCardUrls[type] = uploadResult.imageUrl;
        }
    } catch (uploadError) {
        console.warn('Takım davet görseli sunucuya kaydedilemedi:', type, uploadError);
    }
}

async function captureTeamInviteCards() {
    var root = document.querySelector('.team-invite-share-modal');
    if (!root) return;
    try {
        if (typeof html2canvas !== 'function') {
            await withTeamInviteTimeout(window.sahaseninFeatureAssets.load('capture'), 20000);
        }
        if (!root.isConnected) return;
        if (typeof html2canvas !== 'function') throw new Error('Davet görseli aracı yüklenemedi.');
    } catch (captureError) {
        root.querySelectorAll('[data-invite-actions]').forEach(function (actions) {
            setTeamInviteActionsState(root, actions.dataset.inviteActions, 'error');
        });
        console.warn('Davet görseli aracı yüklenemedi:', captureError);
        return;
    }

    window.teamInviteCardBlobs = {};
    window.teamInviteCardUrls = {};

    root.querySelectorAll('[data-invite-actions]').forEach(function (actions) {
        setTeamInviteActionsState(root, actions.dataset.inviteActions, 'preparing');
    });

    fitTeamInviteCardPreviews(root);
    if (document.fonts && document.fonts.ready) {
        try {
            await withTeamInviteTimeout(document.fonts.ready, 3000);
        } catch (fontError) {
            console.warn('Davet görseli yazı tipleri beklenemedi:', fontError);
        }
    }

    var cards = Array.from(root.querySelectorAll('.TeamInviteCardImg'));
    var uploads = Promise.resolve();

    for (var index = 0; index < cards.length; index++) {
        if (!root.isConnected) return;
        var source = cards[index];
        var type = source.dataset.type || 'oyuncu';
        var captureWidth = Number(source.dataset.captureWidth) || 360;
        var captureHeight = Number(source.dataset.captureHeight) || Math.ceil(source.getBoundingClientRect().height);
        var sourceViewport = source.closest('.team-invite-poster-viewport');
        var previewWidth = sourceViewport ? Number.parseFloat(sourceViewport.style.width) : 0;
        var previewHeight = sourceViewport ? Number.parseFloat(sourceViewport.style.height) : 0;
        if (!(previewWidth > 0)) previewWidth = Math.min(360, captureWidth);
        if (!(previewHeight > 0)) previewHeight = captureHeight * (previewWidth / captureWidth);
        var host = document.createElement('div');
        host.setAttribute('aria-hidden', 'true');
        host.style.cssText = 'position:fixed;left:-100000px;top:0;width:' + previewWidth + 'px;height:' + previewHeight + 'px;overflow:hidden;pointer-events:none;z-index:-2147483647';
        var viewportClone = sourceViewport ? sourceViewport.cloneNode(true) : document.createElement('div');
        if (!sourceViewport) viewportClone.appendChild(source.cloneNode(true));
        viewportClone.style.setProperty('position', 'relative', 'important');
        viewportClone.style.setProperty('margin', '0', 'important');
        viewportClone.style.setProperty('width', previewWidth + 'px', 'important');
        viewportClone.style.setProperty('height', previewHeight + 'px', 'important');
        viewportClone.style.setProperty('overflow', 'hidden', 'important');
        viewportClone.style.setProperty('box-shadow', 'none', 'important');
        var clone = viewportClone.querySelector('.TeamInviteCardImg');
        clone.style.setProperty('position', 'absolute', 'important');
        clone.style.setProperty('left', '0', 'important');
        clone.style.setProperty('top', '0', 'important');
        clone.style.setProperty('width', captureWidth + 'px', 'important');
        clone.style.setProperty('height', captureHeight + 'px', 'important');
        clone.style.setProperty('display', 'block', 'important');
        clone.style.setProperty('transform', 'scale(' + (previewWidth / captureWidth) + ')', 'important');
        clone.style.setProperty('transform-origin', 'top left', 'important');
        host.appendChild(viewportClone);
        document.body.appendChild(host);

        // html2canvas, özellikle WebView tabanlı tarayıcılarda, hem dış ölçek hem de
        // yazının kendi skew/scale dönüşümü varken metni yanlış koordinata taşıyor.
        // Başlıkları raster görüntüden çıkarıp aşağıda doğrudan son tuvale çiziyoruz.
        var canvasTextSpecs = getTeamInviteCanvasTextSpecs(source, type);
        canvasTextSpecs.forEach(function (spec) {
            var textElement = clone.querySelector(spec.selector);
            if (textElement) textElement.style.setProperty('visibility', 'hidden', 'important');
        });

        try {
            await withTeamInviteTimeout(Promise.all(Array.from(clone.querySelectorAll('img')).map(function (img) {
                if (typeof img.decode === 'function') {
                    return img.decode().catch(function () { });
                }
                if (img.complete) return Promise.resolve();
                return new Promise(function (resolve) {
                    img.addEventListener('load', resolve, { once: true });
                    img.addEventListener('error', resolve, { once: true });
                    window.setTimeout(resolve, 3000);
                });
            })), 3000).catch(function (imageError) {
                console.warn('Davet görseli resimleri beklenemedi:', imageError);
            });

            var canvas = await withTeamInviteTimeout(html2canvas(viewportClone, {
                useCORS: true,
                allowTaint: false,
                imageTimeout: 5000,
                backgroundColor: null,
                width: previewWidth,
                height: previewHeight,
                scale: captureWidth / previewWidth,
                scrollX: 0,
                scrollY: 0,
                windowWidth: window.innerWidth,
                windowHeight: window.innerHeight
            }), 15000);
            if (canvas.width !== captureWidth || canvas.height !== captureHeight) {
                var normalizedCanvas = document.createElement('canvas');
                normalizedCanvas.width = captureWidth;
                normalizedCanvas.height = captureHeight;
                normalizedCanvas.getContext('2d').drawImage(canvas, 0, 0, captureWidth, captureHeight);
                canvas = normalizedCanvas;
            }
            drawTeamInviteCanvasText(canvas, canvasTextSpecs);
            var blob = await withTeamInviteTimeout(new Promise(function (resolve) {
                canvas.toBlob(resolve, 'image/jpeg', 0.94);
            }), 3000);
            if (!blob) throw new Error('Görsel oluşturulamadı.');

            if (!root.isConnected) return;
            window.teamInviteCardBlobs[type] = blob;
        } catch (error) {
            console.error('Takım davet görseli hazırlanamadı:', type, error);
        } finally {
            host.remove();
        }

        var generatedBlob = window.teamInviteCardBlobs[type];
        if (generatedBlob) {
            setTeamInviteActionsState(root, type, 'ready');
            // Takım kaydına yazan yüklemeler sırayla çalışsın; ikinci kartın
            // hazırlanması ve indirilmesi bu kuyruğu beklemesin.
            uploads = uploads.then(saveTeamInviteCardImage.bind(null, root, type, generatedBlob));
        } else {
            setTeamInviteActionsState(root, type, 'error');
        }
    }
}

$(document).on('click', '.downloadTeamInviteImg', function (event) {
    event.preventDefault();
    var type = String($(this).data('type') || 'oyuncu');
    var blob = window.teamInviteCardBlobs[type];
    if (!blob) {
        ShowErrorAlert('Görsel hazırlanıyor. Lütfen birkaç saniye sonra tekrar deneyin.');
        return;
    }

    var url = URL.createObjectURL(blob);
    var anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'takim-davet-' + type + '.jpg';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
});

$(document).on('click', '.teamInvitePublish', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    var $button = $(this);
    var title = String($button.data('title') || document.title);
    var description = String($button.data('desc') || '');
    var shareUrl = String($button.data('url') || window.location.href);

    recordTeamInviteShareOpened($button.data('code'), !!navigator.share);
    // Poster yalnızca davet sayfasının OG önizlemesinde kullanılır; paylaşım
    // hedefi web ve uygulama köprüsünde her zaman katılım URL'sidir.
    openNativePublish(title, description, shareUrl);
});

function continuePendingTeamInviteJoin() {
    var $button = $('.team-invite-join-button[data-continue-join="true"]').first();
    if (!$button.length || $button.hasClass('processing')) return;

    // Tek kullanımlık devam niyeti: sayfa kancaları yeniden çalışsa da ikinci POST oluşmasın.
    $button.attr('data-continue-join', 'false');
    window.setTimeout(function () { $button.trigger('click'); }, 0);
}

$(function () {
    continuePendingTeamInviteJoin();
});

$(document).on('click', '.team-invite-join-button', async function (event) {
    event.preventDefault();

    var $button = $(this);
    if ($button.hasClass('processing')) return;

    var originalHtml = $button.html();
    $button.addClass('processing').prop('disabled', true).html('<i class="fa-solid fa-spinner fa-spin"></i> İstek gönderiliyor');

    try {
        var response = await $.ajax({
            url: '/Team/JoinTeamInvite',
            type: 'POST',
            data: { code: $button.data('code') }
        });

        $('#teamInviteAction').addClass('d-none');
        var $result = $('#teamInviteResult').removeClass('d-none');
        if (response.alreadyPending) {
            $result.find('h2').text('Katılma İsteğin Zaten Beklemede');
            $result.find('p').text('Takım yöneticisi isteğini değerlendirdiğinde bildirim alacaksın.');
        }
        $result.find('.pageLink').attr('data-url', response.teamUrl || '/Takimlar');
        window.scrollTo({ top: Math.max($result.offset().top - 24, 0), behavior: 'smooth' });
    } catch (error) {
        var message = error && error.responseText
            ? error.responseText.replace(/^"|"$/g, '')
            : 'Katılma isteği gönderilemedi.';
        ShowErrorAlert(message);
        $button.removeClass('processing').prop('disabled', false).html(originalHtml);
    }
});

async function loadTeamSettingsForm(teamId) {
    var target = $('#teamForm');
    if (!target.length || target.data('team-settings-loaded') === true) return;

    InitLoadScreenElement(target);

    try {
        var response = await Request({
            url: '/Team/_TeamForm',
            type: 'POST',
            data: { id: teamId }
        });

        target.html(response).data('team-settings-loaded', true);
        readyDynamicFilterPage();
        dateInputLoad();
        loadCKeditor();
        parentS2each();
    } catch (error) {
        target.removeData('team-settings-loaded');
        console.error("Detaylı hata bilgisi:", error.responseText);
    }
}

$(document).on("click", '.targetDivSelector[data-id="div_teamForm"]', function () {
    showTeamOverview();
});

$(document).on('click', '.team-open-settings', function (event) {
    event.preventDefault();

    var $generalTab = $('.targetDivSelector[data-id="div_teamForm"]').first();
    if (!$generalTab.hasClass('active')) $generalTab.trigger('click');

    $('.team-overview-panel').addClass('d-none');
    $('.team-settings-panel').removeClass('d-none');
    loadTeamSettingsForm(Number($generalTab.data('team')) || Number($('#TeamDefaultBtn').data('id')) || 0);
});

$(document).on('click', '.team-close-settings', function () {
    showTeamOverview();
});
$(document).on("click", '.targetDivSelector[data-id="div_teamStaff"]', function () {

    StaffEditorAreaEach();
});
$(document).on("click", '.targetDivSelector[data-id="div_teamDays"]', function () {

    var teamId = $(this).data('team');
    var target = $('#teamDays');
    InitLoadScreenElement(target);

    Request({
        url: '/Team/_TeamActiveDayAndTimeForm',
        type: 'POST',
        data: {
            id: teamId
        },
    }).then((response) => {

        target.html(response);
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
});

$(document).on("click", '.targetDivSelector[data-id="div_teamCities"]', function () {

    var teamId = $(this).data('team');
    var target = $('#teamCities');
    InitLoadScreenElement(target);

    Request({
        url: '/Team/_MyTeamLocation',
        type: 'POST',
        data: {
            type: 2,
            teamId: teamId
        },
    }).then((response) => {

        target.html(response);

        loadLocationRelationEditArea();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
});
$(document).on("click", '.targetDivSelector[data-id="div_teamRivals"]', function () {

    updateRivalRequestsTable();
});









$(document).on("click", "#teamStaffBtn", function () {

    var id = $('#TeamDefaultBtn').data('id');

    pageLink(`/Takim-Kadrom/${id}`);
});

$(document).on("click", "#teamActiveDayAndTimeBtn", function () {

    var id = $('#TeamDefaultBtn').data('id');

    pageLink('/Team/_TeamActiveDayAndTimeForm', { id: id })
        .then(() => {

        });
});


$(document).on("submit", "#TeamActiveDayAndTimeForm", function (e) {
    e.preventDefault();

    submitTeamActiveDayAndTimeForm();
});
async function submitTeamActiveDayAndTimeForm() {

    var form = $("#TeamActiveDayAndTimeForm");
    var id = $('#TeamDefaultBtn').data('id');
    var formData = form.serialize();

    Request({
        url: '/Team/SaveTeamActiveDayAndTime',
        type: 'POST',
        data: formData,
        success: function (response) {
            if (response.success) {

            } else {

                ShowErrorAlert();
                console.warn("Hata oluştu:", response.message);
            }
        },
        error: function (xhr, status, error) {
            if (error !== "abort") {
                ShowErrorAlert();

                console.error("Detaylı hata bilgisi:", error.responseText);
            }
        }
    });
}


$(document).on("change", ".DynamicInput", function () {
    var $hours = $(this).closest('.team-day-hours');
    if ($hours.length) {
        var start = $hours.find('input[type="time"]').eq(0).val() || '19:00';
        var finish = $hours.find('input[type="time"]').eq(1).val() || '23:00';
        $hours.closest('.card-body').find('.team-day-name small').text(start + ' – ' + finish);
    }
    submitActiveForm();
});

async function submitActiveForm() {

    if ($('#MemberActiveDayAndTimeForm').length > 0) {
        submitMemberActiveDayAndTimeForm();
    }
    else if ($('#TeamActiveDayAndTimeForm').length > 0) {
        submitTeamActiveDayAndTimeForm();
    }
}

$(document).on("submit", "#MemberActiveDayAndTimeForm", function (e) {
    e.preventDefault();

    submitMemberActiveDayAndTimeForm();
});

let registrationAvailabilityQueue = Promise.resolve(true);
async function submitMemberActiveDayAndTimeForm() {
    const form = document.getElementById('MemberActiveDayAndTimeForm');
    const formData = $(form).serialize();
    const registration = !!document.querySelector('.member-register-wizard');
    const save = () => Request({ url: '/Member/SaveMemberActiveDayAndTime', type: 'POST', data: formData });
    const request = registration ? registrationAvailabilityQueue.then(save) : save();
    const result = request.then(response => {
        if (registration && !form?.isConnected) return true;
        if (response && response.success === false) throw new Error('Günler kaydedilemedi.');
        registrationFieldSaveErrors.delete('Availability');
        registrationFieldSaveRetries.delete('Availability');
        return true;
    }).catch(error => {
        if (registration && !form?.isConnected) return false;
        if (registration) {
            registrationFieldSaveErrors.add('Availability');
            registrationFieldSaveRetries.set('Availability', submitMemberActiveDayAndTimeForm);
        }
        ShowErrorAlert(error?.responseText || 'Günler kaydedilemedi. Lütfen tekrar deneyin.');
        return false;
    });
    if (registration) registrationAvailabilityQueue = result;
    return result;
}



$(document).on("click", ".removeTeamMatchCaptain", function () {

    var id = $(this).data('id');
    var teamId = $(this).data('teamid');
    var matchId = $(this).data('match');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Üye kaptanlıktan alınsın mı?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {
            Request({
                url: '/Team/RemoveTeamMatchCaptain',
                type: 'POST',
                data: {
                    teamId: teamId,
                    memberId: id,
                    matchId: matchId
                }
            }).then(() => {

                StaffEditorAreaEach();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});

$(document).on("click", ".addTeamMatchCaptain", function () {

    var id = $(this).data('id');
    var teamId = $(this).data('teamid');
    var matchId = $(this).data('match');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Üye takım kaptanı olarak atanacak.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {
            Request({
                url: '/Team/AddTeamMatchCaptain',
                type: 'POST',
                data: {
                    matchId: matchId,
                    teamId: teamId,
                    memberId: id
                }
            }).then(() => {

                StaffEditorAreaEach();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});


$(document).on("click", ".removeTeamCaptain", function () {

    var id = $(this).data('id');
    var teamId = $(this).data('teamid');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Üye kaptanlıktan alınsın mı?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {
            Request({
                url: '/Team/RemoveTeamCaptain',
                type: 'POST',
                data: {
                    teamId: teamId,
                    memberId: id
                }
            }).then(() => {

                StaffEditorAreaEach();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});

$(document).on("click", ".addTeamCaptain", function () {

    var id = $(this).data('id');
    var teamId = $(this).data('teamid');
    var teamManager = $(this).data('team-manager');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Üye takım kaptanı olarak atanacak.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {
            Request({
                url: '/Team/AddTeamCaptain',
                type: 'POST',
                data: {
                    teamId: teamId,
                    memberId: id
                }
            }).then(() => {

                StaffEditorAreaEach();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});



$(document).on("click", ".removeTeamMember", function () {

    var id = $(this).data('id');
    var teamId = $(this).data('teamid');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Üye yedeğe alınsın mı?",
        icon: 'warning',
        showCancelButton: true,


        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {
            Request({
                url: '/Team/RemoveTeamMember',
                type: 'POST',
                data: {
                    teamId: teamId,
                    memberId: id
                }
            }).then(() => {

                StaffEditorAreaEach();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});

$(document).on("click", ".addTeamMember", function () {

    var id = $(this).data('id');
    var teamId = $(this).data('teamid');
    var teamManager = $(this).data('team-manager');

    if (teamManager > 0) {

        Swal.fire({
            title: 'Kendi Takımınıza Transfer Oluyorsunuz!',
            text: "Oyuncusu olduğunuz başka bir takım varsa otomatik olarak ayrılacaksınız.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Evet',
            cancelButtonText: 'Hayır'
        }).then((result) => {
            if (result.isConfirmed) {
                Request({
                    url: '/Team/AddTeamMember',
                    type: 'POST',
                    data: {
                        teamId: teamId,
                        memberId: id
                    }
                }).then(() => {

                    StaffEditorAreaEach();
                }).catch((error) => {
                    console.error("Detaylı hata bilgisi:", error.responseText);
                });
            }
        });
    }
    else {
        Swal.fire({
            title: 'Emin misiniz?',
            text: "Üye as kadroya dahil edilsin mi?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Evet',
            cancelButtonText: 'Hayır'
        }).then((result) => {
            if (result.isConfirmed) {
                Request({
                    url: '/Team/AddTeamMember',
                    type: 'POST',
                    data: {
                        teamId: teamId,
                        memberId: id
                    }
                }).then(() => {

                    StaffEditorAreaEach();
                }).catch((error) => {
                    console.error("Detaylı hata bilgisi:", error.responseText);
                });
            }
        });
    }
});






async function MatchStaffEditBuilder() {
    const $allPlayers = $(".player__item.draggablePlayer, .player__item.draggableTeamPlayer").not(".locked");
    if (!$allPlayers.length) return;
    try { await window.sahaseninFeatureAssets.load('drag'); }
    catch (error) { console.warn('Kadro sürükleme aracı yüklenemedi.', error); return; }

    $allPlayers.each(function () {
        if (!this.isConnected || $(this).hasClass('ui-draggable')) return;

        const $player = $(this);
        const $parentField = $player.closest('.field__box');
        const $positionText = $player.find('.position_text');
        const draftField = $player.closest('.draft-roster').length > 0;
        let dragStart;

        $player.draggable({
            containment: $parentField,
            cursor: "grabbing",
            helper: "original",

            start: function (event, ui) {
                dragStart = { x: event.pageX, y: event.pageY, left: ui.position.left, top: ui.position.top };
            },

            drag: function (event, ui) {
                if (!draftField || !dragStart) return;
                const field = $parentField[0];
                const scale = field.getBoundingClientRect().width / field.offsetWidth;
                if (scale >= .999) return;
                ui.position.left = Math.max(0, Math.min(field.clientWidth - $player.outerWidth(), dragStart.left + (event.pageX - dragStart.x) / scale));
                ui.position.top = Math.max(0, Math.min(field.clientHeight - $player.outerHeight(), dragStart.top + (event.pageY - dragStart.y) / scale));
            },

            stop: function (event, ui) {

                const id = $player.data('id');

                const parentOffset = $parentField.offset();
                const playerOffset = $player.offset();

                const x = Math.round(draftField ? ui.position.top : playerOffset.top - parentOffset.top);
                const y = Math.round(draftField ? ui.position.left : playerOffset.left - parentOffset.left);

                // ShowSuccessAlert("Kaydırma Bitti: x:" + x + ", y:" + y);

                if ($player.hasClass('draggablePlayer')) {
                    saveReservationPlayerAxis(id, x, y);
                }
                else if ($player.hasClass('draggableTeamPlayer')) {
                    saveTeamPlayerAxis(id, x, y);
                }

                if ($positionText.length > 0) {

                    $.ajax({
                        url: '/GetPositionForCoordinate',
                        type: 'POST',
                        data: {
                            id: id,
                            x: x,
                            y: y
                        },
                        success: function (response) {

                            $positionText.text(response.name);

                            if (response.memberNotPlayThisPosition === 1 || response.memberNotPlayThisPosition === "1") {

                                $positionText.removeClass('text-white').addClass('text-red');
                            }
                            else {
                                $positionText.addClass('text-white').removeClass('text-red');
                            }
                        }
                    });
                }
            }
        });

    });
}









async function saveReservationPlayerAxis(id, x, y) {

    // Geçersiz veri → refresh
    if (x < 0 || y < 0 || id === 0) {
        console.log("geçersiz veri:", { id, x, y });
        await StaffEditorAreaEach();
        return;
    }

    saveStaffImg();

    if (x > 421) x = 421;

    // 1️⃣ Önce x-y eksenini garanti altına al
    $.ajax({
        url: '/SaveReservationPlayerAxis',
        type: 'POST',
        data: {
            id: id,
            x: x,
            y: y
        }
    });
}
async function StaffEditorAreaEach() {

    var draftRoster = $('[data-draft-manager="roster"]');
    var elements = draftRoster.length ? draftRoster.find("._StaffEditorArea").filter(function () {
        return !$(this).closest('.draft-roster').prop('hidden');
    }) : $("._StaffEditorArea");
    var requests = [];

    lockWaitSaveImg();

    elements.each(function () {
        var element = $(this);
        InitLoadScreenElement(element);

        var teamId = element.data("team");
        var matchId = element.data("match");
        var preview = element.data("preview");
        var onlyPlayers = element.data("only-players");
        var showBlockActions = element.data("block-actions");

        if (!teamId) {
            element.html(`StaffEditorAreaEach skip: teamId=${teamId}, matchId=${matchId}`);
            return true; // continue
        }

        var req = Request({
            url: '/Team/_StaffEditor',
            type: 'POST',
            data: {
                teamId: teamId,
                matchId: matchId,
                preview: preview ?? false,
                onlyPlayers: onlyPlayers ?? false,
                showBlockActions: showBlockActions ?? false
            }
        }).then((response) => {
            element.html(response);
            fitDraftRosterFields(element);
            MatchStaffEditBuilder();
        }).catch((error) => {
            console.error("StaffEditorAreaEach():", error.responseText);
            if (element.closest('[data-draft-manager="roster"]').length) {
                element.html('<p class="fs-08 draft-manager__error" role="alert">Kadro yüklenemedi.</p><button type="button" class="fs-08 btn js-draft-manager-retry">Tekrar dene</button>');
            }
        });

        requests.push(req);
    });

    // ⏳ TÜM StaffEditor'lar yüklendikten sonra
    await Promise.all(requests);

    if ($('._staffAnnouncementsArea').length > 0) {

        elements.each(function () {
            var element = $(this);
            var teamId = element.data("team");
            var matchId = element.data("match");

            var staffAnnouncementsArea = element.find('._staffAnnouncementsArea');

            // Team profiles have a roster but no match; only load match announcements.
            if (!staffAnnouncementsArea.length || !(Number(matchId) > 0) || !(Number(teamId) > 0)) return true;

            InitLoadScreenElement(staffAnnouncementsArea);

            Request({
                url: '/Team/_joinMatchPlayerTeamSelectorModal',
                type: 'POST',
                data: {
                    matchId: matchId,
                    teamId: teamId
                }
            }).then((response) => {

                staffAnnouncementsArea.html(response);
            }).catch((xhr) => {

                staffAnnouncementsArea.html('');
                console.log('staffAnnouncementsArea: ' + xhr.responseText);
            });
        });
    }

    // ✅ Artık DOM hazır
    await saveStaffImg();
}
async function saveStaffImg() {

    // Geliştirme ortamlarında çalışmayı engelle
    if (["localhost"].includes(window.location.hostname)) {
        unlockWaitSaveImg();
        return;
    }

    var elements = $("._StaffEditorArea.preview");
    if (elements.length) await window.sahaseninFeatureAssets.load('capture');

    for (let i = 0; i < elements.length; i++) {

        var element = $(elements[i]);

        var teamId = element.data("team");
        var matchId = element.data("match");

        if (!teamId) continue;

        var matchCard = element.find(".field.isMatch")[0];
        var teamCard = element.find(".field.isTeam")[0];

        var card = null;
        var url = null;

        if (matchCard) {
            card = matchCard;
            url = "/SaveMatchStaffImg";
        }
        else if (teamCard) {
            card = teamCard;
            url = "/SaveTeamStaffImg";
        }
        else {
            continue;
        }

        try {

            var canvas = await html2canvas(card);

            var blob = await new Promise(resolve => {
                canvas.toBlob(resolve, "image/jpeg", 0.9);
            });

            if (!blob) continue;

            var formData = new FormData();
            formData.append("file", blob, "field.jpg");
            formData.append("teamId", teamId);

            if (matchCard && matchId) {
                formData.append("matchId", matchId);
            }

            await $.ajax({
                url: url,
                type: "POST",
                data: formData,
                processData: false,
                contentType: false
            });

            console.log(`saveStaffImg(): Saved img for ${matchCard ? "Match" : "Team"}. teamId:${teamId}, matchId:${matchId}`);

        } catch (err) {

            console.error("saveStaffImg hata:", { teamId, matchId, err });
        }
    }

    unlockWaitSaveImg();
}

async function saveMatchCardImg() {

    // Geliştirme ortamlarında çalışmayı engelle
    if (["localhost"].includes(window.location.hostname)) {
        unlockWaitSaveImg();
        return;
    }

    const elements = $(".MatchCardImg");
    if (elements.length) await window.sahaseninFeatureAssets.load('capture');
    const visibleWidth = Array.from(elements)
        .map(item => item.getBoundingClientRect().width)
        .find(width => Number.isFinite(width) && width > 0) || 360;

    for (let i = 0; i < elements.length; i++) {
        const element = $(elements[i]);
        const matchId = element.data('match');
        const type = element.data('type');

        if (!matchId) {
            console.warn("matchId bulunamadı, atlanıyor...");
            continue;
        }

        let captureHost = null;

        try {
            const source = element[0];
            const sourceRect = source.getBoundingClientRect();
            const computedHeight = parseFloat(window.getComputedStyle(source).height);
            const captureWidth = Number.isFinite(sourceRect.width) && sourceRect.width > 0
                ? sourceRect.width
                : visibleWidth;
            const captureHeight = Number.isFinite(sourceRect.height) && sourceRect.height > 0
                ? sourceRect.height
                : (Number.isFinite(computedHeight) && computedHeight > 0 ? computedHeight : 550);

            // d-none içindeki kartlar 0px genişlikle html2canvas'a verildiğinde radial-gradient
            // hesapları NaN/Infinity üretiyor. Kartı sabit ölçülü, ekran dışı bir klonda yakala.
            captureHost = document.createElement('div');
            captureHost.setAttribute('aria-hidden', 'true');
            captureHost.style.cssText = [
                'position:fixed',
                'left:-100000px',
                'top:0',
                `width:${captureWidth}px`,
                `height:${captureHeight}px`,
                'overflow:hidden',
                'pointer-events:none',
                'z-index:-2147483647'
            ].join(';');

            const captureElement = source.cloneNode(true);
            captureElement.removeAttribute('id');
            captureElement.classList.remove('d-none');
            captureElement.style.setProperty('display', 'flex', 'important');
            captureElement.style.setProperty('width', `${captureWidth}px`, 'important');
            captureElement.style.setProperty('height', `${captureHeight}px`, 'important');

            captureElement.querySelectorAll('.match-card__team').forEach(team => {
                team.style.setProperty('align-items', 'flex-start', 'important');
            });
            captureElement.querySelectorAll('.match-card__vs').forEach(vs => {
                vs.style.setProperty('margin-top', '50px', 'important');
            });

            captureHost.appendChild(captureElement);
            document.body.appendChild(captureHost);

            const images = Array.from(captureElement.querySelectorAll('img'));
            await Promise.all(images.map(img => {
                if (img.complete) return Promise.resolve();
                return new Promise(resolve => {
                    const finish = () => resolve();
                    img.addEventListener('load', finish, { once: true });
                    img.addEventListener('error', finish, { once: true });
                    window.setTimeout(finish, 3000);
                });
            }));

            const canvas = await html2canvas(captureElement, {
                useCORS: true,
                allowTaint: false,
                backgroundColor: null,
                width: Math.ceil(captureWidth),
                height: Math.ceil(captureHeight),
                scale: 1
            });

            const blob = await new Promise(resolve => {
                canvas.toBlob(resolve, "image/jpeg", 0.9);
            });

            if (!blob) {
                console.warn(`Blob oluşturulamadı, matchId: ${matchId}`);
                continue;
            }

            const formData = new FormData();
            formData.append("file", blob, `match_${matchId}.jpg`);
            formData.append("matchId", matchId);
            formData.append("type", type);


            await $.ajax({
                url: '/SaveMatchCardImg',
                type: "POST",
                data: formData,
                processData: false,
                contentType: false
            });

            console.log(`saveMatchCardImg(): Başarıyla kaydedildi, matchId: ${matchId}`);

        } catch (err) {

            console.error("saveMatchCardImg hata:", { matchId, err });
        } finally {
            captureHost?.remove();
        }
    }

    unlockWaitSaveImg();
}

function lockWaitSaveImg() {
    $('.waitSaveImg').addClass('opacity-50 processing');
}
function unlockWaitSaveImg() {
    $('.waitSaveImg').removeClass('opacity-50 processing');
}

function openMatchShareModal(matchId) {

    var modal = createModal({
        title: 'Maç ilanı paylaşım önizlemesi'
    });

    Request({
        url: `/Match/_MatchShareModal`,
        type: 'POST',
        data: {
            matchId: matchId
        }
    }).then((response) => {

        modal.updateContent(response);
        lockWaitSaveImg();
        // Önizlemenin önce ekrana çizilmesine izin ver; pahalı canvas üretimi arka planda başlasın.
        window.requestAnimationFrame(function () {
            window.setTimeout(saveMatchCardImg, 60);
        });
    }).catch((xhr) => {

        modal.updateContent(
            `<div class="text-center p-2 fs-08 fw-bold alert alert-danger m-2 br-12px">
                ${xhr.responseText}
            </div>`);
    });
}










async function saveTeamPlayerAxis(id, x, y) {

    $.ajax({
        url: '/SaveTeamPlayerAxis',
        type: 'POST',
        data: {
            id: id,
            x: x,
            y: y
        },
        success: function () {

            saveStaffImg();
        },
        error: function (xhr, status, error) {
            console.error("Hata: ", error.responseText);
        }
    });
}












$(document).on("click", ".reviewRivalButton", function () {

    removeSheedModal();

    var element = $(this);
    var matchId = element.data('match');

    var data = {
        moveComment: 1
    };

    pageLink(`/Mac-Olustur/${matchId}`, data);
});






$(document).on("click", ".deleteMyWaitingReviews", function () {

    var element = $(this);
    var card = element.closest('.card');

    var id = element.data('id');
    var secondId = element.data('second-id');

    card.addClass('d-none');

    Request({
        url: `/DeleteMyWaitingReviews`,
        type: 'POST',
        data: {
            id: id,
            secondId: secondId
        }
    }).then(() => {

    }).catch((jqXHR) => {

        card.removeClass('d-none');
        ShowErrorAlert(jqXHR.responseText);
    });
});


$(document).on("click", ".teamStandartTabBtn", function () {

    var element = $(this);

    var url = element.data('url');
    var entityName = element.data('name');
    var isPage = element.data('page');
    var id = $('#TeamDefaultBtn').data('id');

    lasteTeamId = id;

    var data = {
        page: 0,
        pageSize: 1000,
        relationId: id,
        entityName: 'Team',
        preview: true,
        isPage: true
    };

    pageLink(`/${entityName}/${url}`, data)
        .then(() => {

            LoadPagerBase();
            Table(true);
        });
});

async function updateTeamTableAndPagerBase(id, entityName) {



    Request({
        url: `/${entityName}/_PagerBase`,
        type: 'POST',
        data: { page: page, pageSize: pageSize },
        target: pagerBase
    }).then(() => {

        $('#pageSize').val(pageSize);
    }).catch((jqXHR) => {

        InitErrorScreen(pagerBase, jqXHR.responseText);
        ShowErrorAlert();
    });

    Request({
        url: `/${entityName}/_Table`,
        type: 'POST',
        data: {
            page: page,
            pageSize: pageSize,
            relationId: id,
            entityName: 'Team'
        },
        target: target
    }).then(() => {

        LoadRelationName();
    }).catch((jqXHR) => {

        InitErrorScreen(target, jqXHR.responseText);
        ShowErrorAlert();
    });
}

$(document).on("click", "#TeamDefaultBtn", function () {
    var id = $(this).data('id');

    loadTeamDefaultForm(id);
});

async function loadTeamDefaultForm(id) {

    pageLink('/Team/_Form', { id: id })
        .then(() => {

            dateInputLoad();
            relationBuilder();
            loadCKeditor();
            addPhoneMask();
        });
}










async function syncLargeMatchCards() {

    var elements = $('._LargeMatchCard');

    if (elements.length === 0)
        return;

    var promises = [];

    elements.each(function () {
        var element = $(this);
        var matchId = element.data('match');

        var promise = $.ajax({
            url: '/Match/_GetMatchCard',
            type: 'POST',
            data: {
                matchId: matchId
            }
        })
            .done(function (response) {
                element.html(response);
            })
            .fail(function (jqXHR) {
                ShowErrorAlert(jqXHR.responseText);
            });

        promises.push(promise);
    });

    // hepsi bitsin (hata olsa bile bekler)
    await Promise.allSettled(promises);

    syncMatchCountDown();
    secondSlider();
}









$(document).on("click", ".OpenReservationModal", function () {
    $('#Description').val("");

    $(".OpenReservationModal").removeClass("active");
    $(this).addClass("active");

    var fieldId = $(this).data('fieldid'); 
    var time = $(this).data("time");
    var date = $(this).data("date");

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                openReservationModal(time, fieldId, date);
            } else {

                quickLoginModal(); 
            }
        });

    fbq('track', 'AddToCart');
    console.log('fbq("track", "AddToCart")');
});

$(document).on("click", ".OpenReservationModalF", function () {

    $(".OpenReservationModalF").removeClass("active");
    $(this).addClass("active");

    var time = $(this).data("time");
    var fieldId = $(this).data("fieldid");

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {
                _openReservationModal(time, fieldId);

            } else {

                quickLoginModal(); 
            }
        });

    fbq('track', 'AddToCart');
    console.log('fbq("track", "AddToCart")');
});

function startCountdown() {
    const minutes = 5;
    const totalSeconds = minutes * 60;
    const endTime = Date.now() + totalSeconds * 1000;
    const activeModalBody = document.querySelector('.custom-modal:not(.sheed-modal-suspended) .custom-modal-body');
    const actionPanel = activeModalBody
        ? activeModalBody.querySelector('.reservation-action-panel')
        : document.querySelector('.reservation-action-panel');
    const countdownElement = actionPanel?.querySelector('[data-reservation-countdown]');
    const progressElement = actionPanel?.querySelector('[data-reservation-progress]');
    const progressRoot = progressElement?.closest('[role="progressbar"]');

    if (!countdownElement || !progressElement) {
        console.error('Reservation action elements not found!');
        return;
    }

    if (countdownInterval) clearInterval(countdownInterval);
    reservationCancellationInFlight = false;

    const updateDisplay = () => {
        const remaining = endTime - Date.now();

        if (remaining <= 0) {
            clearInterval(countdownInterval);
            try { cancelReservation({ silentIfMissing: true }); } catch (e) { console.error(e); }
            return;
        }

        const seconds = Math.floor(remaining / 1000);
        const displayMinutes = Math.floor(seconds / 60).toString().padStart(2, '0');
        const displaySeconds = (seconds % 60).toString().padStart(2, '0');

        const progressPercent = (remaining / (totalSeconds * 1000)) * 100;
        progressElement.style.width = progressPercent + '%';
        countdownElement.textContent = `${displayMinutes}:${displaySeconds}`;
        progressRoot?.setAttribute('aria-valuenow', Math.ceil(progressPercent).toString());
    };

    updateDisplay();
    countdownInterval = setInterval(updateDisplay, 1000);
}

$(document).on("click", ".cancelReservation", function () {

    cancelReservation();
});


async function cancelReservation(options) {

    options = options || {};

    if (reservationCancellationInFlight)
        return;

    var element = $("#ModalTime");

    if (element.length > 0) {
        var reservationId = element.data("reservation");

        if (reservationId > 0) {

            clearInterval(countdownInterval);
            reservationCancellationInFlight = true;

            Request({
                url: '/Reservation/CancelReservation',
                type: 'POST',
                data: {
                    id: reservationId
                },
                success: function () {

                    removeSheedModal();
                    loadFieldCalendar();
                    reservationCancellationInFlight = false;
                },
                error: function (error) {
                    var responseText = (error.responseText || '').toString();
                    var reservationAlreadyGone =
                        error.status === 404 ||
                        responseText.toLowerCase().includes('failed to retrieve reservation') ||
                        responseText.toLowerCase().includes('permission denied (3)');

                    if (options.silentIfMissing && reservationAlreadyGone) {
                        removeSheedModal();
                        loadFieldCalendar();
                    } else {
                        ShowErrorAlert(responseText);
                    }
                    reservationCancellationInFlight = false;
                }
            });
        }
        else {
            console.log("cancelReservation(): reservationId cannot be zero.");
        }
    }
    else {
        console.log("cancelReservation(): $(#ModalTime) element not found.");
    }
}

var reservationLocationFlowInProgress = false;

function escapeReservationLocationText(value) {
    return $('<div>').text(value || '').html();
}

async function ensureReservationLocationPreference(fieldId) {
    var preference = await Request({
        url: '/Reservation/CheckReservationLocationPreference',
        type: 'GET',
        cacheable: false,
        data: { fieldId: fieldId }
    });

    if (!preference || preference.requiresConfirmation !== true)
        return true;

    var districtName = escapeReservationLocationText(preference.districtName);
    var warningId = 'reservationLocationWarning_' + Date.now() + '_' + Math.floor(Math.random() * 10000);

    return new Promise(function (resolve) {
        var settled = false;
        var modal = createModal({
            title: '',
            closable: false,
            modalClass: 'reservation-location-warning-modal',
            content: `
                <section id="${warningId}" class="reservation-location-warning" role="dialog" aria-labelledby="${warningId}_title" aria-describedby="${warningId}_description">
                    <div class="reservation-location-warning-icon" aria-hidden="true">
                        <i class="fa-solid fa-location-dot"></i>
                    </div>
                    <h2 id="${warningId}_title">Bu tesis, tercih ettiğiniz bölgelerin dışında</h2>
                    <p id="${warningId}_description">
                        Rezervasyon yapabilmek için <strong>${districtName}</strong> ilçesini “Oynamak İstediğim İlçeler” listesine eklemeniz gerekiyor. İlçeyi ekledikten sonra rezervasyonunuza kaldığınız yerden devam edebilirsiniz.
                    </p>
                    <div class="reservation-location-warning-actions">
                        <button type="button" class="reservation-location-confirm">
                            <i class="fa-solid fa-plus" aria-hidden="true"></i>
                            <span>İlçeyi Ekle ve Devam Et</span>
                        </button>
                        <button type="button" class="reservation-location-cancel">Vazgeç</button>
                    </div>
                </section>`
        });

        var warning = document.getElementById(warningId);
        var confirmButton = warning.querySelector('.reservation-location-confirm');
        var cancelButton = warning.querySelector('.reservation-location-cancel');

        function finish(result) {
            if (settled)
                return;

            settled = true;
            modal.close();
            resolve(result);
        }

        cancelButton.addEventListener('click', function () {
            finish(false);
        });

        confirmButton.addEventListener('click', async function () {
            if (confirmButton.disabled)
                return;

            confirmButton.disabled = true;
            cancelButton.disabled = true;
            confirmButton.classList.add('is-loading');
            confirmButton.querySelector('span').textContent = 'Ekleniyor...';

            try {
                await Request({
                    url: '/Reservation/AddReservationLocationPreference',
                    type: 'POST',
                    cacheable: false,
                    data: { fieldId: fieldId }
                });
                finish(true);
            } catch (error) {
                ShowErrorAlert(error.responseText || 'İlçe tercihi eklenemedi. Lütfen tekrar deneyin.');
                confirmButton.disabled = false;
                cancelButton.disabled = false;
                confirmButton.classList.remove('is-loading');
                confirmButton.querySelector('span').textContent = 'İlçeyi Ekle ve Devam Et';
            }
        });

        confirmButton.focus();
    });
}

async function _openReservationModal(lastTime, fieldId) {

    if (await Permission() !== true) return;

    if (reservationLocationFlowInProgress)
        return;

    reservationLocationFlowInProgress = true;

    var element = $(".OpenReservationModalF.active");
    var dateValue = element.data("date");

    if (lastTime === undefined) {

        console.log("lastTime is undefined");

        lastTime = $(".OpenReservationModal.active").data("time");

        if (lastTime === undefined) {
            lastTime = element.data("time");
        }
    }

    var modal = null;

    try {
        var memberId = await getCurrentUserId();
        var locationConfirmed = await ensureReservationLocationPreference(fieldId);

        if (!locationConfirmed) {
            $(".OpenReservationModalF, .OpenReservationModal").removeClass("active");
            return;
        }

        var tournamentDateId = $('#tournamentDateId').val();

        modal = createModal({
            title: 'Rezervasyon yap'
        });

        var partialView = await Request({
                url: `/Reservation/ReservationModal`,
                type: 'GET',
                data: {
                    fieldId: fieldId,
                    memberId: memberId,
                    date: dateValue,
                    time: lastTime,
                    tournamentDateId: tournamentDateId
                }
            });

        if (partialView) {
            modal.updateContent(partialView);
            loadReservationModalDetailsArea();
            loadReservationModalPriceDetailsArea();
            loadReservationModalMemberCards();
            startCountdown();
        } else {
            ShowErrorAlert();
        }
    } catch (error) {
        if (modal) {
            modal.updateContent(`<span class="w-100 text-center p-2 text-red fw-bold">${escapeReservationLocationText(error.responseText)}</span>`);
        } else {
            ShowErrorAlert(error.responseText || 'Rezervasyon bilgileri alınamadı.');
        }
    } finally {
        reservationLocationFlowInProgress = false;
    }
}

async function openReservationModal(lastTime, fieldId, date) {

    if (await Permission() !== true) return;

    if (reservationLocationFlowInProgress)
        return;

    reservationLocationFlowInProgress = true;
  
    if (lastTime === undefined) {

        console.log("lastTime is undefined");

        lastTime = $(".OpenReservationModal.active").data("time");

        if (lastTime === undefined) {
            lastTime = $(".OpenReservationModalF.active").data("time");
        }
    }

    var MatchRequestTeamHiddenInputValue = 0;

    if ($('#MatchRequestTeamHiddenInput').length > 0) {

        MatchRequestTeamHiddenInputValue = $('#MatchRequestTeamHiddenInput').val();
    }
 
    var modal = null;

    try {
        var memberId = await getCurrentUserId();
        var locationConfirmed = await ensureReservationLocationPreference(fieldId);

        if (!locationConfirmed) {
            $(".OpenReservationModalF, .OpenReservationModal").removeClass("active");
            return;
        }

        var tournamentDateId = $('#tournamentDateId').val();

        modal = createModal({
            title: 'Rezervasyon yap'
        });

        var partialView = await Request({
                url: `/Reservation/ReservationModal`,
                type: 'GET',
                data: {
                    fieldId: fieldId,
                    memberId: memberId,
                    date: date,
                    time: lastTime,
                    tournamentDateId: tournamentDateId,
                    matchRequestTeam: MatchRequestTeamHiddenInputValue
                }
            });

        if (partialView) {
            modal.updateContent(partialView);
            loadReservationModalDetailsArea();
            loadReservationModalPriceDetailsArea();
            loadReservationModalMemberCards();
            startCountdown();
        } else {
            console.error("EditRow - Boş partialView alındı.");
            ShowErrorAlert();
        }
    } catch (error) {
        console.error("EditRow - Error details:", error.responseText);
        if (modal)
            modal.close();
        ShowErrorAlert(error.responseText || 'Rezervasyon bilgileri alınamadı.');
    } finally {
        reservationLocationFlowInProgress = false;
    }
}





$(document).on("change", ".changeTeamPlayerCountTypeId", function () {

    var element = $(this);
    var count = element.val();
    var id = element.data("team");

    Request({
        url: '/Team/SaveTeamPlayerCountTypeId',
        data: {
            id: id,
            count: count
        },
        type: 'POST',
    }).then(() => {

        StaffEditorAreaEach();
    }).catch((jqXHR) => {

        ShowErrorAlert(jqXHR.responseText);
    });
});


$(document).on("click", ".findMemberForTeamBtn", function (event) {

    event.preventDefault();
    event.stopImmediatePropagation();

    const modal = createModal({
        title: 'Takım için oyuncu aranıyor',
        modalClass: 'team-find-member-modal'
    });

    Request({
        url: '/Oyuncu-Bul',
        data: {
            pageLink: true
        },
    }).then((response) => {

        modal.updateContent(response);


        memberSearch();
    }).catch((jqXHR) => {
        modal.close();
        ShowErrorAlert(jqXHR.responseText || 'Oyuncu bulma ekranı açılamadı.');
    });

    return false;
});




$(document).on("click", "#memberWithUserBtn", function () {

    $('#FindRivalPageDiv2').html('');
    $('#FindRivalPageDiv').html('');
    $('#FindMemberPageDiv').html('');

    Request({
        url: '/Oyuncu-Bul',
        data: {
            pageLink: true,
            addFriend: true
        },
        target: '#FindMemberPageDiv2'
    }).then((data) => {


        memberSearch();
    }).catch((jqXHR) => {

    });
});
$(document).on("click", "#memberWithTeamBtn", function () {

    $('#FindRivalPageDiv2').html('');
    $('#FindRivalPageDiv').html('');
    $('#FindMemberPageDiv2').html('');

    Request({
        url: '/Oyuncu-Bul',
        data: {
            pageLink: true
        },
        target: '#FindMemberPageDiv'
    }).then((data) => {


        memberSearch();
    }).catch((jqXHR) => {

    });
});
$(document).on("click", ".memberWithTeamBtnForModal", function () {

    var modal = createModal({
        title: 'Oyuncu aranıyor'
    });

    Request({
        url: '/Oyuncu-Bul',
        data: {
            pageLink: true
        },
    }).then((response) => {

        modal.updateContent(response);


        memberSearch();
    }).catch((jqXHR) => {

    });
});
$(document).on("click", "#rivalSendMatchRequestBtn", function () {

    $('#FindRivalPageDiv2').html('');
    $('#FindMemberPageDiv').html('');
    $('#FindMemberPageDiv2').html('');

    Request({
        url: '/Rakip-Bul',
        data: {
            pageLink: true
        },
        target: '#FindRivalPageDiv'
    }).then((data) => {


        updateFindRivalTable();
    }).catch((jqXHR) => {

    });
});
$(document).on("click", "#rivalSendRivalRequestBtn", function () {

    $('#FindRivalPageDiv').html('');
    $('#FindMemberPageDiv').html('');
    $('#FindMemberPageDiv2').html('');

    Request({
        url: '/Rakip-Bul',
        data: {
            pageLink: true,
            addFriend: true
        },
        target: '#FindRivalPageDiv2'
    }).then((data) => {


        updateFindRivalTable();
    }).catch((jqXHR) => {

    });
});













$(document).on("click", "#LogInTab", function () {

    var url = $(this).data("url");

    $('#1af-2').html(null);

    Request({
        url: url,
        target: '#loginFormArea'
    }).then((data) => {

    }).catch((jqXHR) => {

    });
});
$(document).on("click", "#RegisterTab", function () {
    var url = $(this).data("url");

    $('#loginFormArea').html(null);

    Request({
        url: url,
        target: '#1af-2'
    }).then((data) => {
        addPhoneMask();

    }).catch((jqXHR) => {
        console.error(jqXHR.responseText);
    });
});

// uploadReceipt butonuna tıklanınca gizli input oluşturup seçtirme ve upload sürecini başlatma
$(document).on('click', '.uploadReceipt', function (e) {
    e.preventDefault();

    var btn = $(this);
    var reservationId = btn.data('id');

    // Eğer zaten yükleme yapılıyorsa tekrar çalıştırma
    if (btn.data('uploading')) return;

    // Gizli file input yarat
    let input = $('<input>', { type: 'file', accept: 'image/*' })
        .css('display', 'none')
        .appendTo('body');

    // cleanup helper
    function cleanUpUI() {
        btn.find('.upload-spinner').remove();
        btn.removeClass('disabled').attr('aria-disabled', 'false');
        btn.data('uploading', false);
        input.remove();
    }

    // buton UI: disabled + spinner + ikon gizle
    btn.data('uploading', true);
    btn.addClass('disabled').attr('aria-disabled', 'true');
    var $icon = btn.find('i.fa-solid').first();
    $icon.hide();
    if (!btn.find('.upload-spinner').length) {
        btn.append('<span class="upload-spinner ms-1 spinner-border spinner-border-sm" role="status"></span>');
    }

    // dosya seçimi olunca
    input.on('change', async function (event) {
        var file = event.target.files && event.target.files[0];
        if (!file) {
            // kullanıcı iptal etti
            cleanUpUI();
            return;
        }

        try {
            // 1) uploadImage fonksiyonunu kullan -> url al
            // uploadImage(file, "Member") bir Promise döndürüyor varsayılarak await kullanıyoruz
            const receiptUrl = await uploadImage(file);

            if (!receiptUrl) {
                throw new Error('Sunucudan geçerli bir url dönmedi.');
            }

            $.ajax({
                url: '/Reservation/SaveReceipt', // gerektiğinde endpoint'i değiştirin
                type: 'POST',
                data: {
                    id: reservationId,
                    url: receiptUrl
                },
                success: function (res) {
                    // Başarı durumuna göre UI geri bildirimi
                    cleanUpUI();

                    // ikon -> check göster
                    $icon.removeClass('fa-upload').addClass('fa-check').show();

                    // Örnek: buton metnini değiştirme (mevcut text node korunacak şekilde)
                    // Buton içindeki ilk text düğümü güncellenir:
                    btn.contents().filter(function () { return this.nodeType === 3; }).first().replaceWith('Dekont yüklendi. ');

                    btn.removeClass('uploadReceipt'); // tekrar tıklanmasını engelle
                    pageLink('/Rezervasyonum/' + reservationId);
                },
                error: function (xhr, status, err) {
                    cleanUpUI();
                    $icon.show();
                    alert('Dekont kaydı sırasında hata oluştu. Lütfen tekrar deneyin.');
                }
            });
        } catch (err) {
            // uploadImage veya başka kısımda hata
            cleanUpUI();
            $icon.show();
            console.error(err);
            alert((err && err.message) ? err.message : 'Yükleme sırasında bir hata oluştu.');
        }
    });

    // otomatik tıklat, kullanıcı dosya seçimi penceresini aç
    input.trigger('click');

    // eğer seçim yapılmazsa cleanup
    input.on('click focusout blur', function () {
        setTimeout(function () {
            if (!input[0].files.length) input.remove();
        }, 500);
    });
});



$(document).on('click', '.downloadReceipt', function (e) {
    e.preventDefault();

    var btn = $(this);
    var url = btn.data('url');
    if (!url) return;

    // Spinner ekle (ikonun hemen önüne)
    if (!btn.find('.dl-spinner').length) {
        btn.append('<span class="dl-spinner ms-2 spinner-border spinner-border-sm" role="status"></span>');
    }

    // Dosyayı indir
    var a = document.createElement('a');
    a.href = url;
    a.download = "";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // 1.5 sn sonra spinner'ı kaldır
    setTimeout(function () {
        btn.find('.dl-spinner').remove();
    }, 1500);
});





$(document).on("click", ".sendingActionBtn", function () {

    sendingActionModal();
});

async function sendingActionModal() {

    removeSheedModal();

    const modal = createModal({
        title: 'Yanıt bekleyen işlem listesi'
    });

    Request({
        url: '/Member/_SendingAction',
        type: 'POST',
    }).then((response) => {

        if (response.success === false) {

            console.error('sendingActionModal(): ' + response.message);
        }
        else {

            modal.updateContent(response);

            updateGlobalRequestCards();

            draggableCardBuilder();

            sahaseninInitCountdown();
        }
    }).catch((jqXHR) => {
        console.error(jqXHR.responseText);
    });
}




$(document).on("click", ".downgradeDay", async function () {
    let dataId = $(this).attr("data-id");
    let input = $(".dateInput[data-id='" + dataId + "']");

    if (input.length === 0)
        input = $("#FieldCalendarInput");

    if (input.length === 0)
        input = $("#ReservationTableDateInput");

    if (input.length > 0) {
        await window.sahaseninFeatureAssets.load('calendar');
        if (!input[0].isConnected) return;
        let currentDate = moment(input.val(), "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
        setDatePart(currentDate);
        input.val(currentDate);
        input.trigger('change');

        if ($("#ReservationTableDateInput").length > 0) {

            reservationTableUpdateAvailableDate();
        }
    }
    else {
        console.log("downgradeDay: No input found for data-id:", dataId);
    }
});

$(document).on("click", ".upgradeDay", async function () {

    let dataId = $(this).attr("data-id");
    var input = $(".dateInput[data-id='" + dataId + "']");

    if (input.length === 0)
        input = $("#FieldCalendarInput");

    if (input.length === 0)
        input = $("#ReservationTableDateInput");

    if (input.length > 0) {
        await window.sahaseninFeatureAssets.load('calendar');
        if (!input[0].isConnected) return;

        let currentDate = moment(input.val(), "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
        setDatePart(currentDate);
        input.val(currentDate);
        input.trigger('change');

        if ($("#ReservationTableDateInput").length > 0) {

            reservationTableUpdateAvailableDate();
        }
    }
    else {
        console.log("downgradeDay: No input found for data-id:", dataId);
    }
});

$(document).on("click", ".dateInput", async function () {

    var element = $(this);
    const needsInit = !element.data('daterangepicker');
    await dateInputLoad(element);
    if (!element[0].isConnected) return;
    const picker = element.data('daterangepicker');
    if (!picker) return;
    let currentValue = element.val();
    picker.setStartDate(currentValue ? moment(currentValue, "YYYY-MM-DD") : moment(SahaseninTime.dateKey(), "YYYY-MM-DD"));
    picker.setEndDate(currentValue ? moment(currentValue, "YYYY-MM-DD") : moment(SahaseninTime.dateKey(), "YYYY-MM-DD"));
    picker.updateView();
    if (needsInit) picker.show();
});

async function dateInputLoad(root = document) {
    var elements = $(root).find('.dateInput').add($(root).filter('.dateInput'));

    if (elements.length > 0) {
        try { await window.sahaseninFeatureAssets.load('calendar'); }
        catch (error) { console.warn('Tarih seçici yüklenemedi.', error); return; }
        elements.each(function () {
            if (!this.isConnected) return;

            var element = $(this);

            if (!element.data('daterangepicker')) {

                let currentValue = element.val();

                element.daterangepicker({
                    singleDatePicker: true,
                    showDropdowns: true,
                    minYear: 2000,
                    maxYear: SahaseninTime.calendarToday().getFullYear(),
                    autoApply: true,
                    startDate: currentValue ? moment(currentValue, "YYYY-MM-DD") : moment(SahaseninTime.dateKey(), "YYYY-MM-DD"),
                    locale: {
                        format: "YYYY-MM-DD",
                        daysOfWeek: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
                        monthNames: [
                            "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
                            "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
                        ],
                        firstDay: 1
                    }
                });

                element.addClass('initialized');
                window.sahaseninExperience?.own(this, () => {
                    element.data('daterangepicker')?.remove();
                    element.removeClass('initialized');
                });
            }
        });
    }
}



async function addPhoneMask(root = document) {

    if (typeof Inputmask !== 'undefined') {

        const selector = '#Phone, #changeMyPhoneForFirstSave';
        const inputs = $(root).find(selector).add($(root).filter(selector)).toArray().filter(input => input.type !== 'hidden' && !input.inputmask);
        if (inputs.length) Inputmask({ mask:'(999) 999-9999' }).mask(inputs);
    }
}


function maskLoginPhone(input) {
    if (input.dataset.composing === "true") return;
    const previous = input.value;
    const selection = input.selectionStart;
    let digits = previous.replace(/[^0-9]/g, "");
    if (digits.startsWith("90") && digits.length > 10) digits = digits.slice(2);
    if (digits.startsWith("0")) digits = digits.slice(1);
    digits = digits.slice(0, 10);
    let formatted = digits.length ? "(" + digits.slice(0, 3) : "";
    if (digits.length > 3) formatted += ") " + digits.slice(3, 6);
    if (digits.length > 6) formatted += "-" + digits.slice(6);
    if (input.value === formatted) return;
    input.value = formatted;
    if (selection !== null && selection < previous.length) {
        const digitsBefore = previous.slice(0, selection).replace(/[^0-9]/g, "").length;
        let position = 0, count = 0;
        while (position < input.value.length && count < digitsBefore) {
            if (/[0-9]/.test(input.value[position])) count++;
            position++;
        }
        input.setSelectionRange(position, position);
    }
}

$(document).on("input", '.member-auth-identity-wrap input[type="tel"]', function () {
    maskLoginPhone(this);
});

$(document).on("click", ".member-auth-identity-toggle", function () {
    const button = $(this);
    const wrap = button.closest(".member-auth-identity-wrap");
    const input = wrap.find('input[name="Mail"]');
    const phoneMode = button.attr("aria-pressed") !== "true";
    const previousMode = phoneMode ? "username" : "phone";
    const nextMode = phoneMode ? "phone" : "username";
    input.data(previousMode, input.val());
    input.val(input.data(nextMode) || "").attr({
        type: phoneMode ? "tel" : "text",
        inputmode: phoneMode ? "tel" : "text",
        autocomplete: phoneMode ? "tel" : "username",
        placeholder: phoneMode ? "(5XX) XXX-XXXX" : "Kullanıcı adı veya e-posta",
        pattern: phoneMode ? "\\(5[0-9]{2}\\) [0-9]{3}-[0-9]{4}" : null,
        title: phoneMode ? "Telefon numaranızı (5XX) XXX-XXXX biçiminde eksiksiz girin." : null,
        "aria-label": phoneMode ? "Telefon numarası" : "Kullanıcı adı veya e-posta"
    }).trigger("focus");
    input.trigger("input");
    if (phoneMode) maskLoginPhone(input[0]);
    wrap.find("[data-login-identity-icon]").attr("class", phoneMode ? "fa-solid fa-phone" : "fa-regular fa-user");
    button.attr("aria-pressed", String(phoneMode)).text(phoneMode ? "E-posta ile" : "Telefon ile");
});

$(document).on('input', '#LogInForm [name="Mail"], #LogInForm [name="Password"]', function () {
    this.closest('form').querySelector('[data-login-member-types]')?.remove();
});

function chooseLoginMemberType(types) {
    return new Promise(resolve => {
        const dialog = document.createElement('dialog');
        dialog.className = 'member-role-dialog';
        dialog.setAttribute('aria-labelledby', 'member-role-title');
        dialog.setAttribute('aria-describedby', 'member-role-description');
        dialog.innerHTML = '<div class="member-role-hero"><span class="member-role-brand"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 3 4 6v5c0 5 8 10 8 10s8-5 8-10V6z"/><path d="m8 12 3 3 5-6"/></svg> SAHASENİN</span><button type="button" class="member-role-close" aria-label="Üyelik seçimini kapat">×</button><span class="member-role-eyebrow">TEK NUMARA, SENİN HESAPLARIN</span><h2 id="member-role-title">Sahaya hangi rolle<br>çıkmak istersin?</h2><p id="member-role-description">Telefon numarana bağlı birden fazla üyelik var. Devam etmek istediğin hesabı seç.</p></div><div class="member-role-options" role="group" aria-label="Üyelik tipleri"></div><p class="member-role-footnote"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg> Kartı seçtiğinde hesabına giriş yapılır.</p>';
        const roles = {
            1: ['Oyuncu', 'Takımın, maçların ve saha senin.', '<circle cx="12" cy="12" r="9"/><path d="m12 8 4 3-1.5 4h-5L8 11zM12 3v5m4 3 4.5-1M14.5 15l3 4M9.5 15l-3 4M8 11l-4.5-1"/>'],
            2: ['Hakem', 'Maçları yönet, oyunun içinde kal.', '<path d="M5 21V4m0 0c5-5 9 5 15 0v10c-6 5-10-5-15 0M10 3v10m5-8v10M5 9c5-5 9 5 15 0"/>'],
            3: ['Seyirci', 'Takımlarını ve maçları takip et.', '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/>'],
            4: ['Teknik direktör', 'Takımına yön ver, oyunu planla.', '<rect x="4" y="4" width="16" height="17" rx="2"/><path d="M9 4V2h6v2M8 9h3m-3 4h8m-8 4h5"/>']
        };
        const opener = document.activeElement;
        let selected = null;
        for (const type of types) {
            const role = roles[Number(type.id)];
            if (!role) continue;
            const button = document.createElement('button');
            button.type = 'button'; button.className = 'member-role-card';
            button.dataset.loginRole = String(type.id);
            button.innerHTML = `<span class="member-role-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${role[2]}</svg></span><strong>${role[0]}</strong><small>${role[1]}</small><span class="member-role-enter" aria-hidden="true">Giriş yap <span>↗</span></span>`;
            button.addEventListener('click', () => { selected = Number(type.id); dialog.close(); }, { once: true });
            dialog.querySelector('.member-role-options').append(button);
        }
        dialog.querySelector('.member-role-close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
            const box = dialog.getBoundingClientRect();
            if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
        });
        dialog.addEventListener('close', () => { dialog.remove(); if (opener?.isConnected) opener.focus({ preventScroll: true }); resolve(selected); }, { once: true });
        document.body.append(dialog);
        dialog.showModal();
        dialog.querySelector('.member-role-card')?.focus({ preventScroll: true });
    });
}

$(document).on("submit", "#LogInForm", async function (e) {
    e.preventDefault();
    const form = this;
    $(form).find('[name="MemberTypeId"]').prop('required', false);
    if (!form.reportValidity()) return;
    if (form.dataset.resolvingRoles === 'true') return;
    form.dataset.resolvingRoles = 'true';
    try {
        const identity = form.querySelector('[name="Mail"]').value;
        const digits = identity.replace(/[^0-9]/g, '');
        if (/^[0-9 ()+.-]+$/.test(identity) && digits.length >= 10) {
            const password = form.querySelector('[name="Password"]').value;
            const types = await $.post('/Login/PhoneMemberTypes', { phone: identity, password });
            if (!form.isConnected || form.querySelector('[name="Mail"]').value !== identity || form.querySelector('[name="Password"]').value !== password) return;
            if (!types.length) {
                form.querySelector('[data-login-member-types]')?.remove();
                ShowErrorAlert('Kullanıcı adı ve şifre hatalı');
                return;
            }
            const selected = types.length === 1 ? Number(types[0].id) : await chooseLoginMemberType(types);
            if (!selected || !form.isConnected || form.querySelector('[name="Mail"]').value !== identity || form.querySelector('[name="Password"]').value !== password) return;
            let host = form.querySelector('[data-login-member-types]');
            if (!host) {
                host = document.createElement('div'); host.dataset.loginMemberTypes = '';
                host.innerHTML = '<input type="hidden" name="MemberTypeId">';
                form.append(host);
            }
            host.querySelector('[name="MemberTypeId"]').value = String(selected);
        } else {
            $(form).find('[name="MemberTypeId"]').val('').prop('required', false);
        }
    } catch (error) {
        ShowErrorAlert(error.responseText || 'Üyelik tipleri kontrol edilemedi. Tekrar deneyin.');
        return;
    } finally { delete form.dataset.resolvingRoles; }

    if (validation()) {
        var element = $(this);

        var url = element.data("url");
        var isAlert = element.data("alert");

        var formData = element.serialize();

        $.post("/Member/CheckTwoFactor", formData)
            .done(function (response) {


                if (response === "") {

                    sendLoginForm(url, isAlert, formData);
                } else {

                    var phone = response;

                    var guid = Math.floor(1000 + Math.random() * 9000);
                    var sms = `İki faktörlü kimlik doğrulamanız için şifre: ${guid}`;
                    var sendSmsUrl = "/MemberSms/SendSms";

                    $.post(sendSmsUrl, { id: 0, description: sms, phone: phone })
                        .done(function () {
                            bootbox.prompt({
                                title: "SMS Onayı",
                                inputType: 'text',
                                placeholder: "SMS onay kodunu girin",
                                buttons: {
                                    cancel: {
                                        label: 'Vazgeç',
                                        className: 'btn-primary'
                                    },
                                    confirm: {
                                        label: 'Tamam',
                                        className: 'btn-primary'
                                    }
                                },
                                callback: function (result) {
                                    if (result === null) {

                                        return;
                                    }

                                    if (result === guid.toString()) {

                                        sendLoginForm(url, isAlert, formData);
                                    } else {

                                        Swal.fire({
                                            title: 'Hata!',
                                            text: 'Girdiğiniz SMS onay kodu geçersiz.',
                                            icon: 'error',
                                            confirmButtonText: 'Tamam'
                                        });
                                    }
                                }
                            });
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            ShowErrorAlert();
                        });


                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {

                ShowErrorAlert();
            });
    } else {

        console.log('Form is not valid.')
        /*ShowErrorAlert('Zorunlu alanlar boş olamaz.');  */
    }
});

async function sendLoginForm(url, isAlert, formData) {

    var _e = $("#Time");
    var time = _e.val();
    var selector = _e.data("selector");
    var fieldId = _e.data("fieldid");

    Swal.fire({
        title: 'Lütfen bekleyin...',
        allowOutsideClick: false,
        didOpen: function () {
            Swal.showLoading();
        }
    });

    $.post(url, formData)
        .done(async function (response) {

            if (response.success) {
                if (response.accountDeleted) {
                    Swal.close();
                    renderDeletedAccountScreen(response.memberName || '', response.reactivationToken || '');
                    return;
                }

                if (response.permission) {

                    await Logged();
                    Swal.close();

                    if (response.redirectUrl) {
                        if ($(".custom-modal.show").length > 0) removeSheedModal();
                        pageLink(response.redirectUrl);
                        return;
                    }

                    if ($(".custom-modal.show").length > 0) {

                        removeSheedModal();
                    }
                    else if (isAlert === "True") {

                        var isMatchRequest = $('.matchRequestBtn').length > 0;
                        var isTransferRequest = $('.transferRequestBtn').length > 0;

                        var isCompanyComment = false;

                        if ($('#CompanyCommentId').length > 0) {

                            if ($('#Description').val() != "") {

                                isCompanyComment = true;
                            }
                        }

                        if (isCompanyComment) {
                            // CompanyComment

                            //SaveCompanyComment();
                        }
                        else if (isMatchRequest) {
                            // MatchRequest

                            executeMatchRequestTasks();
                        }
                        else if (isTransferRequest) {
                            // TransferRequest

                            executeTransferRequestTasks();
                        }
                        else {
                            // Reservation

                            if (fieldId === 0) {

                                ShowErrorAlert("fieldId is zero.");
                            }
                            else {

                                if (selector === "True") {
                                    _openReservationModal(time, fieldId);
                                } else {
                                    // openReservationModal($("#Time").val(), fieldId);
                                }
                            }
                        }
                    }
                    else {

                        openMyAccount();
                    }
                } else {
                    Swal.close();

                    ShowErrorAlert('Kullanıcı adı ve şifre hatalı');
                }
            }
            else {
                ShowErrorAlert(response.message);
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            Swal.close();

            ShowErrorAlert();
        });
}

function renderDeletedAccountScreen(memberName, reactivationToken) {
    var $layout = $('.member-auth-layout').first();
    if (!$layout.length) {
        ShowErrorAlert('Bu hesap silinmiş. Yeniden aktifleştirmek için giriş sayfasını açın.');
        return;
    }

    var $screen = $('<section>', { class: 'member-deleted-account', 'aria-live': 'polite' });
    $('<div>', { class: 'member-deleted-account__icon' })
        .append($('<i>', { class: 'fa-solid fa-user-slash' }))
        .appendTo($screen);
    $('<span>', { class: 'member-deleted-account__eyebrow', text: 'Silinmiş hesap' }).appendTo($screen);
    $('<h1>', { text: memberName ? memberName + ', hesabın şu anda kapalı' : 'Hesabın şu anda kapalı' }).appendTo($screen);
    $('<p>', {
        text: 'Bilgilerin korunuyor. Hesabın sen açıkça onay verene kadar yeniden aktifleştirilmeyecek.'
    }).appendTo($screen);
    $('<button>', {
        type: 'button',
        class: 'member-auth-submit reactivate-deleted-account',
        'data-reactivation-token': reactivationToken || '',
        html: '<i class="fa-solid fa-rotate-left"></i><span>Hesabı tekrar aktifleştir</span>'
    }).appendTo($screen);
    $('<button>', {
        type: 'button',
        class: 'member-deleted-account__cancel pageLink',
        'data-url': '/Giris',
        text: 'Şimdilik kapalı kalsın'
    }).appendTo($screen);
    $layout.empty().append($screen);
}

$(document).on('click', '.reactivate-deleted-account', async function () {
    var $button = $(this);
    if ($button.hasClass('processing')) return;
    $button.addClass('processing').prop('disabled', true);

    try {
        var response = await $.post('/Login/ReactivateDeletedAccount', {
            reactivationToken: $button.attr('data-reactivation-token') || ''
        });
        if (!response || !response.success) throw new Error('Hesap yeniden aktifleştirilemedi.');
        await Logged();
        await pageLink(response.redirectUrl || '/Bilgilerim');
    } catch (error) {
        $button.removeClass('processing').prop('disabled', false);
        ShowErrorAlert(error && error.responseText ? error.responseText : error.message);
    }
});

async function executeMatchRequestTasks() {
    await pageLink('/Rakip-Bul', false);

    // Giriş yaptıktan sonra burası açılıyor, rakip bul da tıkladığı açılmalı : todo
}
async function executeTransferRequestTasks() {
    await pageLink('/Oyuncu-Bul', false);

    await new Promise(resolve => setTimeout(resolve, 1250));

    openTransferRequestModal();
}





// Debounce yardımcı fonksiyonu
function debounce(fn, delay) {
    let timer = null;
    return function (...args) {
        const ctx = this;
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(ctx, args), delay);
    };
}

// Buton durumunu güncelleyen yardımcı fonksiyon
function updateSubmitButtonState() {
    const $btn = $("#SubmitFirstSaveForm");
    const form = document.getElementById('FirstSaveForm');
    const isDisabled = form?.dataset.submitting === 'true' || form?.dataset.loadingRules === 'true';
    if (form) form.querySelectorAll('.registration-role').forEach(button => button.disabled = isDisabled);

    syncFirstSavePhoneButtonState();

    // Sonuç butona uygulanır
    $btn
        .toggleClass("disabled", isDisabled)
        .prop("disabled", isDisabled);
}

function syncFirstSavePhoneButtonState() {

    var phoneBtn = $('#changeMyPhone')
    if (phoneBtn.length > 0) {
        var phoneHiddenInput = $('#Phone');
        if (phoneHiddenInput.hasClass('is-invalid')) {
            phoneBtn.addClass('is-invalid');
        }
        else {
            phoneBtn.removeClass('is-invalid');
        }
    }
}

// --- Şifre kontrolü (Hemen çalışır: input eventi ile) ---
function checkPasswordTwo(event) {
    if (event?.originalEvent?.isComposing) return;
    const input = $('#PasswordOne');
    const value = String(input.val() || '');
    const valid = value.length >= 8;
    input.toggleClass('is-invalid', value.length > 0 && !valid);
    $('#PasswordRequirement').toggleClass('is-valid', valid).find('i')
        .toggleClass('fa-circle-info', !valid).toggleClass('fa-circle-check', valid);
    updateSubmitButtonState();
}

// --- Nick kontrol (server ile) ---
async function NickDynamic() {
    const $el = $("#NickDynamic");
    if (!$el.length || $el.prop('disabled')) return true;
    const nick = ($el.val() || "").toString().trim();
    const maxLength = parseInt($el.attr("maxlength"), 10) || 20;

    if (!nick) {
        $el.removeClass('is-invalid');
        updateSubmitButtonState();
        return true;
    }
    if (nick.length > maxLength) {
        $el.addClass('is-invalid');
        updateSubmitButtonState();
        return false;
    }

    try {
        const data = await Request({
            url: '/CheckNick',
            type: 'POST',
            timeout: 15000,
            data: { id: nick }
        });

        if (!$el[0]?.isConnected || String($el.val() || "").trim() !== nick) return;
        if (data && data.used) {
            $el.addClass('is-invalid');
        } else {
            $el.removeClass('is-invalid');
        }
    } catch (err) {
        $el.addClass('is-invalid');
        ShowErrorAlert('Kullanıcı adı kontrol edilemedi. Lütfen tekrar deneyin.');
        console.error("NickDynamic():", err && err.responseText ? err.responseText : err);
        return false;
    }

    updateSubmitButtonState();
    return !$el.hasClass('is-invalid');
}

// --- Mail kontrol (format + server) ---
async function MailDynamic() {
    const $el = $("#MailDynamic");
    if (!$el.length || $el.prop('disabled')) return true;
    const mail = ($el.val() || "").toString().trim();

    if (!mail) {
        $el.removeClass('is-invalid');
        updateSubmitButtonState();
        return true;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!emailRegex.test(mail)) {
        $el.addClass('is-invalid');
        updateSubmitButtonState();
        return false;
    } else {
        $el.removeClass('is-invalid');
    }

    try {
        const data = await Request({
            url: '/CheckMail',
            type: 'POST',
            timeout: 15000,
            data: { id: mail }
        });

        if (!$el[0]?.isConnected || String($el.val() || '').trim() !== mail) return;
        if (data && data.used) {
            $el.addClass('is-invalid');
        } else {
            $el.removeClass('is-invalid');
        }
    } catch (err) {
        $el.addClass('is-invalid');
        ShowErrorAlert('E-posta kontrol edilemedi. Lütfen tekrar deneyin.');
        console.error("MailDynamic():", err && err.responseText ? err.responseText : err);
        return false;
    }

    updateSubmitButtonState();
    return !$el.hasClass('is-invalid');
}

// Debounce edilmiş versiyonlar (Nick/Mail için)
const debouncedNickDynamic = debounce(NickDynamic, 450);
const debouncedMailDynamic = debounce(MailDynamic, 450);

// --- UpdateNickName özel akış (Enter ile onay) ---
$(document).on("keyup", "#UpdateNickName", async function (e) {
    const $element = $(this);
    const nick = ($element.val() || "").toString().trim();
    const maxLength = parseInt($element.attr("maxlength"), 10) || 20;

    if (!nick || nick.length > maxLength) {
        $element.addClass('is-invalid');
        updateSubmitButtonState();
        return;
    }

    try {
        const data = await Request({
            url: '/CheckNick',
            type: 'POST',
            data: { id: nick }
        });

        if (data && data.used) {
            $element.addClass('is-invalid');
        } else {
            $element.removeClass('is-invalid');
        }
    } catch (err) {
        console.error("UpdateNickName check:", err && err.responseText ? err.responseText : err);
    }

    updateSubmitButtonState();

    if (e.which === 13 || e.key === 'Enter') {
        if ($element.hasClass('is-invalid')) return;

        Swal.fire({
            title: 'Kullanıcı adınızı değiştirmek üzeresiniz',
            text: '@' + nick,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Tamam',
            cancelButtonText: 'Şimdi Değil'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await editableMemberProp('NickName', nick);
                    ShowSuccessAlert();
                    updateSubmitButtonState();
                } catch (err) {
                    console.error("editableMemberProp error:", err);
                }
            } else {
                location.reload();
            }
        });
    }
});

// --- Event binding'ler ---
// Parola alanları: input eventi ile anında kontrol (keyup yerine input)
$(document).on("input", "#PasswordOne", checkPasswordTwo);

// Name ve Surname alanları
$(document).on("input", "#Name.firstSaveFormName, #Surname.firstSaveFormSurName, .firstSaveFormSurName, input[name='Surname']", function (event) {
    if (event.originalEvent?.isComposing) return;
    if (this.closest('#FirstSaveForm')) {
        this.classList.toggle('is-invalid', this.classList.contains('required') && !this.value.trim());
        updateSubmitButtonState();
        return;
    }
    try { validation(); } catch (e) { /* validation yoksa atla */ }

    updateSubmitButtonState();
});


// Mail ve Nick input'ları için
$(document).on("input compositionend", "#MailDynamic", function (event) { if (!event.originalEvent?.isComposing) debouncedMailDynamic(); });
$(document).on("input compositionend", "#NickDynamic", function (event) { if (!event.originalEvent?.isComposing) debouncedNickDynamic(); });







function permissionModal() {
    return pageLink('/Kaydi-Tamamla');
}

$(document).on('click', '.PermissionModal', function () {

    permissionModal();
});

$(document).on("submit", ".MainForm", async function (e) {
    e.preventDefault();
    if (this.matches('.attr') && this.closest('.member-register-wizard')) {
        if (await saveRegistrationDynamicAttribute()) ShowSuccessAlert();
        return;
    }

    if ($(paymentArea).length > 0) {

    }
    else {
        bootbox.hideAll();
    }

    if (validation()) {
        var form = $(this);
        var entityName = form.data("entity-name");
        var formData = form.serialize();


        // Sadece eşitlik kontrolü için
        try {
            var params = new URLSearchParams(formData);
            var teamId = parseInt(params.get("TeamId"));
            var _teamId = parseInt(params.get("_TeamId"));
            if (!isNaN(teamId) && !isNaN(_teamId) && teamId > 0 && _teamId > 0 && teamId === _teamId) {

                ShowErrorAlert("Lütfen farklı takımlar seçiniz.")
                return;
            }
        } catch (e) { }


        if (entityName != 'Member') {

            SubmitMainFormTask(entityName, formData);
        }
        else {
            var invalid = false;

            var phone = $('#Phone');
            var phoneSpan = $("#PhoneSpan");
            var phoneVal = phone.val();

            phone.removeClass('is-invalid');
            phoneSpan.addClass('d-none');

            if (phoneVal != '') {

                if (phoneVal.includes('_')) {

                    phone.addClass('is-invalid');
                    phoneSpan.removeClass('d-none');

                    invalid = true;
                }
            }
            if (phoneVal != '') {

                if (invalid === false) {

                    var check = await CheckPhoneAndMail();

                    if (check) {

                        await SendPhoneSmsCheckMember(formData);
                    }
                    else {
                        ShowErrorAlert('Bu kullanıcı adı veya telefon numarası zaten kayıtlı.');
                    }
                }
            }
            else {

                await SendPhoneSmsCheckMember(formData);
            }
        }
    } else {

        console.log('Form is not valid.');
    }
});


async function IdentityNumberMask() {

    if ($("[name='IdentityNumber']").length > 0) {

        Inputmask({
            mask: "99999999999" // 11 basamak
        }).mask(document.querySelector("[name='IdentityNumber']"));
    }
}
var ckEditorActiveNodes = new WeakSet();
async function loadCKeditor() {
    const nodes = $('.ckEditor').toArray().filter(node => !ckEditorActiveNodes.has(node));
    if (!nodes.length) return;
    let editorType;
    try {
        editorType = await window.sahaseninFeatureAssets.ckEditor();
    } catch (error) {
        console.error('CKEditor yüklenemedi; mevcut metin alanı korunuyor:', error);
        return;
    }

    if ($('.ckEditor').length > 0) {

        $(nodes).each(function () {
            if (!this.isConnected || ckEditorActiveNodes.has(this)) return;
            ckEditorActiveNodes.add(this);
            const node = this;
            var element = $(this);
            var name = element.attr("name");
            var placeholder = element.data("placeholder");

            editorType
                .create(this, {
                    ckfinder: {
                        uploadUrl: '/FileUpload'
                    },
                    language: 'tr',
                    placeholder: placeholder || undefined
                })
                .then(editor => {
                    if (!node.isConnected) {
                        ckEditorActiveNodes.delete(node);
                        return editor.destroy();
                    }
                    // Önce aynı isimde var mı kontrol et
                    var existingIndex = editorInstances.findIndex(e => e.name === name);
                    if (existingIndex !== -1) {
                        // Eski editor'ü destroy et
                        editorInstances[existingIndex].editor.destroy()
                            .catch(err => console.error('Eski editor destroy edilirken hata oluştu:', err));
                        // Listeden sil
                        editorInstances.splice(existingIndex, 1);
                    }

                    // Yeni editor'ü ekle
                    editorInstances.push({ editor: editor, name: name });
                })
                .catch(error => {
                    ckEditorActiveNodes.delete(node);
                    console.error('CKEditor başlatılırken bir hata oluştu:', error);
                });
        });
    }
}
function getFormData() {
    var formData = '';
    var addedNames = new Set(); // Eklenen name değerlerini takip et

    if (editorInstances.length > 0) {
        editorInstances.forEach(function (editorData) {
            var ckEditorContent = editorData.editor.getData();
            var nameAttribute = editorData.name;

            if (nameAttribute && !addedNames.has(nameAttribute)) {
                formData += '&' + nameAttribute + '=' + encodeURIComponent(ckEditorContent);
                addedNames.add(nameAttribute); // Eklenen ismi kaydet
            }
        });
    }

    return formData;
}
function getFormDataForHTML() {
    var html = '';
    var addedNames = new Set();

    if (editorInstances.length > 0) {
        editorInstances.forEach(function (editorData) {
            var ckEditorContent = editorData.editor.getData();
            var nameAttribute = editorData.name;

            if (nameAttribute && !addedNames.has(nameAttribute)) {
                html += ckEditorContent;
                addedNames.add(nameAttribute);
            }
        });
    }

    return html;
}


async function SubmitMainFormTask(entityName, formData) {

    formData += getFormData();

    console.log(formData);

    var url = `/${entityName}/Save`;

    if (url === '/Team/Save')
        url = '/TeamSave'

    $.post(url, formData, function (response) {
        ShowSuccessAlert();

        clearInner();
        loadReservationModalDetailsArea();
        loadReservationModalMemberCards();
        loadReservationModalPriceDetailsArea();

        if (imageFile) {
            var params = new URLSearchParams(formData);
            var id = params.get('TempId');

            if (id > 0) {
                uploadAndUpdateImage(imageFile, entityName, id);
            }
            else {
                var tempId = response.tempId;
                uploadAndUpdateImage(imageFile, entityName, tempId);
            }
        }

        var form = $('#MainForm');

        if (form.hasClass("attr")) {

            openMyAccount();

            setTimeout(() => {
                updateTeamCitiesSelect();
                updateTeamCitiesTable();
            }, 2000);
        }

        removeSheedModal();

    }).fail(function (xhr, status, error) {
        console.error("SaveError: ", xhr.responseText);
        ShowErrorAlert(xhr.responseText);
    });
}


async function clearInner() {
    var element = '#_MemberCreditCardInnerForm';
    if ($(element).length > 0) {
        $(element).html('');
    }
}


$(document).on('click', '#SaveTeamDescriptionEdit', function () {

    let element = $(this);
    var id = element.data('team');
    var description = "";

    if (editorInstances.length > 0) {
        editorInstances.forEach(function (editorData) {
            var ckEditorContent = editorData.editor.getData();

            description = ckEditorContent;
        });
    }

    Request({
        url: '/Team/SaveTeamDescriptionEdit',
        type: 'POST',
        data: {
            id: id,
            description: description
        },
    }).then((response) => {

        ShowSuccessAlert();
    }).catch((error) => {

        ShowErrorAlert();
    });
});
$(document).on('click', '#SaveDescriptionEdit', function () {

    let element = $(this);
    var description = "";

    if (editorInstances.length > 0) {
        editorInstances.forEach(function (editorData) {
            var ckEditorContent = editorData.editor.getData();

            description = ckEditorContent;
        });
    }

    Request({
        url: '/Member/SaveDescriptionEdit',
        type: 'POST',
        data: {
            description: description
        },
    }).then((response) => {

        ShowSuccessAlert();
    }).catch((error) => {

        ShowErrorAlert();
    });
});

$(document).on('change', '.editableTeamProp', function () {

    let element = $(this);

    var id = element.data('team');
    var name = element.attr('name');
    var value = element.val();

    editableTeamProp(id, name, value);
});

$(document).on('change', '.editableMemberProp', function () {

    let element = $(this);

    var name = element.attr('name');
    var value = element.val();

    if (element.closest('.member-register-wizard, #registrationOptionalDetails').length && this.type === 'number' && value === '')
        value = '0';

    editableMemberProp(name, value);

    var trimmed = value.trim();

    if (trimmed === "") {
        element.addClass("is-invalid");
    } else if (!isNaN(trimmed)) {
        if (parseInt(trimmed) > 0) {
            element.removeClass("is-invalid");
        } else {
            element.addClass("is-invalid");
        }
    } else {
        element.removeClass("is-invalid");
    }
});

let registrationFieldSaveQueue = Promise.resolve(true);
const registrationFieldSaveErrors = new Set();
const registrationFieldSaveRetries = new Map();
let registrationWizard = null;
async function waitForRegistrationSaves() {
    await registrationFieldSaveQueue;
    await registrationAvailabilityQueue;
    await registrationPositionSavePromise;
    await registrationPhotoSavePromise;
    for (const retry of Array.from(registrationFieldSaveRetries.values())) await retry();
    await registrationFieldSaveQueue;
    await registrationAvailabilityQueue;
    await registrationPositionSavePromise;
    await registrationPhotoSavePromise;
    if (!registrationFieldSaveErrors.size) return true;
    ShowErrorAlert('Bazı bilgiler kaydedilemedi. İşaretli alanları kontrol edip tekrar deneyin.');
    return false;
}
function editableMemberProp(name, value) {
    const wizard = document.querySelector('.member-register-wizard');
    const registration = !!wizard;
    const save = () => Request({ url: '/editableMemberProp', type: 'POST', data: { name, value }, timeout: 15000 });
    const request = registration ? registrationFieldSaveQueue.then(save) : save();
    const result = request.then(() => {
        if (registration && !wizard.isConnected) return true;
        registrationFieldSaveErrors.delete(name);
        registrationFieldSaveRetries.delete(name);
        if (registration) document.getElementsByName(name).forEach(input => input.classList.remove('is-invalid'));
        if (registration) updateSubmitButtonState();
        if (typeof currentUrl !== 'undefined' && currentUrl.startsWith('/Oyuncu-Bilgileri') && name === 'MemberTypeId') updatePlayerEditAttrPartial();
        if (name === 'MemberTypeId') $('#MemberTypeId').val(value);
        return true;
    }).catch(error => {
        if (registration && wizard.isConnected) {
            registrationFieldSaveErrors.add(name);
            registrationFieldSaveRetries.set(name, () => editableMemberProp(name, value));
            document.getElementsByName(name).forEach(input => input.classList.add('is-invalid'));
            updateSubmitButtonState();
            ShowErrorAlert(error?.responseText || 'Bilgi kaydedilemedi. Tekrar deneyin.');
        }
        console.error('editableMemberProp():', error.responseText);
        return false;
    });
    if (registration) registrationFieldSaveQueue = result;
    return result;
}

async function updatePlayerEditAttrPartial() {

    Request({
        url: '/Member/_PlayerEditAttrPartial',
        type: 'POST',
        data: {},
        target: '#_PlayerEditAttrPartial',
    }).then((response) => {

    }).catch((error) => {
        console.error("editableTeamProp():", error.responseText);
    });
}
function editableTeamProp(id, name, value) {

    Request({
        url: '/editableTeamProp',
        type: 'POST',
        data: {
            id: id,
            name: name,
            value: value
        },
    }).then((response) => {

    }).catch((error) => {
        console.error("editableTeamProp():", error.responseText);
    });
}

$(document).on('click', '.ChangeMyTeamProfilePhoto', function () {

    let element = $(this);
    let id = element.data("id");

    let input = $('<input>', { type: 'file', accept: 'image/*' })
        .css('display', 'none')
        .appendTo('body');

    input.on('change', async function (event) {
        let file = event.target.files[0];
        if (file) {
            try {
                uploadAndUpdateImage(file, "Team", id)
                    .then(function (url) {
                        if (url) {

                            $('.teamImg').attr('src', url);
                        } else {
                            console.error("Resim yükleme başarısız oldu.");
                        }
                    })
                    .catch(function (error) {
                        console.error("Resim yükleme hatası:", error.responseText);
                    });
            } catch (error) {
                console.error("Resim yükleme hatası:", error.responseText);
            }
        }

        input.remove();
    });

    input.trigger('click');
});

$(document).on('click', '.mrp-submit-cash', function (event) {
    event.preventDefault();
    var button = $(this);
    var reservationId = Number(button.data('reservation-id')) || 0;
    if (!reservationId || button.prop('disabled')) return;

    button.prop('disabled', true).addClass('is-loading');
    var icon = button.find('i').first();
    icon.removeClass().addClass('fa-solid fa-spinner');

    $.ajax({
        url: '/MemberFinance/SubmitReservationCashPayment',
        type: 'POST',
        data: { reservationId: reservationId }
    }).done(function () {
        pageLink('/Rezervasyonum/' + reservationId);
    }).fail(function (xhr) {
        button.prop('disabled', false).removeClass('is-loading');
        icon.removeClass().addClass('fa-solid fa-check');
        ShowErrorAlert(xhr.responseText || 'Nakit ödeme bildirimi gönderilemedi.');
    });
});

$(document).on('click', '.ChangeMyProfilePhoto, .ProfilePhotoFirstSave', function (event) {
    event.preventDefault();
    event.stopPropagation();
    const id = this.classList.contains('ChangeMyProfilePhoto') ? Number($(this).data('id')) : 0;
    const input = $('<input>', { type: 'file', accept: 'image/*' }).css('display', 'none').appendTo('body');
    input.one('change', function () {
        const file = this.files[0];
        if (file) saveMemberProfilePhoto(file, id);
        input.remove();
    });
    input.trigger('click');
});
function saveMemberProfilePhoto(file, id) {
    const wizard = document.querySelector('.member-register-wizard');
    const upload = async () => {
        try {
            const url = id > 0 ? await uploadAndUpdateImage(file, 'Member', id) : await uploadImage(file);
            if (!url) throw new Error('Fotoğraf yüklenemedi.');
            if (wizard && !wizard.isConnected) return true;
            $('.userImg').attr('src', url);
            $('#Img').val(url).removeClass('is-invalid');
            registrationFieldSaveErrors.delete('Img');
            registrationFieldSaveRetries.delete('Img');
            return true;
        } catch (error) {
            if (wizard && !wizard.isConnected) return false;
            if (wizard?.isConnected) {
                registrationFieldSaveErrors.add('Img');
                registrationFieldSaveRetries.set('Img', () => saveMemberProfilePhoto(file, id));
            }
            ShowErrorAlert(error?.responseText || 'Fotoğraf yüklenemedi. Lütfen tekrar deneyin.');
            return false;
        }
    };
    if (wizard) return registrationPhotoSavePromise = registrationPhotoSavePromise.then(upload);
    return upload();
}




$(document).on('click', '.OpenChatForm', function (e) {

    var id = $(this).data('id');
    const modal = createModal({
        title: id > 0 ? 'Grup düzenleniyor' : 'Yeni grup kur'
    });

    Request({
        url: '/UsersMessage/_CustomGroupForm',
        type: 'POST',
        data: {
            id: id
        },
    }).then((response) => {

        modal.updateContent(response);
        loadCKeditor();

    }).catch((error) => {

        modal.updateContent(`<span class="w-100 text-center p-2 text-red fw-bold">${error.responseText}</span>`);
    });
});
$(document).on('click', '#SaveCustomGroupBtn', function (e) {

    var id = $(this).data('id');
    var img = $('#Img').val();
    var name = $('#Name').val();
    var public = $('#IsPublicGroup').val();
    var description = getFormDataForHTML();

    if (!name) {
        ShowErrorAlert('lütfen bir grup adı belirtiniz.');
        return;
    }

    Request({
        url: '/UsersMessage/SaveCustomGroup',
        type: 'POST',
        data: {
            id: id,
            Img: img,
            Name: name,
            isPublic: public,
            Description: description
        },
    }).then((response) => {

        pageLink("/Grup-Sohbeti/" + response.id);
    }).catch((error) => {

        ShowErrorAlert("izin verilmiyor: " + error.responseText);
    });
});


$(document).on('focusin.bs.modal', function (e) {
    if ($(e.target).closest('.tox-dialog, .file-input, input[type=file]').length) {
        e.stopImmediatePropagation();
    }
});

$(document).on('click', '.ChangeMemberAttImg', function (e) {
    // sayfanın yenilenmesini / linkin submit davranışını engelle
    e.preventDefault();
    e.stopPropagation();

    // input elementini oluştur (görünmez)
    let input = $('<input>', { type: 'file', accept: 'image/*' })
        .css('display', 'none');

    // input'u modal içine veya body'ye ekle
    var modalBody = $('#custom-modal-body');
    if (modalBody.length > 0) {
        input.appendTo(modalBody);
    } else {
        input.appendTo('body');
    }

    // Fokus suppression (isteğe bağlı, modal kapanmasını engellemek için)
    var suppressFocusHandler = function (ev) {
        if ($(ev.target).is('input[type="file"]') || $(ev.target).closest('input[type="file"]').length) {
            ev.stopImmediatePropagation();
        }
    };
    $(document).on('focusin.bs.modal.suppressFile', suppressFocusHandler);

    // Eğer buton/element type submit ise form submit olmasın diye ekstra önlem:
    // enclosure form varsa temporary olarak submit handler'ı iptal et
    var $closestForm = $(this).closest('form');
    var formSubmitHandler = null;
    if ($closestForm.length > 0) {
        formSubmitHandler = function (ev) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            return false;
        };
        $closestForm.on('submit.suppressFile', formSubmitHandler);
    }

    // İptal/cleanup fonksiyonu
    function cleanup() {
        $(document).off('focusin.bs.modal.suppressFile', suppressFocusHandler);
        if ($closestForm.length > 0 && formSubmitHandler) {
            $closestForm.off('submit.suppressFile', formSubmitHandler);
        }
        input.remove();
    }

    // Kullanıcı file dialog'u kapatıp geri geldiğinde cleanup yapmak için pencere focus handler
    var windowFocusHandler = function () {
        setTimeout(function () {
            cleanup();
            $(window).off('focus', windowFocusHandler);
        }, 300);
    };
    $(window).on('focus', windowFocusHandler);

    // dosya seçimi değiştiğinde çalışacak handler
    input.on('change', function (event) {
        let file = event.target.files ? event.target.files[0] : null;
        if (file) {
            try {
                const formData = new FormData();
                formData.append('file', file);

                $.ajax({
                    url: `/MemberMTypeAttrRelation/UploadImage`,
                    type: 'POST',
                    data: formData,
                    contentType: false,
                    processData: false,
                    dataType: 'json',
                    success: function (response) {
                        if (response.success) {
                            if (response.imageUrl) {
                                $closestForm.find('.ChangeMemberAttImg .slider-item').attr('src', response.imageUrl);
                                $closestForm.find('[name="Img"]').val(response.imageUrl);
                            } else {
                                console.error("Resim yükleme başarısız oldu.");
                            }
                        } else {
                            ShowErrorAlert();
                            console.error("Resim yükleme başarısız oldu.");
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.error('Resim kaydedilemedi:', textStatus, errorThrown);
                    },
                    complete: function () {
                        cleanup();
                    }
                });
            } catch (error) {
                console.error("Resim yükleme hatası:", error.responseText || error);
                cleanup();
            }
        } else {
            // kullanıcı iptal ettiyse cleanup
            cleanup();
        }
    });

    // input'ı tetikle (native click ile)
    // jQuery trigger bazen beklenmedik davranışa yol açabilir; native click daha güvenli
    if (input[0]) {
        input[0].click();
    } else {
        input.trigger('click');
    }
});


async function uploadAndUpdateImage(imageFile, entityName, id) {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('id', id);
        formData.append('file', imageFile);

        $.ajax({
            url: `/${entityName}/UpdateImage`,
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    resolve(response.imageUrl);
                } else {
                    ShowErrorAlert();
                    reject("Resim güncellenemedi.");
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error('Resim kaydedilemedi:', textStatus, errorThrown);
                reject(errorThrown);
            }
        });
    });
}
async function uploadImage(imageFile) {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('file', imageFile);

        $.ajax({
            url: `/SaveImage`,
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    resolve(response.imageUrl);
                } else {
                    ShowErrorAlert();
                    reject("Resim Kaydedilemedi.");
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR.responseText);
                console.error('Resim kaydedilemedi:', textStatus, errorThrown);
                reject(errorThrown);
            }
        });
    });
}








var currentUserIdRequest = null;
var currentUserIdCache = { value: null, expiresAt: 0 };
var currentGuestIdRequest = null;
var currentGuestIdCache = { value: null, expiresAt: 0 };
var renderedMemberUiId = null;
var sessionRevocationRedirectStarted = false;
let memberCheckPromise = null;

async function CheckMember() {
    if (memberCheckPromise) return memberCheckPromise;
    memberCheckPromise = checkMemberState();
    try { return await memberCheckPromise; } finally { memberCheckPromise = null; }
}
async function checkMemberState() {
    if (document.querySelector('[data-potential-landing]') && await window.isPotentialCompanyBrowser?.()) return;
    const before = renderedMemberUiId;
    const memberId = await getCurrentUserId();
    if (before !== null && before !== memberId)
        window.dispatchEvent(new CustomEvent('sahasenin:identity-changed', { detail: { memberId } }));

    if (memberId > 0) {
        window.closePublicSeoEntry?.();
        if (renderedMemberUiId !== memberId) await Logged();
    } else if (renderedMemberUiId !== 0) {
        NotLogged();
    }
}
async function getCurrentUserId() {

    const now = Date.now();
    if (currentUserIdCache.value !== null && currentUserIdCache.expiresAt > now)
        return currentUserIdCache.value;

    if (currentUserIdRequest) return currentUserIdRequest;

    currentUserIdRequest = (async function () {
        try {
            const res = await fetch('/Login/GetSessionValue', {
                method: 'GET',
                cache: 'no-store'
            });

            if (res.headers.get('X-Sahasenin-Session-Revoked') === '1') {
                currentUserIdCache = { value: 0, expiresAt: Date.now() + 3000 };
                NotLogged();
                if (!sessionRevocationRedirectStarted &&
                    !/^\/giris\/?$/i.test(window.location.pathname)) {
                    sessionRevocationRedirectStarted = true;
                    window.location.replace('/giris');
                }
                return 0;
            }

            const memberId = await res.json();
            currentUserIdCache = { value: memberId, expiresAt: Date.now() + 3000 };
            return memberId;
        } catch (err) {
            console.error('getCurrentUserId()', err);
            // Geçici ağ hatasını hesap silinmiş gibi yorumlama. Panelden silinen
            // hesap yalnızca sunucunun açık iptal başlığıyla oturumdan çıkarılır.
            const lastKnownMemberId = Number(currentUserIdCache.value || renderedMemberUiId || 0);
            if (lastKnownMemberId > 0)
                currentUserIdCache = { value: lastKnownMemberId, expiresAt: Date.now() + 3000 };
            return lastKnownMemberId;
        } finally {
            currentUserIdRequest = null;
        }
    })();

    return currentUserIdRequest;
}
async function getCurrentGuestId() {

    const now = Date.now();
    if (currentGuestIdCache.value !== null && currentGuestIdCache.expiresAt > now)
        return currentGuestIdCache.value;

    if (currentGuestIdRequest) return currentGuestIdRequest;

    currentGuestIdRequest = (async function () {
        try {
            const res = await fetch('/Login/GetGuestValue', {
                method: 'GET',
                cache: 'no-store'
            });

            const guestId = await res.json();
            currentGuestIdCache = { value: guestId, expiresAt: Date.now() + 3000 };
            return guestId;
        } catch (err) {
            console.error('getCurrentGuestId()', err);
            return 0;
        } finally {
            currentGuestIdRequest = null;
        }
    })();

    return currentGuestIdRequest;
}

async function Logged() {
    window.closePublicSeoEntry?.();
    try {
        if (typeof window.invalidateMemberScopedCaches === 'function') {
            window.invalidateMemberScopedCaches();
        }
        const res = await fetch('/GetLoggedMemberDatas', {
            method: 'GET',
            cache: 'no-store',
            headers: {
                'Accept': 'application/json'
            }
        });

        if (!res.ok) return;

        const data = await res.json();

        $('.userName').text(data.Name ?? '');
        $('.userImg').attr('src', data.Img ?? '');
        $('#CurrentMemberId').val(data.Id ?? 0);
        $('.MemberTypeText').text(data.Type ?? '');
        renderedMemberUiId = data.Id ?? 0;
        currentUserIdCache = { value: renderedMemberUiId, expiresAt: Date.now() + 30000 };
        CheckThemeMode(data.Theme);

        startNotificationTask();

        $(".NotLogged").addClass("d-none");
        $(".Logged").removeClass("d-none");

        $('#MyProfileOrlogin').text('Bilgilerim');
    } catch (error) {
        console.error('Logged()', error);
    }
}

function NotLogged() {

    if (typeof window.invalidateMemberScopedCaches === 'function') {
        window.invalidateMemberScopedCaches();
    }

    // Ortak işlemler
    CheckThemeMode(1); // Açık tema uygula
    disposeNotificationTask();

    $('.MemberTypeText').text('Misafir');

    // UI
    $(".NotLogged").removeClass("d-none");
    $(".Logged").addClass("d-none");

    $("#CurrentMemberId").val(0);
    renderedMemberUiId = 0;
    currentUserIdCache = { value: 0, expiresAt: Date.now() + 3000 };
    $('.userImg').attr('src', 'https://sahasenin.com/avatar.webp');
    $('.userName').text('');
    $('#MyProfileOrlogin').text('Giriş Yap');
}






$(document).on("click", ".MyAccountBtn", function () {
    if ($('.member-register-wizard').length > 0) {
        $.get('/Team/PendingInviteRedirect')
            .done(function (response) {
                if (response && response.redirectUrl) pageLink(response.redirectUrl);
                else openMyAccount();
            })
            .fail(function () { openMyAccount(); });
        return;
    }

    openMyAccount();
});

async function openMyAccount() {
    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {
                pageLink('/Bilgilerim');
            }
            else {
                pageLink('/Giris');
            }
        });
}

$(document).on("click", ".LogOutBtn", function () {

    pageLink('/Giris');
});







$(document).on('click', '#NotifyNative', function () {

    appsTokenSync();
});













$(document).on('change', '.teamSearch', function () {

    teamSearch();
});

async function teamSearch() {



    return Request({
        url: '/Team/_Tablec',
        type: 'POST',
        cacheable: false,
        ...publicListEnhancementOptions("#_TeamTable")
    }).then(() => {
        $('#_TeamTable').removeAttr('data-public-search-initial');

        renderPager();
        syncGlobalActionBtnAreas('#_TeamTable');
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}
$(document).on('change', '.leagueSearch', function () {

    leagueSearch();
});

async function leagueSearch() {



    return Request({
        url: '/Team/_LeagueTable',
        type: 'POST',
        cacheable: false,
        ...publicListEnhancementOptions("#_LeagueTable")
    }).then(() => {
        $('#_LeagueTable').removeAttr('data-public-search-initial');

        renderPager();
        syncGlobalActionBtnAreas('#_LeagueTable');
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}



let allDistrictOptions = [];
let allFieldOptions = [];
let allCompaniesOptions = [];

function clearLocationCache() {

    allDistrictOptions = [];
    allFieldOptions = [];
    allCompaniesOptions = [];
}

function readyDynamicFilterPage() {

    clearLocationCache();

    var districtSelect = $('#DynamicDistrictId').first();
    if (districtSelect.length) {
        allDistrictOptions = districtSelect.find('option').map(function () {
            var option = $(this);
            return {
                value: String(option.val() || '0'),
                text: option.text(),
                cityId: String(option.data('cityid') || '0')
            };
        }).get();
        districtSelect.data('location-district-options', allDistrictOptions);
    }

    if (allFieldOptions.length === 0) {
        $('#DynamicLocationFields option').each(function () {
            allFieldOptions.push($(this).clone());
        });
    }

    if (allCompaniesOptions.length === 0) {
        $('#DynamicLocationCompanies option').each(function () {
            allCompaniesOptions.push($(this).clone());
        });
    }

    var element = $('#DynamicCityId');
    let initialCityId = Number(element.val() || 0);

    var districtId = $('#DynamicDistrictId').val();

    filterDistrictsByCity(initialCityId, element, districtId);
    filterFieldsByDistrict(districtId, element);
    filterCompaniesByDistrict(districtId, element);
}

$(document).on('change', '#DynamicCityId', function () {

    var element = $(this);
    let selectedCityId = Number(element.val() || 0);
    filterDistrictsByCity(selectedCityId, element, 0);
});
$(document).on('change', '#DynamicDistrictId', function () {

    var element = $(this);
    let selectedDistrictId = element.val();

    if (selectedDistrictId) {
        filterCompaniesByDistrict(selectedDistrictId, element);
        filterFieldsByDistrict(selectedDistrictId, element);
    }
});

function filterDistrictsByCity(cityId, element, preferredDistrictId) {

    let source = $(element);
    let form = source.closest('form');
    let districtSelect = form.length
        ? form.find('#DynamicDistrictId').first()
        : $('#DynamicDistrictId').first();

    if (!districtSelect.length) return;

    let districtOptions = districtSelect.data('location-district-options');
    if (!Array.isArray(districtOptions) || districtOptions.length === 0) {
        districtOptions = allDistrictOptions;
    }

    let placeholder = districtOptions.find(function (option) {
        return String(option.value) === '0';
    });

    districtSelect.empty();

    districtSelect.append($('<option>', {
        value: '0',
        text: placeholder ? placeholder.text : (districtSelect.hasClass('notAll') ? 'İlçe seçiniz' : 'Tümü')
    }).attr('data-cityid', '0'));

    $.each(districtOptions, function (index, option) {
        if (String(option.value) !== '0' && String(option.cityId) === String(cityId)) {
            districtSelect.append($('<option>', {
                value: option.value,
                text: option.text
            }).attr('data-cityid', option.cityId));
        }
    });

    var preferredValue = String(preferredDistrictId || '0');
    var hasPreferredDistrict = districtSelect.find('option').filter(function () {
        return String($(this).val()) === preferredValue;
    }).length > 0;

    var hadSelect2 = districtSelect.hasClass('select2-hidden-accessible');

    districtSelect
        .val(hasPreferredDistrict ? preferredValue : '0')
        .prop('disabled', Number(cityId) <= 0);

    if (hadSelect2) {
        // Select2 bazı WebView sürümlerinde disabled durumunu sonradan kaldırınca
        // görünür kontrolü etkileşim dışı bırakabiliyor. Güncel select'i yeniden kur.
        initializeParentS2(districtSelect);
    }

    districtSelect.trigger('change.select2');

    var districtId = districtSelect.val();
    filterCompaniesByDistrict(districtId, element);
}

function filterFieldsByDistrict(districtId, element) {

    let fieldSelect = $('#DynamicLocationFields');
    fieldSelect.empty();

    if (!fieldSelect.hasClass('notAll')) {

        let allOption = $('<option></option>')
            .val(0)
            .text('Hepsi')
            .prop('selected', true);
        fieldSelect.append(allOption);
    }

    $.each(allFieldOptions, function (index, option) {
        if ($(option).data('districtid') == districtId) {
            fieldSelect.append(option.clone());
        }
    });
}
function filterCompaniesByDistrict(districtId, element) {

    let companiesSelect = $('#DynamicLocationCompanies');
    companiesSelect.empty();

    if (!companiesSelect.hasClass('notAll')) {
        let allOption = $('<option></option>')
            .val(0)
            .text('Hepsi')
            .prop('selected', true);
        companiesSelect.append(allOption);
    }

    $.each(allCompaniesOptions, function (index, option) {
        if ($(option).data('districtid') == districtId) {
            companiesSelect.append(option.clone());
        }
    });

    if (currentUrl.startsWith('/Oyuncu-Bilgileri')) {

        editableMemberProp('DistrictId', districtId);
    }
}





async function loadActiveFiltersArea() {

    var element = $('#_ActiveFiltersArea');

    if (element.length > 0) {
        var type = element.data('type');

        $.ajax({
            url: '/_ActiveFiltersArea',
            type: 'POST',
            data: {
                type: type
            },
            cache: false,
            success: function (response) {

                element.html(response);
            },
            error: function (xhr, status, error) {
                console.error("Detaylı hata bilgisi:", xhr.responseText);
            }
        });
    }
}

function SaveFilterPage(page) {

    var element = $('#PagerInput');
    var func = element.data('func');

    console.log('SaveFilterPage: ' + func);

    return Request({
        url: '/SaveFilterPage',
        type: 'POST',
        data: {
            func: func,
            page: page
        },
    }).then(() => {

        runFunc();

    }).catch((error) => {
        console.error("SaveFilterPage():", error.responseText || error);
        throw error;
    });
}

function SaveFilter(type) {

    debugger;

    console.log('SavedFilter: ' + type);
    $('.OpenFilterBtn').addClass('opacity-50');
    var url = "";
    var data = new FormData();

    switch (type) {
        case 'memberSearch':

            url = '/Member/SaveFilter';

            // Eğer form varsa serialize et
            var $form = $("#memberSearchForm");
            if ($form.length > 0) {
                var serializedArray = $form.serializeArray();
                serializedArray.forEach(item => {
                    data.append(item.name, item.value);
                });
            }

            var table = $("#_MemberTable");
            var matchPlayerId = table.data("match-player");
            if (matchPlayerId === 0) {
                matchPlayerId = $('#FindMemberPageForMyMatch').data("match-player");
            }
            var addFriend = table.data("add-friend");
            data.append("addFriend", addFriend);
            if (matchPlayerId > 0) {
                data.append("matchPlayerId", matchPlayerId);
            }

            // var onlyMatchPlayerFormData = new FormData();
            // onlyMatchPlayerFormData.append("matchPlayerId", matchPlayerId);
            // onlyMatchPlayerFormData.append("addFriend", addFriend);
            //var data = firstLoad ? onlyMatchPlayerFormData : formData;
            break;

        case 'blogSearch':
            url = '/Blog/SaveFilter';
            $('#blogSearchForm').serializeArray().forEach(item => data.append(item.name, item.value));
            break;

        case 'audienceSearch':
            url = '/Member/SaveAudienceFilter';
            var $audienceForm = $("#audienceSearchForm");
            if ($audienceForm.length > 0) {
                $audienceForm.serializeArray().forEach(item => data.append(item.name, item.value));
            }
            break;

        case 'teamSearch':

            url = '/Team/SaveFilter';

            // Eğer form varsa serialize et
            var $form = $("#teamSearchForm");
            if ($form.length > 0) {
                var serializedArray = $form.serializeArray();
                serializedArray.forEach(item => {
                    data.append(item.name, item.value);
                });
            }
            break;

        case 'leagueSearch':

            url = '/Team/SaveLeagueFilter';

            // Eğer form varsa serialize et
            var $form = $("#leagueSearchForm");
            if ($form.length > 0) {
                var serializedArray = $form.serializeArray();
                serializedArray.forEach(item => {
                    data.append(item.name, item.value);
                });
            }
            break;

        case 'refereeSearch':

            url = '/Member/SaveRefereeFilter';

            // Eğer form varsa serialize et
            var $form = $("#refereeSearchForm");
            if ($form.length > 0) {
                var serializedArray = $form.serializeArray();
                serializedArray.forEach(item => {
                    data.append(item.name, item.value);
                });
            }
            break;

        case 'coachSearch':

            url = '/Member/SaveCoachFilter';

            var $form = $("#coachSearchForm");
            if ($form.length > 0) {
                var serializedArray = $form.serializeArray();
                serializedArray.forEach(item => {
                    data.append(item.name, item.value);
                });
            }
            break;

        case 'FindRivalFormElement':

            url = '/Team/SaveRivalFilter';

            // Eğer form varsa serialize et
            var $form = $("#FindRivalFilterForm");
            if ($form.length > 0) {
                var serializedArray = $form.serializeArray();
                serializedArray.forEach(item => {
                    data.append(item.name, item.value);
                });
            }
            break;

        case 'FieldFormElement':

            url = '/Field/SaveFilter';

            var form = $("#FieldFilterForm")[0];
            if (!form)
                return;

            data = new FormData(form);

            var fieldFeatureTypes = $('#FieldFeatureTypes').val();

            if (fieldFeatureTypes && fieldFeatureTypes.length > 0) {
                data.delete('FieldFeatureTypes');
                data.append('FieldFeatureTypes', fieldFeatureTypes);
            }
            break;

        case 'TournamentFormElement':

            url = '/Tournament/SaveFilter';

            // Eğer form varsa serialize et
            var $form = $("#TournamentFilterForm");
            if ($form.length > 0) {
                var serializedArray = $form.serializeArray();
                serializedArray.forEach(item => {
                    data.append(item.name, item.value);
                });
            }
            break;

        case 'ReservationFormElement':

            url = '/Reservation/SaveFilter';

            // Eğer form varsa serialize et
            var $form = $("#ReservationFilterForm");
            if ($form.length > 0) {
                var serializedArray = $form.serializeArray();
                serializedArray.forEach(item => {
                    data.append(item.name, item.value);
                });
            }
            break;
    }

    return Request({
        url: url,
        type: 'POST',
        data: data,
        isFormdata: true,
        cacheable: false
    }).then(() => {

        loadActiveFiltersArea();
        refreshMapMarkers();
        runFunc();
        $('.OpenFilterBtn').removeClass('opacity-50');
    }).catch((error) => {
        $('.OpenFilterBtn').removeClass('opacity-50');
        console.error("SaveFilter():", error.responseText || error);
        throw error;
    });
}

async function memberSearch() {



    var matchId = $('#_MemberTable').data('match') ?? 0;
    var matchPlayerId = $('#_MemberTable').data('match-player') ?? 0;

    return Request({
        url: '/Member/_MemberTable',
        type: 'POST',
        data: {
            matchId: matchId,
            matchPlayerId: matchPlayerId
        },
        cacheable: false,
        ...publicListEnhancementOptions("#_MemberTable")
    }).then(() => {
        $('#_MemberTable').removeAttr('data-public-search-initial');

        renderPager();
        syncGlobalActionBtnAreas('#_MemberTable');
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}

async function audienceSearch() {
    InitLoadScreen("#_AudienceTable");
    return Request({
        url: '/Member/_AudienceTable',
        type: 'POST',
        cacheable: false,
        target: "#_AudienceTable"
    }).then(() => {
        renderPager();
        syncGlobalActionBtnAreas('#_AudienceTable');
    }).catch(error => console.error("Seyirci listesi yüklenemedi:", error.responseText || error));
}

$(document).on("click", ".OpenFilterBtn", function () {

    var url = $(this).data('url');
    OpenFilterMenu(url);
});


async function refereeSearch() {



    var matchId = $('#_RefereeTable').data('match') ?? 0;

    return Request({
        url: '/Member/_RefereeTable',
        type: 'POST',
        data: {
            matchId: matchId
        },
        cacheable: false,
        ...publicListEnhancementOptions("#_RefereeTable")
    }).then(() => {
        $('#_RefereeTable').removeAttr('data-public-search-initial');

        renderPager();
        syncGlobalActionBtnAreas('#_RefereeTable');
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}

async function coachSearch() {



    return Request({
        url: '/Member/_CoachTable',
        type: 'POST',
        cacheable: false,
        ...publicListEnhancementOptions("#_CoachTable")
    }).then(() => {
        $('#_CoachTable').removeAttr('data-public-search-initial');

        renderPager();
        syncGlobalActionBtnAreas('#_CoachTable');
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}



$(document).on("change", ".fieldGallerySelect", function () {
    loadFieldDetailGallery($(this).val());
});

async function loadFieldDetailGallery(selector) {
    var url = $("#_DetailGallery").data("url");
    var id = $("#_DetailGallery").data("id");

    Request({
        url: url,
        type: 'GET',
        data: { id: id, ImgSelector: selector },
        target: "#_DetailGallery"
    }).then(() => {
        dateInputLoad();
        LoadRelationName();
        loadFieldCalendar();
        updateCompanyComments($("#_DetailGallery"));
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}


$(document).on("click", '.btnHref', function () {
    var element = $(this);
    btnHref(element);
});

$(document).on("click", '.btnHref', function () {
    var element = $(this);
    btnHref(element);
});
function btnHref(element) {

    var $parentModal = element.closest('.custom-modal');

    if ($parentModal.length) {

        $parentModal.find('.targetDiv').addClass('d-none');
        $parentModal.find('.btnHref').removeClass('activeCard');
    } else {

        $('.targetDiv').addClass('d-none');
        $('.btnHref').removeClass('activeCard');
    }

    var targetId = element.data('target');
    $('#' + targetId).removeClass('d-none');

    element.addClass('activeCard');

    if (element.hasClass('loadFixtureDiv')) {

        if ($('#FixtureArea').length > 0) {
            loadFixtureDiv(false);
        }
        else {
            console.log('$(#FixtureArea).length = 0');
        }
    }
    if (element.hasClass('StaffEditorAreaEach')) {

        StaffEditorAreaEach();
    }
}

$(document).on("click", '.btnHref2', function () {
    var element = $(this);

    $('.targetDiv2').addClass('d-none');
    $('.btnHref2').removeClass('activeCard');

    var targetId = element.data('target');
    $('#' + targetId).removeClass('d-none');

    element.addClass('activeCard');
});



$(document).on('mousedown click', '.InOrganizerCompanyFieldsSelectBtn', function (event) {
    event.preventDefault();
    event.stopPropagation();

    const modal = createModal({
        title: 'Halı Saha Seç'
    });

    var url = '/GetDistrictFields/' + $(this).data('district');

    try {
        fetchSheepPopUpData(url)
            .then(response => {

                modal.updateContent(response);
            });

    } catch (error) {
        console.error("Hata oluştu:", error.responseText);
        modal.updateContent('<div class="alert alert-danger">Bir hata oluştu, lütfen tekrar deneyin.</div>');
    }
});


$(document).on("click", '.updateInOrganizerCompanyFieldsSelectBtn', function () {
    var id = $(this).data('id');

    removeSheedModal();

    // Modal'dan kalan scroll kısıtlamasını temizle
    $('body').css({
        'overflow': '',
        'position': '',
        'top': '',
        'width': ''
    }).removeClass('modal-open');

    $('.InOrganizerCompanyFieldsSelectBtn').val(id).trigger('change');

    $('#loadFieldCalendarArea').data('field', id);

    loadFieldCalendar();
});


var matchGlobalTimer = null;

function syncAfterMatchTimeline() {
    document.querySelectorAll('.after-match-info__summary[data-start-ms]').forEach(function (timeline) {
        var start = Number(timeline.dataset.startMs);
        var end = Number(timeline.dataset.endMs);
        var created = Number(timeline.dataset.createdMs);
        if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;

        var now = Date.now();
        var phase = now < start ? 'upcoming' : now < end ? 'live' : 'completed';
        var progress = phase === 'completed' ? 100 : phase === 'live'
            ? Math.round((now - start) / (end - start) * 100)
            : Math.round((now - created) / (start - created) * 100);
        progress = Math.max(0, Math.min(100, Number.isFinite(progress) ? progress : 0));

        var remaining = Math.max(0, (phase === 'upcoming' ? start : end) - now);
        var seconds = Math.ceil(remaining / 1000);
        var days = Math.floor(seconds / 86400);
        var hours = Math.floor(seconds % 86400 / 3600);
        var minutes = Math.floor(seconds % 3600 / 60);
        var secs = seconds % 60;
        var timeText = days > 0 ? `${days} gün ` : '';
        timeText += `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;

        timeline.classList.remove('after-match-info__summary--upcoming', 'after-match-info__summary--live', 'after-match-info__summary--completed');
        timeline.classList.add(`after-match-info__summary--${phase}`);
        timeline.querySelector('.after-match-info__status').textContent = phase === 'upcoming' ? 'Başlamamış' : phase === 'live' ? 'Devam ediyor' : 'Tamamlandı';
        timeline.querySelector('.after-match-info__time-label').textContent = phase === 'upcoming' ? 'Başlamasına kalan' : phase === 'live' ? 'Bitmesine kalan' : 'Maç sona erdi';
        timeline.querySelector('.after-match-info__remaining').textContent = phase === 'completed' ? 'Tamamlandı' : timeText;
        timeline.querySelector('.after-match-info__phase-note').textContent = phase === 'upcoming' ? 'Başlangıca doğru' : phase === 'live' ? 'Maç sürüyor' : 'Maç tamamlandı';
        timeline.querySelector('.after-match-info__progress-fill').style.width = `${progress}%`;
        timeline.querySelector('.after-match-info__progress-percent').textContent = `%${progress}`;
        timeline.querySelector('.after-match-info__progress').setAttribute('aria-valuenow', progress);
        var icon = timeline.querySelector('.after-match-info__summary-icon i');
        icon.className = `fa-solid ${phase === 'upcoming' ? 'fa-clock' : phase === 'live' ? 'fa-tower-broadcast' : 'fa-circle-check'}`;
    });
}

function syncMatchCountDown(target) {

    sahaseninInitCountdown();
    syncAfterMatchTimeline();

    // -----------------------------
    // INIT (yeni elemanları yakala)
    // -----------------------------

    var countdowns = findInRenderTarget(target, '.match-countdown:not(.inited)');
    var secondsCountdowns = findInRenderTarget(target, '.match-second-countdown:not(.inited)');

    countdowns.each(function () {
        var $el = $(this);

        $el.addClass('inited');

        var seconds = parseInt($el.attr('data-seconds')) || 0;

        $el.data('seconds', seconds);
    });

    secondsCountdowns.each(function () {
        var $el = $(this);

        $el.addClass('inited blink-fade');

        var seconds = parseInt($el.attr('data-value')) || 0;

        $el.data('seconds', seconds);
    });

    // global timer sadece 1 kere başlar
    if (matchGlobalTimer != null)
        return;

    matchGlobalTimer = setInterval(function () {

        syncAfterMatchTimeline();

        // -----------------------------
        // FULL COUNTDOWN (match-countdown)
        // -----------------------------
        var countdownEls = $('.match-countdown.inited');

        countdownEls.each(function () {

            var $el = $(this);
            var seconds = $el.data('seconds');

            if (seconds == null || seconds <= 0) {
                $el.text('00:00:00 Saat')
                    .removeClass('text-primary text-warning text-red')
                    .addClass('text-red');
                return;
            }

            // renk kontrol
            if (seconds > 3 * 3600) {
                $el.removeClass('text-warning text-red').addClass('text-primary');
            } else if (seconds > 3600) {
                $el.removeClass('text-primary text-red').addClass('text-warning');
            } else {
                $el.removeClass('text-primary text-warning').addClass('text-red');
            }

            var days = Math.floor(seconds / 86400);
            var hours = Math.floor((seconds % 86400) / 3600);
            var minutes = Math.floor((seconds % 3600) / 60);
            var secs = seconds % 60;

            var text = days > 0
                ? String(days).padStart(2, '0') + ' gün, ' +
                String(hours).padStart(2, '0') + ':' +
                String(minutes).padStart(2, '0') + ':' +
                String(secs).padStart(2, '0')
                : String(hours).padStart(2, '0') + ':' +
                String(minutes).padStart(2, '0') + ':' +
                String(secs).padStart(2, '0');

            $el.text(text);

            $el.data('seconds', seconds - 1);
        });

        // -----------------------------
        // SIMPLE COUNTDOWN (match-second-countdown)
        // -----------------------------
        var secondEls = $('.match-second-countdown.inited');

        var hasActiveTimeline = Array.from(document.querySelectorAll('.after-match-info__summary[data-end-ms]'))
            .some(function (timeline) { return Number(timeline.dataset.endMs) > Date.now(); });
        if (secondEls.length === 0 && countdownEls.length === 0 && !hasActiveTimeline) {
            clearInterval(matchGlobalTimer);
            matchGlobalTimer = null;
            return;
        }

        secondEls.each(function () {

            var $el = $(this);
            var seconds = $el.data('seconds');

            if (seconds == null || seconds <= 0)
                return;

            seconds++;

            $el.data('seconds', seconds);
            $el.text(seconds + "'");
        });

    }, 1000); // TEK GLOBAL TIMER
}

// Sayfa yüklendiğinde çalıştır
$(document).ready(function () {
    syncMatchCountDown();
});

async function reservationTableUpdateAvailableDate() {

    var input = $('#ReservationTableDateInput');
    var date = input.val();

    Request({
        url: '/Reservation/_ReservationTableUpdateAvailableDate',
        type: 'POST',
        data: { date: date }
    }).then(() => {

        loadActiveFiltersArea();
        _updateReservationTable();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}



$(document).on("change", ".DatePart", async function (e) {

    var dateStr = getDatePart();
    if (!dateStr) return;

    var datePartInput = $('#DatePartInput');
    if (datePartInput.length > 0) {
        datePartInput.val(dateStr);
        datePartInput.trigger("change");
    }

    // Maç oluşturma penceresi üç ayrı tarih seçicisi kullanır. Takvim isteğinin
    // okuduğu gizli alanı da aynı anda güncel tutarak ilk açılışta ve tarih
    // değişikliklerinde farklı bir sayfadaki tarih alanına bağımlılığı kaldır.
    $('#FieldCalendarInput').val(dateStr);



    if ($('[data-create-match-premium]').length > 0) {
        clearCreateMatchTimeSelection();
        updateCreateMatchDateSummary(dateStr);
        loadFieldCalendar();
    } else {
        if ($('.loadFieldCalendarArea').length > 0) {
            loadCompanyFieldCalendarAreaDivs();
        }
        if ($('#FieldCalendarInput').length > 0) {
            loadFieldCalendar();
        }
    }

    var reservationTableDateInput = $('#ReservationTableDateInput');

    if (reservationTableDateInput.length > 0) {

        var dateStr = getDatePart();
        reservationTableDateInput.val(dateStr);

        reservationTableUpdateAvailableDate();
    }
});


$(document).on("change", '.loadFieldCalendar', function () {

    loadCompanyFieldCalendarAreaDivs();
});


$(document).on("change", '#FieldCalendarInput', function () {
    loadFieldCalendar();
});

function getDatePart() {
    var day = $('#Day').val();      // 01, 02 ...
    var month = $('#Month').val();  // 01, 02 ...
    var year = $('#Year').val();    // 2025

    // boş alan kontrolü
    if (!day || !month || !year) {
        ShowErrorAlert('Tarih eksik girildi');
        return;
    }

    var dateStr = year + '-' + month + '-' + day; // yyyy-MM-dd

    // tarih doğrulama
    var dateObj = new Date(Number(year), Number(month) - 1, Number(day), 12);
    var isValidDate =
        !isNaN(dateObj.getTime()) &&
        dateObj.getFullYear() == parseInt(year) &&
        (dateObj.getMonth() + 1) == parseInt(month) &&
        dateObj.getDate() == parseInt(day);

    if (!isValidDate) {
        ShowErrorAlert('Geçerli bir tarih giriniz');
        return;
    }

    return dateStr;
}

function setDatePart(dateStr) {

    if (!dateStr) {
        ShowErrorAlert('Tarih boş gönderildi');
        return;
    }

    // yyyy-MM-dd format kontrolü
    var parts = dateStr.split('-');
    if (parts.length !== 3) {
        ShowErrorAlert('Geçersiz tarih formatı');
        return;
    }

    var year = parts[0];
    var month = parts[1];
    var day = parts[2];

    // doğrulama
    var dateObj = new Date(Number(year), Number(month) - 1, Number(day), 12);
    var isValidDate =
        !isNaN(dateObj.getTime()) &&
        dateObj.getFullYear() == parseInt(year) &&
        (dateObj.getMonth() + 1) == parseInt(month) &&
        dateObj.getDate() == parseInt(day);

    if (!isValidDate) {
        ShowErrorAlert('Geçerli bir tarih giriniz');
        return;
    }

    $('#Day')
        .val(parseInt(day, 10))
        .trigger('change');

    $('#Month')
        .val(parseInt(month, 10))
        .trigger('change');

    $('#Year')
        .val(parseInt(year, 10))
        .trigger('change');
}


async function loadFieldCalendar(scope) {
    var calendarAreas = scope ? $(scope).find('.loadFieldCalendarArea') : $('.loadFieldCalendarArea');

    if (calendarAreas.length > 0) {

        InitLoadScreen(calendarAreas);

        calendarAreas.each(function () {

            var element = $(this);
            var fieldId = element.data('field');

            var dateValue = scope ? $(scope).find("#FieldCalendarInput").val() : $("#FieldCalendarInput").val();
            if (!dateValue) {
                console.error("loadFieldCalendar(): Takvim tarihi bulunamadı.");
                return;
            }

            Request({
                url: '/Field/OneDayView',
                type: 'POST',
                data: {
                    id: fieldId,
                    date: dateValue,
                    createMatch: false
                },
                target: `#${element.attr('id')}`
            }).then(() => {

                LoadRelationName();
            }).catch((error) => {

                console.error("loadFieldCalendar():", error.responseText || error);
            });
        });
    }
}








$(document).on("click", '.SelectMatchRequestTimeBtn', function () {
    var time = $(this).data("time");

    $(".SelectMatchRequestTimeBtn").removeClass("active");
    $(this).addClass("active");
});

function saveMatchRequest(teamId, _teamId, fieldId, date, memberId, element) {
    var btn = $(".SelectMatchRequestTimeBtn.active").first();

    var time = $('#RivalModalTimeInput').val();
    /*var time = btn.data("time");*/

    var desc = $("#MatchRequestMessageInput").val();

    var formData = new FormData();
    formData.append("TeamId", teamId);
    formData.append("_TeamId", _teamId);
    formData.append("FieldId", fieldId);
    formData.append("Date", date);
    formData.append("MemberId", memberId);
    formData.append("Time", time);
    formData.append("Description", desc);
    formData.append("Accepted", false);

    $.ajax({
        url: '/TeamMatchRequestMessage/_Save',
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        dataType: 'json',
        success: function (response) {
            element.text('Gönderildi');
            element.removeClass('matchRequestBtn');

            ShowSuccessAlert("İstek Gönderildi.");
        },
        error: function (xhr, status, error) {

            ShowSuccessAlert("İstek Gönderildi.");

            console.error("Kaydetme işlemi başarısız oldu:", error.responseText);
        }
    });
}















function normalizeText(value) {
    return (value || '')
        .toString()
        .trim()
        .toLocaleLowerCase('tr-TR');
}

function filterCities() {

    var searchText = normalizeText($('#citySearchInput').val());
    var visibleCount = 0;

    $('.addLocationRelation[data-selector="1"]').each(function () {
        var element = $(this);
        var cityName = normalizeText(element.data('city-name'));

        if (searchText !== '' && cityName.indexOf(searchText) !== -1) {
            element.removeClass('d-none');
            visibleCount++;
        } else {
            element.addClass('d-none');
        }
    });

    var cityContainer = $('#CityContainer');

    if (visibleCount === 0) {
        if (cityContainer.find('.deleteLocationRelation').length === 0) {
            cityContainer.addClass('d-none');
        }
    } else {

        cityContainer.removeClass('d-none');
    }
}

function filterDistricts(inputElement) {
    var element = $(inputElement);
    var searchText = normalizeText(element.val());
    var cityId = element.data('city-id');

    var visible = 0;

    var $districtButtons = $('.addLocationRelation[data-selector="2"][data-city-id="' + cityId + '"]');

    $districtButtons.each(function () {
        var btn = $(this);
        var districtName = normalizeText(btn.data('district-name'));

        if (searchText !== '' && districtName.indexOf(searchText) !== -1) {
            btn.removeClass('d-none');
            visible++;
        } else {
            btn.addClass('d-none');
        }
    });

    var container = element.closest('.card').find('.d-flex.flex-wrap');

    if (visible === 0) {
        if (container.find('.noDistrict').length === 0) {
            // container.append('<div class="empty-state noDistrict">İlçe bulunamadı</div>');
        }
    } else {
        // container.find('.noDistrict').remove();
    }
}

$(document).on('input', '#citySearchInput', function () {
    const hasValue = $(this).val().trim().length > 0;

    $('#clearCitySearchInput').toggleClass('d-none', !hasValue);

    filterCities();
});
$(document).on('click', '#clearCitySearchInput', function () {
    $('#citySearchInput').val('').trigger('input');
    $(this).addClass('d-none');
});

$(document).on('input', '.districtSearchInput[type="text"]', function () {
    const $input = $(this);
    const value = $input.val().trim();
    const cityId = $input.data('city-id');

    const $clearBtn = $('.districtSearchInput.fa-circle-xmark[data-city-id="' + cityId + '"]');

    if (value.length > 0) {
        $clearBtn.removeClass('d-none');
    } else {
        $clearBtn.addClass('d-none');
    }

    filterDistricts(this);
});

$(document).on('click', '.districtSearchInput.fa-circle-xmark', function () {
    const cityId = $(this).data('city-id');

    const $input = $('.districtSearchInput[type="text"][data-city-id="' + cityId + '"]');

    $input.val('').trigger('input').focus();
    $(this).addClass('d-none');
});

$(document).on('click', '.addLocationRelation', function () {

    var element = $(this);
    element.removeClass('border-red bg-half-red text-red');
    element.addClass('border-ff border-primary bg-half-primary text-primary');

    var url = element.data("url");
    var teamId = element.data("team");
    var objectId = element.data("object");
    var locationRelationType = element.data("type");
    var locationRelationTypeSelector = element.data("selector");

    Request({
        url: '/AddLocationRelation',
        type: 'POST',
        data: {
            objectId: objectId,
            teamId: teamId,
            locationRelationType: locationRelationType,
            locationRelationTypeSelector: locationRelationTypeSelector,
        }
    }).then(() => {

        loadLocationRelationEditArea();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
});

$(document).on("click", '.deleteLocationRelation', function () {

    var element = $(this);
    element.removeClass('border-primary bg-half-primary text-primary');
    element.addClass('border-ff border-red bg-half-red text-red');

    var url = element.data("url");
    var teamId = element.data("team");
    var objectId = element.data("object");
    var locationRelationType = element.data("type");
    var locationRelationTypeSelector = element.data("selector");

    Request({
        url: '/RemoveLocationRelation',
        type: 'POST',
        data: {
            objectId: objectId,
            teamId: teamId,
            locationRelationType: locationRelationType,
            locationRelationTypeSelector: locationRelationTypeSelector,
        }
    }).then(() => {

        loadLocationRelationEditArea();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
});

$(document).on('click', '.team-create-match-action', function () {
    const teamId = Number($(this).data('team') || 0);
    closeCreateTeamOverlay();
    createdTeamDetailUrl = '';
    CreateMatchPopUp(teamId, 0);
});

$(document).on('click', '.team-create-rival-action', function () {
    const teamUrl = createdTeamDetailUrl;
    const teamMeta = teamUrl.split('/').filter(Boolean).pop() || '';
    closeCreateTeamOverlay();
    createdTeamDetailUrl = '';
    pageLink('/Rakip-Bul?returnTeam=' + encodeURIComponent(teamMeta));
});

$(document).on('click', '.team-create-settings', function () {
    const url = createdTeamDetailUrl;
    closeCreateTeamOverlay();
    createdTeamDetailUrl = '';
    if (url) pageLink(url + '?tab=general&settings=1');
});

$(document).on('change', '.team-location-city-select', function () {
    const cityId = String($(this).val() || '');
    const districtSelect = $('.team-location-district-select');
    districtSelect.val('').prop('disabled', !cityId);
    districtSelect.find('option[data-city]').each(function () {
        $(this).prop('hidden', String($(this).data('city')) !== cityId);
    });
});

$(document).on('click', '.team-location-add-button', async function () {
    const button = $(this);
    const citySelect = $('.team-location-city-select');
    const cityId = Number(citySelect.val() || 0);
    const districtId = Number($('.team-location-district-select').val() || 0);
    if (!cityId || !districtId) {
        ShowErrorAlert('İl ve ilçe seçmelisiniz.');
        return;
    }

    const common = { teamId: button.data('team'), locationRelationType: button.data('type') };
    button.prop('disabled', true);
    try {
        if (String(citySelect.find(':selected').data('related')) !== 'true') {
            await Request({ url: '/AddLocationRelation', type: 'POST', data: { ...common, objectId: cityId, locationRelationTypeSelector: 1 } });
        }
        await Request({ url: '/AddLocationRelation', type: 'POST', data: { ...common, objectId: districtId, locationRelationTypeSelector: 2 } });
        loadLocationRelationEditArea();
    } catch (error) {
        ShowErrorAlert(error?.responseText || 'Konum eklenemedi.');
        button.prop('disabled', false);
    }
});

async function loadLocationRelationEditArea() {

    var target = $('#_LocationRelationEditArea');
    var teamId = target.data("team");
    var locationRelationType = target.data("type");

    Request({
        url: '/_LocationRelationEdit',
        type: 'POST',
        data: {
            LocationRelationType: locationRelationType,
            teamId: teamId
        }
    }).then((response) => {

        target.html(response);
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}









$(document).on("click", '#myTeamRivals', function () {
    var id = $(this).data("id");

    pageLink('/Rakip-Listesi', { id: id });
});
$(document).on("click", '#myTeamMatchRequests', function () {
    var id = $(this).data("id");

    pageLink('/Member/myTeamMatchRequests', { id: id });
});
$(document).on("click", '#myTeamTransferRequests', function () {
    var id = $(this).data("id");

    pageLink('/Takimima-Katilma-Teklifleri', { id: id })
        .then(() => {

            loadPartialAreas();
        });
});
$(document).on("click", '#myTeamTournamentRequests', function () {
    var id = $(this).data("id");

    pageLink('/Member/myTeamTournamentRequests', { id: id })
        .then(() => {

            loadPartialAreas();
        });
});






$(document).on('input', '.search-input', function () {

    var $input = $(this);
    var group = ($input.attr('data-group') || '').toString();
    var searchTerm = normalizeSearchText($input.val());

    $('.static-filter[data-group="' + group + '"]').each(function () {

        var $item = $(this);
        var itemTerm = normalizeSearchText($item.attr('data-term') || '');

        if (searchTerm === '' || itemTerm.indexOf(searchTerm) !== -1) {
            $item.removeClass('d-none');
        } else {
            $item.addClass('d-none');
        }
    });
});

function normalizeSearchText(value) {
    return (value || '')
        .toString()
        .toLocaleLowerCase('tr-TR')
        .trim();
}



async function updateGlobalRequestCards(target) {

    var elements = findInRenderTarget(target, '.globalRequestCard:not(.init)');

    if (elements.length > 0) {

        elements.addClass('init');
        console.log("updateGlobalRequestCards(): ", elements.length);

        elements.each(function () {

            var element = $(this);

            var id = element.data('id');
            var type = element.data('type');

            Request({
                url: '/UsersMessage/_requestCard',
                type: 'POST',
                data: {
                    id: id,
                    type: type
                },
                success: function (response) {

                    element.html(response);
                    sahaseninInitCountdown();
                    sahaseninUpdateCountdown();
                    element.trigger('globalRequestCard:loaded', [{
                        id: id,
                        type: type,
                        success: true
                    }]);
                },
                error: function () {

                    element.addClass('d-none');
                    element.trigger('globalRequestCard:loaded', [{
                        id: id,
                        type: type,
                        success: false
                    }]);
                }
            });
        });
    }
}
$(document).on("click", '.AcceptGlobalRequest', function () {

    var element = $(this);

    var id = element.data("id");
    var type = element.data("type");
    var url = element.data("url");
    var originalHtml = element.html();
    var requiresCancellationConsent =
        String(element.data('cancellation-consent')).toLowerCase() === 'true';

    Swal.fire({
        title: '',
        text: requiresCancellationConsent
            ? undefined
            : 'Teklifi kabul etmek istediğinize emin misiniz?',
        html: requiresCancellationConsent
            ? `<p>Teklifi kabul etmek istediğinize emin misiniz?</p>
               <div class="form-check d-flex align-items-start gap-2 text-start p-3 border rounded">
                   <input id="paidServiceCancellationConsent" class="form-check-input flex-shrink-0 mt-1" type="checkbox">
                   <label class="form-check-label" for="paidServiceCancellationConsent">Maç ilanı iptal edilirse ücret alamayacağımı kabul ediyorum.</label>
               </div>`
            : undefined,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, onayla!',
        cancelButtonText: 'İptal',
        preConfirm: function () {
            if (requiresCancellationConsent &&
                !document.getElementById('paidServiceCancellationConsent')?.checked) {
                Swal.showValidationMessage('Devam etmek için iptal koşulunu onaylayın.');
                return false;
            }
            return true;
        }
    }).then((result) => {
        if (result.isConfirmed) {

            element.removeClass('AcceptGlobalRequest');
            element.html('<label> Bekleyin.. </label>');

            Request({
                url: url,
                type: 'POST',
                data: {
                    id: id,
                    type: type,
                    cancellationNoFeeAccepted: requiresCancellationConsent
                },
                success: function (response) {

                    if (response && response.paymentRequired) {
                        var acceptedHtml = '<a class="fs-07 fw-bold text-warning me-1 border-ff br-calc px-2 py-1"><i class="fa-solid fa-clock me-1"></i> Kabul edildi, ödeme bekleniyor </a>';
                        element.closest('.requestDynamicDiv').html(acceptedHtml);

                        if ($('#MatchDetailOptionsArea').length > 0)
                            updateMatchDetailOptionsArea();

                        var actionText = response.canPay
                            ? 'Ödemeye Git'
                            : 'Kapat';
                        Swal.fire({
                            icon: 'info',
                            title: 'Güvenli ödeme bekleniyor',
                            text: response.message,
                            showCancelButton: response.canPay,
                            confirmButtonText: actionText,
                            cancelButtonText: 'Kapat'
                        }).then(function (answer) {
                            if (answer.isConfirmed && response.canPay) {
                                if (typeof pageLink === 'function') pageLink(response.redirectUrl);
                                else window.location.href = response.redirectUrl;
                            }
                        });
                        return;
                    }

                    var html = '<a class="fs-07 fw-bold text-primary me-1 border-ff br-calc px-2 py-1"> Onayladınız </a>';

                    var parentDiv = element.closest('.requestDynamicDiv');
                    parentDiv.html(html);


                    // Sadece takım maça katılma teklifi onaylanınca afterMatch'da ise yenilensin
                    var afterMatchAreaDiv = $('#AfterMatchArea');
                    if (afterMatchAreaDiv.length > 0) {

                        var matchId = afterMatchAreaDiv.data('selected-match');
                        updateAfterMatchArea(matchId);
                    }

                    if ($('#MatchDetailOptionsArea').length > 0)
                        updateMatchDetailOptionsArea();

                },
                error: function (xhr) {

                    var responseText = xhr.responseText;

                    if (isPaidServiceAgreementRequiredError(xhr)) {
                        element.addClass('AcceptGlobalRequest');
                        element.html(originalHtml);
                        openPaidServiceAgreementModal(function () {
                            element.trigger('click');
                        });
                        return;
                    }

                    if (isPaidServiceIbanRequiredError(xhr)) {
                        element.addClass('AcceptGlobalRequest');
                        element.html(originalHtml);
                        showPaidServiceIbanRequirement(xhr);
                        return;
                    }

                    ShowErrorAlert(getRequestErrorMessage(xhr));


                    if (responseText === "Bu maç çoktan bitmiş, istek otomatik olarak reddedildi." || responseText === "Süresi geçmiş.") {

                        var html = '<a class="fs-07 fw-bold text-red me-1 border-ff br-calc px-2 py-1"> Süresi Geçmiş </a>';

                        var parentDiv = element.closest('.requestDynamicDiv');
                        parentDiv.html(html);
                    }
                }
            });
        }
    });
});
$(document).on("click", '.DeclineGlobalRequest', function () {

    var element = $(this);

    var id = element.data("id");
    var type = element.data("type");
    var url = element.data("url");

    Swal.fire({
        title: '',
        text: "Teklifi gerçekten reddetmek istiyor musunuz?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, reddet!',
        cancelButtonText: 'İptal'
    }).then((result) => {
        if (result.isConfirmed) {

            element.removeClass('DeclineGlobalRequest');
            element.html('<label> Bekleyin.. </label>');

            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    id: id,
                    type: type
                },
                success: function () {

                    var html = '<a class="fs-08 fw-bold text-red me-1 border-ff br-calc px-2 py-1"> Reddettiniz </a>';

                    var parentDiv = element.closest('.requestDynamicDiv');
                    parentDiv.html(html);

                    if ($('#MatchDetailOptionsArea').length > 0)
                        updateMatchDetailOptionsArea();
                },
                error: function (xhr) {

                    ShowErrorAlert(xhr.responseText);
                }
            });
        }
    });
});






$(document).on("click", '._Req', function () {

    var element = $(this);

    var id = element.data("id");
    var type = element.data("type");
    var url = element.data("url");

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Bu işlemi geri alamazsınız!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'İptal'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: url,
                type: 'POST',
                data: {
                    id: id,
                    type: type
                }
            }).then(() => {
                NotificationTable(1, '#allNotificationTableArea');
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});


$(document).on("click", '.NotificationTypeBtn', function () {

    var id = $(this).data('id');

    NotificationTable(id);
});

async function NotificationTable(id = 1) {

    InitLoadScreen('#NotificationHybridTableArea');

    Request({
        url: '/Member/NotificationTable',
        type: 'POST',
        data: {
            type: id
        },
        target: '#NotificationHybridTableArea'
    }).then(() => {

        if (id == 1) {

            readyMemberSmsTable();
        }

        LoadRelationImg();
        LoadRelationName();

    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}

async function myTeamTransferRequestsTable() {

    InitLoadScreen('#myTeamTransferRequestsTableArea');

    var id = $('#myTeamTransferRequestsTableArea').data('id');

    Request({
        url: '/Member/myTeamTransferRequestsTable',
        data: { id: id },
        target: '#myTeamTransferRequestsTableArea'
    }).then(() => {

        LoadRelationImg();
        LoadRelationName();

    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}
async function LoadTeamTransferRequestTable() {

    InitLoadScreen('#TeamTransferRequestTableArea');

    Request({
        url: '/Member/TeamTransferRequestTable',
        target: '#TeamTransferRequestTableArea'
    }).then(() => {

        LoadRelationImg();
        LoadRelationName();

    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}
async function LoadmyRefereeRequestTable() {

    InitLoadScreen('#myRefereeRequestTable');

    Request({
        url: '/Member/myRefereeRequestTable',
        target: '#myRefereeRequestTable'
    }).then(() => {

    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}
async function LoadmyTeamTournamentRequestsTable() {

    InitLoadScreen('#myTeamTournamentRequestsTableArea');

    var id = $('#myTeamTournamentRequestsTableArea').data('id');

    Request({
        url: '/Member/myTeamTournamentRequestsTable',
        data: { id: id },
        target: '#myTeamTournamentRequestsTableArea'
    }).then(() => {

        LoadRelationImg();
        LoadRelationName();

    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}
async function LoadMyTeamMatchRequestsTable() {

    InitLoadScreen('#myTeamMatchRequestsTableArea');

    var id = $('#myTeamMatchRequestsTableArea').data('id');

    Request({
        url: '/Member/myTeamMatchRequestsTable',
        data: { id: id },
        target: '#myTeamMatchRequestsTableArea'
    }).then(() => {

        //updateGlobalRequestCards();

    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}
async function LoadMySmsHistoryTable() {

    InitLoadScreen('#MemberSmsTableArea');

    Request({
        url: '/Member/MemberSmsTable',
        target: '#MemberSmsTableArea'
    }).then(() => {

        readyMemberSmsTable();

    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}

function readyMemberSmsTable() {
    // Sayfa yüklendiğinde sadece okunmamışlar gösterilsin
    //$('.notificationItem').hide().filter('[data-read="false"]').show();

    // Switch değiştiğinde filtreleme yapılır
    $(document).on("change", '#toggleUnread', function () {
        if (this.checked) {
            // Sadece okunmamışları göster
            $('.notificationItem').hide().filter('[data-read="false"]').show();
            $('#toggleIcon').removeClass('fa-envelope-open-text').addClass('fa-envelope');
            $('#toggleText').text('Sadece Okunmamışlar');
        } else {
            // Tümünü göster
            $('.notificationItem').show();
            $('#toggleIcon').removeClass('fa-envelope').addClass('fa-envelope-open-text');
            $('#toggleText').text('Tüm Mesajlar');
        }
    });
}




$(document).on("click", '.transferRequestBtn', function () {
    var element = $(this);

    lastTransferinId = element.data("id");

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                openTransferRequestModal();
            } else {

                quickLoginModal();
            }
        });
});

async function openTransferRequestModal() {

    if (await Permission() !== true) return;

    var length = $('.transferRequestBtn[data-id="' + lastTransferinId + '"]').length;

    if (length > 0) {

        const modal = createModal({
            title: 'Takıma transfer ediliyor'
        });

        Request({
            url: '/Member/_TransferRequestModal',
            type: 'POST',
            data: { id: lastTransferinId },
            success: function (response) {

                modal.updateContent(response);

                $('#sendTransferRequestBtn').on('click', function () {
                    saveTransferRequest(lastTransferinId);
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                modal.updateContent(`<span class="p-1 text-red fs-08 w-100 text-center">${jqXHR.responseText || "Beklenmedik bir hata oluştu."}</span>`);
            }
        });
    }
    else {
        var element = $('.fm[data-id="' + lastTransferinId + '"]');

        Swal.fire({
            title: `İlgili oyuncu: ${element.text()}`,
            text: 'Bu Oyuncuya transfer teklifi gönderemezsiniz.',
            icon: 'info',
            showConfirmButton: true
        });
    }
}
async function saveTransferRequest(id) {

    var teamId = $('#SelectedTeamId').val();
    var description = $('#TransferDescription').val();

    Request({
        url: '/Member/saveTransferRequest',
        type: 'POST',
        data: {
            id: id,
            teamId: teamId,
            description: description
        }
    }).then(() => {

        removeSheedModal();
        syncGlobalActionBtnAreas();

    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}




$(document).on("click", '.OpenMatchOrganizerToFields', function () {
    var element = $(this);

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                Request({
                    url: '/GetMemberType',
                    type: 'POST',
                    success: function (response) {

                        if ($("#IsTeamlessMatch").val() === "true" || Number($("#GroupMatchChatId").val()) > 0 || response.value == 1 || response.value == 4) {

                            var fieldId = element.data('field');
                            var time = element.data('time');
                            var date = element.data('date');
                            var tournamentId = 0;
                            var rivalTeamId = $('#RivalTeamId').val();
                            var teamId = $('input[name="TeamId"]').val() || 0;
                            var groupChatId = Number($("#GroupMatchChatId").val()) || 0;
                            var teamlessMatch = $("#IsTeamlessMatch").val() === "true" || groupChatId > 0;

                            var matchTeamPlayerCount = 0;

                            if ($('#MatchTeamPlayerCount').length > 0)
                                var matchTeamPlayerCount = $('#MatchTeamPlayerCount').val();

                            var root = element.closest('.custom-modal-body');
                            var facility = root.find('[data-create-match-selected-facility-card]').first();
                            var facilityName = element.data('company-name') || facility.data('company-name') || root.find('#DynamicLocationCompanies option:selected').text() || 'Seçili tesis';
                            var fieldName = element.data('field-name') || root.find('.create-match-premium__pitch.active strong').text() || 'Seçili saha';
                            var escape = value => $('<div>').text(String(value || '')).html().replace(/"/g, '&quot;').replace(/'/g, '&#39;');
                            var startParts = String(time).split(':');
                            var startHour = Number(startParts[0]) || 0;
                            var startMinute = startParts[1] || '00';
                            var timeRange = String(startHour).padStart(2, '0') + ':' + startMinute + '–' + String((startHour + 1) % 24).padStart(2, '0') + ':' + startMinute;
                            var selectedDate = new Date(String(date).slice(0, 10) + 'T12:00:00');
                            var dateLabel = Number.isNaN(selectedDate.getTime()) ? String(date) : new Intl.DateTimeFormat('tr-TR', { day: '2-digit', month: 'long' }).format(selectedDate);
                            var image = facility.find('img').attr('src') || element.data('company-image');
                            var summaryImage = image ? '<img src="' + escape(image) + '" alt="" />' : '<span class="match-draft-confirm__facility-icon"><i class="fa-solid fa-futbol" aria-hidden="true"></i></span>';

                            Swal.fire({
                                title: 'Maç taslağı oluştur',
                                html: '<span class="match-draft-confirm__badge">' + (teamlessMatch ? 'Grup İçi Maç' : 'Takım Maçı') + '</span>' +
                                    '<div class="match-draft-confirm__summary">' + summaryImage + '<div><strong>' + escape(facilityName) + '</strong><span>' + escape(dateLabel) + ' · ' + escape(fieldName) + '</span><b><i class="fa-regular fa-clock" aria-hidden="true"></i> ' + escape(timeRange) + '</b></div></div>' +
                                    '<p class="match-draft-confirm__description">' + (teamlessMatch ? 'İki kadroyu da sen yöneteceksin. Sonraki adımda oyuncuları davet edip maç ilanını yayınlayabilirsin.' : 'Sonraki adımda kadronu düzenleyip oyuncuları davet edebilir ve maç ilanını yayınlayabilirsin.') + '</p>' +
                                    '<div class="match-draft-confirm__warning"><i class="fa-solid fa-circle-info" aria-hidden="true"></i><span>Bu işlem rezervasyon oluşturmaz. Saat uygunluğunu tesisle ayrıca doğrula.</span></div>',
                                iconHtml: '<i class="fa-regular fa-calendar" aria-hidden="true"></i>',
                                customClass: { popup: 'match-draft-confirm', icon: 'match-draft-confirm__icon', actions: 'match-draft-confirm__actions' },
                                showClass: { popup: 'match-draft-confirm--open' },
                                showCancelButton: true,
                                confirmButtonText: 'Taslağı Oluştur',
                                cancelButtonText: 'Vazgeç',
                                reverseButtons: true,
                                focusCancel: true
                            }).then((result) => {
                                if (result.isConfirmed) {

                                    // Firmaya maç organizasyon mesajı gidecek
                                    Request({
                                        url: '/Company/SendSmsCompanyPotantielForMatch',
                                        type: 'POST',
                                        data: {
                                            fieldId: fieldId,
                                            time: time,
                                            date: date
                                        }
                                    });

                                    Request({
                                        url: '/Reservation/CreatePotentielMatch',
                                        type: 'POST',
                                        data: {
                                            fieldId: fieldId,
                                            time: time,
                                            date: date,
                                            tournamentId: tournamentId,
                                            matchRequestTeam: rivalTeamId,
                                            matchTeamPlayerCount: matchTeamPlayerCount,
                                            teamId: teamId,
                                            groupChatId: groupChatId,
                                            teamlessMatch: teamlessMatch
                                        },
                                        success: function (savedMatchId) {

                                            if (savedMatchId > 0) {

                                                bootbox.hideAll();
                                                pageLink(`/Mac-Olustur/${savedMatchId}`);
                                            }
                                            else {

                                                ShowErrorAlert();
                                            }
                                        },
                                        error: function (jqXHR, textStatus, errorThrown) {

                                            ShowErrorAlert(jqXHR.responseText);
                                        }
                                    });
                                }
                            });
                        }
                        else {

                            ShowErrorAlert("Sadece oyuncular ve teknik direktörler maç organize edebilir.");
                        }
                    },
                    error: function (xhr, status, error) {
                        ShowErrorAlert("Üyelik bilgisi alınamadı.");
                    }
                });
            }
            else {

                quickLoginModal();
            }
        });
});


$(document).on("click", '.matchRequestInChatBtn', function () {
    var userId = $(this).data("member-id");

    // PartialView içeriğini AJAX ile getir
    $.ajax({
        url: '/UsersMessage/matchRequestInChatBtnPartial',
        type: 'POST',
        data: { id: userId },
        success: function (result) {
            // AJAX başarılıysa modalı aç ve içeriği yerleştir
            bootbox.dialog({
                title: "Maç Teklifi Gönder",
                message: result,
                size: 'large',
                buttons: {
                    cancel: {
                        label: "İptal",
                        className: "btn-secondary"
                    },
                    send: {
                        label: "Gönder",
                        className: "btn-primary",
                        callback: function () {

                            var teamId = $('#Teams').val();
                            var districtId = $('#DynamicDistrictId').val();

                            var rawDate = $('#Date').val();
                            var dateObj = new Date(String(rawDate).slice(0, 10) + 'T12:00:00');

                            if (isNaN(dateObj.getTime())) {
                                alert("Geçerli bir tarih giriniz.");
                                return false; // Modal kapanmasın
                            }

                            var year = dateObj.getFullYear();
                            var month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
                            var day = ('0' + dateObj.getDate()).slice(-2);
                            var date = year + '-' + month + '-' + day;

                            matchRequestBtn(teamId, date, districtId);
                        }
                    }
                }
            });

            // Form içi bileşenleri initialize et
            dateInputLoad();
            readyDynamicFilterPage();
            s2Each();
        },
        error: function (xhr) {
            ShowErrorAlert(xhr.responseText);
        }
    });
});







$(document).on("change", '#UpdatePotentielMatchTime', function (e) {

    var matchId = $(this).data('id');
    var time = $(this).val();

    Swal.fire({
        title: '',
        text: 'Maç saatini değiştirmek istediğinize emin misiniz?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır',
        allowOutsideClick: false,
        allowEscapeKey: false
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/Reservation/UpdatePotentielMatchTime',
                type: 'POST',
                data: {
                    id: matchId,
                    time: time
                },
                success: function (response) {

                    pageLink(`/Mac-Olustur/${matchId}`);
                },
                error: function (jqXHR, textStatus, errorThrown) {

                    ShowErrorAlert(jqXHR.responseText);
                }
            });
        } else {

            e.preventDefault();

            updateAfterMatchArea(matchId);
        }
    });
});

$(document).on("change", '#UpdatePotentielMatchTeamPlayerCount', function (e) {

    var matchId = $(this).data('match');
    var count = $(this).val();

    Swal.fire({
        title: '',
        text: 'Oyuncu sayısını değiştirmek istediğinize emin misiniz?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır',
        allowOutsideClick: false,
        allowEscapeKey: false
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/Reservation/UpdatePotentielMatchTeamPlayerCount',
                type: 'POST',
                data: {
                    id: matchId,
                    count: count
                },
                success: function (response) {

                    loadAfterMatchSetting();
                    StaffEditorAreaEach();
                },
                error: function (jqXHR, textStatus, errorThrown) {

                    ShowErrorAlert(jqXHR);
                }
            });
        } else {

            e.preventDefault();
            loadAfterMatchSetting();
        }
    });
});





$(document).on("click", '.OpenPost', function () {
    var id = $(this).data('id');

    pageLink('/Blog/' + id);
});

async function loadMatchRequestModalFieldCalendar(fieldId, date, startTime, finishTime) {
    $("#FieldCalendarForFindRival").html("<span class='mx-auto'>Yükleniyor...</span>");

    Request({
        url: '/Field/OneDayView',
        type: 'POST',
        data: { id: fieldId, date: date, startTime: startTime, finishTime: finishTime },
        target: "#FieldCalendarForFindRival"
    }).then(() => {
        LoadRelationName();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}




$(document).on("click", '.deleteCard', function () {
    var id = $(this).data("id");

    Swal.fire({
        title: 'Bu kartı silmek istediğinize emin misiniz?',
        text: "Bu işlemi geri alamazsınız!",
        icon: 'warning',
        showCancelButton: true,


        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'Hayır, iptal et'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/MemberCreditCard/Delete',
                type: 'POST',
                data: { id: id }
            }).then(() => {

                pageLink('/Kartlarim');

            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        } else {
            console.log("Kart silme işlemi iptal edildi.");
        }
    });
});


$(document).on("click", '.blog-item', function (e) {
    e.preventDefault();

    var url = $(this).data("url");
    var id = $(this).data("id");

    Request({
        url: url,
        type: 'GET',
        data: { id: id },
        target: "#_BlogTable"
    }).then(() => {
        LoadRelationName();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
});

$(document).on("click", '.open-modal', function (e) {
    e.preventDefault();

    var id = $(this).data('id');

    var content = $('div[data-id="' + id + '"]').html();

    bootbox.dialog({
        title: 'Detay',
        message: content,
        buttons: {
            ok: {
                label: 'Tamam',
                className: 'btn-primary',
                callback: function () {

                }
            }
        }
    });
});

$(document).on("click", ".home-page-link", function (e) {
    // Links also handled by .pageLink must navigate only once.
    if (this.classList.contains('pageLink')) return;
    if (this.tagName === 'A' && this.getAttribute('href') &&
        (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || (e.button != null && e.button !== 0))) return;
    e.preventDefault();

    pageLink('/Anasayfa', {})
        .then(() => {

            loadPartialAreas();
        });
});



$(document).on("click", ".pageLink", function (e) {
    // Real public links retain the browser's new-tab and modifier-click behavior.
    if (this.tagName === 'A' && this.getAttribute('href') &&
        (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || (e.button != null && e.button !== 0))) return;
    e.preventDefault();


    var element = $(this);
    var url = element.data("url");

    $("#CloseHamburgerMenuBtn").click();

    pageLink(url);
});

$(document).on("click", "[data-team-filter]", function () {
    var filter = String($(this).data("team-filter") || "all");
    var $filters = $(this).closest(".my-teams-reference-filters").find("[data-team-filter]");

    $filters.removeClass("active").attr("aria-selected", "false");
    $(this).addClass("active").attr("aria-selected", "true");

    $(this).closest(".my-teams-reference-content").find("[data-team-card]").each(function () {
        var visible = filter === "all" || String($(this).data("filter-group")) === filter;
        this.hidden = !visible;
    });
});




$(document).on("click", ".openWhatsApp", function () {

    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);

    if (isAndroid) {

        window.location.href = "https://wa.me/908505326261";
    }
});
$(document).on("click", ".openSocialApp", function () {

    var url = $(this).data("url");
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);

    if (isAndroid) {

        window.location.href = url;
    }
});


// Sidebar aç/kapa ve overlay yönetimi
$(document).on("click", "#minimizeSidebar", function () {
    $(".sidebar").toggleClass("open");
    menuBtnChange();
    toggleOverlay();
});

$(document).on("click", ".sidebarMenuArea", function () {
    $(".sidebar").toggleClass("d-none");

    if ($(".sidebar").hasClass('d-none')) {
        $(".sidebarMenu").removeClass("fa-arrow-right").addClass("fa-bars");
        $('.whatsapp-button').removeClass('d-none');
        removeOverlay();
    }
    else {
        $(".sidebarMenu").removeClass("fa-bars").addClass("fa-arrow-right");
        $('.whatsapp-button').addClass('d-none');
        addOverlay();
    }
});

// Overlay olarak #_partialBody'yi kullan
$(document).on("click", "#_partialBody.overlay-active", function () {
    $(".sidebar").addClass("d-none");
    $(".sidebarMenu").removeClass("fa-arrow-right").addClass("fa-bars");
    $('.whatsapp-button').removeClass('d-none');
    removeOverlay();
});

function menuBtnChange() {
    if ($(".sidebar").hasClass("open")) {
        openSideBarMenu();
        addOverlay();
    }
    else {
        closeSideBarMenu();
        removeOverlay();
    }
}

function openSideBarMenu() {
    $('#minimizeSidebar').removeClass('fa-circle-chevron-left');
    $('#minimizeSidebar').addClass('fa-circle-chevron-right');
}

function closeSideBarMenu() {
    $('#minimizeSidebar').removeClass('fa-circle-chevron-right');
    $('#minimizeSidebar').addClass('fa-circle-chevron-left');
    removeOverlay();
}

function addOverlay() {
    $('#_partialBody').addClass('overlay-active');
}

function removeOverlay() {
    $('#_partialBody').removeClass('overlay-active');
}

function sendUrlToMaui(url) {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.urlChanged) {
        window.webkit.messageHandlers.urlChanged.postMessage(url);
    }
}


FirstLoad();

async function FirstLoad() {
    try {

        initNavigation();
        const uri = window.location.pathname + window.location.search;

        if (document.querySelector('[data-potential-landing]') && await window.isPotentialCompanyBrowser?.()) {
            window.initPotentialCompanyLanding?.();
            return;
        }

        // The ready callback above already enhances these server-rendered pages.
        // Reopening them here discards their first HTML and runs the same route twice.
        if (document.querySelector('#_HomePageArea[data-home-initial="true"], #_FieldTable[data-public-catalog-initial="true"], [data-public-search-initial="true"]')) {
            // Existing back/header actions use /Anasayfa as the home route key.
            if (uri === '/') {
                currentUrl = '/Anasayfa';
                $('#CurrentUrl').val(currentUrl);
            }
            return;
        }

        // A non-null MVC model can still render only WaitingPage (QuickMenu).
        // Only skip the route request when actual page content is present, then
        // enhance it after the shell initializes without discarding the SSR HTML.
        if (document.querySelector('#_partialBody[data-server-rendered="true"]') &&
            !document.querySelector('#_partialBody [data-web-startup]')) {
            await new Promise(resolve => requestAnimationFrame(resolve));
            await afterScreenLoad(uri);
            return;
        }

        if (uri === '/') return pageLink('/Anasayfa');

        if (!uri.toLowerCase().includes('/google')) {
            pageLink(uri);
        }
    } catch (e) {
        console.error("FirstLoad(): ", e);
    }
}



$(document).on("click", "#locationFilterBtn", function () {

    var element = $(this);
    var type = $('#dynamic-search-input').data('type');
    var cityId = element.data('city');
    var districtId = element.data('district');

    if (cityId == 0 || districtId == 0) {

        ShowErrorAlert('Bu hizmet şu anda kullanılamıyor.');
        return;
    }

    $.ajax({
        url: '/UpdateFilterCityAndDistrictId',
        method: 'POST',
        data: {
            type: type,
            cityId: cityId,
            districtId: districtId
        },
        success: async function () {

            loadActiveFiltersArea();
            refreshMapMarkers();
            runFunc();
        },
        error: function (error) {

            console.log("LoadHomePageAreas(): " + error.responseText);
        }
    });
});

$(document).on("click", ".FilterShowMapSwitch", function () {

    var element = $(this);
    var type = element.data('type');
    var value = element.data('value');

    $.ajax({
        url: '/FilterShowMapSwitch',
        method: 'POST',
        data: {
            type: type,
            value: value
        },
        success: async function () {

            console.log('saved FilterShowMapSwitch');
        },
        error: function (error) {

            console.log("LoadHomePageAreas(): " + error.responseText);
        }
    });
});

$(document).on("click", ".initSahaseninMap", function () {

    initSahaseninMap();
});



async function enhanceHomePageAreas() {
    const sections = [
        { url:'/Home/_MainVideos', target:'#_MainVideos' },
        { url:'/Home/_MainAdverts', target:'#_MainAdverts', ready:() => advertsReady() },
        { url:'/Home/_LastMatches', target:'#_LastMatches', data:{count:4} },
        { url:'/Home/_StarTenMembers', target:'#_StarTenMembers' },
        { url:'/Home/_StarTenTeams', target:'#_StarTenTeams' }
    ];
    for (const section of sections) {
        const root = document.querySelector(section.target);
        if (!root || root.dataset.homeSectionScheduled === 'true') continue;
        root.dataset.homeSectionScheduled = 'true';
        const load = async () => {
            await Request({...section,cacheable:true});
            if (root.isConnected) section.ready?.();
        };
        if (window.sahaseninExperience) window.sahaseninExperience.whenVisible(root, load);
        else void load().catch(error => console.warn('Ana sayfa bölümü yüklenemedi.', error));
    }
    // Device location is requested only by the user's location button.
    // An unavailable macOS provider must not fail the initial home-page request.
    void LoadUserNearArea(false);
    loadTotalCountsArea();
}

async function LoadHomePageAreas() {
    const area = $('#_HomePageArea');
    if (area.attr('data-home-initial') === 'true') {
        if (area.attr('data-home-enhanced') === 'true') return;
        area.attr('data-home-enhanced', 'true');
        await enhanceHomePageAreas();
        return;
    }
    return Request({
        url: '/Anasayfa',
        method: 'GET',
        cacheable: true,
        success: async function (index) {
            area.html(index);
            await enhanceHomePageAreas();
        },
        error: function (error) {
            console.log("LoadHomePageAreas(): " + error.responseText);
        }
    });
}


async function loadTotalCountsArea() {

    var element = $('#_TotalCountsArea');

    if (element.length === 0)
        return;

    Request({
        url: '/_TotalCountsArea/',
        type: 'POST',
        cacheable: true,
        success: function (response) {

            element.html(response);
        },
        error: function (xhr, status, error) {
            console.log(xhr.responseText);
        }
    });
}



$(document).on("click", ".booleanFilterBtn", async function () {
    var $btn = $(this);
    var $hidden = $(`input[type=hidden][name='${$btn.attr('id')}']`);

    var currentVal = ($hidden.val() || "").toLowerCase() === "true";
    var newVal = !currentVal;

    $hidden.val(newVal);

    if (newVal) {
        $btn.addClass("selected");
    } else {
        $btn.removeClass("selected");
    }

    var type = $btn.data('func');
    SaveFilter(type);
});





async function filterbtnCheckInReservationPage() {
    if ($(window).width() >= 992) {
        $("#Slide-Filter-Menu").removeClass("d-none");
    }
}







// Kategori toggle handler: artık başlığa (mini-cat-header) tıklanınca açıp/kapatıyor.
$(document).on('click', '.mini-cat-header', function (e) {
    e.preventDefault();
    var $header = $(this);
    var targetId = $header.attr('aria-controls'); // örn: catKonumBody
    if (!targetId) return;

    var $body = $('#' + targetId);
    var $toggle = $header.find('.category-toggle');

    // slide toggle
    $body.slideToggle(180, function () {
        // aria-expanded toggling and icon (toggle span üzerinde)
        var expanded = $toggle.attr('aria-expanded') === 'true';
        $toggle.attr('aria-expanded', (!expanded).toString());
        $toggle.html(!expanded ? '<i class="fa-solid fa-caret-down"></i>' : '<i class="fa-solid fa-caret-right"></i>');
    });
});

// payment details info
function setPaymentDetailsInfo(priceTypeVal) {
    var info = '';
    switch (priceTypeVal) {
        case '1': // Cash
            info = 'Nakit ödemeler için ek bilgi gerekli değil.';
            break;
        case '2': // Online
            info = 'Online ödemeler: kredi kartı/ödeme platformu ile yapılır (uygulama içinde yönlendirme gerekebilir).';
            break;
        case '3': // IBAN
            info = 'IBAN ile ödeme seçildi. Ödeme almak için IBAN bilgisi gerekebilir.';
            break;
        default:
            info = 'Ödeme tipi seçiniz.';
    }
    $('#PaymentDetailsInfo').text(info);
}

// Ücret alanlarını disable/enable eden fonksiyon (PlayerType = Ücretsiz -> disabled)
function togglePriceFields() {
    // PlayerTypeEnum'den gelen value string olarak gelir; Free enum değeri = 1
    var playerTypeVal = $('#PlayerTypeEnum').val();

    var $priceSection = $('#PriceSection');
    var $priceTypeSection = $('#PriceTypeSection');

    if (playerTypeVal != 1) {

        $priceSection.removeClass('blur');
        $priceTypeSection.removeClass('blur');
    }
    else {
        $priceSection.addClass('blur');
        $priceTypeSection.addClass('blur');
    }
}

function toggleDateDiv() {
    if ($('.booleanFilterBtn.selected').length > 0) {
        $('#forBooleanDate').addClass('blur');
    } else {
        $('#forBooleanDate').removeClass('blur');
    }
}

// Event bindinglar (korundu)
$(document).on('click', '.booleanFilterBtn', function () {
    toggleDateDiv();
});

$(document).on('change', '#PlayerTypeEnum', function () {
    togglePriceFields();
});

$(document).on('change', '#PriceTypeEnum', function () {
    setPaymentDetailsInfo($(this).val());
});


$(document).on('click', '#fixScrollOnMaui', async function () {

    // Scrollu düzelt
    await window.MauiScrollFixManager.fixScrollOnMaui({ keepWrapperHeight: false });
});

$(document).on('click', '.openMyReservationnnn', async function () {

    var id = $(this).data('id');

    const modal = createModal({
        title: ''
    });

    Request({
        url: '/Rezervasyonum/' + id,
        type: 'GET',
        success: function (response) {

            modal.updateContent(response);
        },
        error: function (xhr, status, error) {
            modal.updateContent(`<span class="p-1 text-red">${xhr.responseText}</span>`);
        }
    });
});

$(document).on('click', '.create-reservation-match', async function () {
    const button = this;
    if (button.disabled) return;

    const reservationId = button.dataset.reservationId;
    const subscriptionSlotId = Number(button.dataset.subscriptionSlotId || 0);
    const endpoint = subscriptionSlotId > 0
        ? '/MemberSubscription/CreateMatch'
        : '/Member/CreateReservationMatch';
    const body = subscriptionSlotId > 0
        ? new URLSearchParams({ subscriptionSlotId: subscriptionSlotId.toString() })
        : new URLSearchParams({ reservationId: reservationId });

    button.disabled = true;
    button.classList.add('is-loading');

    try {
        const response = await fetch(endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body
        });
        if (response.status === 403 && response.headers.get('X-Profile-Completion-Required')) {
            window.redirectToProfileCompletion?.();
            return;
        }
        const contentType = response.headers.get('content-type') || '';
        const result = contentType.includes('json')
            ? await response.json()
            : await response.text();

        if (!response.ok) {
            const errorMessage = typeof result === 'string'
                ? result
                : result?.message || 'Maç oluşturulamadı.';
            throw new Error(errorMessage);
        }

        if (result?.redirectUrl) {
            if (typeof pageLink === 'function') pageLink(result.redirectUrl);
            else window.location.href = result.redirectUrl;
        }
    } catch (error) {
        ShowErrorAlert(error?.message || 'Maç oluşturulamadı.');
        button.disabled = false;
        button.classList.remove('is-loading');
    }
});

$(document).on('click', '.open-subscription-reservation-payment', async function () {
    const reservationId = Number(this.dataset.reservationId || 0);
    if (!reservationId) return;

    const modal = createModal({ title: 'Abonelik rezervasyonunu öde' });
    Request({
        url: '/Reservation/ExistingSubscriptionReservationModal',
        type: 'GET',
        data: { id: reservationId }
    }).then(response => {
        modal.updateContent(response);
        loadReservationModalPriceDetailsArea();
        loadReservationModalMemberCards();
    }).catch(error => {
        modal.updateContent(`<span class="p-2 text-red">${error.responseText || 'Ödeme ekranı açılamadı.'}</span>`);
    });
});
















$(document).on("click", '.matchRequestBtn', function () {

    var element = $(this);
    var teamId = element.data("tteamid");
    var rivalTeamId = element.data("teamid");

    CreateMatchPopUp(teamId, rivalTeamId);
});
$(document).on("click", ".CreateMatchPopUpBtn", function () {

    var element = $(this);
    var teamId = element.data('team');

    CreateMatchPopUp(teamId, 0);
});

async function CreateMatchPopUp(teamId, rivalTeamId, districtId, facilitySelection, groupChatId, teamlessMatch = false) {

    if (await Permission() !== true) return;

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {
                teamId = Number(teamId) || 0;

                if (teamId <= 0 && !(Number(groupChatId) > 0) && !teamlessMatch) {
                    openTeamlessMatchEntry({ districtId: districtId, facilitySelection: facilitySelection });
                    return;
                }

                var modal = createModal({
                    title: teamlessMatch || Number(groupChatId) > 0 ? 'Takımsız Maç Oluştur' : 'Maç Oluştur',
                    modalClass: 'create-match-premium-modal'
                });

                Request({
                    url: '/Match/_CreateMatchPopUp',
                    type: 'POST',
                    data: {
                        id: teamId,
                        rivalTeamId: rivalTeamId,
                        districtId: Number(districtId) || 0,
                        groupChatId: Number(groupChatId) || 0,
                        teamlessMatch: Boolean(teamlessMatch || Number(groupChatId) > 0)
                    }
                }).then((response) => {

                    modal.updateContent(response);
                    if (facilitySelection) window.applyFacilityLandingMatchSelection?.(facilitySelection);
                    loadCompanyFieldCalendarAreaDivs(facilitySelection);

                }).catch((error) => {
                    modal.close();
                    ShowErrorAlert(error.responseText);
                });
            }
            else {

                quickLoginModal();

            }
        });
}
window.CreateMatchPopUp = CreateMatchPopUp;
function loadCompanyFieldCalendarAreaDivs(facilitySelection) {
    var createMatchBody = $('[data-create-match-premium]').last().closest('.custom-modal-body');
    var companyId = createMatchBody.find("#DynamicLocationCompanies").val();
    var calendarTarget = createMatchBody.find("#CompanyFieldCalendarAreaDivs");

    if (!companyId || calendarTarget.length === 0) {
        return;
    }

    clearCreateMatchTimeSelection();

    Request({
        url: '/Match/_CompanyFieldCalendarAreaDivs',
        type: 'POST',
        data: {
            id: companyId
        },
        target: "#CompanyFieldCalendarAreaDivs"
    }).then(() => {
        var selectedFacilityCard = calendarTarget
            .find('[data-create-match-selected-facility-card]')
            .first()
            .detach();

        if (selectedFacilityCard.length > 0) {
            createMatchBody.find('#CreateMatchSelectedFacility')
                .empty()
                .append(selectedFacilityCard);

            createMatchBody.find('#CreateMatchSelectionFacility')
                .text(selectedFacilityCard.data('company-name') || '');
        }

        syncGlobalActionBtnAreas();
        loadFieldCalendar(facilitySelection ? createMatchBody : undefined);
    }).catch((error) => {
        calendarTarget.html('<p class="create-match-empty-fields fs-07">' +
            (error.responseText || 'Saha bilgileri yüklenemedi.') +
            '</p>');
    });
}

$(document).on('click', '.create-match-quick-date', function () {
    const selectedDate = new Date(String($(this).data('date')) + 'T12:00:00');
    const createMatchBody = $(this).closest('.custom-modal-body');
    createMatchBody.find('.create-match-quick-date').removeClass('is-selected');
    $(this).addClass('is-selected');
    createMatchBody.find('#Day').val(String(selectedDate.getDate()));
    createMatchBody.find('#Month').val(String(selectedDate.getMonth() + 1).padStart(2, '0'));
    createMatchBody.find('#Year').val(String(selectedDate.getFullYear()));
    createMatchBody.find('#FieldCalendarInput').val(String($(this).data('date')));
    updateCreateMatchDateSummary(String($(this).data('date')));
    clearCreateMatchTimeSelection();
    loadFieldCalendar();
});

$(document).on('click', '.create-match-other-date', function () {
    $(this).closest('[data-create-match-premium]')
        .find('.create-match-reference-date-selects')
        .toggleClass('is-open');
});

function formatCreateMatchDateLabel(dateValue) {
    var date = new Date(String(dateValue) + 'T12:00:00');
    if (Number.isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat('tr-TR', {
        day: '2-digit',
        month: 'long'
    }).format(date);
}

function updateCreateMatchDateSummary(dateValue, timeValue) {
    var root = $('[data-create-match-premium]').last();
    if (root.length === 0) return;

    var dateLabel = formatCreateMatchDateLabel(dateValue || root.siblings('#FieldCalendarInput').val());
    var timeLabel = timeValue ? String(timeValue).slice(0, 5).replace(':', '.') : 'Saat seç';
    root.find('#CreateMatchSelectionDate').text(dateLabel + ' · ' + timeLabel);
}

function clearCreateMatchTimeSelection() {
    var root = $('[data-create-match-premium]').last();
    if (root.length === 0) return;

    root.find('.premium-field-slot__content.is-create-match-selected')
        .removeClass('is-create-match-selected')
        .removeData('create-match-confirmed');
    root.find('#CreateMatchContinue').prop('disabled', true).removeData('selected-slot');
    updateCreateMatchDateSummary(root.siblings('#FieldCalendarInput').val());
}

$(document).on('click', '.create-match-premium__pitch', function () {
    clearCreateMatchTimeSelection();
});

$(document).on('click', '.create-match-close-current, .create-match-save-exit', function () {
    $(this).closest('.custom-modal').find('.sheed-modal-close').first().trigger('click');
});

function filterCreateMatchFacilitySheet(sheet) {
    var cityId = Number(sheet.find('#CreateMatchFacilityCity').val() || 0);
    var districtSelect = sheet.find('#CreateMatchFacilityDistrict');

    districtSelect.find('option').each(function () {
        var option = $(this);
        var belongsToCity = Number(option.data('cityid') || 0) === cityId;
        option.prop('disabled', !belongsToCity).prop('hidden', !belongsToCity);
    });

    var selectedDistrictOption = districtSelect.find('option:selected');
    if (selectedDistrictOption.prop('disabled')) {
        districtSelect.val(districtSelect.find('option:not(:disabled)').first().val());
    }

    var districtId = Number(districtSelect.val() || 0);
    var visibleCount = 0;

    sheet.find('.create-match-facility-option').each(function () {
        var option = $(this);
        var visible = Number(option.data('city-id') || 0) === cityId &&
            Number(option.data('district-id') || 0) === districtId;
        option.toggleClass('d-none', !visible);
        if (visible) visibleCount++;
    });

    sheet.find('.create-match-facility-empty').toggleClass('d-none', visibleCount > 0);
}

$(document).on('click', '.create-match-open-facility-sheet', function () {
    var createMatchBody = $(this).closest('.custom-modal-body');
    var template = createMatchBody.find('#CreateMatchFacilitySheetTemplate').get(0);
    if (!template) return;

    var facilityModal = createModal({
        title: 'Tesis Değiştir',
        content: template.innerHTML,
        modalClass: 'create-match-facility-modal'
    });
    var facilitySheet = $('.create-match-facility-modal').last().find('[data-create-match-facility-sheet]');

    facilitySheet.on('change', '#CreateMatchFacilityCity', function () {
        filterCreateMatchFacilitySheet(facilitySheet);
    });

    facilitySheet.on('change', '#CreateMatchFacilityDistrict', function () {
        filterCreateMatchFacilitySheet(facilitySheet);
    });

    facilitySheet.on('click', '.create-match-facility-option', function () {
        var option = $(this);
        var companyId = Number(option.data('company-id') || 0);
        var cityId = Number(option.data('city-id') || 0);
        var districtId = Number(option.data('district-id') || 0);
        var cityName = option.data('city-name') || '';
        var districtName = option.data('district-name') || '';
        var companyName = option.data('company-name') || '';

        createMatchBody.find('#DynamicCityId').val(String(cityId));
        createMatchBody.find('#DynamicDistrictId').val(String(districtId));
        createMatchBody.find('#DynamicLocationCompanies').val(String(companyId));
        createMatchBody.find('#CreateMatchLocationText')
            .text([cityName, districtName].filter(Boolean).join(' · '));
        createMatchBody.find('#CreateMatchSelectionFacility').text(companyName);
        createMatchBody.find('#CreateMatchSelectedFacility')
            .html('<button type="button" class="create-match-selected-facility create-match-open-facility-sheet is-loading">' +
                '<span class="create-match-facility-image-skeleton" aria-hidden="true"></span>' +
                '<span class="create-match-facility-copy"><strong class="fs-08">' + $('<div>').text(companyName).html() + '</strong>' +
                '<small class="fs-07">Tesis bilgileri yükleniyor</small></span>' +
                '<i class="fa-solid fa-chevron-right fs-08" aria-hidden="true"></i></button>');

        clearCreateMatchTimeSelection();
        facilityModal.close();
        loadCompanyFieldCalendarAreaDivs();
    });

    filterCreateMatchFacilitySheet(facilitySheet);
});

$(document).on('click', '.create-match-change-team', async function () {
    if (typeof removeSheedModal === 'function') removeSheedModal();
    await pageLink('/Hizli-Erisim/Mac-Yap?choice=matchWithTeam');
});








async function CloseMenu() {

    $("#CloseHamburgerMenuBtn").click();
}

$(document).on("click", ".card-container .card", function () {

    var element = $(this);

    if (!element.hasClass('bg-none')) {
        $(".card-container .card").removeClass("activeCard");
        element.addClass("activeCard");
    }
});

async function loadMapDiv(target) {
    var mapElements = findInRenderTarget(target, '.mapDiv');
    if (mapElements.length > 0) {
        mapElements.each(function () {
            var element = $(this);
            var iframeTag = element.data("iframe");

            if (iframeTag) {
                element.html(iframeTag);
            }
        });
    }
}












$(document).on("click", "#viewMyProfile", function () {

    var id = $(this).data('id');

    pageLink('/Bilgilerim/Profil/' + id)
        .then(() => {

            loadPartialAreas();
            LoadRelationName();
            LoadRelationImg();
            relationBuilder();
        });
});


$(document).on("click", ".cancelTournamentTeamJoinRequest", function () {
    var element = $(this);
    var id = element.data('id');

    element.addClass('opacity-50');

    Request({
        url: '/Tournament/cancelTournamentTeamJoinRequest',
        type: 'POST',
        data: { id: id },
        success: function () {

            syncGlobalActionBtnAreas();
        },
        error: function (xhr, status, error) {
            ShowErrorAlert(xhr.responseText);
        }
    });
});


$(document).on("click", ".cancelRivalRequestBtn", function () {
    var element = $(this);
    var id = element.data('id');

    element.addClass('opacity-50');

    Request({
        url: '/Team/RivalRequestDelete',
        type: 'POST',
        data: { id: id },
        success: function () {

            syncGlobalActionBtnAreas();
        },
        error: function (xhr, status, error) {
            ShowErrorAlert(xhr.responseText);
        }
    });
});


$(document).on("click", ".editMatchBtn", function () {

    var target = $(this).data('target');
    var targetDiv = $(target);

    if (targetDiv.is(':visible')) {

        targetDiv.hide();
    } else {

        $('.button-list').hide();
        targetDiv.show();
    }
});

$(document).on('click', function (event) {
    if (!$(event.target).closest('.editMatchBtn').length) {
        $('.button-list').hide();
    }
});

$(document).on("click", ".removeRivalRequestBtn", function () {
    var element = $(this);
    var id = element.data('id');

    Swal.fire({
        title: '',
        text: "Emin misiniz?",
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Evet, iptal et!',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {

            element.addClass('opacity-50');

            Request({
                url: '/Team/RivalRequestDelete',
                type: 'POST',
                data: { id: id },
                success: function () {

                    syncGlobalActionBtnAreas();
                },
                error: function (xhr, status, error) {
                    ShowErrorAlert(xhr.responseText);
                }
            });
        }
    });
});
$(document).on("click", ".cancelJoinTeamRequestBtn", function () {
    var element = $(this);
    var id = element.data('id');

    element.addClass('opacity-50');

    Request({
        url: '/Team/JoinTeamRequestDelete',
        type: 'POST',
        data: { id: id },
        success: function () {

            syncGlobalActionBtnAreas();

            if ($("._StaffEditorArea").length > 0) {
                StaffEditorAreaEach();
            }
        },
        error: function (xhr, status, error) {
            ShowErrorAlert(xhr.responseText);
        }
    });
});

$(document).on("click", ".addRivalRequestBtn", function () {
    var element = $(this);
    var id = element.data('id');

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                element.addClass('opacity-50');

                Request({
                    url: '/Team/AddRivalRequest',
                    type: 'POST',
                    data: { id: id },
                    success: function () {

                        syncGlobalActionBtnAreas();
                    },
                    error: function (xhr, status, error) {
                        ShowErrorAlert(xhr.responseText);
                    }
                });
            }
            else {

                quickLoginModal();
            }
        });
});
$(document).on("click", ".addJoinTeamRequestBtn", function (event) {
    event.preventDefault();
    event.stopPropagation();

    var element = $(this);
    var teamId = element.data('id');

    element.addClass('opacity-50');

    Request({
        url: '/Team/CurrentUserPlayingTeam',
        type: 'POST',
        success: function (response) {

            if (response.hasTeam) {

                Swal.fire({
                    icon: 'warning',
                    title: 'Yeni transfer dönemi',
                    text: response.message,
                    confirmButtonText: 'Takıma katılma isteği gönder',
                    showCancelButton: true,
                    cancelButtonText: 'İptal'
                }).then((result) => {
                    if (result.isConfirmed) {

                        addJoinTeamRequest(teamId);
                    }
                    else {
                        element.removeClass('opacity-50');
                    }
                });
            }
            else {

                addJoinTeamRequest(teamId);
            }
        },
        error: function (xhr, status, error) {
            ShowErrorAlert(xhr.responseText);
        }
    });
});
async function addJoinTeamRequest(teamId) {

    Request({
        url: '/Team/AddJoinTeamRequest',
        type: 'POST',
        data: { id: teamId },
        success: function () {

            syncGlobalActionBtnAreas();
            StaffEditorAreaEach();
        },
        error: function (xhr, status, error) {
            $('.addJoinTeamRequestBtn[data-id="' + teamId + '"]').removeClass('opacity-50');
            ShowErrorAlert(xhr.responseText);
        }
    });
}

$(document).on("click", ".addCoachJoinTeamRequestBtn", function () {
    var element = $(this);
    var teamId = element.data('id');

    element.addClass('opacity-50');

    Request({
        url: '/Team/AddCoachJoinTeamRequest',
        type: 'POST',
        data: { id: teamId },
        success: function () {
            updateGlobalRequestCards();
            syncGlobalActionBtnAreas();
        },
        error: function (xhr, status, error) {
            element.removeClass('opacity-50');
            ShowErrorAlert(xhr.responseText);
        }
    });
});

$(document).on("click", ".addTeamCoachInviteRequestBtn", function () {
    var element = $(this);
    var memberId = element.data('id');

    element.addClass('opacity-50');

    Request({
        url: '/Team/AddTeamCoachInviteRequest',
        type: 'POST',
        data: { id: memberId },
        success: function () {
            updateGlobalRequestCards();
            syncGlobalActionBtnAreas();
        },
        error: function (xhr, status, error) {
            element.removeClass('opacity-50');
            ShowErrorAlert(xhr.responseText);
        }
    });
});

$(document).on("click", ".notHaveTeamBtn", function () {

    getCurrentUserId()
        .then(memberId => {
            if (memberId > 0) {

                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: 'Rakip olabilmek için öncelikle bir takım kurmanız gerekmektedir',
                    confirmButtonText: 'Takım Kur',
                    showCancelButton: true,
                    cancelButtonText: 'İptal'
                }).then((result) => {
                    if (result.isConfirmed) {

                        pageLink(`/Takimlarim`, {})
                            .then(() => {

                                var element = $('#addteam');
                                var memberId = element.data('memberid');
                                var permission = element.data('permission');

                                if (permission != "PermissionModal") {

                                    addTeam();
                                }
                                else {

                                    permissionModal();
                                }
                            })
                            .catch((error) => {

                                ShowErrorAlert(error.responseText);
                                console.log(error);
                            });
                    }
                });
            }
            else {

                quickLoginModal();

                //Request({
                //    url: '/Login/LoginForm',
                //    type: 'GET',
                //    data: { isAlert: true },
                //    dataType: 'html',
                //    success: function (response) {
                //        Swal.fire({
                //            html: response,
                //            showConfirmButton: false,
                //            showCancelButton: false
                //        });
                //    },
                //    error: function (xhr, status, error) {
                //        ShowErrorAlert();
                //    }
                //});
            }
        });
});


$(document).on("click", ".leaveGroupChat", function () {
    var element = $(this);
    var chatId = element.data('chat');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Grup sohbetinden ayrılmak üzeresiniz.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, ayrıl',
        cancelButtonText: 'Vazgeç',
        reverseButtons: true
    }).then((result) => {
        if (!result.isConfirmed) return;

        element.addClass('opacity-50');

        Request({
            url: '/LeaveGroupChat',
            type: 'POST',
            data: {
                chatId: chatId
            },
            success: function () {

                element.closest('.globalRequestCard').removeClass('init');
                updateGlobalRequestCards();
                syncGlobalActionBtnAreas();

                pageLink("/Grup-Sohbeti/" + chatId);
            },
            error: function (xhr, status, error) {
                element.removeClass('opacity-50');
                ShowErrorAlert(xhr.responseText);
            }
        });
    });
});


$(document).on("click", ".removeGroupChat", function () {
    var element = $(this);
    var chatId = element.data('chat');
    var memberId = element.data('member');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Bu kişiyi gruptan çıkarmak üzeresiniz.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, çıkar',
        cancelButtonText: 'Vazgeç',
        reverseButtons: true
    }).then((result) => {
        if (!result.isConfirmed) return;

        element.addClass('opacity-50');

        Request({
            url: '/RemoveGroupChat',
            type: 'POST',
            data: {
                chatId: chatId,
                memberId: memberId
            },
            success: function () {

                element.closest('.globalRequestCard').removeClass('init');
                updateGlobalRequestCards();
                syncGlobalActionBtnAreas();

                pageLink("/Grup-Sohbeti/" + chatId);
            },
            error: function (xhr, status, error) {
                element.removeClass('opacity-50');
                ShowErrorAlert(xhr.responseText);
            }
        });
    });
});




$(document).on("click", ".cancelMyGlobalRequestBtn", function () {
    var element = $(this);
    var id = element.data('id');
    var type = element.data('type');
    var matchId = element.data('match');

    element.addClass('opacity-50');

    Request({
        url: '/CancelMyGlobalRequest',
        type: 'POST',
        data: {
            id: id,
            type: type
        },
        success: function () {

            element.closest('.globalRequestCard').removeClass('init');
            updateGlobalRequestCards();
            syncGlobalActionBtnAreas();

            if (matchId > 0 && $('#MatchDetailOptionsArea').length > 0)
                updateMatchDetailOptionsArea();
        },
        error: function (xhr, status, error) {
            ShowErrorAlert(xhr.responseText);
        }
    });
});


$(document).on("click", ".cancelFriendRequestBtn", function () {
    var element = $(this);
    var id = element.data('id');

    element.addClass('opacity-50');

    Request({
        url: '/Member/CancelFriendRequest',
        type: 'POST',
        data: { id: id },
        success: function () {

            syncGlobalActionBtnAreas();
        },
        error: function (xhr, status, error) {
            ShowErrorAlert(xhr.responseText);
        }
    });
});

$(document).on("click", ".removeFriendRequestBtn", function () {
    var element = $(this);
    var id = element.data('id');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Bu kullanıcı ile arkadaşlığınız kaldırılacak.",
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Evet, iptal et!',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {

            element.addClass('opacity-50');

            Request({
                url: '/FriendRequest/Delete',
                type: 'POST',
                data: { id: id },
                success: function () {

                    syncGlobalActionBtnAreas();
                },
                error: function (xhr, status, error) {
                    ShowErrorAlert(xhr.responseText);
                }
            });
        }
    });
});

$(document).on("click", ".addFriendRequestBtn", function () {
    var element = $(this);
    var id = element.data('id');

    element.addClass('opacity-50');

    Request({
        url: '/Member/AddFriendRequest',
        type: 'POST',
        data: { id: id },
        success: function () {

            syncGlobalActionBtnAreas();
        },
        error: function (xhr, status, error) {
            ShowErrorAlert(xhr.responseText);
        }
    });
});

$(document).on("click", ".InviteGroupChatBtn", function () {
    var element = $(this);
    var id = element.data('id');
    var chatId = element.data('chat');

    element.addClass('opacity-50');

    Request({
        url: '/Member/InviteGroupChat',
        type: 'POST',
        data: {
            id: id,
            chatId: chatId
        },
        success: function () {

            syncGlobalActionBtnAreas();
        },
        error: function (xhr, status, error) {
            ShowErrorAlert(xhr.responseText);
        }
    });
});

$(document).on("click", ".JoinGroupChatRequestBtn", function () {
    var element = $(this);
    var id = element.data('chat');

    element.addClass('opacity-50');

    Request({
        url: '/Member/JoinGroupChatRequest',
        type: 'POST',
        data: {
            chatId: id
        },
        success: function () {

            syncGlobalActionBtnAreas();
        },
        error: function (xhr, status, error) {
            ShowErrorAlert(xhr.responseText);
        }
    });
});




$(document).on("click", ".protestMatchBtn", function () {

    var element = $(this);
    var matchId = element.data('match');
    var rivalTeamMemberId = element.data('rival-team-member');

    Swal.fire({
        title: 'Emin misiniz?',
        text: "Maç sonucuna itiraz etmek üzeresiniz",
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: 'İtiraz Et!',
        cancelButtonText: 'Vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {

            element.removeClass('protestMatchBtn');
            element.addClass('opacity-50');
            element.html('Bekleyin..');

            Request({
                url: '/Reservation/ProtestMatch',
                type: 'POST',
                data: {
                    matchId: matchId
                },
                success: function () {

                    updateAfterMatchArea(matchId);
                    updateMatchDetailOptionsArea();

                    setTimeout(() => {

                        Swal.fire({
                            title: 'Maç sonucuna itiraz etiiniz',
                            text: "Anlaşmazlık durumunu çözmek için rakip takım yöneticisine yönlendirileceksiniz.",
                            icon: 'success',
                            confirmButtonText: 'Tamam'
                        }).then((result) => {
                            if (result.isConfirmed) {

                                pageLink('/Sohbet/' + rivalTeamMemberId);
                            }
                        });
                    }, 2000);
                },
                error: function (error) {

                    element.html('Yetkiniz Yok');
                    ShowErrorAlert(error.responseText);
                }
            });
        }
    });
});
$(document).on("click", ".notProtestMatchBtn", function () {

    var element = $(this);
    var matchId = element.data('match');

    element.removeClass('protestMatchBtn');
    element.addClass('opacity-50');
    element.html('Bekleyin..');

    Request({
        url: '/Reservation/NotProtestMatch',
        type: 'POST',
        data: {
            matchId: matchId
        },
        success: function () {

            updateAfterMatchArea(matchId);
            updateMatchDetailOptionsArea();
        },
        error: function (error) {

            element.html('Yetkiniz Yok');
            ShowErrorAlert(error.responseText);
        }
    });
});




$(document).on("change", ".ChangeAnotherSettingForInput", async function () {
    const input = $(this);
    try {
        await Request({ url: input.data('url'), type: 'POST', data: { key: input.data('key'), value: Math.max(0, parseInt(input.val(), 10) || 0) } });
        loadAfterMatchSetting();
    } catch (error) { ShowErrorAlert(error.responseText || 'Ücret kaydedilemedi. Tekrar deneyin.'); }
});

$(document).on("click", ".ChangeAnotherSetting", async function () {

    var element = $(this);
    const draftChoice = element.is('.draft-pay-option, .draft-cost-option');
    if (element.prop('disabled') || (draftChoice && element.attr('aria-pressed') === 'true')) return;
    var url = element.data('url');
    var key = element.data('key');
    var value = element.data('val');

    var intValue = parseInt(value);

    if (!isNaN(intValue)) {
        // int ise
        value = intValue;
    } else {
        // değilse (bool vs)
        value = !value;
    }

    if (draftChoice) {
        const controls = element.closest('#AfterMatchSettingArea').find('button:enabled');
        controls.prop('disabled', true);
        try {
            await Request({ url, type: 'POST', data: { key, value } });
            await loadAfterMatchSetting();
        } catch (error) { ShowErrorAlert(error.responseText || 'Ücret modeli kaydedilemedi.'); }
        finally { controls.prop('disabled', false); }
        return;
    }

    Request({
        url: url,
        type: 'POST',
        data: {
            key: key,
            value: value
        },
        success: function () {

            var settingIcon = element.find("i.SettingIcon");

            // icon varsa toggle et
            if (settingIcon.length) {
                settingIcon.toggleClass('fa-toggle-off fa-toggle-on');
            }

            if (element.hasClass('after-match-info__toggle')) {
                var audienceAllowed = settingIcon.hasClass('fa-toggle-on');
                element.data('val', audienceAllowed).attr('data-val', audienceAllowed);
                element.closest('.after-match-info__item').find('.after-match-info__value')
                    .text(audienceAllowed ? 'Davetli' : 'Davetsiz');
            }

            // mevcut değeri al
            var currentVal = element.data('val');

            // boolean ise
            if (typeof currentVal === "boolean") {

                if (settingIcon.hasClass('fa-toggle-on')) {
                    element.attr('data-val', true);
                }
                else {
                    element.attr('data-val', false);
                }
            }

            if (element.hasClass('JoinRequestSelect')) {

                checkJoinRequestSelect();
            }

            if (element.hasClass('changeWantRefereeText')) {

                var span = $('.WantRefereeText').first();

                if (value) {
                    span.addClass('text-red opacity-50');
                    span.removeClass('text-muted');
                    span.text('maç için hakem aranmıyor');
                }
                else {
                    span.addClass('text-muted');
                    span.removeClass('text-red opacity-50');
                    span.text('maç için hakem aranıyor');
                }
            }
            if (element.hasClass('changeWantPlayerText')) {

                var span = $('.WantPlayerText').first();

                if (value) {
                    span.addClass('text-red');
                    span.removeClass('text-muted');

                    span.text('maç için oyuncu aranmıyor');
                }
                else {

                    var matchId = element.data('match');
                    var teamId = element.data('team');

                    Request({
                        url: '/Match/getMatchValidPlayerCount',
                        type: 'POST',
                        data: {
                            matchId: matchId,
                            teamId: teamId
                        },
                        success: function (validMatchPlayerCount) {

                            span.addClass('text-muted');
                            span.removeClass('text-red');

                            if (validMatchPlayerCount > 0) {
                                span.text(validMatchPlayerCount + '  eksik oyuncu aranıyor');
                            }
                            else {
                                span.text('tüm oyuncular hazır');
                            }
                        },
                        error: function (xhr, status, error) {
                            loadAfterMatchSetting();
                        }
                    });
                }
            }


            loadAfterMatchSetting();
        },
        error: function (xhr, status, error) {
            ShowErrorAlert(xhr.responseText);
        }
    });
});



$(document).on("change", ".teamselect", function () {

    var element = $(this);
    var matchId = element.data('match');
    var teamId = element.val();

    Swal.fire({
        title: 'Emin misiniz?',
        text: 'Takımı değiştirmek istediğinize emin misiniz?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, değiştir',
        cancelButtonText: 'Hayır',
        reverseButtons: true
    }).then((result) => {

        if (result.isConfirmed) {

            Request({
                url: '/Reservation/UpdateTeam',
                type: 'POST',
                data: {
                    id: matchId,
                    teamId: teamId
                }
            }).then((response) => {

                removeSheedModal();
                updateAfterMatchArea(matchId);

            }).catch((error) => {

                removeSheedModal();
                ShowErrorAlert(error.responseText);
            });

        } else {

            removeSheedModal();
            updateAfterMatchArea(matchId);
        }
    });
});







// sendRequestPromise: Request varsa kullanır, yoksa $.ajax fallback
if (typeof sendRequestPromise === 'undefined') {
    function sendRequestPromise(opts) {
        return new Promise(function (resolve, reject) {
            if (typeof Request !== 'undefined' && typeof Request === 'function') {
                var userSuccess = opts.success;
                var userError = opts.error;
                opts.success = function (res) {
                    if (typeof userSuccess === 'function') userSuccess(res);
                    resolve(res);
                };
                opts.error = function (xhr, status, err) {
                    if (typeof userError === 'function') userError(xhr, status, err);
                    reject({ xhr: xhr, status: status, err: err });
                };
                try {
                    Request(opts);
                } catch (ex) {
                    reject({ xhr: null, status: 'request_error', err: ex });
                }
            } else {
                $.ajax(opts)
                    .done(function (res) { resolve(res); })
                    .fail(function (xhr, status, err) { reject({ xhr: xhr, status: status, err: err }); });
            }
        });
    }
}

$(document).on('click', '#locationFilterBtn', function () {
    $(this).addClass('bg-half-primary text-primary');
});

var activePasswordResetCountdown = null;

function escapePasswordResetHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

function getPasswordResetModal() {
    return $('.custom-modal').filter(function () {
        return $(this).find('.password-reset-shell').length > 0;
    }).last();
}

function setPasswordResetModalStage(stage) {
    var $modal = getPasswordResetModal();
    if (!$modal.length) return $modal;

    $modal.addClass('password-reset-modal').attr('data-reset-stage', stage);

    var $title = $modal.find('.custom-modal-header > span').first();
    if (stage === 'success') {
        $title.html('<span class="password-reset-header-title">Parola Sıfırlama</span>');
    } else {
        $title.html('<button type="button" class="password-reset-back js-password-reset-back" aria-label="Geri dön"><i class="fa-solid fa-arrow-left" aria-hidden="true"></i></button>');
    }

    $modal.find('.custom-modal-body').scrollTop(0);
    return $modal;
}

function setPasswordResetError($scope, message) {
    var $error = $scope.find('.password-reset-error').first();
    $error.text(message || '').toggleClass('is-visible', !!message);
}

function getPasswordResetErrorMessage(error, fallback) {
    var message = fallback || 'İstek işlenirken bir hata oluştu. Lütfen tekrar deneyin.';
    if (error && error.xhr && error.xhr.responseText) {
        message = String(error.xhr.responseText).replace(/^"|"$/g, '') || message;
    }
    return message;
}

function setPasswordResetButtonLoading($button, isLoading, loadingText) {
    if (!$button || !$button.length) return;

    if (typeof $button.data('password-reset-original') === 'undefined') {
        $button.data('password-reset-original', $button.html());
    }

    $button.prop('disabled', isLoading);
    $button.html(isLoading
        ? '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span>' + escapePasswordResetHtml(loadingText || 'İşleniyor...') + '</span>'
        : $button.data('password-reset-original'));
}

function isPasswordResetSuccessResponse(response) {
    return response === true
        || response === 'true'
        || (typeof response === 'object' && response !== null && response.success === true);
}

function sendPasswordResetCode(mail) {
    return sendRequestPromise({
        url: '/Login/CheckResetPassword',
        type: 'POST',
        data: { mail: mail }
    });
}

function startPasswordResetCountdown() {
    if (activePasswordResetCountdown) {
        window.clearInterval(activePasswordResetCountdown);
        activePasswordResetCountdown = null;
    }

    var expiresAt = Date.now() + (15 * 60 * 1000);

    function updateCountdown() {
        var $countdown = $('#PasswordResetCountdown');
        if (!$countdown.length) {
            window.clearInterval(activePasswordResetCountdown);
            activePasswordResetCountdown = null;
            return;
        }

        var seconds = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
        var minutesPart = Math.floor(seconds / 60).toString().padStart(2, '0');
        var secondsPart = (seconds % 60).toString().padStart(2, '0');
        $countdown.text(minutesPart + ':' + secondsPart);

        if (seconds === 0) {
            window.clearInterval(activePasswordResetCountdown);
            activePasswordResetCountdown = null;
        }
    }

    updateCountdown();
    activePasswordResetCountdown = window.setInterval(updateCountdown, 1000);
}

function syncPasswordResetCode($shell) {
    var code = $shell.find('.password-reset-code-cell').map(function () {
        return ($(this).val() || '').toString().replace(/\D/g, '').slice(0, 1);
    }).get().join('');

    $shell.find('#PassKey').val(code);
    return code;
}

function updatePasswordResetStrength(password) {
    var value = password || '';
    var score = 0;

    if (value.length >= 8) score += 1;
    if (/[a-z]/.test(value) && /[A-Z]/.test(value)) score += 1;
    if (/\d/.test(value)) score += 1;
    if (/[^A-Za-z0-9]/.test(value)) score += 1;

    var width = value.length ? Math.max(18, score * 25) : 0;
    var label = 'Zayıf';
    var color = '#db4b4b';

    if (score >= 4) {
        label = 'Güçlü';
        color = '#2eb14d';
    } else if (score >= 2) {
        label = 'Orta';
        color = '#e9a52c';
    }

    $('#PasswordResetStrengthLabel').text(label).css('color', color);
    $('#PasswordResetStrengthBar').css({ width: width + '%', backgroundColor: color });
}

function buildPasswordResetCredentials(mail) {
    var safeMail = escapePasswordResetHtml(mail);

    return `
        <div class="password-reset-shell password-reset-shell--credentials" data-reset-stage="credentials">
            <div class="password-reset-intro">
                <div class="password-reset-motif password-reset-motif--key" aria-hidden="true">
                    <span class="password-reset-motif-line password-reset-motif-line--left"></span>
                    <span class="password-reset-motif-dot password-reset-motif-dot--left"></span>
                    <span class="password-reset-motif-icon"><i class="fa-solid fa-key"></i></span>
                    <span class="password-reset-motif-dot password-reset-motif-dot--right"></span>
                    <span class="password-reset-motif-line password-reset-motif-line--right"></span>
                </div>
                <h2>Şifreyi Sıfırla</h2>
                <p>Gönderilen kodu girip yeni şifrenizi oluşturun.<br />Hesabınızın güvenliği için tüm alanları doldurun.</p>
            </div>

            <form id="ResetPasswordFinalForm" novalidate>
                <input type="hidden" id="ResetMail" name="mail" value="${safeMail}" />
                <input type="hidden" id="PassKey" name="passKey" />

                <div class="password-reset-field">
                    <label for="ResetMailPreview"><i class="fa-solid fa-user-check me-1"></i> Hesap bilgisi</label>
                    <div class="password-reset-input-wrap">
                        <input type="text" id="ResetMailPreview" value="${safeMail}" readonly />
                        <i class="fa-regular fa-envelope" aria-hidden="true"></i>
                        <i class="fa-solid fa-circle-check password-reset-input-check" aria-hidden="true"></i>
                    </div>
                </div>

                <div class="password-reset-mini-info">
                    <i class="fa-regular fa-paper-plane" aria-hidden="true"></i>
                    <span>Sıfırlama kodu hesabınızla ilişkili iletişim kanalına gönderildi. Kodu kimseyle paylaşmayın.</span>
                </div>

                <div class="password-reset-code-head">
                    <div class="password-reset-code-label"><i class="fa-solid fa-shield-halved"></i><span>Sıfırlama Kodu</span></div>
                </div>
                <div class="password-reset-code-grid" aria-label="Altı haneli sıfırlama kodu">
                    <input class="password-reset-code-cell" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="1" aria-label="Kod hanesi 1" />
                    <input class="password-reset-code-cell" type="text" inputmode="numeric" maxlength="1" aria-label="Kod hanesi 2" />
                    <input class="password-reset-code-cell" type="text" inputmode="numeric" maxlength="1" aria-label="Kod hanesi 3" />
                    <input class="password-reset-code-cell" type="text" inputmode="numeric" maxlength="1" aria-label="Kod hanesi 4" />
                    <input class="password-reset-code-cell" type="text" inputmode="numeric" maxlength="1" aria-label="Kod hanesi 5" />
                    <input class="password-reset-code-cell" type="text" inputmode="numeric" maxlength="1" aria-label="Kod hanesi 6" />
                </div>
                <div class="password-reset-code-meta">
                    <span>Kodun süresinin sonu <strong id="PasswordResetCountdown">15:00</strong></span>
                    <button type="button" id="PasswordResetResend">Kodu Yeniden Gönder</button>
                </div>

                <div class="password-reset-field password-reset-password-field">
                    <label for="NewPassword">Yeni Şifre</label>
                    <div class="password-reset-input-wrap">
                        <input type="password" id="NewPassword" name="newPassword" placeholder="Yeni şifrenizi girin" autocomplete="new-password" minlength="8" required />
                        <button type="button" class="password-reset-toggle" data-target="#NewPassword" aria-label="Yeni şifreyi göster"><i class="fa-regular fa-eye"></i></button>
                    </div>
                    <div class="password-reset-strength">
                        <div class="password-reset-strength-head"><span>Şifre Gücü</span><strong id="PasswordResetStrengthLabel">Zayıf</strong></div>
                        <div class="password-reset-strength-track"><div id="PasswordResetStrengthBar" class="password-reset-strength-bar"></div></div>
                    </div>
                </div>

                <div class="password-reset-field password-reset-password-field">
                    <label for="ConfirmPassword">Yeni Şifre (Tekrar)</label>
                    <div class="password-reset-input-wrap">
                        <input type="password" id="ConfirmPassword" placeholder="Yeni şifrenizi tekrar girin" autocomplete="new-password" minlength="8" required />
                        <button type="button" class="password-reset-toggle" data-target="#ConfirmPassword" aria-label="Yeni şifre tekrarını göster"><i class="fa-regular fa-eye"></i></button>
                    </div>
                </div>

                <div class="password-reset-security-card">
                    <i class="fa-solid fa-shield-halved" aria-hidden="true"></i>
                    <div><strong>Güvenliğiniz bizim için önemli</strong><span>Parolanız en az 8 karakter; harf, rakam ve sembol içermelidir.</span></div>
                </div>

                <p class="password-reset-error" role="alert" aria-live="polite"></p>

                <button type="submit" class="password-reset-primary">
                    <i class="fa-solid fa-lock" aria-hidden="true"></i>
                    <span>Şifreni Sıfırla</span>
                </button>
            </form>

            <div class="password-reset-secure-note">
                <i class="fa-solid fa-lock" aria-hidden="true"></i><span>Tüm bilgileriniz şifrelenerek güvenle korunur.</span>
            </div>
        </div>`;
}

function showPasswordResetSuccess(modal) {
    if (activePasswordResetCountdown) {
        window.clearInterval(activePasswordResetCountdown);
        activePasswordResetCountdown = null;
    }

    modal.updateContent(`
        <div class="password-reset-shell password-reset-shell--success" data-reset-stage="success">
            <div class="password-reset-success-visual" aria-hidden="true">
                <span class="password-reset-success-spark password-reset-success-spark--one"></span>
                <span class="password-reset-success-spark password-reset-success-spark--two"></span>
                <span class="password-reset-success-spark password-reset-success-spark--three"></span>
                <span class="password-reset-success-spark password-reset-success-spark--four"></span>
                <div class="password-reset-success-ring"><i class="fa-solid fa-check"></i></div>
            </div>
            <h2>İşlem Başarılı!</h2>
            <p class="password-reset-success-lead">Parolanız başarıyla güncellendi.</p>
            <p class="password-reset-success-copy">Artık yeni parolanız ile giriş yapabilirsiniz.</p>

            <div class="password-reset-success-card">
                <i class="fa-solid fa-lock" aria-hidden="true"></i>
                <div><strong>Güvenliğiniz bizim için önemli</strong><span>Parolanız kimseyle paylaşılmaz ve güvenli olarak güncellenmiştir.</span></div>
            </div>

            <div class="password-reset-success-actions">
                <button type="button" id="PasswordResetLogin" class="password-reset-primary"><i class="fa-solid fa-circle-arrow-right"></i><span>Giriş Yap</span></button>
                <button type="button" id="PasswordResetHome" class="password-reset-secondary"><i class="fa-solid fa-house"></i><span>Ana Sayfaya Dön</span></button>
            </div>

            <div class="password-reset-secure-note">
                <i class="fa-solid fa-shield-halved" aria-hidden="true"></i>
                <span>Tüm bilgileriniz güvende<br /><strong>SahaSenin ile 💚</strong></span>
            </div>
        </div>`);

    setPasswordResetModalStage('success');
}

$(document).on('click', '#resetPassword', async function () {
    bootbox.hideAll();
    Swal.close();

    var modal = createModal({ title: '' });
    var requestHtml = '';
    var currentMail = '';

    $(document).off('.passwordResetFlow');

    function showRequestStage() {
        if (activePasswordResetCountdown) {
            window.clearInterval(activePasswordResetCountdown);
            activePasswordResetCountdown = null;
        }

        modal.updateContent(requestHtml);
        setPasswordResetModalStage('request');
        new Inputmask({ mask: '(999) 999-9999' }).mask(document.getElementById('ResetPhone'));
        window.setTimeout(function () { $('#ResetPhone').trigger('focus'); }, 80);
    }

    function cleanupPasswordResetFlow() {
        if (activePasswordResetCountdown) {
            window.clearInterval(activePasswordResetCountdown);
            activePasswordResetCountdown = null;
        }
        $(document).off('.passwordResetFlow');
    }

    function showCredentialsStage(mail) {
        currentMail = mail;
        modal.updateContent(buildPasswordResetCredentials(mail));
        setPasswordResetModalStage('credentials');
        startPasswordResetCountdown();
        window.setTimeout(function () { $('.password-reset-code-cell').first().trigger('focus'); }, 80);
    }

    try {
        requestHtml = await $.ajax({
            url: '/Login/ResetPasswordForm',
            type: 'POST'
        });

        showRequestStage();

        $(document).on('click.passwordResetFlow', '.js-password-reset-back', function () {
            var stage = getPasswordResetModal().attr('data-reset-stage');
            if (stage === 'credentials') {
                showRequestStage();
            } else {
                cleanupPasswordResetFlow();
                modal.close();
            }
        });

        $(document).on('click.passwordResetFlow', '.password-reset-modal .close-modal', function () {
            cleanupPasswordResetFlow();
        });

        $(document).on('submit.passwordResetFlow', '#ResetPasswordForm', function (event) {
            event.preventDefault();

            var $form = $(this);
            var alternatives = $form.find('.password-reset-alternatives').prop('open');
            var $mail = $form.find(alternatives ? '#MailOrNickName' : '#ResetPhone');
            var mail = ($mail.val() || '').toString().trim();
            var validPhone = alternatives || new Inputmask({ mask: '(999) 999-9999' }).isValid(mail);
            var $submit = $form.find('button[type="submit"]').first();

            $mail.removeClass('is-invalid');
            setPasswordResetError($form, '');

            if (!mail || !validPhone) {
                $mail.addClass('is-invalid').trigger('focus');
                setPasswordResetError($form, alternatives ? 'Kullanıcı adını veya e-posta adresini gir.' : 'Geçerli bir telefon numarası gir.');
                return;
            }

            setPasswordResetButtonLoading($submit, true, 'Gönderiliyor...');

            sendPasswordResetCode(mail).then(function (response) {
                if (isPasswordResetSuccessResponse(response)) {
                    showCredentialsStage(mail);
                    return;
                }

                $mail.addClass('is-invalid').trigger('focus');
                setPasswordResetError($form, 'Hesap bulunamadı veya telefon numarası doğrulanamıyor. Diğer seçenekleri deneyebilirsin.');
            }).catch(function (error) {
                setPasswordResetError($form, getPasswordResetErrorMessage(error));
            }).finally(function () {
                if ($form.closest('html').length) setPasswordResetButtonLoading($submit, false);
            });
        });

        $(document).on('input.passwordResetFlow', '#MailOrNickName, #ResetPhone', function () {
            $(this).removeClass('is-invalid');
            setPasswordResetError($(this).closest('form'), '');
        });

        $(document).on('input.passwordResetFlow', '.password-reset-code-cell', function () {
            var $cell = $(this);
            var $cells = $cell.closest('.password-reset-code-grid').find('.password-reset-code-cell');
            var value = ($cell.val() || '').toString().replace(/\D/g, '');
            var index = $cells.index(this);

            if (value.length > 1) {
                value.split('').slice(0, $cells.length - index).forEach(function (digit, offset) {
                    $cells.eq(index + offset).val(digit).addClass('is-filled');
                });
                $cells.eq(Math.min(index + value.length, $cells.length - 1)).trigger('focus');
            } else {
                $cell.val(value).toggleClass('is-filled', !!value);
                if (value && index < $cells.length - 1) $cells.eq(index + 1).trigger('focus');
            }

            $cell.closest('.password-reset-code-grid').removeClass('is-invalid');
            syncPasswordResetCode($cell.closest('.password-reset-shell'));
            setPasswordResetError($cell.closest('form'), '');
        });

        $(document).on('paste.passwordResetFlow', '.password-reset-code-cell', function (event) {
            var pasted = (event.originalEvent.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '').slice(0, 6);
            if (!pasted) return;

            event.preventDefault();
            var $cells = $(this).closest('.password-reset-code-grid').find('.password-reset-code-cell');
            $cells.each(function (index) {
                $(this).val(pasted[index] || '').toggleClass('is-filled', !!pasted[index]);
            });
            syncPasswordResetCode($(this).closest('.password-reset-shell'));
            $cells.eq(Math.min(pasted.length, 6) - 1).trigger('focus');
        });

        $(document).on('keydown.passwordResetFlow', '.password-reset-code-cell', function (event) {
            var $cells = $(this).closest('.password-reset-code-grid').find('.password-reset-code-cell');
            var index = $cells.index(this);

            if (event.key === 'Backspace' && !$(this).val() && index > 0) {
                $cells.eq(index - 1).val('').removeClass('is-filled').trigger('focus');
            } else if (event.key === 'ArrowLeft' && index > 0) {
                event.preventDefault();
                $cells.eq(index - 1).trigger('focus');
            } else if (event.key === 'ArrowRight' && index < $cells.length - 1) {
                event.preventDefault();
                $cells.eq(index + 1).trigger('focus');
            }
        });

        $(document).on('click.passwordResetFlow', '.password-reset-toggle', function () {
            var $button = $(this);
            var $input = $($button.data('target'));
            var showPassword = $input.attr('type') === 'password';
            $input.attr('type', showPassword ? 'text' : 'password');
            $button.find('i').toggleClass('fa-eye', !showPassword).toggleClass('fa-eye-slash', showPassword);
            $button.attr('aria-label', showPassword ? 'Şifreyi gizle' : 'Şifreyi göster');
        });

        $(document).on('input.passwordResetFlow', '#NewPassword', function () {
            $(this).removeClass('is-invalid');
            updatePasswordResetStrength($(this).val() || '');
            setPasswordResetError($(this).closest('form'), '');
        });

        $(document).on('input.passwordResetFlow', '#ConfirmPassword', function () {
            $(this).removeClass('is-invalid');
            setPasswordResetError($(this).closest('form'), '');
        });

        $(document).on('click.passwordResetFlow', '#PasswordResetResend', function () {
            var $button = $(this);
            var originalText = $button.text();
            $button.prop('disabled', true).text('Gönderiliyor...');

            sendPasswordResetCode(currentMail || $('#ResetMail').val()).then(function (response) {
                if (!isPasswordResetSuccessResponse(response)) {
                    throw { xhr: { responseText: 'Kod yeniden gönderilemedi.' } };
                }
                startPasswordResetCountdown();
                $button.text('Kod Gönderildi');
                window.setTimeout(function () { $button.text(originalText); }, 1600);
            }).catch(function (error) {
                setPasswordResetError($('#ResetPasswordFinalForm'), getPasswordResetErrorMessage(error, 'Kod yeniden gönderilemedi.'));
                $button.text(originalText);
            }).finally(function () {
                $button.prop('disabled', false);
            });
        });

        $(document).on('submit.passwordResetFlow', '#ResetPasswordFinalForm', function (event) {
            event.preventDefault();

            var $form = $(this);
            var $submit = $form.find('button[type="submit"]').first();
            var code = syncPasswordResetCode($form.closest('.password-reset-shell'));
            var mail = ($form.find('#ResetMail').val() || '').toString().trim();
            var newPassword = ($form.find('#NewPassword').val() || '').toString();
            var confirmPassword = ($form.find('#ConfirmPassword').val() || '').toString();

            setPasswordResetError($form, '');
            $form.find('.password-reset-code-grid').removeClass('is-invalid');
            $form.find('input').removeClass('is-invalid');

            if (code.length !== 6) {
                $form.find('.password-reset-code-grid').addClass('is-invalid');
                $form.find('.password-reset-code-cell').filter(function () { return !$(this).val(); }).first().trigger('focus');
                setPasswordResetError($form, 'Lütfen 6 haneli sıfırlama kodunu eksiksiz girin.');
                return;
            }

            if (newPassword.length < 8) {
                $form.find('#NewPassword').addClass('is-invalid').trigger('focus');
                setPasswordResetError($form, 'Yeni şifreniz en az 8 karakter olmalıdır.');
                return;
            }

            if (!/[A-Za-zÇĞİÖŞÜçğıöşü]/.test(newPassword) || !/\d/.test(newPassword) || !/[^A-Za-zÇĞİÖŞÜçğıöşü0-9]/.test(newPassword)) {
                $form.find('#NewPassword').addClass('is-invalid').trigger('focus');
                setPasswordResetError($form, 'Yeni şifreniz harf, rakam ve en az bir sembol içermelidir.');
                return;
            }

            if (newPassword !== confirmPassword) {
                $form.find('#ConfirmPassword').addClass('is-invalid').trigger('focus');
                setPasswordResetError($form, 'Girdiğiniz şifreler birbiriyle eşleşmiyor.');
                return;
            }

            setPasswordResetButtonLoading($submit, true, 'Şifreniz güncelleniyor...');

            sendRequestPromise({
                url: '/Login/ResetPassword',
                type: 'POST',
                data: { mail: mail, passKey: code, newPassword: newPassword }
            }).then(function () {
                showPasswordResetSuccess(modal);
            }).catch(function (error) {
                setPasswordResetError($form, getPasswordResetErrorMessage(error, 'Kod doğrulanamadı. Lütfen bilgilerinizi kontrol edin.'));
            }).finally(function () {
                if ($form.closest('html').length) setPasswordResetButtonLoading($submit, false);
            });
        });

        $(document).on('click.passwordResetFlow', '#PasswordResetLogin', function () {
            cleanupPasswordResetFlow();
            modal.close();
            window.setTimeout(function () { $('#Mail').trigger('focus'); }, 260);
        });

        $(document).on('click.passwordResetFlow', '#PasswordResetHome', function () {
            cleanupPasswordResetFlow();
            window.location.href = '/';
        });
    } catch (error) {
        modal.close();
        Swal.fire({
            icon: 'error',
            title: 'Hata',
            text: 'Parola sıfırlama formu yüklenemedi. Lütfen tekrar deneyin.',
            confirmButtonText: 'Tamam'
        });
    }
});



$(document).on("click", "#findMatchForTeamBtn", function () {

    InitLoadScreen("#findMatchForTeamDiv");

    Request({
        url: '/Match/_FindMatchForTeam',
        type: 'POST',
        target: "#findMatchForTeamDiv"
    }).then(() => {

    }).catch((error) => {
        ShowErrorAlert(error.responseText);
    });
});



$(document).on("click", "#matchWithUserBtn", function () {

    loadFindMatchForOnlyPlayerArea();
});

$(document).on("click", "#findPublishedMatchesForRoleBtn", function () {
    const target = "#findPublishedMatchesForRoleArea";
    InitLoadScreen(target);

    Request({
        url: '/Reservation/_FindPublishedMatchesForRole',
        type: 'POST',
        target: target
    }).catch((error) => {
        ShowErrorAlert(error.responseText);
    });
});

function loadFindMatchForOnlyPlayerArea() {

    $('#memberWithMatchDiv').html('');

    var element = $("#findMatchForOnlyPlayerArea");

    if (element.length > 0) {

        InitLoadScreenElement(element);

        Request({
            url: '/Reservation/_FindMatchForOnlyPlayer',
            type: 'POST',
            target: "#findMatchForOnlyPlayerArea"
        }).then(() => {

            StaffEditorAreaEach();
        }).catch((error) => {
            ShowErrorAlert(error.responseText);
        });
    }
}






$(document).on("click", "#_Redirect", function () {

    Swal.close();
});

$(document).on("change", "#MatchOrganizerSelect", function () {

    var element = $(this);
    var matchId = element.val();

    updateAfterMatchArea(matchId);
});



$(document).on('click', '.inviteMatchPlayerBtn', async function () {

    var element = $(this);
    var matchPlayerId = element.data('match-player') ?? 0;
    var matchId = element.data('match') ?? 0;
    var memberId = element.data('member') ?? 0;

    Swal.fire({
        title: 'Emin Misiniz',
        text: 'Maça oyuncu olarak davet edeceksiniz.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Davet Et',
        cancelButtonText: 'Vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/Team/inviteMatchPlayer',
                type: 'POST',
                data: {
                    matchPlayerId: matchPlayerId,
                    matchId: matchId,
                    memberId: memberId
                }
            }).then(() => {

                removeSheedModal();
                StaffEditorAreaEach();
            }).catch((error) => {
                ShowErrorAlert(error.responseText);
            });
        }
    });
});
$(document).on('click', '.findMemberMyMatchModal', function () {

    var element = $(this);
    var matchPlayerId = element.data('match-player');
    var matchId = element.data('match');

    var modal = createModal({
        title: 'Maç için oyuncu aranıyor'
    });

    // 1️⃣ Modal içeriğini getir
    $.ajax({
        url: '/Team/_findMemberMyMatchModal',
        type: 'POST',
        data: {
            matchPlayerId: matchPlayerId,
            matchId: matchId
        },
        success: function (response) {

            modal.updateContent(response);

            // 2️⃣ Oyuncu bul sayfasını getir (iç içe ajax)
            $.ajax({
                url: '/Oyuncu-Bul',
                type: 'GET',
                data: {
                    matchPlayerId: matchPlayerId,
                    matchId: matchId,
                    pageLink: true
                },
                success: function (findMemberPage) {

                    $("#FindMemberPageForMyMatch").html(findMemberPage);

                    memberSearch();
                },
                error: function (xhr) {

                    modal.updateContent(
                        `<div class="text-center p-2 fs-08 fw-bold alert alert-danger m-2 br-12px">
                        ${xhr.responseText}
                    </div>`
                    );

                }
            });

        },
        error: function (xhr) {

            modal.updateContent(
                `<div class="text-center p-2 fs-08 fw-bold alert alert-danger m-2 br-12px">
                ${xhr.responseText}
            </div>`
            );

        }
    });

});




$(document).on('click', '._joinMatchPlayerTeamSelectorModal', function () {

    var element = $(this);
    var matchId = element.data('match');

    var modal = createModal({
        title: 'oyuncu ilanları inceleniyor'
    });

    Request({
        url: '/Team/_joinMatchPlayerTeamSelectorModal',
        type: 'POST',
        data: {
            matchId: matchId
        }
    }).then((response) => {

        modal.updateContent(response);
    }).catch((xhr) => {

        modal.updateContent(
            `<div class="text-center p-2 fs-08 fw-bold alert alert-danger m-2 br-12px">
                ${xhr.responseText}
            </div>`);
    });
});

$(document).on('click', '.joinMatchPlayer', function () {

    var element = $(this);
    var paid = Number(element.data('paid')) === 1;
    var amount = Number(element.data('amount')) || 0;

    Swal.fire({
        title: 'Emin Misiniz',
        text: paid
            ? undefined
            : 'Maça oyuncu olarak katılma isteği göndereceksiniz.',
        html: paid
            ? `<p>Başvurarak teklif edilen ${amount.toLocaleString('tr-TR')} TL hizmet bedelini kabul etmiş olacaksınız.</p>
               <div class="form-check d-flex align-items-start gap-2 text-start p-3 border rounded">
                   <input id="paidServiceCancellationConsent" class="form-check-input flex-shrink-0 mt-1" type="checkbox">
                   <label class="form-check-label" for="paidServiceCancellationConsent">Maç ilanı iptal edilirse ücret alamayacağımı kabul ediyorum.</label>
               </div>`
            : undefined,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Maça Katıl',
        cancelButtonText: 'Vazgeç',
        preConfirm: function () {
            if (paid && !document.getElementById('paidServiceCancellationConsent')?.checked) {
                Swal.showValidationMessage('Devam etmek için iptal koşulunu onaylayın.');
                return false;
            }
            return true;
        }
    }).then((result) => {
        if (result.isConfirmed)
            submitJoinMatchPlayer(element, paid);
    });
});

function submitJoinMatchPlayer(element, cancellationNoFeeAccepted, addLocationPreference) {
    var matchId = element.data('match');
    var staff = element.data('staff');
    var paid = Number(element.data('paid')) === 1;

    Request({
        url: '/Team/joinMatchPlayer',
        type: 'POST',
        data: {
            id: element.data('match-player'),
            teamId: element.data('team'),
            matchId: matchId,
            feeAccepted: paid,
            cancellationNoFeeAccepted: Boolean(cancellationNoFeeAccepted),
            addLocationPreference: Boolean(addLocationPreference)
        }
    }).then(function () {
        if (staff > 0)
            StaffEditorAreaEach();
        else
            pageLink('/Mac/' + matchId);
    }).catch(function (error) {
        if (isPaidServiceAgreementRequiredError(error)) {
            openPaidServiceAgreementModal(function () {
                submitJoinMatchPlayer(element, cancellationNoFeeAccepted);
            });
            return;
        }


        if (isPaidServiceIbanRequiredError(error)) {
            showPaidServiceIbanRequirement(error);
            return;
        }

        var locationError = error && error.responseJSON;
        if (locationError && locationError.code === 'MATCH_LOCATION_PREFERENCE_REQUIRED') {
            Swal.fire({
                title: 'Bu maç bölge tercihlerinizin dışında',
                html: '<strong>' + $('<div>').text(locationError.districtName || 'Maç bölgesi').html() +
                    '</strong> bölgesini tercihlerinize ekleyip katılma isteğinize devam edebilirsiniz.',
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Bölge tercihlerime ekle ve devam et',
                cancelButtonText: 'Vazgeç'
            }).then(function (result) {
                if (result.isConfirmed)
                    submitJoinMatchPlayer(element, cancellationNoFeeAccepted, true);
            });
            return;
        }

        ShowErrorAlert(getRequestErrorMessage(error));
    });
}
$(document).on('click', '.paid-service-attendance', function () {
    var button = $(this);
    var status = Number(button.data('status'));
    var isAbsent = status === 2;

    Swal.fire({
        title: isAbsent ? 'Gelmedi olarak işaretlensin mi?' : 'Katılımı onaylıyor musunuz?',
        text: isAbsent
            ? 'Hakediş incelemeye alınacak ve üyeye itiraz hakkı tanınacaktır.'
            : 'Katılım onayından sonra hakediş ve itiraz süreci başlatılacaktır.',
        icon: isAbsent ? 'warning' : 'question',
        showCancelButton: true,
        confirmButtonText: isAbsent ? 'Gelmedi' : 'Geldi',
        cancelButtonText: 'Vazgeç'
    }).then(function (result) {
        if (!result.isConfirmed) return;

        button.prop('disabled', true);
        Request({
            url: '/Reservation/MarkPaidServiceAttendance',
            type: 'POST',
            data: {
                servicePaymentId: button.data('id'),
                status: status
            }
        }).then(function () {
            var card = button.closest('.payment-task-global-card');
            var choices = card.find('.attendance-choice');
            choices
                .prop('disabled', true)
                .removeClass('paid-service-attendance is-selected')
                .addClass('is-locked')
                .removeAttr('data-id data-status');
            button.addClass('is-selected');
            card.find('.payment-task-status').text(isAbsent ? 'Gelmedi' : 'Geldi');
            ShowSuccessAlert(
                isAbsent
                    ? 'Katılım bilgisi “Gelmedi” olarak kaydedildi.'
                    : 'Katılım bilgisi “Geldi” olarak kaydedildi.'
            );
        }).catch(function (error) {
            button.prop('disabled', false);
            ShowErrorAlert(error.responseText);
        });
    });
});

$(document).on('click', '.quick-direct-payment-status', function () {
    var button = $(this);
    var paid = String(button.data('paid')).toLowerCase() === 'true';

    Swal.fire({
        title: paid ? 'Ödeme alındı mı?' : 'Ödeme alınmadı mı?',
        text: paid
            ? 'Bu ödeme ödendi olarak işaretlenecek.'
            : 'Ödeme, bekleyen tahsilat olarak kalacak.',
        icon: paid ? 'question' : 'warning',
        showCancelButton: true,
        confirmButtonText: paid ? 'Ödendi' : 'Ödenmedi',
        cancelButtonText: 'Vazgeç'
    }).then(function (result) {
        if (!result.isConfirmed) return;

        var card = button.closest('.payment-task-global-card');
        var choices = card.find('.quick-direct-payment-status');
        choices.prop('disabled', true);

        Request({
            url: '/MemberFinance/MarkDirectPaymentStatus',
            type: 'POST',
            data: {
                servicePaymentId: button.data('id'),
                paid: paid
            }
        }).then(function () {
            choices.removeClass('is-selected');
            button.addClass('is-selected');
            card.find('.payment-task-status').text(paid ? 'Ödendi' : 'Ödenmedi');

            if (paid) {
                choices
                    .removeClass('quick-direct-payment-status')
                    .addClass('is-locked')
                    .removeAttr('data-id data-paid');
                if (typeof syncQuickActionBtn === 'function')
                    syncQuickActionBtn();
            } else {
                choices.prop('disabled', false);
            }

            ShowSuccessAlert(
                paid
                    ? 'Ödeme “Ödendi” olarak kaydedildi.'
                    : 'Ödeme “Ödenmedi” olarak kaydedildi.'
            );
        }).catch(function (error) {
            choices.prop('disabled', false);
            ShowErrorAlert(getRequestErrorMessage(error));
        });
    });
});

$(document).on('click', '.cancelJoinMatchPlayer', function () {

    var element = $(this);
    var id = element.data('join-match-player-request');
    var matchId = element.data('match');
    var staff = element.data('staff');

    Swal.fire({
        title: 'Emin Misiniz?',
        text: 'Maça oyuncu olarak katılma isteğiniz geri çekilecek',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Evet, Geri çek!',
        cancelButtonText: 'Vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {

            element.html('<label class="join-cta w-100 text-center text-white fs-08 fw-bold">Bekleyin..</label>');

            Request({
                url: '/Team/cancelJoinMatchPlayer',
                type: 'POST',
                data: {
                    id: id
                }
            }).then(() => {

                if (staff > 0)
                    StaffEditorAreaEach();
                else
                    pageLink('/Mac/' + matchId);
            }).catch((error) => {
                ShowErrorAlert(error.responseText);
            });
        }
    });
});


async function updateMatchDetailOptionsArea() {

    var element = $('#MatchDetailOptionsArea');

    if (element.length > 0) {

        var id = element.data('match');
        var hasRenderedContent = $.trim(element.html()).length > 0;
        if (!hasRenderedContent)
            InitLoadScreenElement(element);

        Request({
            url: '/Reservation/_MatchDetailOptionsArea',
            type: 'POST',
            data: {
                matchId: id
            }
        }).then((response) => {

            element.html(response);
        }).catch((error) => {
            if (!hasRenderedContent)
                element.html(
                    '<div class="alert alert-warning fs-07 m-2">Maç işlem alanı yüklenemedi. Lütfen sayfayı yenileyin.</div>'
                );
            console.error('updateMatchDetailOptionsArea():', getRequestErrorMessage(error));
        });
    }
}

$(document).on('click', '.remove_TeamInOrganizerBtn', function () {

    var element = $(this);
    var id = element.data('match');

    Swal.fire({
        title: 'Rakibi Maçtan Çıkart',
        text: 'Rakibi maçtan çıkartmak istediğinize emin misiniz?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Evet, Çıkart',
        cancelButtonText: 'Vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/Reservation/RemoveRivalTeam',
                type: 'POST',
                data: {
                    id: id
                }
            }).then(() => {

                removeSheedModal();
                updateAfterMatchArea(id);

            }).catch((error) => {
                ShowErrorAlert(error.responseText);
            });
        }
    });
});
$(document).on('click', '.remove_RefereeInOrganizerBtn', function () {

    var element = $(this);
    var id = element.data('match');

    Swal.fire({
        title: '',
        text: 'Hakemi maçtan çıkartmak istediğinize emin misiniz?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Evet, Çıkart',
        cancelButtonText: 'Vazgeç'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/Reservation/RemoveReferee',
                type: 'POST',
                data: {
                    id: id
                }
            }).then(() => {

                removeSheedModal();
                openRefereeSelectorBasePageModal(id);
            }).catch((error) => {
                ShowErrorAlert(error.responseText);
            });
        }
    });
});


$(document).on('click', '.cancelPotantielRefereeBtn', function () {

    var element = $(this);
    var matchId = element.data('match');

    Request({
        url: '/Reservation/CancelPotantielReferee',
        type: 'POST',
        data: {
            matchId: matchId
        }
    }).then(() => {

        removeSheedModal();
        openRefereeSelectorBasePageModal(matchId);

    }).catch((error) => {
        ShowErrorAlert(error.responseText);
    });
});

$(document).on('click', '.sendinOrganizerMatchRequestBtn', function () {

    var element = $(this);
    var teamId = element.data('team');
    var matchId = element.data('match');

    Swal.fire({
        title: 'Maç Teklifi Gönder',
        text: 'Maç teklifi göndermek istediğinize emin misiniz?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/Reservation/SendMatchRequest',
                type: 'POST',
                data: {
                    teamId: teamId,
                    matchId: matchId
                }
            }).then(() => {

                removeSheedModal();
                pageLink(`/Mac-Olustur/${matchId}`);

            }).catch((error) => {
                ShowErrorAlert(error.responseText);
            });
        }
    });
});
$(document).on('click', '.sendinOrganizerRefereeRequestBtn', function () {

    var element = $(this);
    var refereeId = element.data('referee');
    var matchId = element.data('match');

    Swal.fire({
        title: '',
        text: 'Hakeme maçı yönetme teklifi göndermek istediğinize emin misiniz?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/Reservation/SendRefereeRequest',
                type: 'POST',
                data: {
                    refereeId: refereeId,
                    matchId: matchId
                }
            }).then(() => {

                removeSheedModal();
                pageLink(`/Mac-Olustur/${matchId}`);

            }).catch((error) => {
                ShowErrorAlert(error.responseText);
            });
        }
    });
});

$(document).on('click', '.UpdatePotantielRefereeBtn', function () {

    var element = $(this);
    var refereeId = element.data('referee');
    var matchId = element.data('match');


    if ($('#AfterMatchArea').length > 0) {

        UpdatePotantielRefereeId(refereeId, matchId);
    }
    else {

        pageLink(`/Mac-Olustur/${matchId}`);
    }
});

function UpdatePotantielRefereeId(refereeId, matchId) {

    Request({
        url: '/Reservation/UpdatePotantielRefereeId',
        type: 'POST',
        data: {
            refereeId: refereeId,
            matchId: matchId
        }
    }).then(() => {

        removeSheedModal();
        openRefereeSelectorBasePageModal(matchId);
    }).catch((error) => {
        ShowErrorAlert(error.responseText);
    });
}

// function UpdatePotantielRivalTeamId(teamId, matchId) {

//     Request({
//         url: '/Reservation/UpdatePotantielRivalTeamId',
//         type: 'POST',
//         data: {
//             teamId: teamId,
//             matchId: matchId
//         }
//     }).then(() => {

//         removeSheedModal();

//         if ($('#AfterMatchArea').length > 0) {

//             updateAfterMatchArea(matchId);
//         }
//         else {

//             pageLink(`/Mac-Olustur/${matchId}`);
//         }

//     }).catch((error) => {
//         ShowErrorAlert();
//     });
// }

async function updateAfterMatchArea(matchId) {

    var element = $('#AfterMatchArea');
    if (element.length > 0) {

        InitLoadScreenElement(element);
        var moveComment = element.data('move-comment');

        Request({
            url: '/Reservation/AfterMatch',
            type: 'POST',
            data: {
                id: matchId,
                moveComment: moveComment
            }
        }).then((response) => {

            element.html(response);

            if (typeof window.loadMatchNotificationDeliveryAreas === 'function') {
                window.loadMatchNotificationDeliveryAreas(element[0]);
            }

            if ($('#TeamForm').length > 0) {

                var form = $('#TeamForm');
                var id = form.data('id');
                var teamId = form.data('teamid');

                updateMatchEventTable(id, teamId, 1);
            }
            if ($('#_TeamForm').length > 0) {

                var _form = $('#_TeamForm');
                var _id = _form.data('id');
                var _teamId = _form.data('teamid');

                updateMatchEventTable(_id, _teamId, 2);
            }

            s2Each();
            draggableCardBuilder();
            removeBodyLock();
            loadAfterMatchSetting();
            captureMatchStatusDiv();
            loadAfterMatchRateRivalArea();
            MatchPricesDiv();

            syncMatchCountDown();
        }).catch((error) => {

            element.html(error.responseText);
        });
    }
    else {

        pageLink(`/Mac-Olustur/${matchId}`);
    }
}

async function MatchPricesDiv() {

    var element = $('#MatchPricesDiv');

    if (element.length > 0) {

        InitLoadScreenElement(element);

        var matchId = element.data('match');

        Request({
            url: `/Match/_CheckDetailToPublishMatchModal`,
            type: 'POST',
            data: {
                matchId: matchId,
                detailsOnly: true
            }
        }).then((response) => {

            element.html(response);
        }).catch((error) => {
            console.error("Detaylı hata bilgisi:", error.responseText);
        });
    }
}


async function captureMatchStatusDiv() {

    if (["localhost", "127.0.0.1", "::1"].includes(window.location.hostname)) return;

    var element = $('#MatchStatusDiv');

    if (element.length > 0) {
        await window.sahaseninFeatureAssets.load('capture');

        var matchId = element.data('match');

        try {

            var canvas = await html2canvas(element[0]);

            var blob = await new Promise(resolve => {
                canvas.toBlob(resolve, "image/jpeg", 0.9);
            });

            if (!blob) return;

            var formData = new FormData();
            formData.append("file", blob, "field.jpg");
            formData.append("MatchId", matchId);

            await $.ajax({
                url: '/SaveMatchStatusImg',
                type: "POST",
                data: formData,
                processData: false,
                contentType: false
            });

            console.log(`captureMatchStatusDiv(): Saved img for Match. matchId:${matchId}`);

        } catch (err) {

            console.log("captureMatchStatusDiv hata:" + err);
        }
    }
}






$(document).on("click", ".option-div", function () {
    const $this = $(this);
    $this.toggleClass('selected'); // Tıklanan seçeneği seçili/de-seçili yap

    var func = $this.data('func');
    const group = $this.data('group'); // Grup adını al
    const hiddenInput = $('input[data-group="' + group + '"]'); // İlgili gizli inputu bul

    // Seçilen değerleri sadece bu grup için topla
    const selectedValues = $('.option-div[data-group="' + group + '"].selected')
        .map(function () {
            return $(this).data('value');
        })
        .get();

    // Eğer hiçbir şey seçili değilse, gizli input "0" olsun
    if (selectedValues.length === 0) {
        hiddenInput.val('0');
    } else {
        hiddenInput.val(selectedValues.join(',')); // Seçilenleri virgülle birleştir
    }

    // Tabloyu güncelle (sadece FieldFeatureOptions için çalışacaksa koşul ekleyebilirsin)
    switch (func) {

        case 'FieldFormElement':

            updateFieldTable();
            break;
        case 'ReservationFormElement':

            _updateReservationTable();
            break;
        case 'TournamentFormElement':

            _updateTournamentTable();
            break;
    }
});



$(document).on('change', '.memberSearch', function () {

    SaveFilter('memberSearch');
});
$(document).on('change', '.audienceSearch', function () {
    SaveFilter('audienceSearch');
});
$(document).on('change', '.refereeSearch', function () {

    SaveFilter('refereeSearch');
});
$(document).on('change', '.coachSearch', function () {

    SaveFilter('coachSearch');
});
$(document).on("change", ".ReservationFormElement", async function () {

    await SaveFilter('ReservationFormElement');
});
$(document).on("change", ".FieldFormElement", async function () {

    await SaveFilter('FieldFormElement');
});
$(document).on("change", ".TournamentFormElement", async function () {

    await SaveFilter('TournamentFormElement');
});
$(document).on("change", ".FindRivalFormElement", async function () {

    await SaveFilter('FindRivalFormElement');
});

















$(document).on('mouseenter', '.rivalStar', function () {
    $('.rivalStar').removeClass('hovered');
    $(this).addClass('hovered').prevAll().addClass('hovered');
});

$(document).on('mouseleave', '.ratingRival', function () {
    $('.rivalStar').removeClass('hovered');
});

// Yıldızları UI'da boyamak/temizlemek için yardımcı fonksiyon
function toggleStars($container, targetValue) {
    $container.find('.rivalStar').each(function () {
        var v = parseInt($(this).data('value'), 10) || 0;
        if (v > 0 && v <= targetValue) {
            $(this).removeClass('fa-regular opacity-50').addClass('selected fa-solid text-warning');
        } else {
            $(this).removeClass('selected fa-solid text-warning').addClass('fa-regular opacity-50');
        }
    });
}

function syncTextInputs() {
    // Bireysel inputlar
    $('.rateRivalSingleTextInput').each(function () {
        var $input = $(this);
        var $ratingDiv = $input.closest('.card-body').find('.ratingRivalDiv').first();
        var rateVal = parseInt($ratingDiv.find('input[name="Rate"]').val(), 10) || 0;
        var isDisabled = $ratingDiv.hasClass('disabled') || rateVal === 0;

        $input.prop('disabled', isDisabled)
            .toggleClass('opacity-50', isDisabled)
            .attr('placeholder', isDisabled ? '' : ($input.data('ph') || ''));
    });

    // Toplu input
    var $totalRateDiv = $('#totalRateDiv').closest('.ratingRivalDiv');
    var totalRate = parseInt($totalRateDiv.find('input[name="Rate"]').val(), 10) || 0;
    var isTotalDisabled = totalRate === 0;

    $('#totalRateInput')
        .prop('disabled', isTotalDisabled)
        .toggleClass('opacity-50', isTotalDisabled)
        .attr('placeholder', isTotalDisabled ? '' : ($('#totalRateInput').data('ph') || ''));

    SaveRateRivalModel();
}

$(function () {
    // Başlangıç placeholder'larını sakla ve state'leri ayarla
    $('#totalRateInput, .rateRivalSingleTextInput').each(function () {
        var $i = $(this);
        if (!$i.data('ph')) {
            $i.data('ph', $i.attr('placeholder') || $i.attr('data-ph') || '');
        }
        $i.attr('placeholder', '').prop('disabled', true).addClass('opacity-50');
    });

    // Edit modu / önceden dolu gelen değerler varsa UI'a yansıt
    $('.ratingRivalDiv').each(function () {
        var rv = parseInt($(this).find('input[name="Rate"]').val(), 10) || 0;
        if (rv > 0) toggleStars($(this).find('.ratingRival'), rv);
    });

    syncTextInputs();
});

$(document).on('click', '.rivalStar', function () {
    var $star = $(this);
    var ratingValue = parseInt($star.data('value'), 10) || 0;

    var $ratingRival = $star.closest('.ratingRival');
    var $ratingDiv = $ratingRival.closest('.ratingRivalDiv');
    var $rateInput = $ratingDiv.find('input[name="Rate"]');
    var currentValue = parseInt($rateInput.val(), 10) || 0;
    var isTotal = $ratingRival.is('#totalRateDiv');

    // Aynı değer tıklanıyorsa (İptal durumu)
    if (currentValue === ratingValue) {
        $rateInput.val(0);
        toggleStars($ratingRival, 0);

        if (isTotal) {
            $('.ratingRivalDiv').not($ratingDiv).removeClass('disabled opacity-50').each(function () {
                $(this).find('input[name="Rate"]').val(0);
                toggleStars($(this).find('.ratingRival'), 0);
            });
            $('#totalRateInput').val(''); // İptal edildiğinde açıklamayı da temizle
        }
        syncTextInputs();
        return;
    }

    // Yeni değer atama
    $rateInput.val(ratingValue);
    toggleStars($ratingRival, ratingValue);

    if (isTotal) {
        // Toplu değerlendirme - Tümüne uygula ve disable et
        $('.ratingRivalDiv').not($ratingDiv).each(function () {
            $(this).find('input[name="Rate"]').val(ratingValue);
            toggleStars($(this).find('.ratingRival'), ratingValue);
        }).addClass('disabled opacity-50');

        $('.rateRivalSingleTextInput').val(''); // Bireysel yorumları sıfırla
    } else {
        // Bireysel değerlendirme - Toplu değerlendirmeyi temizle ve disable et
        var $bulkDiv = $('#totalRateDiv').closest('.ratingRivalDiv');
        $bulkDiv.find('input[name="Rate"]').val(0);
        toggleStars($('#totalRateDiv'), 0);
        $bulkDiv.addClass('disabled opacity-50');
        $('#totalRateInput').val('');

        $('.ratingRivalDiv').not($bulkDiv).removeClass('disabled opacity-50');
    }

    syncTextInputs();
});


// --- SaveRateRival Model Oluşturucu (jQuery Optimize Hal) ---
// Doğrudan fonksiyonu tanımlayın
function buildSaveRateRivalModel(matchId) {

    const $totalRateDiv = $('#totalRateDiv').closest('.ratingRivalDiv');
    const totalRateValue = parseInt($totalRateDiv.find('input[name="Rate"]').val(), 10) || 0;

    return {
        MatchId: matchId,
        IsTotalRate: totalRateValue > 0,
        TotalRate: totalRateValue > 0 ? {
            Rate: totalRateValue,
            Description: $('#totalRateInput').val()?.trim() || null
        } : null,
        TeamIdAndRate: getTeamData(),
        MemberIdAndRates: getMembersData()
    };
}

// Yardımcı fonksiyonlar (Opsiyonel - kodu temiz tutar)
function getTeamData() {
    const $teamDiv = $('.ratingRivalDiv[data-teamid]').first();
    if (!$teamDiv.length) return null;
    return {
        TeamId: parseInt($teamDiv.data('teamid'), 10),
        Rate: parseInt($teamDiv.find('input[name="Rate"]').val(), 10),
        Description: $teamDiv.closest('.card-body').find('.rateRivalSingleTextInput').val()?.trim() || null
    };
}

function getMembersData() {
    const members = [];
    $('.ratingRivalDiv[data-memberid]').each(function () {
        const $d = $(this);
        members.push({
            MemberId: parseInt($d.data('memberid'), 10),
            Rate: parseInt($d.find('input[name="Rate"]').val(), 10),
            Description: $d.closest('.card-body').find('.rateRivalSingleTextInput').val()?.trim() || null
        });
    });
    return members;
}

async function SaveRateRivalModel() {

    console.log('SaveRateRivalModel()');

    var matchId = $('#btnSaveRivalRatingMatchId').val();

    // Küçük bir doğrulama: Maç ID'si yoksa ilerleme
    if (!matchId || matchId === 0)
        return;


    // 1. Modeli o anki form durumundan oluştur
    var ratingModel = buildSaveRateRivalModel(matchId);

    // 2. AJAX ile Backend'e gönder
    $.ajax({
        url: '/Match/SaveRateRival', // Controller/Action yolunuzu buraya yazın
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(ratingModel),
        beforeSend: function () {
            // İsterseniz burada butonu disable edip loading ikonu koyabilirsiniz
            $('#btnSaveRatings').prop('disabled', true).text('Kaydediliyor...');
        },
        success: function () {

        },
        error: function (xhr) {

            loadAfterMatchRateRivalArea();
            ShowErrorAlert(xhr.responseText);
        }
    });
};
















$(document).on('click', '#MatchCommentsBtn', function () {

    updateMatchComments();
});

async function updateMatchComments() {

    var matchId = $('#MatchCommentsBtn').data('match');
    var target = $(`#_MatchCommentsArea[data-id="${matchId}"]`);

    InitLoadScreenElement(target);

    Request({
        url: '/Match/_MatchCommentsArea',
        type: 'POST',
        data: {
            matchId: matchId
        }
    }).then((response) => {

        target.html(response);
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}









$(document).on('mouseenter', '.star', function () {
    var stars = $(this).closest('.rating').find('.star');
    stars.removeClass('hovered');
    $(this).addClass('hovered');
    $(this).prevAll().addClass('hovered');
});

$(document).on('mouseleave', '.rating', function () {
    $(this).find('.star').removeClass('hovered');
});

$(document).on('click', '.star', function () {
    var star = $(this);
    var ratingValue = star.data('value');

    // sadece aynı kapsamdaki Rate inputunu bul
    var rateInput = star.closest('.ratingDiv').find('input[name="Rate"]');
    rateInput.val(ratingValue);

    // yıldızları resetle ve yeniden boyama
    star.closest('.rating').find('.star').removeClass('selected fa-solid').addClass('fa-regular');
    star.addClass('selected fa-solid').removeClass('fa-regular');
    star.prevAll().addClass('selected fa-solid').removeClass('fa-regular');
});




$(document).on("click", ".deleteProductComment", function () {

    var id = $(this).data('id');

    Swal.fire({
        title: 'Yorumu silmek istediğinize emin misiniz?',
        text: "Bu işlem geri alınamaz!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'İptal'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/ProductComment/Delete',
                type: 'POST',
                data: { id: id }
            }).then(() => {

                updateProductComments();
                ShowSuccessAlert();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});
$(document).on("click", ".deleteCompanyComment", function () {

    var id = $(this).data('id');

    Swal.fire({
        title: 'Yorumu silmek istediğinize emin misiniz?',
        text: "Bu işlem geri alınamaz!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'İptal'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/CompanyComment/Delete',
                type: 'POST',
                data: { id: id }
            }).then(() => {

                updateCompanyComments();
                ShowSuccessAlert();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});
$(document).on("click", ".deleteLeagueVideoComment", function () {

    var id = $(this).data('id');

    Swal.fire({
        title: 'Yorumu silmek istediğinize emin misiniz?',
        text: "Bu işlem geri alınamaz!",
        icon: 'warning',
        showCancelButton: true,


        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'İptal'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/LeagueVideoComment/Delete',
                type: 'POST',
                data: { id: id }
            }).then(() => {

                updateLeagueVideoComments();
                ShowSuccessAlert();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});
$(document).on("click", ".deleteMemberComment", function () {

    var id = $(this).data('id');

    Swal.fire({
        title: 'Yorumu silmek istediğinize emin misiniz?',
        text: "Bu işlem geri alınamaz!",
        icon: 'warning',
        showCancelButton: true,


        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'İptal'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/MemberRate/Delete',
                type: 'POST',
                data: { id: id }
            }).then(() => {

                updateMemberComments();
                ShowSuccessAlert();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});

$(document).on("click", ".deleteTournamentComment", function () {

    var id = $(this).data('id');

    Swal.fire({
        title: 'Yorumu silmek istediğinize emin misiniz?',
        text: "Bu işlem geri alınamaz!",
        icon: 'warning',
        showCancelButton: true,


        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'İptal'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/TournamentComment/Delete',
                type: 'POST',
                data: { id: id }
            }).then(() => {

                updateTournamentComments();
                ShowSuccessAlert();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});
$(document).on("click", ".deleteTeamComment", function () {

    var id = $(this).data('id');

    Swal.fire({
        title: 'Yorumu silmek istediğinize emin misiniz?',
        text: "Bu işlem geri alınamaz!",
        icon: 'warning',
        showCancelButton: true,


        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'İptal'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/TeamComment/Delete',
                type: 'POST',
                data: { id: id }
            }).then(() => {

                updateTeamComments();
                ShowSuccessAlert();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});

$(document).on("click", ".deleteComment", function () {

    var id = $(this).data('id');

    Swal.fire({
        title: 'Yorumu silmek istediğinize emin misiniz?',
        text: "Bu işlem geri alınamaz!",
        icon: 'warning',
        showCancelButton: true,


        confirmButtonText: 'Evet, sil!',
        cancelButtonText: 'İptal'
    }).then((result) => {
        if (result.isConfirmed) {

            Request({
                url: '/Comment/Delete',
                type: 'POST',
                data: { id: id }
            }).then(() => {

                updateComments();
                ShowSuccessAlert();
            }).catch((error) => {
                console.error("Detaylı hata bilgisi:", error.responseText);
            });
        }
    });
});


$(document).on("submit", "#ProductForm", function (e) {
    e.preventDefault();

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                SaveProductComment();
            }
            else {

                quickLoginModal();

                //Request({
                //    url: '/Login/LoginForm',
                //    type: 'GET',
                //    data: { isAlert: true },
                //    dataType: 'html',
                //    success: function (response) {
                //        Swal.fire({
                //            html: response,
                //            showConfirmButton: false,
                //            showCancelButton: false
                //        });
                //    },
                //    error: function (xhr, status, error) {
                //        ShowErrorAlert();
                //    }
                //});
            }
        });
});

$(document).on("submit", "#_CommentForm", function (e) {
    e.preventDefault();

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                SaveComment();
            }
            else {

                quickLoginModal();
            }
        });
});


$(document).on("submit", "#_TournamentCommentForm", function (e) {
    e.preventDefault();

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                SaveTournamentComment();
            }
            else {

                quickLoginModal();
            }
        });
});
$(document).on("submit", "#_TeamCommentForm", function (e) {
    e.preventDefault();

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                SaveTeamComment();
            }
            else {

                quickLoginModal();
            }
        });
});

$(document).on("submit", "#_MemberCommentForm", function (e) {
    e.preventDefault();

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                SaveMemberComment();
            }
            else {

                quickLoginModal();
            }
        });
});

$(document).on("submit", "#_LeagueVideoCommentForm", function (e) {
    e.preventDefault();

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                SaveLeagueVideoComment();
            }
            else {

                quickLoginModal();
            }
        });
});


$(document).on("submit", ".CommentForm", function (e) {
    e.preventDefault();

    var form = $(this);
    var area = form.data('area');
    // Rate'i formdan al (stringi parse etmeye gerek yok)
    var rate = form.find("[name=Rate]").val();

    if (rate > 0) {

        getCurrentUserId()
            .then(memberId => {

                if (memberId > 0) {

                    SaveCompanyComment(form, area);
                }
                else {

                    quickLoginModal();
                }
            });
    }
    else {

        ShowErrorAlert('Lütfen bir puanlama yapınız.');
    }
});

$(document).on("submit", ".SubProductCommentForm", function (e) {
    e.preventDefault();

    var formId = $(this).data('id');

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                SaveSubProductComment(formId);
            }
            else {

                quickLoginModal();
            }
        });
});
$(document).on("submit", ".SubCommentForm", function (e) {
    e.preventDefault();

    var formId = $(this).data('id');

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                SaveSubCompanyComment(formId);
            }
            else {

                quickLoginModal();
            }
        });
});
$(document).on("submit", ".SubTeamCommentForm", function (e) {
    e.preventDefault();

    var formId = $(this).data('id');

    getCurrentUserId().then(memberId => memberId > 0 ? SaveSubTeamComment(formId) : quickLoginModal());
});
$(document).on("submit", ".SubMemberCommentForm", function (e) {
    e.preventDefault();

    var formId = $(this).data('id');

    getCurrentUserId().then(memberId => memberId > 0 ? SaveSubMemberComment(formId) : quickLoginModal());
});
$(document).on("submit", ".SubTournamentCommentForm", function (e) {
    e.preventDefault();

    var formId = $(this).data('id');

    getCurrentUserId().then(memberId => memberId > 0 ? SaveSubTournamentComment(formId) : quickLoginModal());
});
$(document).on("submit", ".SubLeagueVideoCommentForm", function (e) {
    e.preventDefault();

    var formId = $(this).data('id');

    getCurrentUserId().then(memberId => memberId > 0 ? SaveSubLeagueVideoComment(formId) : quickLoginModal());
});



async function Permission() {
    try {
        let response = await $.get('/Member/Permission');

        if (response === false) {
            permissionModal();
        }

        return response;
    } catch (error) {
        console.error('Permission()', error.responseText);
    }
}



async function SaveProductComment() {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                Permission().then(response => {
                    if (response) {

                        var form = $("#ProductForm");
                        form.find('[name="MemberId"]').val(memberId);
                        var formData = form.serialize();

                        // Rate'i formdan al (stringi parse etmeye gerek yok)
                        var rate = form.find("[name=Rate]").val();

                        if (rate > 0) {
                            Request({
                                url: '/ProductComment/Save',
                                type: 'POST',
                                data: formData,
                                isFormdata: false
                            }).then(() => {

                                updateProductComments();
                                ShowSuccessAlert();
                            }).catch((error) => {
                                console.error("Detaylı hata bilgisi:", error.responseText);
                            });
                        }
                        else {
                            ShowErrorAlert('Lütfen bir puanlama yapınız.');
                        }
                    }
                });
            }
        });
}

async function SaveComment() {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                Permission().then(response => {
                    if (response) {

                        var form = $("#_CommentForm");
                        form.find('[name="MemberId"]').val(memberId);
                        var formData = form.serialize();

                        // Rate'i formdan al (stringi parse etmeye gerek yok)
                        var rate = form.find("[name=Rate]").val();

                        if (rate > 0) {
                            Request({
                                url: '/Comment/Save',
                                type: 'POST',
                                data: formData,
                                isFormdata: false
                            }).then(() => {

                                updateComments();
                                ShowSuccessAlert();
                            }).catch((error) => {
                                console.error("Detaylı hata bilgisi:", error.responseText);
                            });
                        }
                        else {
                            ShowErrorAlert('Lütfen bir puanlama yapınız.');
                        }
                    }
                });
            }
        });
}

async function SaveTournamentComment() {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                Permission().then(response => {
                    if (response) {

                        var form = $("#_TournamentCommentForm");
                        form.find('[name="MemberId"]').val(memberId);
                        var formData = form.serialize();

                        // Rate'i formdan al (stringi parse etmeye gerek yok)
                        var rate = form.find("[name=Rate]").val();

                        if (rate > 0) {
                            Request({
                                url: '/TournamentComment/Save',
                                type: 'POST',
                                data: formData,
                                isFormdata: false
                            }).then(() => {

                                updateTournamentComments();
                                ShowSuccessAlert();
                            }).catch((error) => {
                                console.error("Detaylı hata bilgisi:", error.responseText);
                            });
                        } else {
                            ShowErrorAlert('Lütfen bir puanlama yapınız.');
                        }
                    }
                });
            }
        });
}
async function SaveTeamComment() {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                Permission().then(response => {
                    if (response) {

                        var form = $("#_TeamCommentForm");
                        form.find('[name="MemberId"]').val(memberId);
                        var formData = form.serialize();

                        // Rate'i formdan al (stringi parse etmeye gerek yok)
                        var rate = form.find("[name=Rate]").val();

                        if (rate > 0) {
                            Request({
                                url: '/TeamComment/Save',
                                type: 'POST',
                                data: formData,
                                isFormdata: false
                            }).then(() => {

                                updateTeamComments();
                                ShowSuccessAlert();
                            }).catch((error) => {
                                console.error("Detaylı hata bilgisi:", error.responseText);
                            });
                        } else {
                            ShowErrorAlert('Lütfen bir puanlama yapınız.');
                        }
                    }
                });
            }
        });
}
async function SaveMemberComment() {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                Permission().then(response => {
                    if (response) {

                        var form = $("#_MemberCommentForm");
                        form.find('[name="_MemberId"]').val(memberId);
                        var formData = form.serialize();

                        // Rate'i formdan al (stringi parse etmeye gerek yok)
                        var rate = form.find("[name=Rate]").val();

                        if (rate > 0) {
                            Request({
                                url: '/Member/SaveMemberCommentAndSendSms',
                                type: 'POST',
                                data: formData,
                                isFormdata: false
                            }).then(() => {

                                updateMemberComments();
                                ShowSuccessAlert();
                            }).catch((error) => {
                                console.error("Detaylı hata bilgisi:", error.responseText);
                            });
                        } else {
                            ShowErrorAlert('Lütfen bir puanlama yapınız.');
                        }
                    }
                });
            }
        });
}

async function SaveLeagueVideoComment() {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                Permission().then(response => {
                    if (response) {

                        var form = $("#_LeagueVideoCommentForm");
                        form.find('[name="MemberId"]').val(memberId);
                        var formData = form.serialize();

                        // Rate'i formdan al (stringi parse etmeye gerek yok)
                        var rate = form.find("[name=Rate]").val();

                        if (rate > 0) {
                            Request({
                                url: '/LeagueVideoComment/Save',
                                type: 'POST',
                                data: formData,
                                isFormdata: false
                            }).then(() => {

                                updateLeagueVideoComments();
                                ShowSuccessAlert();
                            }).catch((error) => {
                                console.error("Detaylı hata bilgisi:", error.responseText);
                            });
                        } else {
                            ShowErrorAlert('Lütfen bir puanlama yapınız.');
                        }
                    }
                });
            }
        });
}

async function SaveSubProductComment(formId) {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                var form = $('#SubProductCommentForm_' + formId);
                form.find('[name="MemberId"]').val(memberId);
                var formData = form.serialize();

                Request({
                    url: '/ProductComment/Save',
                    type: 'POST',
                    data: formData,
                    isFormdata: false
                }).then(() => {

                    updateProductComments();
                    ShowSuccessAlert();
                }).catch((error) => {
                    console.error("Detaylı hata bilgisi:", error.responseText);
                });
            }
        });
}

async function SaveSubCompanyComment(formId) {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                var form = $('#SubCommentForm_' + formId);
                form.find('[name="MemberId"]').val(memberId);
                var formData = form.serialize();

                Request({
                    url: '/CompanyComment/SaveCompanyComment',
                    type: 'POST',
                    data: formData,
                    isFormdata: false
                }).then(() => {

                    updateCompanyComments();
                    ShowSuccessAlert();
                }).catch((error) => {
                    console.error("Detaylı hata bilgisi:", error.responseText);
                });
            }
        });
}
async function SaveSubTeamComment(formId) {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                var form = $('#SubTeamCommentForm_' + formId);
                form.find('[name="MemberId"]').val(memberId);
                var formData = form.serialize();

                Request({
                    url: '/TeamComment/Save',
                    type: 'POST',
                    data: formData,
                    isFormdata: false
                }).then(() => {

                    updateTeamComments();
                    ShowSuccessAlert();
                }).catch((error) => {
                    console.error("Detaylı hata bilgisi:", error.responseText);
                });
            }
        });
}
async function SaveSubMemberComment(formId) {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                var form = $('#SubMemberCommentForm_' + formId);
                form.find('[name="_MemberId"]').val(memberId);
                var formData = form.serialize();

                Request({
                    url: '/Member/SaveMemberCommentAndSendSms',
                    type: 'POST',
                    data: formData,
                    isFormdata: false
                }).then(() => {

                    updateMemberComments();
                    ShowSuccessAlert();
                }).catch((error) => {
                    console.error("Detaylı hata bilgisi:", error.responseText);
                });
            }
        });
}
async function SaveSubTournamentComment(formId) {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                var form = $('#SubTournamentCommentForm_' + formId);
                form.find('[name="MemberId"]').val(memberId);
                var formData = form.serialize();

                Request({
                    url: '/TournamentComment/Save',
                    type: 'POST',
                    data: formData,
                    isFormdata: false
                }).then(() => {

                    updateTournamentComments();
                    ShowSuccessAlert();
                }).catch((error) => {
                    console.error("Detaylı hata bilgisi:", error.responseText);
                });
            }
        });
}



async function SaveSubLeagueVideoComment(formId) {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                var form = $('#SubLeagueVideoCommentForm_' + formId);
                form.find('[name="MemberId"]').val(memberId);
                var formData = form.serialize();

                Request({
                    url: '/LeagueVideoComment/Save',
                    type: 'POST',
                    data: formData,
                    isFormdata: false
                }).then(() => {

                    updateLeagueVideoComments();
                    ShowSuccessAlert();
                }).catch((error) => {
                    console.error("Detaylı hata bilgisi:", error.responseText);
                });
            }
        });
}

async function SaveCompanyComment(form) {

    getCurrentUserId()
        .then(memberId => {

            if (memberId > 0) {

                Permission().then(response => {

                    if (response) {

                        form.find('[name="MemberId"]').val(memberId);
                        var formData = form.serialize();

                        Request({
                            url: '/CompanyComment/SaveCompanyComment',
                            type: 'POST',
                            data: formData,
                            isFormdata: false
                        }).then(() => {

                            form.find('[name="Description"]').val('');
                            form.find('[name="Rate"]').val('0');
                            form.find('.fa-star.star.selected').removeClass('selected fa-solid').addClass('fa-regular');

                            updateCompanyComments();
                            ShowSuccessAlert();
                        }).catch((error) => {
                            console.error("Detaylı hata bilgisi:", error.responseText);
                        });
                    }
                });
            }
        });
}

async function updateMemberPosts() {

    if ($('.Div_MemberPosts').length > 0) {

        var id = $('#ModelMemberId').val();

        Request({
            url: '/Member/MemberPostArea',
            type: 'POST',
            data: { id: id },
            target: ".Div_MemberPosts"
        }).then(() => {

        }).catch((error) => {
            console.error("updateMemberPosts():", error.responseText);
        });
    }
}

async function updateTournamentComments() {

    InitLoadScreen('#div_Comments');

    var id = $('#TournamentId').val();

    Request({
        url: '/Tournament/TournamentComments',
        type: 'POST',
        data: { id: id },
        target: "#div_Comments"
    }).then(() => {

    }).catch((error) => {
        console.error("updateTournamentComments():", error.responseText);
    });
}

async function updateMemberComments() {

    var commentAreas = $('._MemberProfileCommentArea');

    if (commentAreas.length > 0) {
        commentAreas.each(function () {

            var element = $(this);
            var memberId = element.data('member');
            InitLoadScreenElement(element);

            Request({
                url: '/Member/MemberComments',
                type: 'POST',
                data: { id: memberId }
            }).then((response) => {

                element.html(response);
            }).catch((error) => {
                console.error("updateMemberComments():", error.responseText);
            });
        });
    }
}

async function updateLeagueVideoComments() {

    InitLoadScreen('#Div_LeagueVideoComment');

    var id = $('#Div_LeagueVideoComment').data('id');

    Request({
        url: '/LeagueVideo/_leagueVideoComments',
        type: 'POST',
        data: { id: id },
        target: "#Div_LeagueVideoComment"
    }).then(() => {

    }).catch((error) => {
        console.error("updateLeagueVideoComments():", error.responseText);
    });
}

async function updateComments() {

    InitLoadScreen('#div2');

    var id = $('#PostId').val();

    Request({
        url: '/Blog/_Comments',
        type: 'POST',
        data: { id: id },
        target: "#div2"
    }).then(() => {

    }).catch((error) => {
        console.error("updateComments():", error.responseText);
    });
}
async function updateTeamComments() {

    InitLoadScreen('#Div_TeamProfileComment');

    var id = $('#TeamId').val();

    Request({
        url: '/Team/TeamComments',
        type: 'POST',
        data: { id: id },
        target: "#Div_TeamProfileComment"
    }).then(() => {

    }).catch((error) => {
        console.error("updateTeamComments():", error.responseText);
    });
}


async function updateProductComments() {

    var form = $('#ProductForm');

    if (form.length > 0) {

        var id = form.data('stock');

        InitLoadScreen('#ProductCommentsArea');

        Request({
            url: '/Stock/_StockComments',
            type: 'POST',
            data: {
                id: id
            },
            target: '#ProductCommentsArea'
        }).then(() => {

        }).catch((error) => {
            console.error("updateProductComments():", error.responseText);
        });
    }
    else {

        console.log("Yorum formu bulunamadı.");
    }
}
$(document).on("click", ".loadCompanyFacilityDetail", function () {
    loadCompanyFacilityDetail();
});

$(document).on("click", "[data-facility-slide]", function () {
    const slider = this.closest('.facility-detail__showcase').querySelector('.facility-detail__slider');
    slider.scrollBy({ left: Number(this.dataset.facilitySlide) * slider.clientWidth * .8,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
});
$(document).on("click", "[data-facility-jump]", function (event) {
    const card = document.getElementById(this.hash.slice(1));
    if (!card) return;
    event.preventDefault();
    if (card.tagName === 'DETAILS') card.open = true;
    card.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    const target = card.querySelector('summary') || card;
    if (target === card) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
});

async function loadCompanyFacilityDetail() {
    var target = $('#divx2');

    if (!target.length || target.attr('data-loaded') === 'true' || target.attr('data-loading') === 'true') {
        return;
    }

    target.attr('data-loading', 'true').attr('aria-busy', 'true');
    target.html('<p class="p-3 fs-07" role="status">Tesis bilgileri yükleniyor…</p>');

    try {
        await Request({
            url: target.data('url'),
            type: 'GET',
            data: { id: target.data('company') },
            target: '#divx2',
            cacheable: false
        });

        target.attr('data-loaded', 'true');
        await updateCompanyComments(target);
    }
    catch (error) {
        target.html('<div class="p-3 text-center fs-07"><p role="alert">Tesis bilgileri yüklenemedi.</p><button type="button" class="loadCompanyFacilityDetail br-calc border-ff px-3 py-2 fs-07">Tekrar dene</button></div>');
        console.error("loadCompanyFacilityDetail():", error.responseText || error);
    }
    finally {
        target.removeAttr('data-loading').removeAttr('aria-busy');
    }
}

async function updateCompanyComments(target) {

    var areas = target ? $(target).find('.CompanyCommentsArea') : $('.CompanyCommentsArea');
    var requests = [];

    if (areas.length > 0) {
        areas.each(function () {

            var id = $(this).data('id');
            var area = $(this).attr('id');
            var facilityCatalogGroupId = $(this).data('facilitycataloggroupid');

            InitLoadScreen('#' + area);

            var request = Request({
                url: '/Field/CompanyComments',
                type: 'POST',
                data: {
                    id: id,
                    FacilityCatalogGroupId: facilityCatalogGroupId
                },
                target: '#' + area
            }).then(() => {

            }).catch((error) => {
                console.error("updateCompanyComments():", error.responseText);
            });

            requests.push(request);
        });

        await Promise.all(requests);
    }
    else {

        console.log("Yorum alanı bulunamadı.");
    }
}



$(document).on("click", ".removeMemberFavProduct", function () {

    var element = $(this);
    var id = element.data('id');

    Request({
        url: '/MemberFavoruiteProduct/Delete',
        type: 'POST',
        data: { id: id }
    }).then(() => {

        syncGlobalActionBtnAreas();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
});
$(document).on("click", ".addMemberFavProduct", function () {

    var element = $(this);
    var id = element.data('id');

    getCurrentUserId()
        .then(memberId => {

            Swal.close();

            if (memberId > 0) {

                var formData = new FormData();
                formData.append("StockId", id);
                formData.append("MemberId", memberId);

                Request({
                    url: '/MemberFavoruiteProduct/Save',
                    type: 'POST',
                    data: formData,
                    isFormdata: true
                }).then(() => {

                    syncGlobalActionBtnAreas();
                }).catch((error) => {
                    console.error("Detaylı hata bilgisi:", error.responseText);
                });

            } else {
                element.html('Giriş Yapın');
            }
        });
});



$(document).on("click", ".removeMemberFavCompany", function () {

    var element = $(this);
    var id = element.data('id');

    Request({
        url: '/MemberFavouriteField/Delete',
        type: 'POST',
        data: { id: id }
    }).then(() => {

        syncGlobalActionBtnAreas();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
});
$(document).on("click", ".addMemberFavCompany", function () {

    var element = $(this);
    var id = element.data('id');

    getCurrentUserId()
        .then(memberId => {

            Swal.close();

            if (memberId > 0) {

                var formData = new FormData();
                formData.append("CompanyId", id);
                formData.append("MemberId", memberId);

                Request({
                    url: '/MemberFavouriteField/Save',
                    type: 'POST',
                    data: formData,
                    isFormdata: true
                }).then(() => {

                    syncGlobalActionBtnAreas();
                }).catch((error) => {
                    console.error("Detaylı hata bilgisi:", error.responseText);
                });

            } else {
                element.html('Giriş Yapmanız Gerekmektedir');
            }
        });
});

async function syncGlobalActionBtnAreas(target) {

    var elements = findInRenderTarget(target, '.globalActionBtn');

    if (elements.length == 0)
        return;

    elements.each(function () {

        var element = $(this);
        element.removeClass('globalActionBtn');

        var type = element.data('type');
        var id = element.data('id');
        var externalId = element.data('external') ?? 0;

        Request({
            url: '/_GlobalActionBtnArea',
            type: 'POST',
            data: {
                type: type,
                objectId: id,
                externalId: externalId
            }
        }).then((response) => {

            element.html(response);
            element.addClass('globalActionBtn');
        }).catch((error) => {
            console.error("Detaylı hata bilgisi:", error.responseText);
        });
    });
}




$(document).on("click", ".CompanyDetail", function () {
    var id = $(this).data('id');

    pageLink($(this).attr('data-url') || `/Tesisler/${id}`);
});



$(document).on("change", ".locationel", function () {

    var element = $(this);

    var isFindRival = element.hasClass('FindRivalFormElement');

    updateLocationFields(isFindRival);
});

$(document).on("change", ".locationcel", function () {
    updateLocationCompanies();
});

function updateLocationFields(isFindRival) {

    var CityId = $("#CityId").val();
    var DistrictId = $("#DistrictId").val();

    Request({
        url: '/Field/GetLocationField',
        type: 'GET',
        data:
        {
            CityId: CityId,
            DistrictId: DistrictId,
            isFindRival: isFindRival
        },
        target: "#LocationFields"
    }).then(() => {

        updateFindRivalTable();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}

function updateLocationCompanies() {

    var CityId = $("#CityId").val();
    var DistrictId = $("#DistrictId").val();

    Request({
        url: '/Field/GetLocationCompanies',
        type: 'GET',
        data:
        {
            CityId: CityId,
            DistrictId: DistrictId
        },
        target: "#LocationCompanies"
    }).then(() => {

        updateFindRivalTable();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}


async function updateMyFriendListTable() {

    InitLoadScreen('#UserChatsTableArea');

    Request({
        url: '/_UserChatsTable',
        type: 'POST',
        target: "#UserChatsTableArea"
    }).then(() => {

        syncGlobalActionBtnAreas();
        updateGlobalRequestCards();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}

async function updateFriendTable() {

    InitLoadScreen('#FriendRequestTableArea');

    Request({
        url: '/Member/FriendRequestTable',
        type: 'POST',
        target: "#FriendRequestTableArea"
    }).then(() => {

    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}
async function updateJoinGroupRequestTable() {

    InitLoadScreen('#JoinGroupRequestTableArea');

    Request({
        url: '/Member/JoinGroupRequestsTable',
        type: 'POST',
        target: "#JoinGroupRequestTableArea"
    }).then(() => {


    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}
async function updateRivalRequestsTable() {

    var id = $('#TTeamId').val();

    InitLoadScreen('#MyTeamRivalRequestsTableArea');

    Request({
        url: '/Member/MyTeamRivalRequestsTable',
        type: 'POST',
        data: { id: id },
        target: "#MyTeamRivalRequestsTableArea"
    }).then(() => {
        var count = Number($('#MyTeamRivalRequestsTableArea [data-team-request-count]').data('team-request-count')) || 0;
        $('.team-rivals-grid > section').eq(0).find('.team-count-badge').text(count);
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });

    InitLoadScreen('#MyTeamRivalsArea');

    Request({
        url: '/Member/myTeamRivals',
        type: 'GET',
        data: { id: id },
        target: "#MyTeamRivalsArea"
    }).then(() => {
        var count = Number($('#MyTeamRivalsArea [data-team-rival-count]').data('team-rival-count')) || 0;
        $('.team-rivals-grid > section').eq(1).find('.team-count-badge').text(count);
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}


async function updateFindRivalTable() {



    var matchId = $("#_FindRivalTable").data("match") ?? 0;
    var tournamentId = $("#_FindRivalTable").data("tournament") ?? 0;

    return Request({
        url: '/Team/_FindRivalTable',
        type: 'POST',
        data: {
            matchId: matchId,
            tournamentId: tournamentId
        },
        cacheable: false,
        ...publicListEnhancementOptions("#_FindRivalTable")
    }).then(() => {
        $('#_FindRivalTable').removeAttr('data-public-search-initial');

        renderPager();
        syncGlobalActionBtnAreas();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}











async function updateFieldTable(first) {

    if (first) {
        var today = SahaseninTime.dateKey();
        $('#Date').val(today);

        var CityId = $("#CityId").val();
        var DistrictId = $("#DistrictId").val();

        Request({
            url: '/Field/GetLocationCompanies',
            type: 'GET',
            data:
            {
                CityId: CityId,
                DistrictId: DistrictId
            },
            cacheable: false,
            target: "#LocationCompanies"
        }).then(() => {


            _updateFieldTable();

        }).catch((error) => {
            console.error("Detaylı hata bilgisi:", error.responseText);
        });
    } else {


        _updateFieldTable();
    }
}


async function _updateTournamentTable() {



    return Request({
        url: '/Tournament/_TournamentTable',
        type: 'POST',
        cacheable: false,
        ...publicListEnhancementOptions("#_TournamentTable")
    }).then(() => {
        $('#_TournamentTable').removeAttr('data-public-search-initial');

        renderPager();
        syncGlobalActionBtnAreas();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}



async function _updateFieldTable() {
    // Request owns the normal skeleton; the first SSR catalog still stays visible.
    return Request({
        url: '/Field/_Table',
        type: 'GET',
        target: "#_FieldTable",
        ...publicListEnhancementOptions("#_FieldTable"),
        cacheable: false
    }).then(() => {

        $('#_FieldTable').removeAttr('data-public-catalog-initial');
        renderPager();
        sliderGalleryBuilder();
        syncGlobalActionBtnAreas();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}

$(document).on('click', '.public-facility-link, .public-profile-link', function (e) {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.which > 1) return;
    if (typeof pageLink !== 'function') return;
    e.preventDefault();
    pageLink(this.getAttribute('href'));
});

$(document).on('click', '.cardPageLink', function (e) {

    if ($(e.target).closest('a[href]').length > 0) return;

    // Eğer tıklanan yer (target) '.action' sınıfına sahipse veya içindeyse işlemi durdur
    if ($(e.target).closest('.action').length > 0) {
        return;
    }

    if ($(e.target).closest('.js-toggle-stat-tree').length > 0) {
        return;
    }

    if ($(e.target).closest('.chatOrOgShareButton').length > 0) {
        return;
    }

    // Slider içindeki noktalara (dots) tıklanıldığında da sayfa değişmesin istersen burayı kullanabilirsin
    if ($(e.target).closest('.dots').length > 0) {
        return;
    }

    var element = $(this);
    var url = element.data("url");


    // Eğer element '.myTeamForReservationJoinRequest' classına sahip bir elementin içindeyse durdur
    if (element.closest('.myTeamForReservationJoinRequest').length) {
        return;
    }

    // Eğer element '.UpdatePotantielRivalTeamBtn' classına sahip bir elementin içindeyse durdur
    if (element.closest('.UpdatePotantielRivalTeamBtn').length) {
        return;
    }

    // Eğer element '.CreateMatchPopUpBtn' classına sahip bir elementin içindeyse durdur
    if (element.closest('.CreateMatchPopUpBtn').length) {
        return;
    }

    // Eğer element '.opacity-50' classına sahip bir elementin içindeyse durdur
    if (element.closest('.opacity-50').length) {
        return;
    }

    if (!url)
        return;

    if (url === currentUrl)
        return;

    $("#CloseHamburgerMenuBtn").click();

    pageLink(url);
});

$(document).on('click', '.cardOpenSheepPopup', function (e) {

    // Eğer tıklanan yerin üstündeki element (target) '.CreateMatchPopUpBtn' sınıfına sahipse veya içindeyse işlemi durdur
    if ($(e.target).closest('.CreateMatchPopUpBtn').length > 0) {
        return;
    }

    // Eğer tıklanan yer (target) '.fullscreenVideoBtn' sınıfına sahipse veya içindeyse işlemi durdur
    if ($(e.target).closest('.fullscreenVideoBtn').length > 0) {
        return;
    }

    // Eğer tıklanan yer (target) '.action' sınıfına sahipse veya içindeyse işlemi durdur
    if ($(e.target).closest('.action').length > 0) {
        return;
    }

    if ($(e.target).closest('.js-toggle-stat-tree').length > 0) {
        return;
    }

    if ($(e.target).closest('.chatOrOgShareButton').length > 0) {
        return;
    }




    // Slider içindeki noktalara (dots) tıklanıldığında da sayfa değişmesin istersen burayı kullanabilirsin
    if ($(e.target).closest('.dots').length > 0) {
        return;
    }

    if ($(e.target).closest('.openRivalSelectorModal, .js-draft-opponent-picker, #teamModal').length > 0) {
        return;
    }

    const element = $(this);
    const url = element.data('url');
    var header = element.data('header') ?? '';

    if (!url)
        return;

    if (url === currentUrl)
        return;

    // Anında shadow ekle
    element.addClass('hover');

    // 500ms sonra kaldır (non-blocking)
    setTimeout(() => {
        element.removeClass('hover');
    }, 500);

    // Popup açılmasını bekletmez
    openSheepPopUp(url, header);
});

















async function updateBlogTable(first) {

    InitLoadScreen("#_BlogTable");

    Request({
        url: '/Blog/_Table',
        type: 'GET',
        cacheable: false,
        target: "#_BlogTable"
    }).then(() => {

    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}


async function _updateReservationTable() {
    // Request inserts the same table skeleton without an intermediate spinner write.
    return Request({
        url: '/Reservation/_ReservationTable',
        type: 'POST',
        cacheable: false,
        ...publicListEnhancementOptions("#_ReservationTable")
    }).then(() => {
        $('#_ReservationTable').removeAttr('data-public-search-initial');

        s2Each();
        renderPager();
        syncGlobalActionBtnAreas();
    }).catch((error) => {
        console.error("Detaylı hata bilgisi:", error.responseText);
    });
}



async function RemoveBlurScreen(divId) {
    $(divId).css('filter', 'blur(0)');
}
async function BlurLoadScreen(divId) {
    $(divId).css('filter', 'blur(0px)');
}


async function InitLoadScreenBordered(divId) {
    window.injectSkeleton(divId);
}
async function InitLoadScreen(divId) {
    window.injectSkeleton(divId);
}
async function InitLoadScreenElement(element) {
    window.injectSkeleton(element);
}
async function InitHomeLoadScreen(divId) {
    window.injectSkeleton(divId);
}

var loadPageHtml = `
<div class="container-bg">
    <div id="DesktopContainer">
        <div class="row">
            <div class="col-12">
                <div class="card m-2 border-ff shadow-none">
                    <div class="card-body text-center">
                        <div class="spinner-border sahasenin-modern-spinner"  role="status">
                            <span class="visually-hidden">İçerikler Yükleniyor...</span>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</div>
`;


async function InitErrorScreen(divId, error) {
    $(divId).html('<div class="w-100 h-100"><p class="w-100 badge badge-danger p-3 text-wrap" style="overflow:hidden;">' + error + '</p></div>');
}


async function ShowSyncAlert(title) {

    try {
        const $notify = $('#NotifyNative');

        if ($notify.length) {
            $notify.find('span').text(title);
        }
    } catch (error) {
        ShowErrorAlert();
    }
}

async function ShowErrorAlert(title) {
    if (title) {

        await Swal.fire({
            icon: 'warning',
            title: '',
            text: title,
            showConfirmButton: true,
            confirmButtonText: 'Tamam'
        });
    } else {

        await Swal.fire({
            icon: 'error',
            title: '',
            showConfirmButton: false,
            timer: 700
        });
    }
}

async function ShowSuccessAlert(title) {
    Swal.fire({
        icon: 'success',
        title: title ?? '',
        showConfirmButton: false,
        timer: 700
    });
}




var rts__preloader = ` 
        <div id="rts__preloader">
            <div class="main-fader responsive-height-comments">
                <div class="loader">
                    <svg viewBox="0 0 866 866" xmlns="http://www.w3.org/2000/svg">
                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 164.83 151.5">
                            <path class="path-0" d="M117.24,69.24A8,8,0,0,0,115.67,67c-4.88-4-9.8-7.89-14.86-11.62A4.93,4.93,0,0,0,96.93,55c-5.76,1.89-11.4,4.17-17.18,6a4.36,4.36,0,0,0-3.42,4.12c-1,6.89-2.1,13.76-3,20.66a4,4,0,0,0,1,3.07c5.12,4.36,10.39,8.61,15.68,12.76a3.62,3.62,0,0,0,2.92.75c6.29-2.66,12.52-5.47,18.71-8.36a3.49,3.49,0,0,0,1.68-2.19c1.34-7.25,2.54-14.55,3.9-22.58Z" fill="#e41b23" />
                            <path class="path-1" d="M97.55,38.68A43.76,43.76,0,0,1,98,33.44c.41-2.36-.5-3.57-2.57-4.64C91.1,26.59,87,24,82.66,21.82a6.18,6.18,0,0,0-4-.71C73.45,22.55,68.32,24.25,63.22,26c-3.63,1.21-6.08,3.35-5.76,7.69a26.67,26.67,0,0,1-.6,4.92c-1.08,8.06-1.08,8.08,5.86,11.92,3.95,2.19,7.82,5.75,11.94,6.08s8.76-2.41,13.12-3.93c9.33-3.29,9.33-3.3,9.78-14Z" fill="#e41b23" />
                            <path class="path-2" d="M66.11,126.56c5.91-.91,11.37-1.7,16.81-2.71a3.3,3.3,0,0,0,1.87-2.17c1-4.06,1.73-8.19,2.84-12.24.54-2-.11-3-1.55-4.15-5-4-9.9-8.12-15-12a6.19,6.19,0,0,0-4.15-1.1c-5.35.66-10.7,1.54-16,2.54A4,4,0,0,0,48.34,97a109.13,109.13,0,0,0-3,12.19,4.47,4.47,0,0,0,1.34,3.6c5.54,4.36,11.23,8.53,16.91,12.69a10.84,10.84,0,0,0,2.57,1.11Z" fill="#e41b23" />
                            <path class="path-3" d="M127.42,104.12c4.1-2.1,8-3.93,11.72-6a6,6,0,0,0,2.27-3,58.22,58.22,0,0,0,3.18-29.92c-.26-1.7-8-7.28-9.71-6.85A5,5,0,0,0,133,59.65c-2.81,2.49-5.71,4.88-8.33,7.56a9.46,9.46,0,0,0-2.47,4.4c-1.29,6.49-2.38,13-3.35,19.55a5.73,5.73,0,0,0,.83,3.91c2.31,3.08,5,5.88,7.7,9Z" fill="#e41b23" />
                            <path class="path-4" d="M52.58,29.89c-2.15-.36-3.78-.54-5.39-.9-2.83-.64-4.92.1-7,2.32A64.1,64.1,0,0,0,26.09,54.64c-2.64,7.92-2.62,7.84,5.15,10.87,1.76.69,2.73.45,3.93-1C39.79,59,44.54,53.65,49.22,48.2a4.2,4.2,0,0,0,1.13-2c.8-5.32,1.49-10.68,2.24-16.34Z" fill="#e41b23" />
                            <path class="path-5" fill="#e41b23" d="M23,68.13c0,2.51,0,4.7,0,6.87a60.49,60.49,0,0,0,9.75,32.15c1.37,2.13,6.4,3,7,1.2,1.55-5,2.68-10.2,3.82-15.34.13-.58-.58-1.38-.94-2.06-2.51-4.77-5.47-9.38-7.45-14.37C32.94,71,28.22,69.84,23,68.13Z" />
                            <path class="path-6" fill="#e41b23" d="M83.91,12.86c-.32.36-.66.71-1,1.07.9,1.13,1.57,2.62,2.73,3.33,4.71,2.84,9.56,5.48,14.39,8.1a9.29,9.29,0,0,0,3.13.83c5.45.69,10.89,1.38,16.35,1.94a10.41,10.41,0,0,0,3.07-.71c-11.48-9.9-24.26-14.61-38.71-14.56Z" />
                            <path class="path-7" fill="#e41b23" d="M66.28,132.51c13.36,3.78,25.62,3.5,38-.9C91.68,129.59,79.36,128,66.28,132.51Z" />
                            <path class="path-8" fill="#e41b23" d="M127.2,30.66l-1.27.37a18.58,18.58,0,0,0,1,3.08c3,5.52,6.21,10.89,8.89,16.54,1.34,2.83,3.41,3.82,6.49,4.9a60.38,60.38,0,0,0-15.12-24.9Z" />
                            <path class="bb-9" fill="#e41b23" d="M117.35,125c5.58-2.32,16.9-13.84,18.1-19.2-2.41,1.46-5.18,2.36-6.78,4.23-4.21,5-7.89,10.37-11.32,15Z" />
                        </svg>
                    </svg>
                </div>
            </div>
        </div> 
    `;




async function _sliders() {

    // banner slider
    var swiper = new Swiper(".bannerSlide", {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        speed: 1300,
        loop: true,
        loopFillGroupWithBlank: true,
        fadeEffect: {
            crossFade: true
        },
        virtualTranslate: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        speed: 1500,

        effect: "fade",
        centeredSlides: false,
        breakpoints: {
            1500: {
                slidesPerView: 1,
            },
            991: {
                slidesPerView: 1,
            },
            767: {
                slidesPerView: 1,
            },
            575: {
                slidesPerView: 1,
            },
            0: {
                slidesPerView: 1,
            }
        },
        navigation: {
            nextEl: ".slide-next",
            prevEl: ".slide-prev",
        },
        pagination: {
            el: '.swiper-paginations',
            clickable: 'true'
        }
    });

    var swiper = new Swiper(".bannerSlide2", {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        speed: 1300,
        loop: true,
        loopFillGroupWithBlank: true,
        fadeEffect: {
            crossFade: true
        },
        virtualTranslate: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        speed: 1500,
        effect: "fade",
        centeredSlides: false,
        breakpoints: {
            1500: {
                slidesPerView: 1,
            },
            991: {
                slidesPerView: 1,
            },
            767: {
                slidesPerView: 1,
            },
            575: {
                slidesPerView: 1,
            },
            0: {
                slidesPerView: 1,
            }
        },
        navigation: {
            nextEl: ".slide-next",
            prevEl: ".slide-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        }
    });

    // Banner Slider 1
    var swiper1 = new Swiper(".oneManual", {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        speed: 700,
        loop: true,
        loopFillGroupWithBlank: true,
        centeredSlides: false,
        navigation: {
            nextEl: ".slide-next",
            prevEl: ".slide-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        }
    });

    // Banner Slider 2
    var swiper2 = new Swiper(".thumbBannerSlide", {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        speed: 1300,
        loop: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
            1500: {
                slidesPerView: 1,
            },
            991: {
                slidesPerView: 1,
            },
            767: {
                slidesPerView: 1,
            },
            575: {
                slidesPerView: 1,
            },
            0: {
                slidesPerView: 1,
            }
        },
        thumbs: {
            /*swiper: swiperthumb,*/ // 'swiperthumb' nesnesi tanımlanmış olmalıdır
        },
        navigation: {
            nextEl: ".slide-next",
            prevEl: ".slide-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        }
    });

    // Banner Slider 3
    var swiper3 = new Swiper(".oneSlide", {
        slidesPerView: 1,
        spaceBetween: 50,
        slidesPerGroup: 1,
        speed: 700,
        loop: true,
        loopFillGroupWithBlank: true,
        centeredSlides: false,
        navigation: {
            nextEl: ".slide-next",
            prevEl: ".slide-prev",
        },
        pagination: {
            el: ".swiper-pag",
            clickable: true
        }
    });
}

$(document).on('click', '.toggle-password', function () {
    const input = $('#password');
    const type = input.attr('type') === 'password' ? 'text' : 'password';
    input.attr('type', type);

    const icon = $(this).is('i') ? $(this) : $(this).find('i');
    icon.toggleClass('fa-eye fa-eye-slash');
    $(this).attr('aria-label', type === 'text' ? 'Şifreyi gizle' : 'Şifreyi göster');
});







$(document)
    .off("click.statisticsToggle")

    .on("click.statisticsToggle", ".js-toggle-stat-group", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $icon = $(this).find(".js-toggle-stat-group-icon");
        const isCaretToggle = $icon.hasClass("fa-caret-down") || $icon.hasClass("fa-caret-right");

        toggleTarget($(this), {
            iconSelector: ".js-toggle-stat-group-icon",
            openIcon: isCaretToggle ? "fa-caret-down" : "fa-minus",
            closeIcon: isCaretToggle ? "fa-caret-right" : "fa-plus"
        });
    })

    .on("click.statisticsToggle", ".js-toggle-stat-tree", function (e) {
        e.preventDefault();
        e.stopPropagation();

        openStatTreeModal($(this));
    })

    .on("click.statisticsToggle", ".js-stat-metric-row", function (e) {
        if ($(e.target).closest(".js-toggle-stat-tree").length > 0) {
            return;
        }

        const detailButton = $(this).find(".js-toggle-stat-tree").first();
        openStatTreeModal(detailButton);
    })

    .on("keydown.statisticsToggle", ".js-stat-metric-row", function (e) {
        if (e.key !== "Enter" && e.key !== " ") {
            return;
        }

        e.preventDefault();
        const detailButton = $(this).find(".js-toggle-stat-tree").first();
        openStatTreeModal(detailButton);
    })

    .on("click.statisticsToggle", ".js-toggle-more", function (e) {
        e.preventDefault();
        e.stopPropagation();

        toggleTarget($(this), {
            iconSelector: ".js-toggle-more-icon",
            textSelector: ".js-toggle-more-text",
            openText: "Daha Az",
            closeText: "Daha Fazla",
            openIcon: "fa-minus",
            closeIcon: "fa-plus"
        });
    })

    .on("click.statisticsToggle", ".js-stat-tree-panel", function (e) {
        e.stopPropagation();
    });

function toggleTarget(button, options) {
    if (!button || !button.length)
        return;

    if (button.prop("disabled"))
        return;

    const targetSelector = button.data("target");

    if (!targetSelector)
        return;

    const target = $(targetSelector);

    if (!target.length)
        return;

    const willShow = target.hasClass("d-none");

    target.toggleClass("d-none", !willShow);

    button.attr("aria-expanded", willShow ? "true" : "false");

    if (options.activeButtonClass) {
        button.toggleClass(options.activeButtonClass, willShow);
    }

    if (options.iconSelector) {
        button.find(options.iconSelector)
            .toggleClass(options.closeIcon, !willShow)
            .toggleClass(options.openIcon, willShow);
    }

    if (options.textSelector) {
        button.find(options.textSelector)
            .text(willShow ? options.openText : options.closeText);
    }
}

function openStatTreeModal(button) {
    if (!button || !button.length)
        return;

    if (button.prop("disabled"))
        return;

    const targetSelector = button.data("target");

    if (!targetSelector)
        return;

    const target = $(targetSelector);

    if (!target.length)
        return;

    if (typeof Swal === "undefined")
        return;

    const modalTitle =
        button.data("title") ||
        button.attr("title") ||
        "İstatistik Detayı";

    const clonedPanel = target
        .clone(false, false)
        .removeClass("d-none")
        .addClass("d-block");
    const fallbackDescription = button.data("description");
    let modalHtml = clonedPanel.prop("outerHTML");

    if (fallbackDescription && !$.trim(clonedPanel.text())) {
        modalHtml = '<div class="statistics-detail-panel d-block">' +
            '<span class="d-block fs-07">' + $("<div>").text(fallbackDescription).html() + '</span>' +
            '</div>';
    }

    button.attr("aria-expanded", "true");
    button.addClass("bg-half-primary");

    Swal.fire({
        title: modalTitle,
        html: modalHtml,
        width: "650px",
        showConfirmButton: true,
        confirmButtonText: "Kapat",
        buttonsStyling: false,
        customClass: {
            popup: "br-calc stat-tree-modal-popup",
            title: "fs-09 fw-bold",
            htmlContainer: "text-start",
            confirmButton: "btn btn-primary br-calc px-4"
        },
        didClose: function () {
            button.attr("aria-expanded", "false");
            button.removeClass("bg-half-primary");
        }
    });
}
(function initializePaymentDeadlineManager() {
    if (window.paymentDeadlineManagerInitialized) return;
    window.paymentDeadlineManagerInitialized = true;

    var selector = '[data-reservation-payment-deadline],[data-finance-deadline]';
    var groups = new Map();
    var elementRecords = new WeakMap();
    var parsedDeadlines = new Map();
    var pendingRoots = new Set();
    var pendingFrame = 0;

    function deadlineValue(element) {
        return element.dataset.reservationPaymentDeadline ||
            element.dataset.financeDeadline || '';
    }

    function outputElement(element) {
        return element.querySelector('[data-reservation-payment-countdown]') ||
            element.querySelector('[data-finance-deadline-text]');
    }

    function parsedDeadline(raw) {
        if (parsedDeadlines.has(raw)) return parsedDeadlines.get(raw);
        var value = /^\d{12,}$/.test(raw) ? Number(raw) : Date.parse(raw);
        parsedDeadlines.set(raw, value);
        return value;
    }

    function applyExpiredState(record, expired) {
        record.element.classList.toggle('expired', expired);
        var reservationCard = record.element.closest('.reservation-global-card');
        if (reservationCard)
            reservationCard.classList.toggle('payment-expired', expired);

        var reservationDetail = record.element.closest('.my-reservation-premium');
        if (!reservationDetail) return;

        reservationDetail.classList.toggle('payment-expired', expired);
        var expiredAlert = reservationDetail.querySelector('[data-payment-expired-alert]');
        if (expiredAlert) expiredAlert.classList.toggle('d-none', !expired);

        var title = record.element.querySelector('[data-payment-expiry-title]');
        if (title)
            title.textContent = expired ? title.dataset.expiredText : title.dataset.activeText;

        var description = record.element.querySelector('[data-payment-expiry-description]');
        if (description)
            description.textContent = expired
                ? description.dataset.expiredText
                : description.dataset.activeText;

        var statusIcon = record.element.querySelector('[data-payment-status-icon]');
        if (statusIcon) {
            statusIcon.classList.toggle('fa-clock', !expired);
            statusIcon.classList.toggle('fa-triangle-exclamation', expired);
        }

        var paymentStep = reservationDetail.querySelector('[data-payment-step-state]');
        if (paymentStep)
            paymentStep.textContent = expired
                ? paymentStep.dataset.expiredText
                : paymentStep.dataset.activeText;
    }

    function addElement(element) {
        var raw = deadlineValue(element);
        var output = outputElement(element);
        if (!raw || !output) return;

        var current = elementRecords.get(element);
        if (current && current.raw === raw && current.output === output) return;
        if (current) current.group.records.delete(current);

        var group = groups.get(raw);
        if (!group) {
            group = {
                raw: raw,
                deadline: parsedDeadline(raw),
                records: new Set(),
                lastMinutes: null,
                lastText: '',
                expired: false,
                dirty: true
            };
            groups.set(raw, group);
        }

        var record = { element: element, output: output, raw: raw, group: group };
        group.records.add(record);
        group.dirty = true;
        elementRecords.set(element, record);

        // Aynı son tarihin sonucu daha önce hesaplandıysa yeni karta doğrudan aktarılır.
        if (group.lastText) {
            output.textContent = group.lastText;
            applyExpiredState(record, group.expired);
        }
    }

    function register(root) {
        if (!root) return;
        if (root.nodeType === 1 && root.matches(selector)) addElement(root);
        if (typeof root.querySelectorAll === 'function')
            root.querySelectorAll(selector).forEach(addElement);
    }

    function formatMinutes(minutes) {
        if (!minutes) return 'Süre doldu';
        var days = Math.floor(minutes / 1440);
        var hours = Math.floor((minutes % 1440) / 60);
        var rest = minutes % 60;
        return (days ? days + ' gün ' : '') +
            (hours ? hours + ' saat ' : '') + rest + ' dk kaldı';
    }

    function update(root) {
        if (root) register(root);
        var now = Date.now();

        groups.forEach(function (group, raw) {
            group.records.forEach(function (record) {
                if (!record.element.isConnected || !record.output.isConnected) {
                    group.records.delete(record);
                    elementRecords.delete(record.element);
                }
            });
            if (!group.records.size) {
                groups.delete(raw);
                parsedDeadlines.delete(raw);
                return;
            }
            if (!Number.isFinite(group.deadline)) return;

            // Bir son tarih, o değeri kullanan kart sayısından bağımsız olarak yalnızca bir kez hesaplanır.
            var minutes = Math.max(0, Math.ceil((group.deadline - now) / 60000));
            if (!group.dirty && group.lastMinutes === minutes) return;

            group.lastMinutes = minutes;
            group.lastText = formatMinutes(minutes);
            group.expired = minutes === 0;
            group.dirty = false;
            group.records.forEach(function (record) {
                if (record.output.textContent !== group.lastText)
                    record.output.textContent = group.lastText;
                applyExpiredState(record, group.expired);
            });
        });
    }

    function schedule(root) {
        if (root) pendingRoots.add(root);
        if (pendingFrame) return;
        var run = function () {
            pendingFrame = 0;
            pendingRoots.forEach(register);
            pendingRoots.clear();
            update();
        };
        pendingFrame = typeof window.requestAnimationFrame === 'function'
            ? window.requestAnimationFrame(run)
            : window.setTimeout(run, 0);
    }

    window.refreshReservationPaymentDeadlines = function (root) {
        update(root || document);
    };

    function start() {
        update(document);
        if (document.documentElement && typeof MutationObserver !== 'undefined') {
            new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType === 1 &&
                            (node.matches(selector) || node.querySelector(selector)))
                            schedule(node);
                    });
                });
            }).observe(document.documentElement, { childList: true, subtree: true });
        }
        window.setInterval(function () { update(); }, 30000);
        document.addEventListener('visibilitychange', function () {
            if (!document.hidden) update();
        });
    }

    if (document.readyState === 'loading')
        document.addEventListener('DOMContentLoaded', start, { once: true });
    else
        start();
})();

// Facility tab accessibility; panel switching is owned by global target-div.js.
$(document).on('click', '[data-facility-tab]', function () {
    const root = this.closest('.facility-detail');
    root.querySelectorAll('[data-facility-tab]').forEach(tab => {
        const active = tab === this;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
    });
});
$(document).on('keydown', '[data-facility-tab]', function (event) {
    if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = Array.from(this.parentElement.querySelectorAll('[data-facility-tab]'));
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(this) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    tabs[index].focus(); tabs[index].click();
});

// Shared card gallery uses the images supplied by GlobalCardModel.
$(document).on('click keydown', '.openGlobalCardGallery', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    const images = JSON.parse(this.dataset.galleryImages || '[]');
    const items = images.map(src => ({ src, title: this.dataset.galleryTitle || '' }));
    if (items.length && window.imageManager) window.imageManager.openItems(items, 0);
});

$(document).on('click', '.global-card__toggle', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const panel = document.getElementById(this.getAttribute('aria-controls'));
    if (!panel) return;
    const expanded = this.getAttribute('aria-expanded') !== 'true';
    this.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
});

// Match ratings are saved together by the existing batch-rating flow.
$(document).on('submit', '.globalCommentBatchForm', function (e) {
    e.preventDefault();
});

// Blog uses the same saved-filter lifecycle as the other public lists.
$(document).on('change', '.blogSearch', function () {
    SaveFilter('blogSearch');
});

// Registration shares one layout for new accounts and provider/account completion.
function applyRegistrationFieldRules(fields) {
    document.querySelectorAll('[data-registration-field]').forEach(host => {
        const rule = fields[host.dataset.registrationField];
        if (!rule) return;
        host.classList.toggle('d-none', !rule.show);
        host.querySelectorAll('input, select').forEach(input => {
            input.disabled = !rule.show;
            input.classList.toggle('required', !!rule.required);
            if (!rule.required) input.classList.remove('is-invalid');
        });
        if (rule.required && host.closest('details')) host.closest('details').open = true;
    });
    $('#FirstSaveForm').attr('data-registration-rules', JSON.stringify(fields));
    updateSubmitButtonState();
}
function registrationPhoneDigits(value) {
    let digits = String(value || '').replace(/\D/g, '');
    if (digits.length === 12 && digits.startsWith('90')) digits = digits.slice(2);
    if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1);
    return digits;
}
function showRegistrationValidationError(input, message) {
    if (input) {
        input.classList.add('is-invalid');
        const disclosure = input.closest('details');
        if (disclosure) disclosure.open = true;
        if (input.closest('#registrationOptionalDetails')?.hidden)
            document.querySelector('.registration-details-launch')?.click();
        const target = input.id === 'Phone' && input.type === 'hidden' ? document.getElementById('changeMyPhone')
            : input.id === 'Img' ? document.getElementById('registrationAvatar')
            : input.id === 'AcceptKvkk' ? input.closest('.registration-kvkk')
            : input.classList.contains('select2-hidden-accessible') ? $(input).next('.select2').find('.select2-selection').get(0)
            : input;
        target?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        target?.focus({ preventScroll: true });
    }
    ShowErrorAlert(message);
}
function validateRegistrationBasicFields() {
    const form = document.getElementById('FirstSaveForm');
    if (!form) return false;
    const fields = JSON.parse(form.dataset.registrationRules || '{}');
    const invalid = [];
    const check = (input, missing, message) => {
        input?.classList.toggle('is-invalid', missing);
        if (missing) invalid.push({ input, message });
    };
    check(form.querySelector('#MemberTypeId'), !Number(form.querySelector('#MemberTypeId')?.value), 'Lütfen bir üyelik tipi seçiniz.');
    for (const [name, rule] of Object.entries(fields)) {
        if (!rule.required || !['Name', 'Surname', 'CityId', 'DistrictId', 'NickName', 'Mail', 'Img'].includes(name)) continue;
        const input = form.querySelector('[name="' + name + '"]');
        const value = String(input?.value || '').trim();
        const missing = !value || value === '0' || (name === 'Img' && value.endsWith('/avatar.webp'));
        check(input, missing, name === 'Img' ? 'Lütfen profil fotoğrafı yükleyiniz.' : 'Devam etmek için işaretli hesap bilgilerini tamamlayın.');
    }
    const gender = form.querySelector('#GenderTypeSwitch');
    check(gender, !!gender?.classList.contains('genderNXC5') && !Number(gender.dataset.id), 'Lütfen cinsiyet seçiniz.');
    const phone = form.querySelector('#Phone');
    check(phone, !/^5\d{9}$/.test(registrationPhoneDigits(phone?.value)), 'Geçerli bir telefon numarası giriniz.');
    const password = form.querySelector('#PasswordOne:not(:disabled)');
    if (password) check(password, password.value.length < 8, 'Parola en az 8 karakter olmalıdır.');
    const consent = form.querySelector('#AcceptKvkk');
    check(consent, consent?.value !== 'True', 'Devam etmek için KVKK metnini okuyup onaylayın.');
    const mail = form.querySelector('[name="Mail"]');
    if (mail && fields.Mail?.show && mail.value.trim())
        check(mail, !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail.value.trim()), 'Geçerli bir e-posta adresi giriniz.');
    if (invalid.length) showRegistrationValidationError(invalid[0].input, invalid[0].message);
    return invalid.length === 0;
}

$(document).on('submit', '#FirstSaveForm', function (event) {
    event.preventDefault();
    $('#SubmitFirstSaveForm').trigger('click');
});
$(document).on('click', '.registration-role', function () { return selectRegistrationRole(this); });
async function selectRegistrationRole(button) {
    if (!button) return;
    if (button.disabled) return;
    if (button.dataset.phoneUsed === 'true') { await pageLink('/Giris'); return; }
    const memberType = Number(button.dataset.memberType);
    if (button.getAttribute('aria-pressed') === 'true' && !registrationFieldSaveErrors.has('RoleRequirements')) return;
    $('.registration-role').prop('disabled', true);
    $('#FirstSaveForm').attr('data-loading-rules', 'true');
    updateSubmitButtonState();
    try {
        if (Number($('#MemberId').val()) > 0 && !await editableMemberProp('MemberTypeId', memberType)) {
            registrationFieldSaveErrors.add('RoleRequirements');
            return;
        }
        $('#MemberTypeId').val(memberType);
        FirstSaveFirstMemberTypeId = memberType;
        $('.registration-role').each(function () {
            const selected = Number(this.dataset.memberType) === memberType;
            this.classList.toggle('checked', selected);
            this.setAttribute('aria-pressed', String(selected));
        });
        const rules = await Request({ url: '/Login/RegistrationRoleRequirements', type: 'POST', data: { memberTypeId: memberType } });
        if (rules.fields) applyRegistrationFieldRules(rules.fields);
        $('#GenderTypeSwitch').toggleClass('d-none', !rules.showGender).toggleClass('genderNXC5', !!rules.requireGender);
        registrationFieldSaveErrors.delete('RoleRequirements');
        await GetDynamicStepListForMemberTypeId();
        updateSubmitButtonState();
    } catch (error) {
        registrationFieldSaveErrors.add('RoleRequirements');
        ShowErrorAlert(error?.responseText || 'Üyelik tipi bilgileri yüklenemedi. Tekrar deneyin.');
    } finally {
        $('.registration-role').prop('disabled', false);
        $('#FirstSaveForm').removeAttr('data-loading-rules');
        updateSubmitButtonState();
    }
}
$(document).on('click', '.registration-details-launch', function () {
    const launch = this;
    const details = document.getElementById('registrationOptionalDetails');
    if (!details || !details.hidden) return;
    const parent = details.parentNode;
    const next = details.nextSibling;
    const modal = createModal({
        title: 'İsteğe bağlı detaylar',
        content: '',
        modalClass: 'registration-details-modal',
        onClose: function () {
            details.hidden = true;
            if (parent.isConnected) parent.insertBefore(details, next?.parentNode === parent ? next : null);
            if (launch.isConnected) launch.focus({ preventScroll: true });
        }
    });
    // The modal must stay at body level; page containers can establish clipping
    // and stacking contexts. Move the original controls and restore them on close.
    modal.element.classList.add('member-register-reference');
    const wizardStyle = getComputedStyle(launch.closest('.member-register-wizard'));
    for (const property of ['--register-green', '--register-ink', '--register-muted', '--register-line', '--registration-control'])
        modal.element.style.setProperty(property, wizardStyle.getPropertyValue(property));
    modal.element.setAttribute('role', 'dialog');
    modal.element.setAttribute('aria-modal', 'true');
    modal.element.setAttribute('aria-label', 'İsteğe bağlı detaylar');
    modal.element.querySelector('.custom-modal-body').appendChild(details);
    details.hidden = false;
    details.querySelectorAll('.parentS2.select2-hidden-accessible').forEach(input => $(input).select2('destroy'));
    parentS2each(details);
    details.querySelector('.registration-details-done').onclick = () => modal.close();
    modal.element.querySelector('.close-modal')?.focus({ preventScroll: true });
});
$(document).on('keydown', '.registration-kvkk', function (event) {
    if (event.target !== this || ![' ', 'Enter'].includes(event.key)) return;
    event.preventDefault();
    $(this).trigger('click');
});
$(document).on('click', '.registration-kvkk', function (event) {
    if ($(event.target).closest('.openDescription').length) return;
    const value = $(this).find('.hiddenInput').val() === 'True';
    this.setAttribute('aria-checked', String(value));
    if ($('#FirstSaveForm').attr('data-existing') === 'true') editableMemberProp('AcceptKvkk', String(value));
});
function initRegistrationBirthWheels() {
    const root = document.querySelector('[data-birth-wheel]');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const wheels = Array.from(root.querySelectorAll('.registration-wheel'));
    const hidden = part => root.querySelector('#Birth' + part);
    function position(wheel) {
        const options = Array.from(wheel.children);
        const value = Number(hidden(wheel.dataset.part).value);
        const index = options.findIndex(option => Number(option.dataset.value) === value);
        wheel.scrollTop = Math.max(0, index) * (options[0]?.getBoundingClientRect().height || 32);
        options.forEach(option => option.setAttribute('aria-selected', String(Number(option.dataset.value) === value)));
        wheel.setAttribute('aria-activedescendant', 'birth-' + wheel.dataset.part + '-' + value);
    }
    function clampDay() {
        const count = new Date(Number(hidden('Year').value), Number(hidden('Month').value), 0).getDate();
        const wheel = wheels.find(item => item.dataset.part === 'Day');
        hidden('Day').value = Math.min(count, Number(hidden('Day').value));
        if (wheel.children.length !== count) {
            wheel.replaceChildren(...Array.from({ length: count }, (_, index) => {
                const option = document.createElement('div');
                const value = index + 1;
                option.id = 'birth-Day-' + value;
                option.dataset.value = value;
                option.setAttribute('role', 'option');
                option.className = 'registration-wheel-option fs-08';
                option.textContent = String(value).padStart(2, '0');
                return option;
            }));
        }
        position(wheel);
    }
    function select(wheel, index) {
        if (!root.isConnected) return;
        const options = Array.from(wheel.children);
        const option = options[Math.max(0, Math.min(options.length - 1, index))];
        if (!option) return;
        const input = hidden(wheel.dataset.part);
        const changed = input.value !== option.dataset.value;
        input.value = option.dataset.value;
        if (wheel.dataset.part !== 'Day') clampDay();
        position(wheel);
        if (changed) $(input).trigger('change');
    }
    wheels.forEach(wheel => {
        let timer;
        position(wheel);
        wheel.addEventListener('scroll', () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                if (!root.isConnected) return;
                select(wheel, Math.round(wheel.scrollTop / (wheel.firstElementChild?.getBoundingClientRect().height || 32)));
            }, 100);
        }, { passive: true });
        wheel.addEventListener('click', event => {
            const option = event.target.closest('[role="option"]');
            if (option) select(wheel, Array.from(wheel.children).indexOf(option));
        });
        wheel.addEventListener('keydown', event => {
            const index = Array.from(wheel.children).findIndex(option => option.dataset.value === hidden(wheel.dataset.part).value);
            const next = { ArrowDown: index + 1, ArrowUp: index - 1, PageDown: index + 5, PageUp: index - 5, Home: 0, End: wheel.children.length - 1 }[event.key];
            if (next !== undefined) { event.preventDefault(); select(wheel, next); }
        });
    });
    root.flushSelection = () => wheels.forEach(wheel => select(wheel, Math.round(wheel.scrollTop / (wheel.firstElementChild?.getBoundingClientRect().height || 32))));
    if (root.dataset.saveDefault === 'true') $(hidden('Year')).trigger('change');
}

$(document).on('click', '[data-step-target]', function () {
    const input = document.getElementById(this.dataset.stepTarget);
    if (!input || input.disabled || input.readOnly) return;
    const minimum = Number(input.min) || 0;
    const maximum = Number(input.max) || 250;
    const current = Number(input.value) || minimum;
    const next = Math.max(minimum, Math.min(maximum, current + Number(this.dataset.step)));
    if (String(next) === input.value) return;
    input.value = next;
    $(input).trigger('change');
});

$(document).on('input', '#LogInForm [name="Mail"]', function () {
    const host = this.form.querySelector('[data-login-member-types]');
    if (host) { host.classList.add('d-none'); host.querySelector('select').required = false; host.querySelector('select').value = ''; delete host.dataset.phone; }
});

function applyPhoneRoleAvailability(types, phone) {
    const form = document.getElementById('FirstSaveForm');
    if (!form) return;
    form.dataset.availabilityPhone = phone;
    $('.registration-role').each(function () {
        const used = types.includes(Number(this.dataset.memberType));
        this.dataset.phoneUsed = String(used);
        this.disabled = form.dataset.loadingRules === 'true';
        this.classList.toggle('is-phone-used', used);
        this.querySelector('.registration-role-used')?.classList.toggle('d-none', !used);
        if (used && this.getAttribute('aria-pressed') === 'true') {
            this.classList.remove('checked'); this.setAttribute('aria-pressed', 'false');
            $('#MemberTypeId').val(0); FirstSaveFirstMemberTypeId = 0;
        }
    });
    updateSubmitButtonState();
}
async function refreshPhoneRoleAvailability() {
    const form = document.getElementById('FirstSaveForm'), phone = $('#Phone').val();
    if (!form || !/^5\d{9}$/.test(registrationPhoneDigits(phone))) return false;
    registrationFieldSaveErrors.add('PhoneAvailability');
    updateSubmitButtonState();
    try {
        const response = await $.ajax({ url: '/CheckPhone', type: 'POST', timeout: 15000,
            data: { id: phone, memberTypeId: Number($('#MemberTypeId').val()) || 0 } });
        if (form.isConnected && $('#Phone').val() === phone) {
            registrationFieldSaveErrors.delete('PhoneAvailability');
            const selectedType = Number($('#MemberTypeId').val());
            const occupied = response.occupiedTypes || [];
            applyPhoneRoleAvailability(occupied, phone);
            if (occupied.includes(selectedType) || (response.used && !response.occupiedTypes)) {
                showRegistrationValidationError(document.getElementById('Phone'), response.message || 'Bu telefon numarası seçilen üyelik tipinde kullanımda.');
                return false;
            }
            return true;
        }
    } catch (error) { if (form.isConnected) ShowErrorAlert(error.responseText || 'Telefon kontrol edilemedi. Devam Et ile tekrar deneyin.'); }
    return false;
}

$(document).on('compositionstart', '.registration-form input, #phoneInput, #LogInForm input', function () { this.dataset.composing = 'true'; });
$(document).on('compositionend', '.registration-form input, #phoneInput, #LogInForm input', function () {
    delete this.dataset.composing;
    if (this.id === 'phoneInput') syncPhoneVerificationInput(this);
    else if (this.type === 'tel' && this.closest('#LogInForm')) maskLoginPhone(this);
});

$(document).on('keydown', '#registrationAvatar', function (event) {
    if (event.target !== this || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault(); $(this).trigger('click');
});

$(document).on('submit', '.registration-attribute-form', async function (event) {
    event.preventDefault();
    const form = $(this), button = form.find('[type="submit"]'), status = form.find('.registration-attribute-status');
    button.prop('disabled', true);
    try {
        const saved = await Request({ url: '/Login/SaveOptionalAttribute', type: 'POST', data: form.serialize() });
        form.find('[name="MemberMTypeAttrRelationId"]').val(saved.MemberMTypeAttrRelationId || saved.memberMTypeAttrRelationId);
        status.text('Kaydedildi');
    } catch (error) { status.text('Kaydedilemedi'); ShowErrorAlert(error?.responseText || 'Ek bilgi kaydedilemedi.'); }
    finally { button.prop('disabled', false); }
});


$(document).on('click', '.js-share-community-invite', async function (event) {
    event.preventDefault();
    event.stopPropagation();
    const button = $(this);
    if (button.prop('disabled')) return;
    button.prop('disabled', true);
    try {
        const invite = await Request({ url: '/Community/PrepareInvite', type: 'POST', data: { chatId: button.data('chat-id') }, cacheable: false });
        if (navigator.share && !isAndroidWebView()) {
            try { await navigator.share({ title: invite.title, text: invite.text, url: invite.url }); }
            catch (error) {
                if (error.name === 'AbortError') return;
                await Swal.fire({ title: 'Davet Linki Paylaş', input: 'text', inputValue: invite.url, confirmButtonText: 'Tamam' });
            }
        } else if (window.jsBridge && window.jsBridge.postMessage) {
            window.jsBridge.postMessage('url:' + invite.url);
        } else {
            await Swal.fire({ title: 'Davet bağlantısı', input: 'text', inputValue: invite.url,
                showCancelButton: true, confirmButtonText: 'Kopyala', cancelButtonText: 'Kapat',
                preConfirm: async () => {
                    try { await navigator.clipboard.writeText(invite.url); }
                    catch { Swal.showValidationMessage('Bağlantıyı seçip kopyalayabilirsiniz.'); return false; }
                } });
        }
    } catch (error) { ShowErrorAlert(error.responseText || 'Davet bağlantısı oluşturulamadı.'); }
    finally { button.prop('disabled', false); }
});

$(document).on('change', '.js-group-match-transfer', async function () {
    const select = $(this);
    if (!select.val()) return;
    select.prop('disabled', true);
    try {
        await Request({ url: '/MatchPlayer/TransferGroupPlayer', type: 'POST', cacheable: false,
            data: { matchId: select.data('match'), matchPlayerId: select.data('player'), targetTeamId: select.val() } });
        if (activeDraftMatchManager?.section === 'roster') await refreshDraftMatchManager();
        else await updateAfterMatchArea(select.data('match'));
    } catch (error) { ShowErrorAlert(error.responseText || 'Oyuncu taşınamadı.'); }
    finally { select.val('').prop('disabled', false); }
});


$(document).on('click', '.js-edit-group-roster', async function () {
    const button = $(this);
    const modal = createModal({ title: 'Grup içi maç kadrosunu düzenle' });
    modal.updateContent('<div class="_StaffEditorArea" data-team="' + Number(button.data('team')) + '" data-match="' + Number(button.data('match')) + '"></div>');
    await StaffEditorAreaEach();
});

// Teamless entry is shared by Quick Access, private rooms and the guide's help link.
function teamlessGuideKey(memberId, chatId) {
    return 'teamless-match-guide:v1:' + memberId + ':' + (Number(chatId) > 0 ? 'chat' : 'quick');
}
function readTeamlessGuidePreference(memberId, chatId) {
    try {
        const value = JSON.parse(localStorage.getItem(teamlessGuideKey(memberId, chatId)) || 'null');
        return value && value.hide === true ? { hide: true, bindChat: value.bindChat !== false, hasTeam: value.hasTeam === true, action: value.action === "team" ? "team" : "teamless" } : null;
    } catch { return null; }
}
let teamlessMatchEntryBusy = false;
async function openTeamlessMatchEntry(options = {}) {
    if (teamlessMatchEntryBusy) return;
    teamlessMatchEntryBusy = true;
    try {
        const memberId = await getCurrentUserId();
        if (!(memberId > 0)) { quickLoginModal(); return; }
        const groupChatId = Math.max(0, Number(options.groupChatId) || 0);
        const entry = await Request({ url: '/Match/MatchEntry', type: 'POST', data: { groupChatId }, cacheable: false });
        const teamId = Number(entry.teamId) || 0;
        const districtId = Number(entry.districtId) || Number(options.districtId) || 0;
        window.__teamlessMatchIntent = { memberId, teamId, groupChatId, districtId, facilitySelection: options.facilitySelection };
        const preference = readTeamlessGuidePreference(memberId, groupChatId);
        if (!options.forceGuide && preference && preference.hasTeam === (teamId > 0)) {
            if (preference.action === "team" && teamId > 0) {
                await CreateMatchPopUp(teamId, 0, districtId, options.facilitySelection);
                return;
            }
            await CreateMatchPopUp(0, 0, districtId, options.facilitySelection, preference.bindChat ? groupChatId : 0, true);
            return;
        }
        removeSheedModal();
        await pageLink('/Takimsiz-Mac-Rehberi?groupChatId=' + groupChatId + '&districtId=' + districtId);
    } catch (error) { ShowErrorAlert(error.responseText || 'Maç oluşturma seçenekleri yüklenemedi.'); }
    finally { teamlessMatchEntryBusy = false; }
}
window.openTeamlessMatchEntry = openTeamlessMatchEntry;

$(document).on('click', '.js-match-entry, .js-teamless-show-guide', function (event) {
    event.preventDefault(); event.stopImmediatePropagation();
    openTeamlessMatchEntry({ groupChatId: $(this).data('chat-id'), districtId: $(this).data('district-id'), forceGuide: $(this).hasClass('js-teamless-show-guide') });
});

function saveTeamlessGuidePreference(root, action) {
    const memberId = Number(root.data('member'));
    const chatId = Number(root.data('chat')) || 0;
    const bindChat = !root.find('[data-teamless-bind]').length || root.find('[data-teamless-bind]').prop('checked');
    try {
        if (root.find('[data-teamless-hide]').prop('checked')) {
            localStorage.setItem(teamlessGuideKey(memberId, chatId), JSON.stringify({ hide: true, bindChat, hasTeam: Number(root.data('team')) > 0, action }));
        } else localStorage.removeItem(teamlessGuideKey(memberId, chatId));
    } catch { /* The guide also works when browser storage is disabled. */ }
}

$(document).on('click', '.js-teamless-continue', async function () {
    const root = $(this).closest('[data-teamless-guide]');
    const memberId = Number(root.data('member'));
    if (await getCurrentUserId() !== memberId) { quickLoginModal(); return; }
    const originalChatId = Number(root.data('chat')) || 0;
    const bindChat = !root.find('[data-teamless-bind]').length || root.find('[data-teamless-bind]').prop('checked');
    saveTeamlessGuidePreference(root, 'teamless');
    const intent = window.__teamlessMatchIntent?.memberId === memberId ? window.__teamlessMatchIntent : {};
    await CreateMatchPopUp(0, 0, Number(root.data('district')) || 0, intent.facilitySelection, bindChat ? originalChatId : 0, true);
});

$(document).on('click', '.js-teamless-create-team', async function () {
    const root = $(this).closest('[data-teamless-guide]');
    const memberId = Number(root.data('member'));
    if (await getCurrentUserId() !== memberId) { quickLoginModal(); return; }
    const intent = window.__teamlessMatchIntent?.memberId === memberId ? window.__teamlessMatchIntent : {};
    const teamId = Number(root.data('team')) || 0;
    if (teamId > 0) {
        saveTeamlessGuidePreference(root, 'team');
        await CreateMatchPopUp(teamId, 0, Number(root.data('district')) || 0, intent.facilitySelection);
        return;
    }
    pendingCreateMatchAfterTeam = { rivalTeamId: 0, districtId: Number(root.data('district')) || 0, facilitySelection: intent.facilitySelection };
    addTeam();
});

$(document).on('click', '.js-teamless-open-room', async function () {
    const button = $(this);
    if (button.prop('disabled')) return;
    button.prop('disabled', true);
    try {
        if (!(await getCurrentUserId() > 0)) { quickLoginModal(); return; }
        const entry = await Request({ url: '/Community/RoomEntry', type: 'POST', data: {}, cacheable: false });
        if (Number(entry.chatId) > 0) {
            await pageLink('/Grup-Sohbeti/' + Number(entry.chatId));
        } else {
            const modal = createModal({ title: 'Özel sohbet odanı oluştur' });
            const form = await Request({ url: '/UsersMessage/_CustomGroupForm', type: 'POST', data: { id: 0 }, cacheable: false });
            modal.updateContent(form);
            loadCKeditor();
        }
    } catch (error) { ShowErrorAlert(error.responseText || 'Sohbet odası açılamadı.'); }
    finally { button.prop('disabled', false); }
});
